import './App.css';
import { db, auth, storage } from './firebaseData';
import { strings } from './translations';
import axios from 'axios';
import { isIOS } from 'react-device-detect';
import CssBaseline from '@mui/material/CssBaseline';
import _ from 'lodash';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import InfoIcon from '@mui/icons-material/Info';
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  onSnapshot,
  Timestamp,
  addDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
} from 'firebase/firestore';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import DataSaverOnRoundedIcon from '@mui/icons-material/DataSaverOnRounded';
import LoginRoundedIcon from '@mui/icons-material/LoginRounded';
import ButtonGroup from '@mui/material/ButtonGroup';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { AspectRatio } from 'react-aspect-ratio';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Link, useParams } from 'react-router-dom';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import MoneyIcon from '@mui/icons-material/Money';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import * as geolib from 'geolib';
import moment from 'moment';
import * as React from 'react';
import OtpInput from 'react18-otp-input';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Geocode from 'react-geocode';
import Toolbar from '@mui/material/Toolbar';
import ToggleButton from '@mui/material/ToggleButton';
import Checkbox from '@mui/material/Checkbox';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import 'react-phone-number-input/style.css';
import validator from 'validator';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import Menu from '@mui/material/Menu';
import DialogContent from '@mui/material/DialogContent';
import CancelIcon from '@mui/icons-material/Cancel';
import Button from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Select from '@mui/material/Select';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MoreIcon from '@mui/icons-material/MoreVert';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import Backdrop from '@mui/material/Backdrop';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import StarIcon from '@mui/icons-material/Star';
import parse from 'autosuggest-highlight/parse';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import { v4 as uuidv4 } from 'uuid';
import { ImageList, ImageListItem } from '@material-ui/core';
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  updatePassword,
} from 'firebase/auth';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import GoogleMapReact from 'google-map-react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import WidgetsRoundedIcon from '@mui/icons-material/WidgetsRounded';
import {
  getCountries,
  getCountryCallingCode,
} from 'react-phone-number-input/input';
import en from 'react-phone-number-input/locale/en.json';
import { ReactComponent as BusinessSvg } from './assets/business.svg';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import {
  Link as _ScrollLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from 'react-scroll';
import {loadStripe} from '@stripe/stripe-js';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  Elements,
  ElementsConsumer,
} from '@stripe/react-stripe-js';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const stripePromise = loadStripe('pk_test_51Groo5F76HIlmZyWmhOPE8wDkPI40bvJrOmrhsPD4qCMKjPCIjgtuoPLzAwf0xhJHG1B95rGO5sOOgQlziO9P6Yb00tfKKwtpx');
const logo = require('./assets/loading.gif');
const closed_english = require('./assets/closed_english.png');
const closed_spanish = require('./assets/closed_spanish.png');
const emptycart = require('./assets/emptycart.png');
const AnyReactComponent = ({ text }) => <div>{text}</div>;
const emails = ['username@gmail.com', 'user02@gmail.com'];
// const list = [
//   {
//     id: 'a',
//     firstname: 'Robin',
//     lastname: 'Wieruch',
//     year: 1988,
//   },
//   {
//     id: 'b',
//     firstname: 'Dave',
//     lastname: 'Davidds',
//     year: 1990,
//   },
//   {
//     id: 'c',
//     firstname: 'Robin',
//     lastname: 'Davidds',
//     year: 1988,
//   },
//   {
//     id: 'd',
//     firstname: 'Dave',
//     lastname: 'Wieruch',
//     year: 1990,
//   },
// ];

export function withRouter(Children) {
  return (props) => {
    const match = { params: useParams() };
    return <Children {...props} match={match} />;
  };
}

const scheduleFormatted = ({ hour, minute }) => {
  const checkTime = (val) => (val < 10 ? `0${val}` : val);
  return `${checkTime(hour)}:${checkTime(minute)}`;
};
const DAYS = [
  strings['Dom'],
  strings['Lun'],
  strings['Mar'],
  strings['Mié'],
  strings['Jue'],
  strings['Vie'],
  strings['Sáb'],
];

const ScrollLink = styled(_ScrollLink)(({ theme, color }) => ({
  '&.active-class': {
    color: color,
    fontWeight: '800',
    textShadow: 'rgb(149 157 165 / 20%) 0px 8px 24px',
  },
}));

const Order = styled('div')(({ theme }) => ({
  width: '60%',
  display: 'flex',
  flexDirection: 'row',
  height: '19vh',
  margin: 'auto',
  marginTop: 15,
  borderRadius: 12,
  backgroundColor: '#fff',
  border: '1px solid #e6ebf1',
  boxShadow: 'none',
  padding: '12px 6px 12px',
  '& p': {
    fontSize: '14px',
  },
  '&:hover': {
    cursor: 'pointer',
    boxShadow: '0px 4px 10px #64717a42',
  },
  '@media screen and (max-width: 480px)': {
    flexDirection: 'column',
    height: 'auto',
    width: '90%',
    textAlign: 'center',
  },
}));

const ScheduleBlock = styled('div')(({ theme, color }) => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  padding: '0px 15px',
  borderRight: '1px solid #CCC',
  width: '10%',
  minWidth: '80px',
  '& h4': {
    margin: '0px 0px 3px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: color,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '& p': {
    margin: '0px',
    fontSize: '14px',
  },
  '&:last-child': {
    border: 0,
  },
}));

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme, color }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  backgroundColor: color,
  borderRadius: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(2em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

function BusinessInfoDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList } = props;

  const handleClose = (event, reason) => {
    // if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      onClose={handleClose}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {strings['Información adicional']}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {displayList}
    </Dialog>
  );
}

BusinessInfoDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  displayList: PropTypes.element.isRequired,
};

function AddCardDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList } = props;
  const handleClose = (event, reason) => {
    // if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };

  return (
    <Dialog
      style={{ zIndex: 199999 }}
      fullScreen={fullScreen}
      onClose={handleClose}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {strings['Agregar tarjeta']}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {/* <DialogTitle>My Addresses<Box display="flex" justifyContent="flex-end" onClick={handleClose} style={{margin: '5px 0px 0px 0px', float: 'right'}}><CancelIcon /></Box> </DialogTitle>   */}
      {displayList}
    </Dialog>
  );
}

AddCardDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element.isRequired,
};

function PreOrderDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList } = props;
  const handleClose = (event, reason) => {
    // if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      onClose={handleClose}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {strings["Programar tu entrega"]}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {/* <DialogTitle>My Addresses<Box display="flex" justifyContent="flex-end" onClick={handleClose} style={{margin: '5px 0px 0px 0px', float: 'right'}}><CancelIcon /></Box> </DialogTitle>   */}
      {displayList}
    </Dialog>
  );
}

PreOrderDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element.isRequired,
};
function SimpleDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList } = props;
  const handleClose = (event, reason) => {
    // if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      onClose={handleClose}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {strings['Mis direcciones']}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {/* <DialogTitle>My Addresses<Box display="flex" justifyContent="flex-end" onClick={handleClose} style={{margin: '5px 0px 0px 0px', float: 'right'}}><CancelIcon /></Box> </DialogTitle>   */}
      {displayList}
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element.isRequired,
};

function MinimumDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList, displayTitle } = props;

  const handleClose = (event, reason) => {
    // if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };
  return (
    <Dialog
      fullScreen={false}
      onClose={handleClose}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {displayTitle}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {displayList}
    </Dialog>
  );
}

MinimumDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element.isRequired,
  displayTitle: PropTypes.string.isRequired,
};

function AlertDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList, displayTitle } = props;

  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };
  return (
    <Dialog
      fullScreen={false}
      onClose={handleClose}
      open={open}
      disableEscapeKeyDown={true}
    >
      {/* <DialogTitle sx={{ m: 0, p: 2 }}>
        {displayTitle}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle> */}
      {displayList}
    </Dialog>
  );
}

AlertDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element.isRequired,
  displayTitle: PropTypes.string.isRequired,
};

function RegisterDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList } = props;
  const handleClose = (event, reason) => {
    // if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      onClose={handleClose}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {strings['Registro']}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {/* <DialogTitle>My Addresses<Box display="flex" justifyContent="flex-end" onClick={handleClose} style={{margin: '5px 0px 0px 0px', float: 'right'}}><CancelIcon /></Box> </DialogTitle>   */}
      {displayList}
    </Dialog>
  );
}

RegisterDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element.isRequired,
};

function AdditionalDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList } = props;
  const handleClose = (event, reason) => {
    // if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      onClose={handleClose}
      open={open}
      disableEscapeKeyDown={true}
      style={{ zIndex: 99999 }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {strings['Información opcional']}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {/* <DialogTitle>My Addresses<Box display="flex" justifyContent="flex-end" onClick={handleClose} style={{margin: '5px 0px 0px 0px', float: 'right'}}><CancelIcon /></Box> </DialogTitle>   */}
      {displayList}
    </Dialog>
  );
}

AdditionalDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element.isRequired,
};

function OTPDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList } = props;
  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      onClose={handleClose}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {strings['OTP']}
      </DialogTitle>
      {displayList}
    </Dialog>
  );
}

OTPDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element.isRequired,
};

const CountrySelect = ({ value, onChange, labels, ...rest }) => (
  <FormControl variant="filled" sx={{ minWidth: 75 }}>
    <InputLabel id="demo-simple-select-filled-label">Code</InputLabel>
    <Select
      {...rest}
      value={value}
      onChange={(event) => onChange(event.target.value || undefined)}
    >
      <MenuItem value="">{labels['ZZ']}</MenuItem>
      {getCountries().map((country) => (
        <MenuItem key={country} value={'+' + getCountryCallingCode(country)}>
          +{getCountryCallingCode(country)}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

CountrySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
};

function PaymentDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList } = props;
  const handleClose = (event, reason) => {
    // if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };

  return (
    <Dialog
      style={{ zIndex: 99999 }}
      fullScreen={fullScreen}
      onClose={handleClose}
      maxWidth={'50vw'}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {strings['Selecciona tu método de pago']}
        {onClose ? (
          <IconButton
            style={{ color: 'slategray' }}
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {displayList}
    </Dialog>
  );
}

PaymentDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element.isRequired,
};

function DiscountDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList } = props;
  const handleClose = (event, reason) => {
    // if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };

  return (
    <Dialog
      style={{ zIndex: 99999 }}
      fullScreen={fullScreen}
      onClose={handleClose}
      maxWidth={'50vw'}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {strings['Promociones']}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {displayList}
    </Dialog>
  );
}

DiscountDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element.isRequired,
};

function LoginDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList } = props;
  const handleClose = (event, reason) => {
    // if (reason && reason === 'backdropClick') return;
    onClose(selectedValue);
  };

  return (
    <Dialog
      style={{ zIndex: 99999 }}
      fullScreen={fullScreen}
      onClose={handleClose}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} style={{ fontSize: '1.5rem', }}>
        {strings['Ingresar']}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {displayList}
    </Dialog>
  );
}

LoginDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element.isRequired,
};

function VariablesDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList, title } = props;
  const handleClose = (event, reason) => {
    // if (reason && reason === 'backdropClick') return;
    onClose();
  };

  return (
    <Dialog
      style={{ zIndex: 99999 }}
      fullScreen={fullScreen}
      maxWidth={'100vh'}
      onClose={handleClose}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        sx={{ m: 0, p: 2 }}
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#2e2c36',
          width: '93%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {title}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {displayList}
    </Dialog>
  );
}

VariablesDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element,
  title: PropTypes.string.isRequired,
};

function CartDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList, title } = props;
  const handleClose = (event, reason) => {
    onClose();
  };

  return (
    <Dialog
      className="MuiDialogtest-container"
      sx={{ zIndex: 9999, margin: 0, float: 'right !important' }}
      fullScreen={title > 600 ? false : true}
      maxWidth={title > 600 ? '336px' : '100vh'}
      width={title > 600 ? '336px' : '100vh'}
      alignContent="flex-end"
      justifyContent="flex-end"
      onClose={handleClose}
      open={open}
      scroll="body"
      PaperProps={{
        square: true,
        sx: {
          maxWidth: title > 600 ? '336px' : 'auto',
          width: title > 600 ? '336px' : '-webkit-fill-available',
          height: isIOS ? 'calc((var(--vh, 1vh) * 100))' : '100vh',
          maxHeight: isIOS
            ? 'calc((var(--vh, 1vh) * 100)) !important'
            : '100vh !important',
          margin: 0,
          overflow: 'hidden',
          float: 'right',
        },
      }}
      disableEscapeKeyDown={true}
    >
      {displayList}
    </Dialog>
  );
}

CartDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element,
  title: PropTypes.number.isRequired,
};

function TrackDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { onClose, selectedValue, open, displayList, title } = props;
  const handleClose = (event, reason) => {
    onClose();
  };

  return (
    <Dialog
      className="MuiDialogtest-container"
      sx={{ zIndex: 9999, margin: 0, float: 'right !important' }}
      fullScreen={title > 600 ? false : true}
      maxWidth={title > 600 ? '400px' : '100vh'}
      alignContent="flex-end"
      justifyContent="flex-end"
      onClose={handleClose}
      open={open}
      scroll="body"
      PaperProps={{
        square: true,
        sx: {
          maxWidth: title > 600 ? '400px' : 'auto',
          height: isIOS ? 'calc((var(--vh, 1vh) * 100))' : '100vh',
          maxHeight: isIOS
            ? 'calc((var(--vh, 1vh) * 100)) !important'
            : '100vh !important',
          margin: 0,
          overflow: 'hidden',
          float: 'right',
        },
      }}
      disableEscapeKeyDown={true}
    >
      {/* <DialogTitle
        sx={{ m: 0, p: 2 }}
        style={{
                      fontSize: this.state.width > 600 ? '24px' : '22px',
                      fontWeight: '800',
                      color: '#2e2c36',
                      lineHeight: '1',
                      letterSpacing: '-0.24px',
                      fontFamily: 'Nunito',
                    }}
      >
                    {'Tu canasta'}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </DialogTitle> */}
      {/* <DialogTitle>My Addresses<Box display="flex" justifyContent="flex-end" onClick={handleClose} style={{margin: '5px 0px 0px 0px', float: 'right'}}><CancelIcon /></Box> </DialogTitle>   */}
      {displayList}
    </Dialog>
  );
}

TrackDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  displayList: PropTypes.element,
  title: PropTypes.number.isRequired,
};

class Detail extends React.Component {
  constructor(props, context) {
    super(props, context);
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        const uid = user.uid;
        // console.log('signed', user);
        const menuDoc = doc(db, 'users', uid);
        this.setState({
          orders: [],
        });
        var orders = [];
        const { id } = this.props.match.params;
        const q = query(
          collection(db, 'orders'),
          where('restId', '==', id),
          where('userId', '==', uid),
          where('delivered', '==', false),
          orderBy('createdOn', 'desc')
        );
        await onSnapshot(q, async (data) => {
          this.setState({
            orders: [],
          });
          if (data.docs.length <= 0 && this.state.trackingId) {
            this.setState({
              showTracking: false,
              trackingDetails: null,
              trackingId: null,
            });
          }
          data.docs.forEach(async (document) => {
            orders = orders.filter((element) => element.id !== document.id);
            if (
              this.state.trackingId &&
              this.state.trackingId === document.id
            ) {
              await this.setState({ trackingDetails: document.data() });
            }
            orders.push(document);
            await this.setState({ orders: orders });
            // console.log('orders', orders);
          });
        });

        const docMenuSn = onSnapshot(menuDoc, async (docMenuSnap) => {
          if (docMenuSnap.data()) {
            if (docMenuSnap.data().phoneNumberVerified) {
              if (this.state.openLogin) {
                this.setState({ loading: false, openLogin: false });
                this.setState({
                  openAlert: true,
                  alertType: 'success',
                  alertMsg: strings['Inicio de sesión exitoso'],
                });
              }
              this.setState({
                userId: uid,
                userDetails: docMenuSnap.data(),
                photoURL: user.photoURL,
                cards: docMenuSnap.data().cards ? docMenuSnap.data().cards : [],
                offersUsed: docMenuSnap.data().offersUsed
                  ? docMenuSnap.data().offersUsed
                  : [],
              });
              // if (docMenuSnap.data()['custId'] == null) {
              //   try {
              //     var response = await axios.post(
              //       'https://lemon-order.herokuapp.com/drivers/createcust/',null,
              //       {
              //       params: {
              //         'email': docMenuSnap.data().email,
              //         'name': docMenuSnap.data().fullName,
              //         'phone': docMenuSnap.data().phoneNumber,
              //         'uid': uid,
              //       },
              //     }
              //     );
              //     if (response.status === 200) {
              //       console.log(response.data['id']);
              //       if (response.data['id'] != null) {
              //       } else {
              //         console.log('failed');
              //       }
              //     } else {
              //       console.log('failed');
              //     }
              //   } catch (e) {
              //     console.log('exception ¢e',e);
              //   }
              // } else {
              //   // custId = (event.data() as Map)['custId'].toString();
              //   // print(custId);
              //   // //custId = 'cus_JwCyg2xRg0XoOT';
              //   // updateCards();
              // }
            } else {
              if(!this.state.openOTP && this.state.isMounted && this._ismounted) {
              this.setState({
                openOTP: true,
                phoneNumber: docMenuSnap.data().phoneNumber,
                phoneCountry: '+507',
                showPassword: false,
              });
              const min = 0;
              const max = 999999;
              const rand = Math.floor(min + Math.random() * (max - min));
              var dataSend = rand.toString();
              for (var i = 0; i < 6; i++) {
                if (dataSend.length < 6) {
                  dataSend = '0' + dataSend;
                }
              }
              // console.log(dataSend,this.state.isMounted, this._ismounted);
              this.setState({ otpSend: dataSend });
              await axios
                .post('https://lemon-order.herokuapp.com/drivers/create-otp/', {
                  code: dataSend,
                  number: docMenuSnap.data().phoneNumber,
                })
                .then(async (response) => {
                  console.log(response);
                });
              }
              this.setState({
                userId: uid,
                userDetails: docMenuSnap.data(),
                photoURL: user.photoURL,
                cards: docMenuSnap.data().cards ? docMenuSnap.data().cards : [],
              });
            }
          } else {
            // console.log('openlogin',this.setState.openLogin);
            if (this.state.openLogin) {
              this.setState({
                openAlert: true,
                alertType: 'error',
                alertMsg: 'Error de inicio de sesión',
              });
            }
            if (!this.state.openRegister) {
              this.setState({ loading: false });
              this.setState({ userId: null, userDetails: null, cards: [] });
              auth.signOut();
            }
          }
        });
        // ...
      } else {
        console.log('Login Here');
        this.setState({ userId: null, userDetails: null, cards: [] });
        signInWithEmailAndPassword(
          auth,
          'ordernar@golemon.express',
          'demo1234'
        )
          .then((userCredential) => {
            // Signed in
            console.log('signing', userCredential);
            const user = userCredential.user;
            const uid = user.uid;

            // this.setState({ userId: uid });
            // ...
          })
          .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            this.setState({
              openAlert: true,
              alertType: 'error',
              alertMsg: strings['No puedo iniciar sesión, actualice la página'],
            });
            console.log(errorMessage, errorCode);
          });

        //       signInWithEmailAndPassword(auth, 'demo@demo.com', 'demo1234')
        // .then((userCredential) => {
        //   // Signed in
        //   console.log('signing',userCredential);
        //   const user = userCredential.user;
        //   const uid = user.uid;
        //   this.setState({ userId: uid });
        //   // ...
        // })
        // .catch((error) => {
        //   const errorCode = error.code;
        //   const errorMessage = error.message;
        //   console.log(errorMessage,errorCode);
        // });
        // User is signed out
        // ...
      }
    });
    var days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    this._ismounted = true;
    this.state = {
      orders: [],
      busId: '',
      alertMsg: '',
      openAddCard: false,
      newCard: {
        cardNo: '',
        cvv:'',
        month: '',
        year: '',
        expiry: '',
        name: ''
      },
      selectLocationName: null,
      canDeliverHere: false,
      openAlert: false,
      showCart: false,
      showTracking: false,
      trackingDetails: null,
      toggleDetails: false,
      trackingId: null,
      showDiscount: false,
      showPayment: false,
      alertType: 'error',
      isMounted: true,
      anchorEl: null,
      open: false,
      openLocation: false,
      openPreOrder: false,
      showTomorrow: false,
      selectedPreOrder: null,
      currenciesList2Selected: null,
      currenciesListSelected: null,
      currenciesList3Selected: null,
      openLogin: false,
      openBusinessInfo: false,
      password: '',
      email: '',
      fullName: '',
      tempOrder: {},
      productIds: [],
      otp: '',
      otpSend: '',
      phoneNumber: '',
      phoneCountry: '+507',
      showPassword: false,
      openRegister: false,
      openAdditional:false,
      tableNumber: '',
      clientName: '',
      clientTel: '',
      additionalInfoAdded: false,
      openOTP: false,
      showMinimum: false,
      openDialogAlert: false,
      openVariable: false,
      selectedProduct: null,
      userId: null,
      selectedValue: emails[1],
      selectedLocationName: '',
      selectedLocationNotes: '',
      currentLocation: {
        latitude: 0,
        longitude: 0,
      },
      currentAddress: '',
      selectedLocationData: '',
      selectedLocationId: '',
      selectedLocation: {
        latitude: 0,
        longitude: 0,
      },
      businessData: null,
      locOptions: [],
      offers: [],
      offers2: [],
      addresses: [],
      defaultCountry: 'ES',
      selectedLocationDetails: {},
      cards: [],
      loading: false,
      offersUsed: [],
      cart: {
        restId: '',
        restName: '',
        restLogo: '',
        maxTime: 0,
        totalCost: 0,
        totalItems: 0,
        item: [],
        totalOxxoCost: 0,
        totalOxxoItems: 0,
        oxxoNameData: '',
        oxxoLogoImage: '',
        oxxoItem: [],
      },
      delivery: 0,
      selectedMenuIndex: 0,
      menuProductItems: [],
      selectedType: 2,
      selectedType2: 2,
      hasClickedLoc: false,
      autoLoc: '',
      offerDetails: {},
      onlyPickup: false,
      storeIsOpen: false,
      deliveryFee: 0,
      dynamicFeeType: 0,
      selectLocationData: {
        id: '',
        name: '',
        address: '',
        geoAddress: '',
        addressNotes: '',
        latitude: 10.99835602,
        longitude: 77.01502627,
      },
      cookingInstructions: '',
      spoon: false,
      selectedAddress: {
        latitude: 0,
        longitude: 0,
      },
      defaultProps: {
        center: {
          lat: 10.99835602,
          lng: 77.01502627,
        },
        zoom: 16,
      },
      mobileMoreAnchorEl: null,
      menuData: [],
      menu: [],
      userDetails: null,
      width: 0,
      height: 0,
      showAddressModal: false,
      selectedDate: new Date(),
      selectedWeekDay: new Date().getDay(),
      isTomorrow: false,
      isPreOrder: false,
      isStore: false,
      order: {
        offerCode: '',
        selectedOffer: {},
        offerId: '',
        offerValue: 0,
        cashbackValue: 0,
        offerCode2: '',
        offerId2: '',
        offerValue2: 0,
        restId: '',
        restName: '',
        restLogo: '',
        maxTime: 0,
        itemCost: 0,
        deliveryCharge: 0,
        usageFee: 0,
        taxes: 0,
        serviceFee: 0,
        grandTotal: 0,
        items: [],
      },
      offerCode: '',
      selectedOffer: null,
      offerId: '',
      offerSuccess: '',
      offerErrorText: '',
      offerValue: 0,
      cashbackValue: 0,
      offerInd: null,
      isOfferApplied: false,
      isOfferError: false,
      isFreeDelivery: false,
      deliveryInstructions: '',
      defaultCard: null,
      toggleDelivery: true,
      tipPercent: 0,
      dynamicDelivery: false,
      additionalDelivery: 0,
      normalDelivery: 0,
      additionalDeliveryPercentage2: 0,
      reasonTitle: '',
      reasonDescription: '',
      isStore2: false,
      showMap: false,
      currenciesList: [],
      currenciesList3: [],
      currenciesList2: [],
      vh: window.innerHeight * 0.01,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    this.setState({ vh: vh });
    // We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      this.setState({ vh: vh });
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  }

  async getCities(id2) {
    // let { id } = this.props.params;
    var days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];

    const q = query(
      collection(db, 'businesses'),
      where('slugIds', 'array-contains', id2)
    );
    var docSnap;
    var id;
    await getDocs(q).then((data) => {
      if(data.docs.length>0) {
        docSnap = data.docs[0];
        id = data.docs[0].id;
      }
    });
    // const busDoc = doc(db, 'businesses', id);
    // const docSnap = await getDoc(busDoc);
    if (docSnap && docSnap.exists()) {
      // console.log('Document data:', docSnap.data());
      document.getElementById('favicon').href = docSnap.data().logo;
      document.getElementById('mainName2').innerHTML = docSnap.data().name;
      var value = docSnap.data();
      if (docSnap.data().enabled) {
        var polygon = [];
        var disablePolygon = [];
        var canDeliver = false;
        var dynamicFeeType = -1;
        var deliveryFee = 0;
        if (value['deliveryZones'] != null) {
          for (var j = 0; j < value['deliveryZones'].length; j++) {
            polygon = [];
            for (var i = 0; i < value['deliveryZones'][j]['area'].length; i++) {
              if (
                value['deliveryZones'][j]['area'][i]['latitude'] != null &&
                value['deliveryZones'][j]['area'][i]['longitude'] != null
              ) {
                polygon.push({
                  latitude: value['deliveryZones'][j]['area'][i]['latitude'],
                  longitude: value['deliveryZones'][j]['area'][i]['longitude'],
                });

                //print('added data');
              }
            }
            var canDeliverTemp = geolib.isPointInPolygon(
              this.state.selectedAddress,
              polygon
            );
            // console.log('delivery fee233 ' + canDeliverTemp.toString());
            if (canDeliverTemp && dynamicFeeType < 0 && deliveryFee <= 0) {
              canDeliver = true;
              this.setState({ canDeliverHere: true });
              // canDeliver = mp.PolygonUtil.containsLocation(
              //     selectedAddress, polygon, true);
              dynamicFeeType =
                value['deliveryZones'][j]['dynamicFeeType'] != null
                  ? value['deliveryZones'][j]['dynamicFeeType']
                  : 1;
              deliveryFee = value['deliveryZones'][j]['deliveryFee'] + 0.0;
              // console.log('delivery fee23 ' + deliveryFee.toString());
            } else if (canDeliverTemp) {
              canDeliver = true;
              this.setState({ canDeliverHere: true });
              if (deliveryFee >= value['deliveryZones'][j]['deliveryFee']) {
                dynamicFeeType =
                  value['deliveryZones'][j]['dynamicFeeType'] != null
                    ? value['deliveryZones'][j]['dynamicFeeType']
                    : 1;
                deliveryFee = value['deliveryZones'][j]['deliveryFee'] + 0.0;
                // console.log('delivery fee23 ' + deliveryFee.toString());
              }
            }

            //print('can deliver ID: ' + value['id']);

            // if (disablePolygon.length > 0 && !disableDelivery) {
            //   disableDelivery = mp.PolygonUtil.containsLocation(
            //       selectedAddress, disablePolygon, true);
            //   if (disableDelivery) {
            //     disableTime = value['disableArea2'][j]['disableTime'];
            //   }
            // }
          }
          // console.log('candeliver', canDeliver);
          var canDeliverHere2 = true;
          if (!canDeliver && value['canPickup'] != null && value['canPickup']) {
            this.setState({ selectedType: 2, selectedType2: 2 });
          } else if (!canDeliver) {
            this.setState({ canDeliverHere: false });
            canDeliverHere2 = false;
          }
          // if (canDeliver) {
          var disableTime = {
            start: {
              hour: 0,
              minute: 0,
            },
            end: {
              hour: 0,
              minute: 0,
            },
          };
          var disableDelivery = false;
          if (value['disableArea2'] != null) {
            for (var j = 0; j < value['disableArea2'].length; j++) {
              disablePolygon = [];
              for (
                var i = 0;
                i < value['disableArea2'][j]['area'].length;
                i++
              ) {
                if (
                  value['disableArea2'][j]['area'][i]['latitude'] != null &&
                  value['disableArea2'][j]['area'][i]['longitude'] != null
                ) {
                  disablePolygon.push({
                    latitude: value['disableArea2'][j]['area'][i]['latitude'],
                    longitude: value['disableArea2'][j]['area'][i]['longitude'],
                  });
                  //print('added data');
                }
              }

              //print('can deliver ID: ' + value['id']);

              if (disablePolygon.length > 0 && !disableDelivery) {
                disableDelivery = geolib.isPointInPolygon(
                  this.state.selectedAddress,
                  disablePolygon,
                  true
                );
                if (disableDelivery) {
                  disableTime = value['disableArea2'][j]['disableTime'];
                }
              }
            }
          }
          var isOpen;
          var toggledOff = false;
          if (value['available']) {
            // console.log(this.state.selectedWeekDay);
            if (value['schedule'][this.state.selectedWeekDay]['enabled']) {
              for (
                var i = 0;
                i <
                value['schedule'][this.state.selectedWeekDay]['lapses'].length;
                i++
              ) {
                //date = tz.TZDateTime.now(timezone);
                //print(date.hour);
                if (
                  value['schedule'][this.state.selectedWeekDay]['lapses'][i][
                    'open'
                  ]['hour'] < this.state.selectedDate.getHours() &&
                  value['schedule'][this.state.selectedWeekDay]['lapses'][i][
                    'close'
                  ]['hour'] > this.state.selectedDate.getHours()
                ) {
                  isOpen = true;
                } else if (
                  value['schedule'][this.state.selectedWeekDay]['lapses'][i][
                    'open'
                  ]['hour'] === this.state.selectedDate.getHours()
                ) {
                  if (
                    value['schedule'][this.state.selectedWeekDay]['lapses'][i][
                      'open'
                    ]['minute'] < this.state.selectedDate.getMinutes()
                  ) {
                    isOpen = true;
                  }
                } else if (
                  value['schedule'][this.state.selectedWeekDay]['lapses'][i][
                    'close'
                  ]['hour'] === this.state.selectedDate.getHours()
                ) {
                  if (
                    value['schedule'][this.state.selectedWeekDay]['lapses'][i][
                      'close'
                    ]['minute'] > this.state.selectedDate.getMinutes()
                  ) {
                    isOpen = true;
                  }
                }
              }
            }
            if (isOpen == null) isOpen = false;
          } else {
            isOpen = false;
            toggledOff = true;
          }
          if (isOpen && disableDelivery) {
            var date12 = this.state.selectedDate.getHours();
            var disableendhour = disableTime['end']['hour'];
            if (disableTime['start']['hour'] > disableendhour) {
              if (disableTime['start']['hour'] > date12) date12 = date12 + 24;
              disableendhour = disableendhour + 24;
            }
            if (
              disableTime['start']['hour'] < date12 &&
              disableendhour > date12
            ) {
              isOpen = false;
            } else if (disableTime['start']['hour'] === date12) {
              if (
                disableTime['start']['minute'] <
                this.state.selectedDate.getMinutes()
              ) {
                isOpen = false;
              }
            } else if (disableendhour === date12) {
              if (
                disableTime['end']['minute'] >
                this.state.selectedDate.getMinutes()
              ) {
                isOpen = false;
              }
            }
          }
          var cashOnly = false;
          if (value['cashOnly'] != null) {
            cashOnly = value['cashOnly'];
          }
          var cardOnly = false;
          if (value['cardOnly'] != null) {
            cardOnly = value['cardOnly'];
          }
          var spoon = false;
          var verified = false;
          var createdAt = 0;
          var offerEndTime = 0;
          var showOffer = false;
          var offerDesc = '';
          var partner = true;
          var cardOnDelivery = false;
          if (value['cardOnDelivery'] != null) {
            cardOnDelivery = value['cardOnDelivery'];
          }
          var mobilePayment = false;
          if (value['mobilePayment'] != null) {
            mobilePayment = value['mobilePayment'];
          }
          var cryptoPayment = false;
          if (value['cryptoPayment'] != null) {
            cryptoPayment = value['cryptoPayment'];
          }
          var minimumPurchase = 0;
          if (value['minimumPurchase'] != null) {
            minimumPurchase = value['minimumPurchase'] + 0.0;
          }
          var onlyInHouseDriver = false;
          if (value['onlyInHouseDriver'] != null) {
            onlyInHouseDriver = value['onlyInHouseDriver'];
          }
          var driverServiceFee = 0;
          if (value['driverServiceFee'] != null) {
            driverServiceFee = value['driverServiceFee'] + 0.0;
          }
          var driverServicePercentage = 0;
          if (value['driverServicePercentage'] != null) {
            driverServicePercentage = value['driverServicePercentage'] + 0.0;
          }
          var isCityDisable = false;
          if (value['isCityDisable'] != null) {
            isCityDisable = value['isCityDisable'];
          }
          var canPickup = false;
          if (value['canPickup'] != null) {
            canPickup = value['canPickup'];
          }
          if (value['partner'] != null) {
            partner = value['partner'];
          }
          if (value['verified'] != null) {
            verified = value['verified'];
          }
          if (value['spoon'] != null) {
            spoon = value['spoon'];
          }
          if (value['createdAt'] != null) {
            createdAt = value['createdAt'];
          }
          if (value['offerEndTime'] != null) {
            offerEndTime = value['offerEndTime'];
          }
          if (value['showOffer'] != null) {
            showOffer = value['showOffer'];
          }
          if (value['offerDesc'] != null) {
            offerDesc = value['offerDesc'];
          }
          if (
            (isOpen || (canPickup && toggledOff && !cashOnly)) &&
            canDeliverHere2
          ) {
            if (!isOpen) {
              console.log('candeliver2 ¢canDeliver');
              this.setState({
                onlyPickup: true,
                selectedType: 2,
                selectedType2: 2,
              });
            }
            this.setState({
              storeIsOpen: true,
              deliveryFee: deliveryFee,
              dynamicFeeType: dynamicFeeType,
            });
          } else {
            this.setState({
              storeIsOpen: false,
            });
          }
          console.log('DATA',isOpen,canPickup,toggledOff,cashOnly,canDeliverHere2,deliveryFee,dynamicFeeType);
          this.setState({ businessData: docSnap.data(), loading: true });
          this.setState((prevState) => ({
            cart: {
              ...prevState.cart, // copy all other key-value pairs of food object
              restId: id,
              restName: value['name'],
              restLogo: value['logo'],
            },
          }));
          var cityId =
            value['location'] != null && value['location']['cityId'] != null
              ? value['location']['cityId'].toString()
              : '0';
          console.log('cityId', cityId);
          const cityDoc = doc(db, 'cities', cityId);
          const docCitySn = onSnapshot(cityDoc, async (docCitySnap) => {
            var dynamicDelivery = false;
            var additionalDelivery = 0;
            var normalDelivery = 0;
            var additionalDeliveryPercentage2 = 0;
            var reasonTitle = '';
            var reasonDescription = '';
            if (docCitySnap.data()) {
              dynamicDelivery = docCitySnap.data()['dynamicDelivery'];
              if (dynamicFeeType === 1)
                additionalDeliveryPercentage2 =
                  docCitySnap.data()['deliveryPercentage'] + 0.0;
              else if (dynamicFeeType === 2)
                additionalDeliveryPercentage2 =
                  docCitySnap.data()['deliveryPercentage5'] + 0.0;
              else if (dynamicFeeType === 3)
                additionalDeliveryPercentage2 =
                  docCitySnap.data()['deliveryPercentage5plus'] + 0.0;
              else if (dynamicFeeType === 0)
                additionalDeliveryPercentage2 =
                  docCitySnap.data()['deliveryPercentageInit'] + 0.0;
              reasonTitle = docCitySnap.data()['reasonTitle'];
              reasonDescription = docCitySnap.data()['reasonDescription'];
              console.log(
                'additionalcharge: ' + additionalDeliveryPercentage2.toString()
              );
            }

            normalDelivery = deliveryFee;
            var delivery = 0;
            if (dynamicDelivery) {
              additionalDelivery =
                normalDelivery * (additionalDeliveryPercentage2 / 100) + 0.0;
              delivery = normalDelivery + additionalDelivery;
            } else {
              delivery = normalDelivery;
            }

            // if (this.state.selectedType === 2 || this.state.selectedType === 1) {
            //   delivery = 0;
            //   normalDelivery = 0;
            //   additionalDelivery = 0;
            // }
            console.log(
              'delivery',
              delivery,
              normalDelivery,
              dynamicDelivery,
              additionalDeliveryPercentage2,
              additionalDelivery
            );
            this.setState({
              delivery: delivery,
              dynamicDelivery: dynamicDelivery,
              additionalDelivery: additionalDelivery,
              normalDelivery: normalDelivery,
              additionalDeliveryPercentage2: additionalDeliveryPercentage2,
              reasonTitle: reasonTitle,
              reasonDescription: reasonDescription,
            });
          });
          if (value.cashOnly) {
            this.setState({
              defaultCard: {
                cardNumber: 'COD',
                recent: true,
              },
            });
          }
          const menuDoc = doc(db, 'business_menu', id);
          const docMenuSn = onSnapshot(menuDoc, async (docMenuSnap) => {
            if (docMenuSnap.data()) {
              console.log('Document data:', docMenuSnap.data().menu);

              var menus2 = docMenuSnap.data().menu;
              var menus3 = [];
              var offers = [];
              if (docMenuSnap.data().offers) {
                for (var i = 0; i < docMenuSnap.data().offers.length; i++) {
                  if (docMenuSnap.data()['offers'][i]['enabled']) {
                    offers.push(docMenuSnap.data()['offers'][i]);
                  }
                }
              }
              // menus2.splice(0, 0,{
              //   'enabled': true,
              //   'id': uuidv4(),
              //   'name': 'Discounts',
              //   'products': [],
              // });

              // for (var im = 0; im < menus2.length; im++) {
              //   for (var jm = 0; jm < menus2[im]['products'].length; jm++) {
              //     if(menus2[im]['products'][jm]['discountPercentage']!=null && menus2[im]['products'][jm]['discountPercentage']>0 && moment().isBefore(moment(menus2[im]['products'][jm]['discountedTill'].toDate())))
              //       menus2[0]['products'].add(menus2[im]['products'][jm]);
              //   }
              // }
              // if(menus2[0]['products'].length<=0) {
              //   menus2.splice(0, 1);
              // }
              for (var i = 0; i < menus2.length; i++) {
                // print(menus2[i]['willBeAvailableAt']!=null);
                // if(menus2[i]['willBeAvailableAt']!=null)
                // print(DateTime.now().compareTo(menus2[i]['willBeAvailableAt'].toDate()));
                if (
                  menus2[i]['products'] != null &&
                  this.getTimings(menus2[i]['schedule']) &&
                  (menus2[i]['enabled'] ||
                    (!menus2[i]['enabled'] &&
                      menus2[i]['willBeAvailableAt'] != null &&
                      moment().isAfter(
                        moment(menus2[i]['willBeAvailableAt'].toDate())
                      )))
                ) {
                  console.log(menus2[i]['name']);
                  menus3.push(menus2[i]);
                  // menuitems.add(
                  //   MenuItem(
                  //     title: ((menus2[i]['nameEng']!=null && context.locale == Locale('en'))?menus2[i]['nameEng']:menus2[i]['name']).toString(),
                  //     titleColor: textColor,
                  //     backgroundColor: textFieldColor,
                  //     //child: Icon(Icons.accessibility, color: Colors.black),
                  //     subtitle: "",
                  //     subTitleColor: textColor,
                  //     onTap: () =>
                  //         _scrollController.scrollTo(
                  //           index: i + 3,
                  //           alignment: MediaQuery
                  //               .of(context)
                  //               .size
                  //               .height * 0.0125 * 0.025,
                  //           duration: Duration(milliseconds: 200),
                  //         ),
                  //   ),
                  // );
                  // print(menuitems.length);
                } else {
                }
              }
              this.setState({
                menuData: menus3.map(item => ({...item})),
                menu: menus3,
                offers: offers,
                loading:false,
              });
            } else {
              this.setState({
                loading:false,
              });
              // doc.data() will be undefined in this case
              console.log('No such document!');
            }
          });
          // }
        }
      }
    } else {
      // doc.data() will be undefined in this case
      console.log('No such document!');
    }
    //return cityList;
  }

  async componentWillMount() {
    var locationData = JSON.parse(localStorage.getItem('location'));
    if (locationData == null) {
      locationData = [];
    }
    for (var i = 0; i < locationData.length; i++) {
      if (locationData[i]['selected']) {
        this.setState({
          selectLocationName: locationData[i]['geoAddress'],
        });
        console.log(locationData[i]);
        break;
      }
    }
    this.setState({ addresses: locationData }, (newState) => {
      console.log(
        'locationData',
        this.state.addresses,
        typeof this.state.addresses
      );
    });
    var selected = JSON.parse(localStorage.getItem('selected'));
    if (selected == null) {
      selected = { latitude: 0, longitude: 0 };
    }
    this.setState({ selectedAddress: selected }, (newState) => {
      console.log(
        'selectedAddress',
        this.state.selectedAddress,
        typeof this.state.selectedAddress
      );
    });
    console.log('locationData', locationData);
    const { id } = this.props.match.params;
    var date2 = new Date();
    var weekDay = [6,0,1,2,3,4,5];
    var currentDay = weekDay[date2.getDay()];
    this.setState({ selectedDate: date2, selectedWeekDay: currentDay, busId: id });
    // this.setState({ businessData: {} });
    this.listMaker();
    await this.getCities(id);
  }

  async listMaker() {
    var date2 = new Date();
    var weekDay = [6,0,1,2,3,4,5];
    var currentDay = weekDay[date2.getDay()];
    var currenciesList3 = this.state.currenciesList3;
    var currenciesList2 = this.state.currenciesList2;
    var currenciesList = this.state.currenciesList;
        // await preOrder.put('isTomorrow', isTomorrow);
    // await preOrder.put('isPreOrder', isPreOrder);
    // await preOrder.put('selectedWeekDay', currentDay);
    // await preOrder.put('selectedDate', selected);
    var current = moment(new Date()).add(45, 'm').toDate();
    //List timing = [];
    console.log(current);
    var startHour = current.getHours();
    var startMinute = current.getMinutes();
    if (startMinute !== 0 || startMinute !== 30) {
      if (startMinute < 30) {
        startMinute = 30;
      } else if (startMinute < 60) {
        startMinute = 0;
        startHour = startHour + 1;
      }
    }
    //print(startHour);
    //print(startMinute);
    for (var i = startHour; startHour <= 23; i++) {
      var addition = '';
      var addTime = new Date();
      addTime.setFullYear(current.getFullYear());
      addTime.setMonth(current.getMonth());
      addTime.setDate(current.getDate());
      addTime.setHours(startHour);
      addTime.setMinutes(startMinute);
      addTime = moment(addTime).add(-40, 'm').toDate();
      //addTime = DateTime(current.year,current.month,current.day,startHour,startMinute).add(Duration(minutes:-45));
      // var timezone = tz.getLocation('America/Mexico_City');
      // addTime = tz.TZDateTime(timezone, current.year, current.month,
      //         current.day, startHour, startMinute)
      //     .add(Duration(minutes: -40));
      if (startMinute === 0) {
        addition = addition +
            startHour.toString() +
            ':' +
            startMinute.toString() +
            '0 - ';

        startMinute = 30;
        addition =
            addition + startHour.toString() + ':' + startMinute.toString();
      } else {
        addition = addition +
            startHour.toString() +
            ':' +
            startMinute.toString() +
            ' - ';
        startMinute = 0;
        startHour = startHour + 1;
        addition = addition +
            startHour.toString() +
            ':' +
            startMinute.toString() +
            '0';
      }
      addition = addition.replaceAll('24', '00');
      //print(addition);
      //print(addTime);
      currenciesList.push({'display': addition, 'date': addTime});
    }
    //print(currenciesList);

    var current2 = moment(new Date()).add(45, 'm').toDate();
    //List timing = [];
    //print(current2);
    var startHour2 = 0;
    var startMinute2 = 0;
    if (startMinute2 !== 0 || startMinute2 !== 30) {
      if (startMinute2 < 30) {
        startMinute2 = 30;
      } else if (startMinute2 < 60) {
        startMinute2 = 0;
        startHour2 = startHour2 + 1;
      }
    }
    //print(startHour2);
    //print(startMinute2);
    for (var i = startHour2; startHour2 <= 23; i++) {
      var addition = '';
      var addTime = new Date();
      addTime.setFullYear(current2.getFullYear());
      addTime.setMonth(current2.getMonth());
      addTime.setDate(current2.getDate()+1);
      addTime.setHours(startHour2);
      addTime.setMinutes(startMinute2);
      addTime = moment(addTime).add(-40, 'm').toDate();
      //addTime = DateTime(current2.year,current2.month,current2.day+1,startHour2,startMinute2).add(Duration(minutes:-45));
      // var timezone = tz.getLocation('America/Mexico_City');
      // addTime = tz.TZDateTime(timezone, current2.year, current2.month,
      //         current2.day + 1, startHour2, startMinute2)
      //     .add(Duration(minutes: -40));
      if (startMinute2 === 0) {
        addition = addition +
            startHour2.toString() +
            ':' +
            startMinute2.toString() +
            '0 - ';

        startMinute2 = 30;
        addition =
            addition + startHour2.toString() + ':' + startMinute2.toString();
      } else {
        addition = addition +
            startHour2.toString() +
            ':' +
            startMinute2.toString() +
            ' - ';
        startMinute2 = 0;
        startHour2 = startHour2 + 1;
        addition = addition +
            startHour2.toString() +
            ':' +
            startMinute2.toString() +
            '0';
      }
      addition = addition.replaceAll('24', '00');
      //print(addition);
      //print(addTime);
      currenciesList3.push({'display': addition, 'date': addTime});
      currenciesList2 = [
        //{'title': 'ahora','date':tz.TZDateTime.now(timezone),'id':1},
        {'title': strings['hoy'], 'date': new Date(), 'id': 1},
        {
          'title': strings['mańana'],
          'date': moment(new Date()).add(1, 'd').toDate(),
          'id': 2
        },
      ];
    }
    this.setState(
      {
        currenciesList2: currenciesList2,
        currenciesList3: currenciesList3,
        currenciesList: currenciesList,
        currenciesList2Selected: 0,
        currenciesList3Selected: 0,
        currenciesListSelected: 0
      }
    );
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this._ismounted = true;
    this.setState({isMounted: true});
    const { id } = this.props.match.params;
    let localCartState = localStorage.getItem('cart_state');
    localCartState = JSON.parse(localCartState);
    this.setState({ cart: (localCartState && localCartState.restId === id) ? localCartState : this.state.cart });
    Events.scrollEvent.register('begin', function (to, element) {
      console.log('begin', arguments);
    });

    Events.scrollEvent.register('end', function (to, element) {
      console.log('end', arguments);
    });

    scrollSpy.update();
  }

  componentWillUnmount() {
    this._ismounted = false;
    this.setState({isMounted: false});
    // console.log('IT IS UNDONE');
    window.removeEventListener('resize', this.updateWindowDimensions);
    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    localStorage.setItem('cart_state', JSON.stringify(this.state.cart));
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  getTimings(schedule) {
    //print(schedule);
    var days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    var isOpen;
    if (schedule != null) {
      // var date2 = new Date();
      // var weekDay = [6,0,1,2,3,4,5];
      // var currentDay = weekDay[date2.getDay()];
      // this.setState({ selectedDate: date2, selectedWeekDay: currentDay });
      if (schedule[this.state.selectedWeekDay]['enabled']) {
        for (
          var i = 0;
          i < schedule[this.state.selectedWeekDay]['lapses'].length;
          i++
        ) {
          //selectedDate = tz.TZDateTime.now(timezone);
          if (
            schedule[this.state.selectedWeekDay]['lapses'][i]['open']['hour'] <
              this.state.selectedDate.getHours() &&
            schedule[this.state.selectedWeekDay]['lapses'][i]['close']['hour'] >
              this.state.selectedDate.getHours()
          ) {
            isOpen = true;
          } else if (
            schedule[this.state.selectedWeekDay]['lapses'][i]['open'][
              'hour'
            ] === this.state.selectedDate.getHours()
          ) {
            if (
              schedule[this.state.selectedWeekDay]['lapses'][i]['open'][
                'minute'
              ] < this.state.selectedDate.getMinutes()
            ) {
              isOpen = true;
            }
          } else if (
            schedule[this.state.selectedWeekDay]['lapses'][i]['close'][
              'hour'
            ] === this.state.selectedDate.getHours()
          ) {
            if (
              schedule[this.state.selectedWeekDay]['lapses'][i]['close'][
                'minute'
              ] > this.state.selectedDate.getMinutes()
            ) {
              isOpen = true;
            }
          }
        }
      }
      if (isOpen == null) isOpen = false;
    } else {
      isOpen = true;
    }
    // print('isOpen ¢isOpen');
    return isOpen;
  }

  handleChange(e) {
    // var menuD = JSON.parse(JSON.stringify(this.state.menuData));
    var menuD = this.state.menuData.map(item => ({...item}))
    for (var i = 0; i < menuD.length; i++) {
      menuD[i]['products'] = menuD[i]['products'].filter(
        (val) =>
          typeof val.name === 'string' &&
          val.name.toLowerCase().includes(e.target.value.toLowerCase())
      );
      // console.log(
      //   'handle change called',
      //   e.target.value,
      //   i,
      //   menuD[i]['products'].length
      // );
    }
    this.setState({ menu: menuD });
  }
  handleSetActive(to) {
    document.getElementById(to).scrollIntoView({ block: 'nearest' });
  }

  render() {
    const getStat = (order) => {
      var update = '';
      if (!order['acceptedByRest']) {
        update = strings['Esperando a que el negocio acepte su pedido'];
      }
      if (order['acceptedByRest'] && !order['readyToBePicked']) {
        update = strings['El negocio está preparando su producto.'];
      }
      // if (order['acceptedByRest'] && order['readyToBePicked']) {
      //   update = 'Orden lista para recolección ';
      // }
      if (
        order['driverAssigned'] &&
        !order['driverReached'] &&
        !order['orderPickedUp']
      ) {
        update =
          order['driverName'].split(' ')[0] +
          strings[' está en camino para recoger su pedido'];
      }
      if (
        order['driverAssigned'] &&
        order['driverReached'] &&
        !order['orderPickedUp']
      ) {
        update =
          order['driverName'].split(' ')[0] + strings[' llegó al negocio'];
      }

      if (order['orderPickedUp']) {
        update =
          order['driverName'].split(' ')[0] + strings[' ha recogido tu pedido'];
      }
      if (order['delivered'] && !order['cancelled']) {
        update = strings['Su orden ha sido completada'];
      }
      if (order['delivered'] && order['cancelled']) {
        update = strings['Su pedido ha sido cancelado'];
      }
      return update;
    };

    const getTimings = (schedule) => {
      //print(schedule);
      var days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ];
      var isOpen;
      if (schedule != null) {
        // var date2 = new Date();
        // var weekDay = [6,0,1,2,3,4,5];
        // var currentDay = weekDay[date2.getDay()];
        // this.setState({ selectedDate: date2, selectedWeekDay: currentDay });
        if (schedule[this.state.selectedWeekDay]['enabled']) {
          for (
            var i = 0;
            i < schedule[this.state.selectedWeekDay]['lapses'].length;
            i++
          ) {
            //selectedDate = tz.TZDateTime.now(timezone);
            if (
              schedule[this.state.selectedWeekDay]['lapses'][i]['open'][
                'hour'
              ] < this.state.selectedDate.getHours() &&
              schedule[this.state.selectedWeekDay]['lapses'][i]['close'][
                'hour'
              ] > this.state.selectedDate.getHours()
            ) {
              isOpen = true;
            } else if (
              schedule[this.state.selectedWeekDay]['lapses'][i]['open'][
                'hour'
              ] === this.state.selectedDate.getHours()
            ) {
              if (
                schedule[this.state.selectedWeekDay]['lapses'][i]['open'][
                  'minute'
                ] < this.state.selectedDate.getMinutes()
              ) {
                isOpen = true;
              }
            } else if (
              schedule[this.state.selectedWeekDay]['lapses'][i]['close'][
                'hour'
              ] === this.state.selectedDate.getHours()
            ) {
              if (
                schedule[this.state.selectedWeekDay]['lapses'][i]['close'][
                  'minute'
                ] > this.state.selectedDate.getMinutes()
              ) {
                isOpen = true;
              }
            }
          }
        }
        if (isOpen == null) isOpen = false;
      } else {
        isOpen = true;
      }
      // print('isOpen ¢isOpen');
      return isOpen;
    };
    const sendOTP = async (phone) => {
      const min = 0;
      const max = 999999;
      const rand = Math.floor(min + Math.random() * (max - min));
      var dataSend = rand.toString();
      for (var i = 0; i < 6; i++) {
        if (dataSend.length < 6) {
          dataSend = '0' + dataSend;
        }
      }
      // console.log(dataSend, phone);
      this.setState({ otpSend: dataSend });
      await axios
        .post('https://lemon-order.herokuapp.com/drivers/create-otp/', {
          code: dataSend,
          number: phone,
        })
        .then(async (response) => {
          // console.log(response);
        });
    };
    const isMenuOpen = Boolean(this.state.anchorEl);
    const isMobileMenuOpen = Boolean(this.state.mobileMoreAnchorEl);
    const handleProfileMenuOpen = (event) => {
      // setAnchorEl(event.currentTarget);
      this.setState({ anchorEl: event.currentTarget });
      // this.state.anchorEl = event.currentTarget;
    };

    const handleCartOpen = (event) => {
      console.log('minimumPurchase',this.state.businessData.minimumPurchase);
      if(this.state.businessData.minimumPurchase==null || this.state.businessData.minimumPurchase<=this.state.cart['totalCost']) {
      var locationData = this.state.addresses;
      for (var i = 0; i < locationData.length; i++) {
        if (locationData[i]['selected']) {
          this.setState({
            selectedLocation: locationData[i],
            selectedLocationName: locationData[i]['name'],
            selectedLocationData: locationData[i]['geoAddress'],
            selectedLocationNotes: locationData[i]['addressNotes'],
          });
          // console.log(locationData[i]);
          break;
        }
      }
      // setAnchorEl(event.currentTarget);
      this.setState({
        showCart: true,
        additionalInfoAdded: false,
        order: {
          offerCode: '',
          selectedOffer: {},
          offerId: '',
          offerValue: 0,
          cashbackValue: 0,
          offerCode2: '',
          offerId2: '',
          offerValue2: 0,
          restId: '',
          restName: '',
          restLogo: '',
          maxTime: 0,
          itemCost: 0,
          deliveryCharge: 0,
          usageFee: 0,
          taxes: 0,
          serviceFee: 0,
          grandTotal: 0,
          items: [],
        },
        offerCode: '',
        selectedOffer: null,
        offerId: '',
        offerSuccess: '',
        offerErrorText: '',
        offerValue: 0,
        cashbackValue: 0,
        offerInd: null,
        defaultCard: null,
        isOfferApplied: false,
        isOfferError: false,
        isFreeDelivery: false,
        cookingInstructions: '',
        deliveryInstructions: '',
        showDiscountIsBusiness: false,
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        this.setState({ showCart: false });
      };
    } else{
      this.setState({
        showMinimum: true,
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        this.setState({ showMinimum: false });
      };
    }
      // this.state.anchorEl = event.currentTarget;
    };

    const handleAlertOpen = (event) => {
      this.setState({
        openDialogAlert: true,
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        this.setState({ openDialogAlert: false });
      };
    };

    const handleAllergyOpen = (event) => {
      this.setState({
        showAllergy: true,
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        this.setState({ showAllergy: false });
      };
      // this.state.anchorEl = event.currentTarget;
    };

    const handleTrackingOpen = (orderDetails, id) => {
      // setAnchorEl(event.currentTarget);
      this.setState({
        showTracking: true,
        trackingDetails: orderDetails,
        trackingId: id,
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        this.setState({
          showTracking: false,
          trackingDetails: null,
          trackingId: null,
        });
      };
      // this.state.anchorEl = event.currentTarget;
    };

    const handleClearCart = () => {
      this.setState({
        showCart: false,
        additionalInfoAdded: false,
        cart: {
          ...this.state.cart,
          item: [],
          totalItems: 0,
          totalCost: 0,
          totalOxxoCost: 0,
          totalOxxoItems: 0,
        },
      });
      localStorage.removeItem('cart_state');
    };

    const getPrimaryColor = () => {
      if (
        this.state.businessData &&
        this.state.businessData?.primaryColor &&
        this.state.businessData.primaryColor != ''
      ) {
        return this.state.businessData.primaryColor;
      }

      return '#01d262';
    };

    const handleMobileMenuClose = () => {
      // setMobileMoreAnchorEl(null);
      this.setState({ mobileMoreAnchorEl: null });
    };

    const handleMenuClose = () => {
      this.setState({ anchorEl: null });
      handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
      this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
      <>
        {!this.state.userId ? (
          <Menu
            anchorEl={this.state.anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => {
                handleMenuClose();
                handleClickOpenLogin();
              }}
            >
            <Stack
                 direction="row"
                 justifyContent="center"
                 alignItems="center"
                 spacing={0}
                >
                <LoginRoundedIcon
                   style={{
                     height: '17px',
                     fontSize: '17px',
                     fontWeight: 'bold',
                     color: getPrimaryColor(),
                     marginRight: '10px',
                   }}
                 />
                <Typography
                 style={{
                   fontWeight: '700',
                   fontFamily: 'Nunito',
                   textTransform: 'none',
                   padding: '5px 11px',
                   color: '#3e4547',
                 }}
               >
                 {strings["Iniciar sesión"]}
               </Typography>
              </Stack>
            </MenuItem>
            <MenuItem
                onClick={() => {
                  handleMenuClose();
                  handleClickOpenRegister();
                  // handleClickOpenOTP();
                }}
              >
              <Stack
                   direction="row"
                   justifyContent="center"
                   alignItems="center"
                   spacing={0}
                  >
                  <DataSaverOnRoundedIcon
                     style={{
                       height: '17px',
                       fontSize: '17px',
                       fontWeight: 'bold',
                       color: getPrimaryColor(),
                       marginRight: '10px',
                     }}
                   />
                  <Typography
                   style={{
                     fontWeight: '700',
                     fontFamily: 'Nunito',
                     textTransform: 'none',
                     padding: '5px 11px',
                     color: '#3e4547',
                   }}
                 >
                   {strings["Registrarse"]}
                 </Typography>
                </Stack>
            </MenuItem>
          </Menu>
        ) : (
          <Menu
            anchorEl={this.state.anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
          >
            {this.state.userDetails && (
              <>
                <MenuItem
                  onClick={async () => {
                    handleMenuClose();
                  }}
                >
                  <Link
                    to={'/profile/'+this.state.busId}
                    style={{
                      color: '#444444',
                      textDecoration: 'none',
                      width: '100%',
                    }}
                  >
                    {strings['Perfil']}
                  </Link>
                </MenuItem>
              </>
            )}
            <MenuItem
              onClick={async () => {
                handleMenuClose();
                await auth.signOut();
              }}
            >
              {strings['Cerrar sesión']}
            </MenuItem>
          </Menu>
        )}
      </>
    );
    // const renderMenu = (
    //   <Menu
    //     anchorEl={this.state.anchorEl}
    //     anchorOrigin={{
    //       vertical: 'top',
    //       horizontal: 'right',
    //     }}
    //     id={menuId}
    //     keepMounted
    //     transformOrigin={{
    //       vertical: 'top',
    //       horizontal: 'right',
    //     }}
    //     open={isMenuOpen}
    //     onClose={handleMenuClose}
    //   >
    //   { (this.state.userId)?<><MenuItem onClick={async()=>{handleMenuClose();
    //   await auth.signOut();
    //   }}>Log Out</MenuItem></>: <><MenuItem onClick={()=>{handleMenuClose();
    //   handleClickOpenLogin();
    //   }}>Login</MenuItem><MenuItem onClick={()=>{handleMenuClose();
    //   handleClickOpenRegister();
    //   // handleClickOpenOTP();
    //   }}>Register</MenuItem></>}
    //   </Menu>
    // );
    const handleClickOpen = () => {
      this.setState({ openLocation: true });
      this.setState({ hasClickedLoc: false });
      this.setState({
        selectLocationData: {
          id: '',
          name: strings['mi hogar'],
          address: '',
          geoAddress: '',
          addressNotes: '',
          latitude: this.state.defaultProps.center.lat,
          longitude: this.state.defaultProps.center.lng,
        },
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        handleClose();
      };
    };
    const handlePreOrderOpen = () => {
      this.setState({ openPreOrder: true,      showTomorrow: false,
        selectedPreOrder: (this.state.showTomorrow)?this.state.currenciesList3[this.state.currenciesList3Selected]['date']:(this.state.currenciesList && (this.state.currenciesList.length - 1)>=this.state.currenciesListSelected)?this.state.currenciesList[this.state.currenciesListSelected]['date']:this.state.currenciesList3[this.state.currenciesList3Selected]['date'] });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        handlePreOrderClose();
      };
    };

    const handleClickAddCardOpen = () => {
      this.setState({ openAddCard: true,newCard: {
        cardNo: '',
        cvv:'',
        month: '',
        year: '',
        expiry: '',
        name: ''
      } });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        handleAddCardClose();
      };
    };

    const multiFactor = () => {
      var factor = 1.0;
      if(this.state.selectedType < 2) {
        if(this.state.businessData.enableIncrease != null &&
            this.state.businessData.enableIncrease && this.state.businessData.increasePercentage != null &&
            this.state.businessData.increasePercentage) {
              factor = 1 + (this.state.businessData.increasePercentage/ 100);
            }
      }
      return factor;
    }

        const getOriginal = () => {
      var returnValue = 0.0;
      var cart =  this.state.cart;
      for(var i=0;i<cart['item'].length;i++) {
      if(cart['item'][i]['originalPrice']!=null) {
        returnValue = returnValue + (cart['item'][i]['originalPrice'] * cart['item'][i]['quantity']) + 0.0;
      } else {
        returnValue = returnValue + (cart['item'][i]['price'] * cart['item'][i]['quantity']) + 0.0;
      }
    }
      return returnValue;
    }

    const handleClickOpenVariable = (product) => {
      if (product['customize'] != null) {
        // console.log(product);
        var productIds = [];
        var tempOrder = {
          name: product['name'],
          time: product['averageTime'],
          id: product['id'],
          originalPrice:
            this.state.businessData.partner != null &&
            this.state.businessData.partner
              ? product['discountPercentage'] != null &&
                product['discountPercentage'] > 0 &&
                moment().isBefore(moment(product['discountedTill'].toDate()))
                ? product['price'] -
                  (product['price'] * product['discountPercentage']) / 100
                : product['price']
              : (product['discountPercentage'] != null &&
                product['discountPercentage'] > 0 &&
                moment().isBefore(moment(product['discountedTill'].toDate()))
                  ? product['price'] -
                    (product['price'] * product['discountPercentage']) / 100
                  : product['price']) +
                (product['discountPercentage'] != null &&
                product['discountPercentage'] > 0 &&
                moment().isBefore(moment(product['discountedTill'].toDate()))
                  ? product['price'] -
                    (product['price'] * product['discountPercentage']) / 100
                  : product['price']) *
                  (this.state.businessData.tax / 100),
          price:
            Number(((this.state.businessData.partner != null &&
            this.state.businessData.partner
              ? product['discountPercentage'] != null &&
                product['discountPercentage'] > 0 &&
                moment().isBefore(moment(product['discountedTill'].toDate()))
                ? product['price'] -
                  (product['price'] * product['discountPercentage']) / 100
                : product['price']
              : (product['discountPercentage'] != null &&
                product['discountPercentage'] > 0 &&
                moment().isBefore(moment(product['discountedTill'].toDate()))
                  ? product['price'] -
                    (product['price'] * product['discountPercentage']) / 100
                  : product['price']) +
                (product['discountPercentage'] != null &&
                product['discountPercentage'] > 0 &&
                moment().isBefore(moment(product['discountedTill'].toDate()))
                  ? product['price'] -
                    (product['price'] * product['discountPercentage']) / 100
                  : product['price']) *
                  (this.state.businessData.tax / 100)) * multiFactor()).toFixed((multiFactor()>1)?0:2)),
          quantity: 1,
          addons: 0,
        };
        for (var j = 0; j < product['customize'].length; j++) {
          // print(menus2[i -
          //     3]['products'][index]['customize'][j]['conditionOption']);
          if (
            (product['customize'][j]['enabled'] ||
              (!product['customize'][j]['enabled'] &&
                product['customize'][j]['willBeAvailableAt'] != null &&
                moment().isAfter(
                  moment(product['customize'][j]['willBeAvailableAt'].toDate())
                ))) &&
            (product['customize'][j]['conditioned'] == null ||
              !product['customize'][j]['conditioned'] ||
              (product['customize'][j]['conditioned'] != null &&
                product['customize'][j]['conditioned'] &&
                productIds.includes(
                  product['customize'][j]['conditionOption']
                )))
          ) {
            if (
              product['customize'][j]['min'] != null &&
              (tempOrder['customize'] == null ||
                tempOrder['customize'].length === j ||
                tempOrder['customize'][j]['options'].length <
                  product['customize'][j]['min'])
            ) {
              //print('hee');
              if (product['customize'][j]['min'] === 0) {
                if (tempOrder['customize'] == null) {
                  //print('heedd');
                  tempOrder['customize'] = [
                    {
                      name: product['customize'][j]['name'],
                      id: product['customize'][j]['id'],
                      options: [],
                    },
                  ];
                } else if (tempOrder['customize'].length === j) {
                  tempOrder['customize'].push({
                    name: product['customize'][j]['name'],
                    id: product['customize'][j]['id'],
                    options: [],
                  });
                  //                                                                                                } else if(tempOrder['customize'][j]['options'].find((tord)=> tord['id'].contains(restaurant[0]
                  //                                                                                                    .menu[i -
                  //                                                                                                    3]['products'][index]['customize'][j]['options'][temp]['id']))){
                  //                                                                                                  setState(() {
                  //                                                                                                    tempOrder['price'] = tempOrder['price'] + restaurant[0]
                  //                                                                                                        .menu[i -
                  //                                                                                                        3]['products'][index]['customize'][j]['options'][temp]['price'];
                  //                                                                                                    tempOrder['addons'] = tempOrder['addons'] + 1;
                  //                                                                                                  });
                }
              }
              for (
                var temp = 0;
                temp < product['customize'][j]['min'];
                temp++
              ) {
                //                                                                                                restaurant[0]
                //                                                                                                    .menu[i -
                //                                                                                                    3]['products'][index]['customize'][j]['options'][temp]['selected'] =
                //                                                                                                true;
                if (tempOrder['customize'] == null) {
                  //print('heedd');
                  tempOrder['customize'] = [
                    {
                      name: product['customize'][j]['name'],
                      id: product['customize'][j]['id'],
                      options: [
                        {
                          name: product['customize'][j]['options'][temp][
                            'name'
                          ],
                          id: product['customize'][j]['options'][temp]['id'],
                          originalPrice:
                            this.state.businessData.partner != null &&
                            this.state.businessData.partner
                              ? product['customize'][j]['options'][temp][
                                  'price'
                                ]
                              : product['customize'][j]['options'][temp][
                                  'price'
                                ] +
                                product['customize'][j]['options'][temp][
                                  'price'
                                ] *
                                  (this.state.businessData.tax / 100),
                          price:
                            Number(((this.state.businessData.partner != null &&
                            this.state.businessData.partner
                              ? product['customize'][j]['options'][temp][
                                  'price'
                                ]
                              : product['customize'][j]['options'][temp][
                                  'price'
                                ] +
                                product['customize'][j]['options'][temp][
                                  'price'
                                ] *
                                  (this.state.businessData.tax / 100)) * multiFactor()).toFixed(multiFactor()>1?0:2)),
                        },
                      ],
                    },
                  ];
                  productIds.push(
                    product['customize'][j]['options'][temp]['id']
                  );
                  tempOrder['price'] =
                    tempOrder['price'] +
                    Number(((this.state.businessData.partner != null &&
                    this.state.businessData.partner
                      ? product['customize'][j]['options'][temp]['price']
                      : product['customize'][j]['options'][temp]['price'] +
                        product['customize'][j]['options'][temp]['price'] *
                          (this.state.businessData.tax / 100))* multiFactor()).toFixed(multiFactor()>1?0:2));
                          tempOrder['originalPrice'] =
                    tempOrder['originalPrice'] +
                    (this.state.businessData.partner != null &&
                    this.state.businessData.partner
                      ? product['customize'][j]['options'][temp]['price']
                      : product['customize'][j]['options'][temp]['price'] +
                        product['customize'][j]['options'][temp]['price'] *
                          (this.state.businessData.tax / 100));
                  tempOrder['addons'] = tempOrder['addons'] + 1;
                } else if (tempOrder['customize'].length === j) {
                  tempOrder['customize'].push({
                    name: product['customize'][j]['name'],
                    id: product['customize'][j]['id'],
                    options: [
                      {
                        name: product['customize'][j]['options'][temp]['name'],
                        id: product['customize'][j]['options'][temp]['id'],
                        originalPrice:
                          this.state.businessData.partner != null &&
                          this.state.businessData.partner
                            ? product['customize'][j]['options'][temp]['price']
                            : product['customize'][j]['options'][temp][
                                'price'
                              ] +
                              product['customize'][j]['options'][temp][
                                'price'
                              ] *
                                (this.state.businessData.tax / 100),
                        price:
                          Number(((this.state.businessData.partner != null &&
                          this.state.businessData.partner
                            ? product['customize'][j]['options'][temp]['price']
                            : product['customize'][j]['options'][temp][
                                'price'
                              ] +
                              product['customize'][j]['options'][temp][
                                'price'
                              ] *
                                (this.state.businessData.tax / 100))* multiFactor()).toFixed(multiFactor()>1?0:2)),
                      },
                    ],
                  });
                  //                                                                                                } else if(tempOrder['customize'][j]['options'].find((tord)=> tord['id'].contains(restaurant[0]
                  //                                                                                                    .menu[i -
                  //                                                                                                    3]['products'][index]['customize'][j]['options'][temp]['id']))){
                  productIds.push(
                    product['customize'][j]['options'][temp]['id']
                  );
                  tempOrder['price'] =
                    tempOrder['price'] +
                    Number(((this.state.businessData.partner != null &&
                    this.state.businessData.partner
                      ? product['customize'][j]['options'][temp]['price']
                      : product['customize'][j]['options'][temp]['price'] +
                        product['customize'][j]['options'][temp]['price'] *
                          (this.state.businessData.tax / 100))* multiFactor()).toFixed(multiFactor()>1?0:2));
                  tempOrder['originalPrice'] =
                    tempOrder['originalPrice'] +
                    (this.state.businessData.partner != null &&
                    this.state.businessData.partner
                      ? product['customize'][j]['options'][temp]['price']
                      : product['customize'][j]['options'][temp]['price'] +
                        product['customize'][j]['options'][temp]['price'] *
                          (this.state.businessData.tax / 100));
                  tempOrder['addons'] = tempOrder['addons'] + 1;
                  //                                                                                                  setState(() {
                  //                                                                                                    tempOrder['price'] = tempOrder['price'] + restaurant[0]
                  //                                                                                                        .menu[i -
                  //                                                                                                        3]['products'][index]['customize'][j]['options'][temp]['price'];
                  //                                                                                                    tempOrder['addons'] = tempOrder['addons'] + 1;
                  //                                                                                                  });
                } else {
                  tempOrder['customize'][j]['options'].push({
                    name: product['customize'][j]['options'][temp]['name'],
                    id: product['customize'][j]['options'][temp]['id'],
                    originalPrice:
                      this.state.businessData.partner != null &&
                      this.state.businessData.partner
                        ? product['customize'][j]['options'][temp]['price']
                        : product['customize'][j]['options'][temp]['price'] +
                          product['customize'][j]['options'][temp]['price'] *
                            (this.state.businessData.tax / 100),
                    price:
                      Number(((this.state.businessData.partner != null &&
                      this.state.businessData.partner
                        ? product['customize'][j]['options'][temp]['price']
                        : product['customize'][j]['options'][temp]['price'] +
                          product['customize'][j]['options'][temp]['price'] *
                            (this.state.businessData.tax / 100))* multiFactor()).toFixed(multiFactor()>1?0:2)),
                  });

                  productIds.push(
                    product['customize'][j]['options'][temp]['id']
                  );
                  tempOrder['price'] =
                    tempOrder['price'] +
                    Number(((this.state.businessData.partner != null &&
                    this.state.businessData.partner
                      ? product['customize'][j]['options'][temp]['price']
                      : product['customize'][j]['options'][temp]['price'] +
                        product['customize'][j]['options'][temp]['price'] *
                          (this.state.businessData.tax / 100))* multiFactor()).toFixed(multiFactor()>1?0:2));
                  tempOrder['originalPrice'] =
                    tempOrder['originalPrice'] +
                    (this.state.businessData.partner != null &&
                    this.state.businessData.partner
                      ? product['customize'][j]['options'][temp]['price']
                      : product['customize'][j]['options'][temp]['price'] +
                        product['customize'][j]['options'][temp]['price'] *
                          (this.state.businessData.tax / 100));
                  tempOrder['addons'] = tempOrder['addons'] + 1;
                  //                                                                                                  setState(() {
                  //                                                                                                    tempOrder['price'] = tempOrder['price'] + restaurant[0]
                  //                                                                                                        .menu[i -
                  //                                                                                                        3]['products'][index]['customize'][j]['options'][temp]['price'];
                  //                                                                                                    tempOrder['addons'] = tempOrder['addons'] + 1;
                  //                                                                                                  });
                }
                //print(tempOrder);
              }
            }
          } else {
            if (tempOrder['customize'] == null) {
              //print('heedd');
              tempOrder['customize'] = [
                {
                  name: product['customize'][j]['name'],
                  id: product['customize'][j]['id'],
                  options: [],
                },
              ];
              // Future.delayed(Duration.zero, () {
              //   setState(() {});
              // });
            } else if (tempOrder['customize'].length === j) {
              tempOrder['customize'].push({
                name: product['customize'][j]['name'],
                id: product['customize'][j]['id'],
                options: [],
              });
              //                                                                                                } else if(tempOrder['customize'][j]['options'].find((tord)=> tord['id'].contains(restaurant[0]
              //                                                                                                    .menu[i -
              //                                                                                                    3]['products'][index]['customize'][j]['options'][temp]['id']))){
              //                                             Future.delayed(Duration.zero, () {
              //                                               setState(() {});
              //                                             });
              //                                                                                                  setState(() {
              //                                                                                                    tempOrder['price'] = tempOrder['price'] + restaurant[0]
              //                                                                                                        .menu[i -
              //                                                                                                        3]['products'][index]['customize'][j]['options'][temp]['price'];
              //                                                                                                    tempOrder['addons'] = tempOrder['addons'] + 1;
              //                                                                                                  });
            }
            var temp2 = 0;
            if (
              tempOrder['customize'] != null &&
              tempOrder['customize'].length > j
            ) {
              for (
                temp2 = 0;
                temp2 < tempOrder['customize'][j]['options'].length;
                temp2++
              ) {
                const index = productIds.indexOf(
                  tempOrder['customize'][j]['options'][temp2]['id']
                );
                if (index > -1) {
                  // only splice array when item is found
                  productIds.splice(index, 1); // 2nd parameter means remove one item only
                }
                // productIds.remove(tempOrder['customize'][j]['options'][temp2]['id']);
                tempOrder['price'] =
                  tempOrder['price'] -
                  tempOrder['customize'][j]['options'][temp2]['price'];
                tempOrder['addons'] = tempOrder['addons'] - 1;
              }
              if (temp2 === tempOrder['customize'][j]['options'].length) {
                tempOrder['customize'][j]['options'] = [];
              }
            }
            // productIds.add(menus2[i -
            //     3]['products'][index]['customize'][j]['options'][temp]['id']);
            // tempOrder['price'] =
            //     tempOrder['price'] +
            //         (menus2[i -
            //             3]['products'][index]['customize'][j]['options'][temp]['price'] *
            //             tempOrder['quantity']);
            // tempOrder['addons'] =
            //     tempOrder['addons'] + 1;
          }
        }
        this.setState({ tempOrder: tempOrder, productIds: productIds });
        this.setState({ selectedProduct: product });
        this.setState({ openVariable: true });
        window.history.pushState(null, '', window.location.href);

        window.onpopstate = () => {
          window.onpopstate = () => {};
          window.history.back();
          handleCloseVariable();
        };
      }
    };

    const handleClickOpenLogin = () => {
      this.setState({
        openLogin: true,
        password: '',
        email: '',
        fullName: '',
        otp: '',
        phoneNumber: '',
        phoneCountry: '+507',
        showPassword: false,
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        handleCloseLogin();
      };
    };

    const handleClickOpenPayment = () => {
      this.setState({
        showPayment: true,
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        handleClosePayment();
      };
    };

    const handleClickOpenDiscount = () => {
      this.setState({
        showDiscount: true,
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        handleCloseDiscount();
      };
    };

    const handleClickOpenRegister = () => {
      this.setState({
        openRegister: true,
        password: '',
        email: '',
        fullName: '',
        otp: '',
        phoneNumber: '',
        phoneCountry: '+507',
        showPassword: false,
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        handleCloseRegister();
      };
    };

    const handleClickOpenAdditional = () => {
      this.setState({
        openAdditional:true,
      tableNumber: '',
      clientName: '',
      clientTel: '',
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        handleCloseAdditional();
      };
    };

    const handleClickOpenOTP = () => {
      this.setState({ openOTP: true, showPassword: false });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        // window.history.back()
        // handleCloseVariable();
      };
    };

    // const handleToggle = () => {
    //   this.setState({ open: !this.state.open });
    // };
    const openAlert = (alertType, alertMsg) => {
      this.setState({
        openAlert: true,
        alertType: alertType,
        alertMsg: alertMsg,
      });
    };
    const handleClose = (value) => {
      this.setState({ openLocation: false });
      this.setState({ hasClickedLoc: false });
      this.setState({ autoLoc: '' });
      this.setState({ selectedValue: value });
      this.setState({
        selectLocationData: {
          id: '',
          name: strings['mi hogar'],
          address: '',
          geoAddress: '',
          addressNotes: '',
          latitude: this.state.defaultProps.center.lat,
          longitude: this.state.defaultProps.center.lng,
        },
      });
    };
    const handleCardClose = (value) => {
      this.setState({ openCards: false });
    };
    const handleMinimumClose = (value) => {
      this.setState({ showMinimum: false });
    };
    const handleAlertClose = (value) => {
      this.setState({ openDialogAlert: false });
    };
    const handlePreOrderClose = (value) => {
      this.setState({ openPreOrder: false,      showTomorrow: false,
        selectedPreOrder: null, });
    };

    const handleAddCardClose = (value) => {
      this.setState({ openAddCard: false });
      // this.setState({ hasClickedLoc: false });
      // this.setState({ autoLoc: '' });
      // this.setState({ selectedValue: value });
      // this.setState({
      //   selectLocationData: {
      //     id: '',
      //     name: strings['mi hogar'],
      //     address: '',
      //     geoAddress: '',
      //     addressNotes: '',
      //     latitude: this.state.defaultProps.center.lat,
      //     longitude: this.state.defaultProps.center.lng,
      //   },
      // });
    };

    const handleCloseVariable = () => {
      this.setState({ selectedProduct: null });
      this.setState({ tempOrder: {}, productIds: [] });
      this.setState({ openVariable: false });
    };

    const handleClosePayment = () => {
      this.setState({
        showPayment: false,
      });
    };

    const handleCloseDiscount = () => {
      this.setState({
        showDiscount: false,
        showDiscountIsBusiness: false,
      });
    };

    const handleCloseLogin = () => {
      this.setState({
        openLogin: false,
        password: '',
        email: '',
        fullName: '',
        otp: '',
        phoneNumber: '',
        phoneCountry: '+507',
        showPassword: false,
      });
    };
    const handleCloseRegister = () => {
      this.setState({
        openRegister: false,
        password: '',
        email: '',
        fullName: '',
        otp: '',
        phoneNumber: '',
        phoneCountry: '+507',
        showPassword: false,
      });
    };
    const handleCloseAdditional = () => {
      this.setState({
        openAdditional: false,
      });
    };
    const handleCloseOTP = () => {
      this.setState({
        openOTP: false,
        password: '',
        email: '',
        fullName: '',
        otp: '',
        phoneCountry: '+507',
        phoneNumber: '',
        showPassword: false,
      });
    };
    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
      <Menu
        anchorEl={this.state.mobileMoreAnchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        id={mobileMenuId}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
      >
        <MenuItem onClick={handleProfileMenuOpen}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
          >
            {this.state.photoURL ? (
              <img
                style={{
                  verticalAlign: 'middle',
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                }}
                src={this.state.photoURL}
              />
            ) : (
              <AccountCircle />
            )}
          </IconButton>
          <p>{strings['Perfil']}</p>
        </MenuItem>
      </Menu>
    );
    const refs = this.state.menu.reduce((acc, value) => {
      acc[value.id] = React.createRef();
      return acc;
    }, {});
    const sendNotification = async (receiver, msg, title, id, order) => {
      //List tokenData = await getToken(receiver);
      //final FirebaseFirestore _db = FirebaseFirestore.instance;
      const q = query(
        collection(db, 'business_users'),
        where('businessId', '==', receiver)
      );
      await getDocs(q).then((data) => {
        //print('size: ' + data.size.toString());
        data.docs.forEach(async (element) => {
          // console.log('sending notifications! ',element.data()['email'].toString());
          if (
            element.data()['token'] != null &&
            element.data()['token'] !== ''
          ) {
            //tokenData.add((element.data() as Map)['token']);
            //print('token : ${(element.data() as Map)['token']}');
            //print('msg: ¢msg');
            //print('title:¢title');
            //print('id:¢id');
            var data2 = {
              click_action: 'FLUTTER_NOTIFICATION_CLICK',
              orderId: id,
              for: 'restaurant',
              isOrder: 'yes',
              status: 'done',
              isPreOrder: order['isPreOrder'].toString(),
              title: title,
              body: msg,
              token: element.data()['token'],
            };

            await axios
              .post('https://lemon-order.herokuapp.com/business/send/', null,{
                params: data2
              })
              .then(async (response) => {
                // console.log(response);
              });
            // var uri = Uri.https(herokuOrderAppHttp, '/business/send/', data2);

            // var response = await http.post(uri, headers: {
            //   HttpHeaders.contentTypeHeader: 'application/x-www-form-urlencoded',
            // });

            // if(response.statusCode)
            // // final headers = {
            // //   'content-type': 'application/json',
            // //   'Authorization':
            // //       'Bearer AAAAnlq9nws:APA91bG4geMfGAupCddUNthlMn9MD0Td2N11gG91FE_bf3aBBwXuP_KZLpoDmQ974LMVDd4hl2BpzCfAfKDKl3yvhpaaHm05mXHfKF3usIzu1E1FhFPkTaTB0f5SwAkJGOsOa2ttKUOA'
            // // };
            //
            // BaseOptions options = new BaseOptions(
            //   connectTimeout: 5000,
            //   receiveTimeout: 3000,
            // );

            // try {
            //   final response = await Dio().post(
            //     'https://devy-app.herokuapp.com/business/send/',
            //     queryParameters: {
            //       "message": {
            //         "click_action": "FLUTTER_NOTIFICATION_CLICK",
            //         "orderId": id,
            //         'for': 'restaurant',
            //         'isOrder': 'yes',
            //         "status": "done",
            //         'title': title,
            //         'body': msg
            //       },
            //       "token": "${(element.data() as Map)['token']}"
            //     },
            //     options: Options(headers: {
            //       HttpHeaders.contentTypeHeader: 'application/x-www-form-urlencoded'
            //     }),
            //   );
            //   if (response.statusCode == 200) {
            //
            //   } else {
            //     print('failed');
            //     //_onErrorPressed(context, 'something went wrong');
            //   }
            // } on DioError catch (e) {
            //   print('exception ¢e');
            //   //_onErrorPressed(context, 'something went wrong');
            // }
          }

          // try {
          //   final response = await Dio(options).post(
          //       'https://fcm.googleapis.com/v1/projects/devyxyz/messages:send',
          //       data: data);
          //   if (response.statusCode == 200) {
          //   } else {
          //     print('notification sending failed');
          //   }
          // } on DioError catch (e) {
          //   print('exception ¢e');
          //   print('exception ${e.message}');
          // }
        });
      });
    };
    const findTotal3 = (id) => {
      var total1 = 0;
      //print(cart['item'].filter((item)=>item['id'].toString().contains(id)));
      this.state.cart['item']
        .filter((item) => item['id'].toString().includes(id))
        .forEach((itemss) => (total1 = total1 + itemss['quantity']));
      return total1.toString();
    };

    const findTotal = (id, i) => {
      var total1 = this.state.cart['item'][id]['customize'][i]['name'] + ': ';
      for (
        var j = 0;
        j < this.state.cart['item'][id]['customize'][i]['options'].length;
        j++
      ) {
        if (j === 0) {
          total1 =
            total1 +
            this.state.cart['item'][id]['customize'][i]['options'][j]['name'];
        } else {
          total1 =
            total1 +
            ',' +
            this.state.cart['item'][id]['customize'][i]['options'][j]['name'];
        }
      }
      return total1;
    };

    const checkOffer = () => {
      var offerCode = this.state.offerCode;
      var offerId = this.state.offerId;
      var offerSuccess = this.state.offerSuccess;
      var offerErrorText = this.state.offerErrorText;
      var offerValue = this.state.offerValue;
      var cashbackValue = this.state.cashbackValue;
      var offerInd = this.state.offerInd;
      var isOfferApplied = this.state.isOfferApplied;
      var isOfferError = this.state.isOfferError;
      var isFreeDelivery = this.state.isFreeDelivery;
      var offersUsed = this.state.offersUsed;
      var devyOffers = this.state.offers;
      var cart = this.state.cart;
      var delivery = this.state.delivery;
      // setState(() {
      if (offerInd != null) {
        this.setState({
          selectedOffer: devyOffers[offerInd],
        });
        if (
          offersUsed.find(
            (element) => element['id'] === devyOffers[offerInd]['id']
          ) == null
        ) {
          if (
            devyOffers[offerInd]['isItemOffer'] != null &&
            devyOffers[offerInd]['isItemOffer']
          ) {
            offerValue = 0;
            cashbackValue = 0.0;
            // console.log(devyOffers[offerInd]['items']);
            var testList = devyOffers[offerInd]['items'];
            for (var ij = 0; ij < cart['item'].length; ij++) {
              //print(testList.filter((element34) => element34['id'].contains(cart['item'][ij]['id'])));
              if (
                testList.find(
                  (element34) => element34['id'] === cart['item'][ij]['id']
                ) != null
              ) {
                var tempValue = testList.find(
                  (element) =>
                    element['id'].toString() ===
                    cart['item'][ij]['id'].toString()
                );
                if (
                  tempValue['id'] === cart['item'][ij]['id'] &&
                  Math.trunc(
                    cart['item'][ij]['quantity'] /
                      (devyOffers[offerInd]['freeItem'] +
                        devyOffers[offerInd]['buyItem'])
                  ) > 0
                ) {
                  offerValue =
                    offerValue +
                    cart['item'][ij]['price'] *
                      Math.trunc(
                        cart['item'][ij]['quantity'] /
                          (devyOffers[offerInd]['freeItem'] +
                            devyOffers[offerInd]['buyItem'])
                      ) +
                    0.0;
                }
              }
            }
            if (offerValue > 0) {
              isOfferApplied = true;
              offerInd = offerInd;
              isFreeDelivery = false;
              isOfferError = false;
              offerErrorText = '';
              offerCode = devyOffers[offerInd]['code'];
              offerId = devyOffers[offerInd]['id'];
              offerSuccess = strings['Su cupón ha sido agregado con éxito.'];
            } else {
              isOfferApplied = false;
              isOfferError = true;
              isFreeDelivery = false;
              offerInd = offerInd;
              offerErrorText =
                strings['Añade al menos '] +
                (
                  devyOffers[offerInd]['freeItem'] +
                  devyOffers[offerInd]['buyItem']
                ).toString() +
                strings[' productos promocionales.'];
              offerCode = devyOffers[offerInd]['code'];
              offerSuccess = '';
              offerValue = 0;
              cashbackValue = 0.0;
              offerId = '';
            }
          } else if (
            cart['totalCost'] >= devyOffers[offerInd]['minimumItemValue']
          ) {
            if (
              devyOffers[offerInd]['maximumItemValue'] === 0 ||
              cart['totalCost'] <= devyOffers[offerInd]['maximumItemValue']
            ) {
              isOfferApplied = true;
              isFreeDelivery = false;
              isOfferError = false;
              offerErrorText = '';
              offerCode = devyOffers[offerInd]['code'];
              offerId = devyOffers[offerInd]['id'];
              //storage.setItem('cart', jsonEncode(cart));
              offerSuccess = strings['Su cupón ha sido agregado con éxito.'];
              if (devyOffers[offerInd]['freeDelivery']) {
                offerValue = delivery + 0.0;
                cashbackValue = 0.0;
                isFreeDelivery = true;
              } else {
                isFreeDelivery = false;
                offerValue =
                  devyOffers[offerInd]['discountAmount'] +
                  0.0 +
                  (devyOffers[offerInd]['discountPercentage'] / 100) *
                    cart['totalCost'];
                if (offerValue < devyOffers[offerInd]['minimumDiscount']) {
                  offerValue = devyOffers[offerInd]['minimumDiscount'] + 0.0;
                } else if (
                  devyOffers[offerInd]['maximumDiscount'] !== 0 &&
                  offerValue > devyOffers[offerInd]['maximumDiscount']
                ) {
                  offerValue = devyOffers[offerInd]['maximumDiscount'] + 0.0;
                }
                cashbackValue =
                  devyOffers[offerInd]['cashbackAmount'] != null
                    ? devyOffers[offerInd]['cashbackAmount'] +
                      0.0 +
                      (devyOffers[offerInd]['cashbackPercentage'] != null
                        ? (devyOffers[offerInd]['cashbackPercentage'] / 100) *
                          cart['totalCost']
                        : 0)
                    : 0.0;
              }
            } else {
              isOfferApplied = false;
              isFreeDelivery = false;
              isOfferError = true;
              offerErrorText =
                strings['Los productos máximos deben ser ¢'] +
                devyOffers[offerInd]['maximumItemValue'].toString();
              offerCode = devyOffers[offerInd]['code'];
              offerSuccess = '';
              offerValue = 0;
              cashbackValue = 0.0;
              offerId = '';
            }
          } else if (
            cart['totalCost'] < devyOffers[offerInd]['minimumItemValue']
          ) {
            isOfferApplied = false;
            isFreeDelivery = false;
            isOfferError = true;
            offerErrorText =
              strings['Los productos mínimos deben ser ¢'] +
              devyOffers[offerInd]['minimumItemValue'].toString();
            offerCode = devyOffers[offerInd]['code'];
            offerSuccess = '';
            offerValue = 0;
            cashbackValue = 0.0;
            offerId = '';
          }
        } else {
          if (
            offersUsed
              .filter((element) => element['id'] === devyOffers[offerInd]['id'])
              [
                offersUsed.filter(
                  (element) => element['id'] === devyOffers[offerInd]['id']
                ).length - 1
              ]['usedOn'].toMillis() +
              devyOffers[offerInd]['timeBetweenUses'] * 1000 <
            Date.now()
          ) {
            if (
              devyOffers[offerInd]['isItemOffer'] != null &&
              devyOffers[offerInd]['isItemOffer']
            ) {
              offerValue = 0;
              cashbackValue = 0.0;
              console.log(devyOffers[offerInd]['items']);
              var testList = devyOffers[offerInd]['items'];
              for (var ij = 0; ij < cart['item'].length; ij++) {
                //print(testList.filter((element34) => element34['id'].contains(cart['item'][ij]['id'])));
                if (
                  testList.find(
                    (element34) => element34['id'] === cart['item'][ij]['id']
                  ) != null
                ) {
                  var tempValue = testList.find(
                    (element) =>
                      element['id'].toString() ===
                      cart['item'][ij]['id'].toString()
                  );
                  if (
                    tempValue['id'] === cart['item'][ij]['id'] &&
                    Math.trunc(
                      cart['item'][ij]['quantity'] /
                        (devyOffers[offerInd]['freeItem'] +
                          devyOffers[offerInd]['buyItem'])
                    ) > 0
                  ) {
                    offerValue =
                      offerValue +
                      cart['item'][ij]['price'] *
                        Math.trunc(
                          cart['item'][ij]['quantity'] /
                            (devyOffers[offerInd]['freeItem'] +
                              devyOffers[offerInd]['buyItem'])
                        ) +
                      0.0;
                  }
                }
              }
              if (offerValue > 0) {
                isOfferApplied = true;
                isFreeDelivery = false;
                offerInd = offerInd;
                isOfferError = false;
                offerErrorText = '';
                offerCode = devyOffers[offerInd]['code'];
                offerId = devyOffers[offerInd]['id'];
                offerSuccess = strings['Su cupón ha sido agregado con éxito.'];
              } else {
                isOfferApplied = false;
                isFreeDelivery = false;
                isOfferError = true;
                offerInd = offerInd;
                offerErrorText =
                  strings['Añade al menos '] +
                  (
                    devyOffers[offerInd]['freeItem'] +
                    devyOffers[offerInd]['buyItem']
                  ).toString() +
                  strings[' productos promocionales.'];
                offerCode = devyOffers[offerInd]['code'];
                offerSuccess = '';
                offerValue = 0;
                cashbackValue = 0.0;
                offerId = '';
              }
            } else if (
              cart['totalCost'] >= devyOffers[offerInd]['minimumItemValue']
            ) {
              if (
                devyOffers[offerInd]['maximumItemValue'] === 0 ||
                cart['totalCost'] <= devyOffers[offerInd]['maximumItemValue']
              ) {
                isOfferApplied = true;
                isFreeDelivery = false;
                isOfferError = false;
                offerErrorText = '';
                offerId = devyOffers[offerInd]['id'];
                offerCode = devyOffers[offerInd]['code'];
                offerSuccess = strings['Su cupón ha sido agregado con éxito.'];
                if (devyOffers[offerInd]['freeDelivery']) {
                  offerValue = delivery + 0.0;
                  cashbackValue = 0.0;
                  isFreeDelivery = true;
                } else {
                  isFreeDelivery = false;
                  offerValue =
                    devyOffers[offerInd]['discountAmount'] +
                    0.0 +
                    (devyOffers[offerInd]['discountPercentage'] / 100) *
                      cart['totalCost'];
                  if (offerValue < devyOffers[offerInd]['minimumDiscount']) {
                    offerValue = devyOffers[offerInd]['minimumDiscount'] + 0.0;
                  } else if (
                    devyOffers[offerInd]['maximumDiscount'] !== 0 &&
                    offerValue > devyOffers[offerInd]['maximumDiscount']
                  ) {
                    offerValue = devyOffers[offerInd]['maximumDiscount'] + 0.0;
                  }
                  cashbackValue =
                    devyOffers[offerInd]['cashbackAmount'] != null
                      ? devyOffers[offerInd]['cashbackAmount'] +
                        0.0 +
                        (devyOffers[offerInd]['cashbackPercentage'] != null
                          ? (devyOffers[offerInd]['cashbackPercentage'] / 100) *
                            cart['totalCost']
                          : 0)
                      : 0.0;
                }
              } else {
                isOfferApplied = false;
                isFreeDelivery = false;
                isOfferError = true;
                offerErrorText =
                  strings['Los productos máximos deben ser ¢'] +
                  devyOffers[offerInd]['maximumItemValue'].toString();
                offerCode = devyOffers[offerInd]['code'];
                offerSuccess = '';
                offerValue = 0;
                cashbackValue = 0.0;
                offerId = '';
              }
            } else if (
              cart['totalCost'] < devyOffers[offerInd]['minimumItemValue']
            ) {
              isOfferApplied = false;
              isFreeDelivery = false;
              isOfferError = true;
              offerErrorText =
                strings['Los productos mínimos deben ser ¢'] +
                devyOffers[offerInd]['minimumItemValue'].toString();
              offerCode = devyOffers[offerInd]['code'];
              offerSuccess = '';
              offerValue = 0;
              cashbackValue = 0.0;
              offerId = '';
            }
          } else {
            isOfferApplied = false;
            isFreeDelivery = false;
            isOfferError = true;
            offerErrorText =
              strings[
                'Este cupón se ha utilizado recientemente, inténtalo de nuevo más tarde.'
              ];
            offerCode = devyOffers[offerInd]['code'];
            offerSuccess = '';
            offerValue = 0;
            cashbackValue = 0.0;
            offerId = '';
          }
        }
      }
      // if(usingWallet) {
      //   if(offerValue2>walletMax()) {
      //     // setState(() {
      //       offerValue2 = walletMax();
      //       cashbackValue =  0.0;
      //       print(offerValue2);
      //     // });
      //   }
      // }
      // else if(offerInd2!=null) {
      //   if (offersUsed
      //       .find((
      //       element) =>
      //       element['id']
      //           .contains(
      //           devyOffers2[offerInd2]['id'])) ==
      //       null) {
      //     if(devyOffers2[offerInd2]['isItemOffer']!=null && devyOffers2[offerInd2]['isItemOffer']){
      //       offerValue2 = 0;
      //       cashbackValue =  0.0;
      //       print(devyOffers2[offerInd2]['items']);
      //       var testList = devyOffers2[offerInd2]['items'];
      //       for(var ij=0;ij<cart['item'].length;ij++) {
      //         //print(testList.filter((element34) => element34['id'].contains(cart['item'][ij]['id'])));
      //         if(testList.find((element34) => element34['id'].contains(cart['item'][ij]['id'])) !=
      //             null) {
      //               var tempValue = testList.find((element) => (element['id'].toString().contains(cart['item'][ij]['id'].toString())));
      //           if(tempValue['id']==cart['item'][ij]['id'] && (cart['item'][ij]['quantity']/(devyOffers2[offerInd2]['freeItem']+devyOffers2[offerInd2]['buyItem'])).truncate()>0) {
      //             offerValue2 = offerValue2 + (cart['item'][ij]['price'] * ((cart['item'][ij]['quantity']/(devyOffers2[offerInd2]['freeItem']+devyOffers2[offerInd2]['buyItem'])).truncate())) + 0.0;
      //           }
      //         }
      //       }
      //       if(offerValue2>0) {
      //         isOfferApplied2 = true;
      //         offerInd2 = offerInd2;
      //         isFreeDelivery2 = false;
      //         isOfferError2 = false;
      //         offerErrorText2 = '';
      //         offerCode2 = devyOffers2[offerInd2]['code'];
      //         offerId2 = devyOffers2[offerInd2]['id'];
      //         offerSuccess2 = "cart3077".tr();
      //       } else {
      //         isOfferApplied2 = false;
      //         isOfferError2 = true;
      //         isFreeDelivery2 = false;
      //         offerInd2 = offerInd2;
      //         // offerErrorText2 = 'cart3082'.tr(args:[(devyOffers2[offerInd2]['freeItem']+devyOffers2[offerInd2]['buyItem']).toString()]);
      //         offerCode2 = devyOffers2[offerInd2]['code'];
      //         offerSuccess2 = "";
      //         offerValue2 = 0;
      //         cashbackValue =  0.0;
      //         offerId2 = '';
      //       }
      //     }
      //     else if ((cart['totalCost'] - ((isFreeDelivery)?0:offerValue)) >=
      //         devyOffers2[offerInd2]['minimumItemValue']) {
      //       if (devyOffers2[offerInd2]['maximumItemValue'] ==
      //           0 ||
      //           (cart['totalCost'] - ((isFreeDelivery)?0:offerValue)) <=
      //               devyOffers2[offerInd2]['maximumItemValue']) {
      //         isOfferApplied2 =
      //         true;
      //         isFreeDelivery2 = false;
      //         isOfferError2 =
      //         false;
      //         offerErrorText2 =
      //         '';
      //         offerCode2 =
      //         devyOffers2[offerInd2]['code'];
      //         offerId2 =
      //         devyOffers2[offerInd2]['id'];
      //         //storage.setItem('cart', jsonEncode(cart));
      //         offerSuccess2 =
      //             "cart3108".tr();
      //         if (devyOffers2[offerInd2]['freeDelivery'] && !isFreeDelivery) {
      //           offerValue2 =
      //               delivery +
      //                   0.0;
      //           cashbackValue =  0.0;
      //           isFreeDelivery2 = true;
      //         } else if (devyOffers2[offerInd2]['freeDelivery'] && isFreeDelivery) {
      //           isOfferApplied2 = false;
      //           isOfferError2 = true;
      //           isFreeDelivery2 = false;
      //           isUsingInviteCode = false;
      //           isUsingSubscription = false;
      //           offerInd2 = offerInd2;
      //           offerErrorText2 = 'Oferta de envío gratis ya aplicada';
      //           offerCode2 = devyOffers2[offerInd2]['code'];
      //           offerSuccess2 = "";
      //           offerValue2 = 0;
      //           cashbackValue =  0.0;
      //           offerId2 = '';
      //         } else {
      //           isFreeDelivery2 = false;
      //           offerValue2 =
      //               devyOffers2[offerInd2]['discountAmount'] +
      //                   0.0 +
      //                   (devyOffers2[offerInd2]['discountPercentage'] /
      //                       100) *
      //                       (cart['totalCost'] - ((isFreeDelivery)?0:offerValue));
      //           if (offerValue2 <
      //               devyOffers2[offerInd2]['minimumDiscount']) {
      //             offerValue2 =
      //                 devyOffers2[offerInd2]['minimumDiscount'] +
      //                     0.0;
      //           } else
      //           if (devyOffers2[offerInd2]['maximumDiscount'] !=
      //               0 &&
      //               offerValue2 >
      //                   devyOffers2[offerInd2]['maximumDiscount']) {
      //             offerValue2 =
      //                 devyOffers2[offerInd2]['maximumDiscount'] +
      //                     0.0;
      //           }
      //           cashbackValue = devyOffers2[offerInd2]['cashbackAmount'] != null ? (devyOffers2[offerInd2]['cashbackAmount'] + 0.0 +((devyOffers2[offerInd2]['cashbackPercentage']!=null)?( (devyOffers2[offerInd2]['cashbackPercentage'] / 100) * (cart['totalCost'] - ((isFreeDelivery)?0:offerValue))):0)): 0.0;
      //         }
      //       } else {
      //         isOfferApplied2 =
      //         false;
      //         isFreeDelivery2 = false;
      //         isOfferError2 =
      //         true;
      //         offerErrorText2 =
      //             'cart3143'.tr() +
      //                 devyOffers2[offerInd2]['maximumItemValue']
      //                     .toString();
      //         offerCode2 =
      //         devyOffers2[offerInd2]['code'];
      //         offerSuccess2 =
      //         "";
      //         offerValue2 =
      //         0;
      //         cashbackValue =  0.0;
      //         offerId2 =
      //         '';
      //       }
      //     } else if ((cart['totalCost'] - ((isFreeDelivery)?0:offerValue)) <
      //         devyOffers2[offerInd2]['minimumItemValue']) {
      //       isOfferApplied2 =
      //       false;
      //       isFreeDelivery = false;
      //       isOfferError2 =
      //       true;
      //       offerErrorText2 =
      //           'cart3163'.tr() +
      //               devyOffers2[offerInd2]['minimumItemValue']
      //                   .toString();
      //       offerCode2 =
      //       devyOffers2[offerInd2]['code'];
      //       offerSuccess2 =
      //       "";
      //       offerValue2 =
      //       0;
      //       cashbackValue =  0.0;
      //       offerId2 =
      //       '';
      //     }
      //   } else {
      //     if ((offersUsed
      //         .filter((
      //         element) =>
      //         element['id']
      //             .contains(
      //             devyOffers2[offerInd2]['id']))
      //         .toList()[offersUsed
      //         .filter((
      //         element) =>
      //         element['id']
      //             .contains(
      //             devyOffers2[offerInd2]['id']))
      //         .toList()
      //         .length -
      //         1]['usedOn']
      //         .toMillis() +
      //         int.parse(
      //             devyOffers2[offerInd2]['timeBetweenUses']) * 1000) <
      //         (DateTime
      //             .now()
      //             .toMillis())) {
      //       if(devyOffers2[offerInd2]['isItemOffer']!=null && devyOffers2[offerInd2]['isItemOffer']){
      //         offerValue2 = 0;
      //         cashbackValue =  0.0;
      //         print(devyOffers2[offerInd2]['items']);
      //         var testList = devyOffers2[offerInd2]['items'];
      //         for(var ij=0;ij<cart['item'].length;ij++) {
      //           //print(testList.filter((element34) => element34['id'].contains(cart['item'][ij]['id'])));
      //           if(testList.find((element34) => element34['id'].contains(cart['item'][ij]['id'])) !=
      //               null) {
      //                 var tempValue = testList.find((element) => (element['id'].toString().contains(cart['item'][ij]['id'].toString())));
      //             if(tempValue['id']==cart['item'][ij]['id'] && (cart['item'][ij]['quantity']/(devyOffers2[offerInd2]['freeItem']+devyOffers2[offerInd2]['buyItem'])).truncate()>0) {
      //               offerValue2 = offerValue2 + (cart['item'][ij]['price'] * ((cart['item'][ij]['quantity']/(devyOffers2[offerInd2]['freeItem']+devyOffers2[offerInd2]['buyItem'])).truncate())) + 0.0;
      //             }
      //           }
      //         }
      //         if(offerValue2>0) {
      //           isOfferApplied2 = true;
      //           isFreeDelivery2 = false;
      //           offerInd2 = offerInd2;
      //           isOfferError2 = false;
      //           offerErrorText2 = '';
      //           offerCode2 = devyOffers2[offerInd2]['code'];
      //           offerId2 = devyOffers2[offerInd2]['id'];
      //           offerSuccess2 = "cart3221".tr();
      //         } else {
      //           isOfferApplied2 = false;
      //           isFreeDelivery2 = false;
      //           isOfferError2 = true;
      //           offerInd2 = offerInd2;
      //           // offerErrorText2 = 'cart3226'.tr(args:[(devyOffers2[offerInd2]['freeItem']+devyOffers2[offerInd2]['buyItem']).toString()]);
      //           offerCode2 = devyOffers2[offerInd2]['code'];
      //           offerSuccess2 = "";
      //           offerValue2 = 0;
      //           cashbackValue =  0.0;
      //           offerId2 = '';
      //         }
      //       }
      //       else if ((cart['totalCost'] - ((isFreeDelivery)?0:offerValue)) >=
      //           devyOffers2[offerInd2]['minimumItemValue']) {
      //         if (devyOffers2[offerInd2]['maximumItemValue'] ==
      //             0 ||
      //             (cart['totalCost'] - ((isFreeDelivery)?0:offerValue)) <=
      //                 devyOffers2[offerInd2]['maximumItemValue']) {
      //           isOfferApplied2 =
      //           true;
      //           isFreeDelivery2 = false;
      //           isOfferError2 =
      //           false;
      //           offerErrorText2 =
      //           '';
      //           offerId2 =
      //           devyOffers2[offerInd2]['id'];
      //           offerCode2 =
      //           devyOffers2[offerInd2]['code'];
      //           offerSuccess2 =
      //               "cart3251".tr();
      //           if (devyOffers2[offerInd2]['freeDelivery'] && !isFreeDelivery) {
      //             offerValue2 =
      //                 delivery +
      //                     0.0;
      //             cashbackValue =  0.0;
      //             isFreeDelivery2 = true;
      //           } else if (devyOffers2[offerInd2]['freeDelivery'] && isFreeDelivery) {
      //             isOfferApplied2 = false;
      //             isOfferError2 = true;
      //             isFreeDelivery2 = false;
      //             isUsingInviteCode = false;
      //             isUsingSubscription = false;
      //             offerInd2 = offerInd2;
      //             offerErrorText2 = 'Oferta de envío gratis ya aplicada';
      //             offerCode2 = devyOffers2[offerInd2]['code'];
      //             offerSuccess2 = "";
      //             offerValue2 = 0;
      //             cashbackValue =  0.0;
      //             offerId2 = '';
      //           } else {
      //             isFreeDelivery2 = false;
      //             offerValue2 =
      //                 devyOffers2[offerInd2]['discountAmount'] +
      //                     0.0 +
      //                     (devyOffers2[offerInd2]['discountPercentage'] /
      //                         100) *
      //                         (cart['totalCost'] - ((isFreeDelivery)?0:offerValue));
      //             if (offerValue2 <
      //                 devyOffers2[offerInd2]['minimumDiscount']) {
      //               offerValue2 =
      //                   devyOffers2[offerInd2]['minimumDiscount'] +
      //                       0.0;
      //             } else
      //             if (devyOffers2[offerInd2]['maximumDiscount'] !=
      //                 0 &&
      //                 offerValue2 >
      //                     devyOffers2[offerInd2]['maximumDiscount']) {
      //               offerValue2 =
      //                   devyOffers2[offerInd2]['maximumDiscount'] +
      //                       0.0;
      //             }
      //             cashbackValue = devyOffers2[offerInd2]['cashbackAmount'] != null ? (devyOffers2[offerInd2]['cashbackAmount'] + 0.0 +((devyOffers2[offerInd2]['cashbackPercentage']!=null)?( (devyOffers2[offerInd2]['cashbackPercentage'] / 100) * (cart['totalCost'] - ((isFreeDelivery)?0:offerValue))):0)): 0.0;
      //           }
      //         } else {
      //           isOfferApplied2 =
      //           false;
      //           isFreeDelivery2 = false;
      //           isOfferError2 =
      //           true;
      //           offerErrorText2 =
      //               'cart3286'.tr() +
      //                   devyOffers2[offerInd2]['maximumItemValue']
      //                       .toString();
      //           offerCode2 =
      //           devyOffers2[offerInd2]['code'];
      //           offerSuccess2 =
      //           "";
      //           offerValue2 =
      //           0;
      //           cashbackValue = 0.0;
      //           offerId2 =
      //           '';
      //         }
      //       } else if((cart['totalCost'] - ((isFreeDelivery)?0:offerValue)) <
      //           devyOffers2[offerInd2]['minimumItemValue']) {
      //         isOfferApplied2 =
      //         false;
      //         isFreeDelivery2 = false;
      //         isOfferError2 =
      //         true;
      //         offerErrorText2 =
      //             'cart3306'.tr() +
      //                 devyOffers2[offerInd2]['minimumItemValue']
      //                     .toString();
      //         offerCode2 =
      //         devyOffers2[offerInd2]['code'];
      //         offerSuccess2 =
      //         "";
      //         offerValue2 =
      //         0;
      //         cashbackValue =  0.0;
      //         offerId2 =
      //         '';
      //       }
      //     } else {
      //       isOfferApplied2 =
      //       false;
      //       isFreeDelivery2 = false;
      //       isOfferError2 =
      //       true;
      //       offerErrorText2 =
      //           'cart3325'.tr();
      //       offerCode2 =
      //       devyOffers2[offerInd2]['code'];
      //       offerSuccess2 =
      //       "";
      //       offerValue2 =
      //       0;
      //       cashbackValue =  0.0;
      //       offerId2 =
      //       '';
      //     }
      //   }
      // }
      // });

      this.setState({
        offerCode: offerCode,
        offerId: offerId,
        offerSuccess: offerSuccess,
        offerErrorText: offerErrorText,
        offerValue: offerValue,
        cashbackValue: cashbackValue,
        offerInd: offerInd,
        isOfferApplied: isOfferApplied,
        isOfferError: isOfferError,
        isFreeDelivery: isFreeDelivery,
        offersUsed: offersUsed,
        offers: devyOffers,
        cart: cart,
        delivery: delivery,
      });
      // console.log('he', {
      //   offerCode: offerCode,
      //   offerId: offerId,
      //   offerSuccess: offerSuccess,
      //   offerErrorText: offerErrorText,
      //   offerValue: offerValue,
      //   cashbackValue: cashbackValue,
      //   offerInd: offerInd,
      //   isOfferApplied: isOfferApplied,
      //   isOfferError: isOfferError,
      //   isFreeDelivery: isFreeDelivery,
      //   offersUsed: offersUsed,
      //   offers: devyOffers,
      //   cart: cart,
      //   delivery: delivery,
      // });
    };

    const findTotal2 = () => {
      var total1 = 'v5.1.65 ';
      for (var j = 0; j < this.state.cart['item'].length; j++) {
        if (j === 0) {
          total1 =
            total1 +
            this.state.cart['item'][j]['quantity'].toString() +
            ' X ' +
            this.state.cart['item'][j]['name'] +
            ' - ¢' +
            (
              this.state.cart['item'][j]['price'] *
              this.state.cart['item'][j]['quantity']
            ).toFixed(2);
        } else {
          total1 =
            total1 +
            ',' +
            this.state.cart['item'][j]['quantity'].toString() +
            ' X ' +
            this.state.cart['item'][j]['name'] +
            ' - ¢' +
            (
              this.state.cart['item'][j]['price'] *
              this.state.cart['item'][j]['quantity']
            ).toFixed(2);
        }
      }
      total1 =
        total1 + strings[' Costo de envío: '] + this.state.delivery.toFixed(2);
      total1 =
        total1 + strings[' Descuento: '] + this.state.offerValue.toFixed(2);
      return total1;
    };

    const grandTotal = () => {
      //print(distance['rows'][0]['elements'][0]['distance']['value']);
      //print(distance['rows'][0]['elements'][0]['distance']['value']);
      // normalDelivery =restaurant[0].deliveryPrice;

      // if(dynamicDelivery) {
      //   additionalDelivery = (normalDelivery * (additionalDeliveryPercentage2/100)) + 0.0;
      //   delivery = normalDelivery + additionalDelivery;
      // } else {
      //   delivery= normalDelivery;
      // }

      // if(widget.isPickup) {
      //   delivery = 0;
      //   normalDelivery = 0;
      //   additionalDelivery = 0;
      // }

      var serviceFee =
        this.state.businessData.driverServiceFee +
        (this.state.cart['totalCost'] *
          this.state.businessData.driverServicePercentage) /
          100 +
        0.0;
      var total23 =
        (this.state.cart['totalCost'] * this.state.tipPercent) / 100 + 0.0;
      var total1 =
        this.state.cart['totalCost'] -
        this.state.offerValue +
        this.state.delivery +
        total23 +
        serviceFee;
      // var total1 = cart['item'][id]['customize'][i]['name'] + ': ';
      // for (int j = 0;
      // j < cart['item'][id]['customize'][i]['options'].length;
      // j++) {
      //   if (j == 0) {
      //     total1 =
      //         total1 + cart['item'][id]['customize'][i]['options'][j]['name'];
      //   } else {
      //     total1 = total1 +
      //         ',' +
      //         cart['item'][id]['customize'][i]['options'][j]['name'];
      //   }
      // }
      return total1;
    };

    const calcTip = () => {
      var total1 =
        (this.state.cart['totalCost'] * this.state.tipPercent) / 100 + 0.0;
      return total1;
    };

    const findTotalT = (id, i, order) => {
      var total1 =
        (order['items'][id]['customize'][i]['nameEng'] != null
          ? order['items'][id]['customize'][i]['nameEng']
          : order['items'][id]['customize'][i]['name']) + ': ';
      for (
        var j = 0;
        j < order['items'][id]['customize'][i]['options'].length;
        j++
      ) {
        if (j === 0) {
          total1 =
            total1 +
            (order['items'][id]['customize'][i]['options'][j]['nameEng'] != null
              ? order['items'][id]['customize'][i]['options'][j]['nameEng']
              : order['items'][id]['customize'][i]['options'][j]['name']);
        } else {
          total1 =
            total1 +
            ',' +
            (order['items'][id]['customize'][i]['options'][j]['nameEng'] != null
              ? order['items'][id]['customize'][i]['options'][j]['nameEng']
              : order['items'][id]['customize'][i]['options'][j]['name']);
        }
      }
      return total1;
    };
    const grandTotal2 = () => {
      //print(distance['rows'][0]['elements'][0]['distance']['value']);
      //print(distance['rows'][0]['elements'][0]['distance']['value']);
      // normalDelivery =restaurant[0].deliveryPrice;

      // if(dynamicDelivery) {
      //   additionalDelivery = (normalDelivery * (additionalDeliveryPercentage2/100)) + 0.0;
      //   delivery = normalDelivery + additionalDelivery;
      // } else {
      //   delivery= normalDelivery;
      // }

      // if(widget.isPickup) {
      //   delivery = 0;
      //   normalDelivery = 0;
      //   additionalDelivery = 0;
      // }
      var serviceFee =
        (this.state.businessData.driverServiceFee
          ? this.state.businessData.driverServiceFee
          : 0) +
        (this.state.cart['totalCost'] *
          (this.state.businessData.driverServicePercentage
            ? this.state.businessData.driverServicePercentage
            : 0)) /
          100 +
        0.0;
      var total1 =
        this.state.cart['totalCost'] -
        this.state.offerValue +
        ((this.state.selectedType === 1 || this.state.selectedType === 2)?0:this.state.delivery) +
        calcTip() +
        serviceFee;
      // if(cart['totalOxxoCost']>0) {
      //   total1 = total1 + oxxoDelivery + cart['totalOxxoCost'];
      // }
      // var total1 = cart['item'][id]['customize'][i]['name'] + ': ';
      // for (int j = 0;
      // j < cart['item'][id]['customize'][i]['options'].length;
      // j++) {
      //   if (j == 0) {
      //     total1 =
      //         total1 + cart['item'][id]['customize'][i]['options'][j]['name'];
      //   } else {
      //     total1 = total1 +
      //         ',' +
      //         cart['item'][id]['customize'][i]['options'][j]['name'];
      //   }
      // }
      return total1;
    };

    // Scroll Into View API: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
    const handleClick = (id) =>
      refs[id].current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    // console.log("Document data:", this.state.businessData);
    var _sessionToken = uuidv4();
    let columns = this.state.width < 1000 ? 1 : this.state.width < 1600 ? 2 : 3;
    // const GOOGLE_MAPS_API_KEY = 'AIzaSyC3aviU6KHXAjoSnxcw6qbOhjnFctbxPkE';

    return this.state.businessData ? (
      <>
        <Snackbar
        style={{zIndex: 9999999}}
          open={this.state.openAlert}
          autoHideDuration={6000}
          onClose={(event, reason) => {
            if (reason === 'clickaway') {
              return;
            }

            this.setState({ openAlert: false });
          }}
        >
          <Alert
            onClose={(event, reason) => {
              if (reason === 'clickaway') {
                return;
              }

              this.setState({ openAlert: false });
            }}
            severity={this.state.alertType}
            sx={{ width: '100%' }}
          >
            {this.state.alertMsg}
          </Alert>
        </Snackbar>

        <Box sx={{ flexGrow: 1 }}>
          <AppBar
            position="sticky"
            color="transparent"
            elevation={1}
            style={{
              border: '0px solid #e2e8f0',
              boxShadow: 'none',
              background: 'transparent',
            }}
          >
            <Toolbar style={{ padding: this.state.width >= 600 ? '0 24px' : '0 5%', minHeight: this.state.width >= 600 ?  '60px' : '56px', }}>
              {this.state.width >= 600 ? (
                <Box
                  textAlign="center"
                  height={'7.5%'}
                  style={{ borderRadius: '50%', width: '40px', }}
                >
                  <img
                    src={this.state.businessData.logo}
                    alt="logo"
                    height={'100%'}
                    style={{ borderRadius: '50%', width: '40px', height: '40px', marginTop: '5px', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px', }}
                  />
                </Box>
              ) : null}{' '}
              {this.state.width < 600 ? (
                <Box style={{ marginRight: '10px', }}>
                  <img
                    src={this.state.businessData.logo}
                    alt="logo"
                    height={'100%'}
                    style={{ borderRadius: '50%', width: '38px', height: '38px', marginTop: '4px', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px', }}
                  />
                </Box>
              ) : null}{' '}

            {this.state.width >= 1000 ? (
              <div>
                <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={0}
                >
                <>{(!this.state.isPreOrder)?
                <Button
                  style={{
                    margin: '1px',
                    backgroundColor: '#fff',
                    textTransform: 'none',
                    borderRight: '0px solid #cccccc',
                    padding: '5px 15px 5px 5px',
                    fontSize: '15px',
                    borderRadius: '12px',
                    margin:"0px 8px 0px 16px"
                  }}
                  variant="text"
                  startIcon={
                    <AccessTimeRoundedIcon style={{ color: '#6a696e', marginLeft: '14px', }} />
                  }
                  endIcon={
                    <ArrowDropDownIcon style={{ color: 'slategray' }} />
                  }
                  onClick={handlePreOrderOpen}
                >
                  <>

                      <span
                        style={{ color: '#2c3036', fontWeight: 'bold' }}
                      >
                        {strings["Ahora"]}
                      </span>
                     {' '}
                  </>
                </Button>: <Button
                  style={{
                    margin: '0px 8px 0px 16px',
                    backgroundColor: '#fff',
                    textTransform: 'none',
                    borderRight: '0px solid #cccccc',
                    padding: '5px 15px 5px 5px',
                    fontSize: '15px',
                    borderRadius: '12px',
                    backgroundColor: getPrimaryColor()
                  }}
                  variant="filled"
                  startIcon={
                    <AccessTimeIcon style={{ color: '#fff', marginLeft: '14px', }} />
                  }
                  endIcon={
                    <CancelIcon style={{ color: '#fff' }} />
                  }
                  onClick={()=>{
                    this.setState(
                        { businessData: null },
                        (newState) => {
                          var weekDay = [6,0,1,2,3,4,5];
                    var currentDay = weekDay[new Date().getDay()];
                    const { id } = this.props.match.params;
                    this.setState({ selectedDate: new Date(), selectedWeekDay: currentDay, busId: id,isTomorrow: false,  isPreOrder: false });

                              handlePreOrderClose();
                              // this.setState({ businessData: {} });
                              this.getCities(id);
                            });

                      }}
                    >
                      <>

                          <span
                            style={{ color: '#fff', fontWeight: 'bold' }}
                          >
                            {((!this.state.isTomorrow)
                                                  ? strings[' Hoy, ']
                                                  : strings[' Mañana, ']) + moment(this.state.selectedDate).add(40, 'm').toDate().getHours()
                                                  .toString() +
                                              ':' +
                                              (Math.round(moment(this.state.selectedDate).add(40, 'm').toDate().getMinutes() /
                                                      10))
                                                  .toString() +
                                              '0'}
                          </span>
                         {' '}
                      </>
                    </Button>
                    }</></Stack>
                  </div>
                ) : null}
                {this.state.selectedType === 0 && this.state.width >= 1000 ? (
                    <Button
                      style={{
                        margin: '1px',
                        backgroundColor: '#fff',
                        textTransform: 'none',
                        borderRight: '0px solid #cccccc',
                        padding: '5px 15px 5px 5px',
                        fontSize: '15px',
                        borderRadius: '6px',
                      }}
                      variant="text"
                      startIcon={
                        <LocationOnIcon style={{ color: getPrimaryColor() }} />
                      }
                      endIcon={
                        <ArrowDropDownIcon style={{ color: getPrimaryColor() }} />
                      }
                      onClick={handleClickOpen}
                    >
                      <>
                        {this.state.width >= 1000 ? (
                          <span
                            style={{ color: getPrimaryColor(), fontWeight: 'bold', textAlign: 'left', }}
                          >
                            {this.state.selectLocationName
                              ? this.state.selectLocationName
                              : strings['Seleccionar mi ubicación']}
                          </span>
                        ) : null}{' '}
                      </>
                    </Button>
                  ) : null}{' '}
              <Search
                style={{
                  borderRadius: 10,
                  backgroundColor: '#f8f9fb',
                  marginLeft: this.state.width < 600 ? '0' : '20px',
                  marginRight: '0',
                }}
              >
                <SearchIconWrapper color={getPrimaryColor()}>
                  <SearchIcon style={{ color: 'white' }} />
                </SearchIconWrapper>
                <StyledInputBase className="inputcolor"
                  placeholder={strings['Buscar producto']}
                  inputProps={{ 'aria-label': 'search' }}
                  placeholderTextColor="#000000"
                  onChange={(e) => {
                    this.handleChange(e);
                  }}
                />
              </Search>
              <Box sx={{ flexGrow: 1 }} />
              <Stack
                height={'1.5%'}
                style={{
                  color: '#2c3036',
                  cursor: 'pointer',
                  marginRight: this.state.width > 999 ? '0' : '10px',
                  display: this.state.width > 599 ? 'flex' : 'none',
                }}
                onClick={() => this.setState({ openBusinessInfo: true })}
              >
                <p style={{ background: 'white', borderRadius: '50px', margin: '0', height: '40px', width: '40px', textAlignLast: 'center', display: 'initial', padding: '0', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px', }}>
                  <InfoRoundedIcon
                    style={{
                      marginTop: '8px',
                      color: getPrimaryColor(),
                    }}
                  />{' '}
                </p>
              </Stack>
              <Box
                sx={{ display: { xs: 'flex', md: 'flex' } }}
                style={{
                  margin: '1px',
                  borderLeft: '0px solid #cccccc',
                  color: getPrimaryColor(),
                }}
              >

              {/* {' Phone footer '} */}
              <div className="showonphone" style={{display: 'flex',position: 'fixed',zIndex: '999',background: 'white',bottom: '0px',right: '0px',boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',borderRadius: '28px 28px 0 0',padding: '12px 18px',width: '100%',height: '64px',}}>
                {/* {' Business info on phoneview '} */}
                <Stack style={{ minWidth: '18%', alignItems: 'center', width: this.state.cart.totalItems > 0 ? '18%' : '33.333%', color: '#2c3036', cursor: 'pointer', }} onClick={() => this.setState({ openBusinessInfo: true })}>
                  <p style={{ background: 'white', borderRadius: '50px', margin: '0', height: '40px', width: '40px', textAlignLast: 'center', display: 'initial', padding: '0', }}>
                    <InfoOutlinedIcon
                      style={{
                        marginTop: '7px',
                        color: '#040607',
                        fontSize: '26px',
                      }}
                    />{' '}
                  </p>
                </Stack>
                {/* {' preorder select on phoneview '} */}
                <div style={{ minWidth: '18%', marginTop: '0px', width: this.state.cart.totalItems > 0 ? '18%' : '33.333%',}}>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={0}
                  >
                  <>{(!this.state.isPreOrder)?
                  <Button
                    style={{
                      height: '40px',
                      backgroundColor: '#fff',
                      textTransform: 'none',
                      borderRight: '0px solid #cccccc',
                      padding: '6px 15px 6px 15px',
                      fontSize: '15px',
                      borderRadius: '12px',
                    }}
                    variant="text"
                    startIcon={
                      <AccessTimeIcon style={{ color: '#040607', fontSize: '26px', marginRight: '-8px', marginLeft: '4px', }} />
                    }
                    onClick={handlePreOrderOpen}
                  >
                    <>
                       {' '}
                    </>
                  </Button>: <Button
                    style={{
                      backgroundColor: '#fff',
                      height: '40px',
                      textTransform: 'none',
                      borderRight: '0px solid #cccccc',
                      padding: '6px 15px 6px 15px',
                      fontSize: '15px',
                      borderRadius: '12px',
                      backgroundColor: getPrimaryColor()
                    }}
                    variant="filled"
                    startIcon={
                      <AccessTimeIcon style={{ color: '#040607', fontSize: '26px', marginRight: '-8px', marginLeft: '4px', }} />
                    }
                    onClick={()=>{
                      this.setState(
                          { businessData: null },
                          (newState) => {
                            var weekDay = [6,0,1,2,3,4,5];
              var currentDay = weekDay[new Date().getDay()];
              const { id } = this.props.match.params;
              this.setState({ selectedDate: new Date(), selectedWeekDay: currentDay, busId: id,isTomorrow: false,  isPreOrder: false });

                            handlePreOrderClose();
                            // this.setState({ businessData: {} });
                            this.getCities(id);
                          });

                    }}
                  >
                    <>
                       {' '}
                    </>
                  </Button>
                  }</></Stack>
                </div>
                {/* {' Select the order type on phone view '} */}
                <FormControl className="ocultatipodeordenrencel" style={{ minWidth: '18%', margin: this.state.cart.totalItems > 0 ? 'auto' : '0px', width: this.state.cart.totalItems > 0 ? '18%' : '33.333%',}}
                  sx={{ m: 0, minWidth: 120, p: 0,display: 'flex',justifyContent: 'center',alignItems: 'center',width: '90%',marginLeft: '5%', height: '40px' }}>
                  <Select
                    style={{height: '40px', boxShadow: 'none', paddingLeft: '20px', marginLeft: this.state.cart.totalItems > 0 ? '7px' : '0', }}
                    value={this.state.selectedType}
                    onChange={(event) => {
                      console.log(event.target.value,this.state.selectedType, (typeof event.target.value));
                      if(event.target.value !== -1) {
                        if(this.state.cart.item.length>0) {
                        this.setState({ selectedType2: event.target.value });
                        handleAlertOpen();
                        } else {
                        this.setState({ selectedType: event.target.value });
                                          console.log(this.state);
                                          if (!this.state.canDeliverHere && event.target.value === 0) {
                                            this.setState({ storeIsOpen: false });
                                          } else if (
                                            !this.state.canDeliverHere &&
                                            (event.target.value === 1 || event.target.value === 2)
                                          ) {
                                            this.setState({ storeIsOpen: true });
                                          }
                            }
                            }
                          }} displayEmpty inputProps={{ 'aria-label': '' }}>
                    <MenuItem value={0}>
                          <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={0}
                      >
                      <DirectionsBikeIcon
                        style={{
                          fontSize: '17px',
                          fontWeight: 'bold',
                          color: getPrimaryColor(),
                          marginRight: '10px',
                        }}
                      />
                      <Typography
                      style={{
                        fontWeight: '700',
                        fontFamily: 'Nunito',
                        textTransform: 'none',
                        padding: '5px 11px',
                        color: '#3e4547',
                      }}
                    >
                      {strings["Entrega a domicilio"]}
                    </Typography>
                    </Stack>
                    </MenuItem>
                    <MenuItem value={1}>
                       <Stack
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                          spacing={0}
                        >
                        <DirectionsRunIcon
                            style={{
                              height: '17px',
                              fontSize: '17px',
                              fontWeight: 'bold',
                              color: getPrimaryColor(),
                              marginRight: '10px',
                            }}
                          />
                          <Typography
                            style={{
                              fontWeight: '700',
                              fontFamily: 'Nunito',
                              textTransform: 'none',
                              padding: '5px 11px',
                              color: '#3e4547',}}>
                          {strings["Recoger en tienda"]}
                        </Typography>
                      </Stack>
                    </MenuItem>
                    <MenuItem value={2}>
                      <Stack
                           direction="row"
                           justifyContent="center"
                           alignItems="center"
                           spacing={0}
                          >
                          <RestaurantMenuIcon
                             style={{
                               height: '17px',
                               fontSize: '17px',
                               fontWeight: 'bold',
                               color: getPrimaryColor(),
                               marginRight: '10px',
                             }}
                           />
                          <Typography
                           style={{
                             fontWeight: '700',
                             fontFamily: 'Nunito',
                             textTransform: 'none',
                             padding: '5px 11px',
                             color: '#3e4547',
                           }}
                         >

                           {strings["Comer en"]}
                         </Typography>
                        </Stack>
                    </MenuItem>
                  </Select>
                </FormControl>
                {/* {' cart on phone view this.state.width < 600 && {this.state.width < 600 && this.state.cart.totalItems > 0 ? ( '} */}
                {this.state.cart.totalItems > 0 ? (
                  <IconButton
                    style={{
                      background: getPrimaryColor(),
                      boxShadow: '0 1px 7px'+getPrimaryColor()+69,
                      borderRadius: '50px',
                      padding: '9px 8px',
                      height: '40px',
                      width: '46%',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'contain',
                      backgroundImage: 'url("https://dl3.pushbulletusercontent.com/TdNV48MFqCOZiU57WBx86aEeoZIl6jhj/Shopping_cart.png")',
                    }}
                    size="large"
                    aria-label=""
                    color="inherit"
                    onClick={() => {
                      if (
                        this.state.cart.totalItems > 0 &&
                        this.state.storeIsOpen
                      ) {
                        handleCartOpen();
                        // this.setState({ showCart: true });
                      }
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: '19px',
                        fontWeight: '800',
                        color: '#ffffff',
                        marginRight: '10px',
                      }}
                    >
                      {strings['Ver pedido']}
                    </Typography>
                    <Badge
                      badgeContent={this.state.cart.totalItems}
                      color="error"
                    >
                    <div className="App">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="kt-svg-icon" sx={{ fill: getPrimaryColor(),}}>
                          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <rect x="0" y="0" width="24" height="24"/>
                              <path d="M12,4.56204994 L7.76822128,9.6401844 C7.4146572,10.0644613 6.7840925,10.1217854 6.3598156,9.76822128 C5.9355387,9.4146572 5.87821464,8.7840925 6.23177872,8.3598156 L11.2317787,2.3598156 C11.6315738,1.88006147 12.3684262,1.88006147 12.7682213,2.3598156 L17.7682213,8.3598156 C18.1217854,8.7840925 18.0644613,9.4146572 17.6401844,9.76822128 C17.2159075,10.1217854 16.5853428,10.0644613 16.2317787,9.6401844 L12,4.56204994 Z" fill="#ffffff" fillRule="nonzero" opacity="0.3"/>
                              <path d="M3.28077641,9 L20.7192236,9 C21.2715083,9 21.7192236,9.44771525 21.7192236,10 C21.7192236,10.0817618 21.7091962,10.163215 21.6893661,10.2425356 L19.5680983,18.7276069 C19.234223,20.0631079 18.0342737,21 16.6576708,21 L7.34232922,21 C5.96572629,21 4.76577697,20.0631079 4.43190172,18.7276069 L2.31063391,10.2425356 C2.17668518,9.70674072 2.50244587,9.16380623 3.03824078,9.0298575 C3.11756139,9.01002735 3.1990146,9 3.28077641,9 Z M12,12 C11.4477153,12 11,12.4477153 11,13 L11,17 C11,17.5522847 11.4477153,18 12,18 C12.5522847,18 13,17.5522847 13,17 L13,13 C13,12.4477153 12.5522847,12 12,12 Z M6.96472382,12.1362967 C6.43125772,12.2792385 6.11467523,12.8275755 6.25761704,13.3610416 L7.29289322,17.2247449 C7.43583503,17.758211 7.98417199,18.0747935 8.51763809,17.9318517 C9.05110419,17.7889098 9.36768668,17.2405729 9.22474487,16.7071068 L8.18946869,12.8434035 C8.04652688,12.3099374 7.49818992,11.9933549 6.96472382,12.1362967 Z M17.0352762,12.1362967 C16.5018101,11.9933549 15.9534731,12.3099374 15.8105313,12.8434035 L14.7752551,16.7071068 C14.6323133,17.2405729 14.9488958,17.7889098 15.4823619,17.9318517 C16.015828,18.0747935 16.564165,17.758211 16.7071068,17.2247449 L17.742383,13.3610416 C17.8853248,12.8275755 17.5687423,12.2792385 17.0352762,12.1362967 Z" fill="#ffffff"/>
                          </g>
                      </svg>
                    </div>
                    </Badge>
                  </IconButton>
                ) : null}
              </div>
              {/* {' Phone footer '} */}

              {/* {' Select the order type on tablet view '} */}
              <div className="showontablet" style={{ display: 'none', }}>
                <FormControl className="ocultatipodeordenrentablet"
                  sx={{ m: 0, minWidth: 120, p: 0,display: 'flex',justifyContent: 'center',alignItems: 'center',width: '90%',marginLeft: '5%', height: '40px' }}>
                  <Select
                    style={{ height: '40px', margin: '0', borderRadius: '14px',}}
                    value={this.state.selectedType}
                    onChange={(event) => {
                      console.log(event.target.value,this.state.selectedType, (typeof event.target.value));
                      if(event.target.value !== -1) {
                        if(this.state.cart.item.length>0) {
                        this.setState({ selectedType2: event.target.value });
                        handleAlertOpen();
                        } else {
                        this.setState({ selectedType: event.target.value });
                                          console.log(this.state);
                                          if (!this.state.canDeliverHere && event.target.value === 0) {
                                            this.setState({ storeIsOpen: false });
                                          } else if (
                                            !this.state.canDeliverHere &&
                                            (event.target.value === 1 || event.target.value === 2)
                                          ) {
                                            this.setState({ storeIsOpen: true });
                                          }
                            }
                          }
                          }} displayEmpty inputProps={{ 'aria-label': '' }}>
                    <MenuItem value={2}>
                      <Stack
                           direction="row"
                           justifyContent="center"
                           alignItems="center"
                           spacing={0}
                          >
                          <RestaurantMenuIcon
                             style={{
                               height: '17px',
                               fontSize: '17px',
                               fontWeight: 'bold',
                               color: getPrimaryColor(),
                               marginRight: '10px',
                             }}
                           />
                          <Typography
                           style={{
                             fontWeight: '700',
                             fontFamily: 'Nunito',
                             textTransform: 'none',
                             padding: '5px 11px',
                             color: '#3e4547',
                           }}
                         >

                           {strings["Comer en"]}
                         </Typography>
                        </Stack>
                    </MenuItem>
                    <MenuItem value={0}>
                          <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={0}
                      >
                      <DirectionsBikeIcon
                        style={{
                          fontSize: '17px',
                          fontWeight: 'bold',
                          color: getPrimaryColor(),
                          marginRight: '10px',
                        }}
                      />
                      <Typography
                      style={{
                        fontWeight: '700',
                        fontFamily: 'Nunito',
                        textTransform: 'none',
                        padding: '5px 11px',
                        color: '#3e4547',
                      }}
                    >
                      {strings["Entrega a domicilio"]}
                    </Typography>
                    </Stack>
                    </MenuItem>
                    <MenuItem value={1}>
                       <Stack
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={0}
                    >
                    <DirectionsRunIcon
                        style={{
                          height: '17px',
                          fontSize: '17px',
                          fontWeight: 'bold',
                          color: getPrimaryColor(),
                          marginRight: '10px',
                        }}
                      />
                      <Typography
                        style={{
                          fontWeight: '700',
                          fontFamily: 'Nunito',
                          textTransform: 'none',
                          padding: '5px 11px',
                          color: '#3e4547',}}>
                      {strings["Recoger en tienda"]}
                    </Typography>
                  </Stack>
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
              {/* {' Select the order type on tablet view '} */}
              {/* {' Preorder select on tablet view '} */}
              {this.state.width < 1000 && this.state.width > 599? (
                <div style={{ marginTop: '0px', }}>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={0}
                  >
                  <>{(!this.state.isPreOrder)?
                  <Button
                    style={{
                      height: '40px',
                      backgroundColor: '#fff',
                      textTransform: 'none',
                      borderRight: '0px solid #cccccc',
                      padding: '6px 15px 6px 15px',
                      fontSize: '15px',
                      borderRadius: '12px',
                      margin: '0 0 0 12px',
                    }}
                    variant="text"
                    startIcon={
                      <AccessTimeIcon style={{ color: '#646464', fontSize: '26px', marginRight: '-8px', marginLeft: '4px', }} />
                    }
                    onClick={handlePreOrderOpen}
                  >
                    <>
                       {' '}
                    </>
                  </Button>: <Button
                    style={{
                      backgroundColor: '#fff',
                      height: '40px',
                      textTransform: 'none',
                      borderRight: '0px solid #cccccc',
                      padding: '6px 15px 6px 15px',
                      fontSize: '15px',
                      borderRadius: '12px',
                      backgroundColor: getPrimaryColor(),
                      margin: '0 12px',
                    }}
                    variant="filled"
                    startIcon={
                      <AccessTimeIcon style={{ color: '#fff', fontSize: '26px', marginRight: '-8px', marginLeft: '4px', }} />
                    }
                    onClick={()=>{
                      this.setState(
                          { businessData: null },
                          (newState) => {
                            var weekDay = [6,0,1,2,3,4,5];
              var currentDay = weekDay[new Date().getDay()];
              const { id } = this.props.match.params;
              this.setState({ selectedDate: new Date(), selectedWeekDay: currentDay, busId: id,isTomorrow: false,  isPreOrder: false });

                            handlePreOrderClose();
                            // this.setState({ businessData: {} });
                            this.getCities(id);
                          });

                    }}
                  >
                    <>
                       {' '}
                    </>
                  </Button>
                  }</></Stack>
                </div>
              ) : null}
              {/* <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
                style={{
                  background: 'white',
                  boxShadow: 'rgb(149 157 165 / 20%) 0px 8px 24px',
                  padding: '9px',
                  marginRight: '0',
                }}
              >
                {this.state.photoURL ? (
                  <img
                    style={{
                      verticalAlign: 'middle',
                      width: '30px',
                      height: '30px',
                      borderRadius: '50%',
                    }}
                    src={this.state.photoURL}
                  />
                ) : (
                  <TuneRoundedIcon style={{ fontSize: '21px', }}/>
                )}
              </IconButton> */}
              </Box>
              <>
                {this.state.width > 599 && this.state.cart.totalItems > 0 ? (
                <IconButton
                  style={{
                    height: '90px',
                    width: '250px',
                    position: 'fixed',
                    bottom: '14px',
                    right: '20px',
                    background: '#ffffff',
                    borderRadius: '16px',
                    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
                    border: '2px solid #ffffff',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    paddingLeft: '50px',
                    backgroundImage: 'url("https://dl3.pushbulletusercontent.com/TdNV48MFqCOZiU57WBx86aEeoZIl6jhj/Shopping_cart.png")',
                  }}
                  size="large"
                  aria-label=""
                  color="inherit"
                  onClick={() => {
                    if (
                      this.state.cart.totalItems > 0 &&
                      this.state.storeIsOpen
                    ) {
                      handleCartOpen();
                      // this.setState({ showCart: true });
                    }
                  }}
                >
                  <Badge
                    badgeContent={this.state.cart.totalItems}
                    color="error"
                  >
                    <div className="App">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" className="kt-svg-icon" sx={{ fill: getPrimaryColor(),}}>
                          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <rect x="0" y="0" width="24" height="24"/>
                              <path d="M12,4.56204994 L7.76822128,9.6401844 C7.4146572,10.0644613 6.7840925,10.1217854 6.3598156,9.76822128 C5.9355387,9.4146572 5.87821464,8.7840925 6.23177872,8.3598156 L11.2317787,2.3598156 C11.6315738,1.88006147 12.3684262,1.88006147 12.7682213,2.3598156 L17.7682213,8.3598156 C18.1217854,8.7840925 18.0644613,9.4146572 17.6401844,9.76822128 C17.2159075,10.1217854 16.5853428,10.0644613 16.2317787,9.6401844 L12,4.56204994 Z" fill="#000000" fillRule="nonzero" opacity="0.3"/>
                              <path d="M3.28077641,9 L20.7192236,9 C21.2715083,9 21.7192236,9.44771525 21.7192236,10 C21.7192236,10.0817618 21.7091962,10.163215 21.6893661,10.2425356 L19.5680983,18.7276069 C19.234223,20.0631079 18.0342737,21 16.6576708,21 L7.34232922,21 C5.96572629,21 4.76577697,20.0631079 4.43190172,18.7276069 L2.31063391,10.2425356 C2.17668518,9.70674072 2.50244587,9.16380623 3.03824078,9.0298575 C3.11756139,9.01002735 3.1990146,9 3.28077641,9 Z M12,12 C11.4477153,12 11,12.4477153 11,13 L11,17 C11,17.5522847 11.4477153,18 12,18 C12.5522847,18 13,17.5522847 13,17 L13,13 C13,12.4477153 12.5522847,12 12,12 Z M6.96472382,12.1362967 C6.43125772,12.2792385 6.11467523,12.8275755 6.25761704,13.3610416 L7.29289322,17.2247449 C7.43583503,17.758211 7.98417199,18.0747935 8.51763809,17.9318517 C9.05110419,17.7889098 9.36768668,17.2405729 9.22474487,16.7071068 L8.18946869,12.8434035 C8.04652688,12.3099374 7.49818992,11.9933549 6.96472382,12.1362967 Z M17.0352762,12.1362967 C16.5018101,11.9933549 15.9534731,12.3099374 15.8105313,12.8434035 L14.7752551,16.7071068 C14.6323133,17.2405729 14.9488958,17.7889098 15.4823619,17.9318517 C16.015828,18.0747935 16.564165,17.758211 16.7071068,17.2247449 L17.742383,13.3610416 C17.8853248,12.8275755 17.5687423,12.2792385 17.0352762,12.1362967 Z" fill="#000000"/>
                          </g>
                      </svg>
                    </div>
                  </Badge>
                  <Typography
                    style={{
                      fontSize: '18px',
                      color: '#464c51',
                      paddingLeft: '20px',
                      fontWeight: '500',
                    }}
                  >{strings["carritoeatin"]}
                  </Typography>
                </IconButton>
                ) : null}
              </>
              <Box sx={{ display: { xs: 'none', md: 'none' } }}>
                <IconButton
                  size="large"
                  aria-label="show more"
                  aria-controls={mobileMenuId}
                  aria-haspopup="true"
                  onClick={handleMobileMenuOpen}
                  color="inherit"
                >
                  <MoreIcon />
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
          {renderMobileMenu}
          {renderMenu}
        </Box>
        <VariablesDialog
          selectedValue={this.state.selectedValue}
          open={this.state.openVariable}
          onClose={handleCloseVariable}
          title={
            this.state.selectedProduct ? this.state.selectedProduct.name : ''
          }
          displayList={
            this.state.selectedProduct ? (
              <DialogContent dividers style={{ padding: '5px 24px', border: '0', }}>
                <div
                  style={{ width: this.state.width < 1000 ? '100%' : '100vh' }}
                >
                  <div
                    style={{
                      width: '100%',
                      height:
                        this.state.width < 600
                          ? 'calc( 80vh)'
                          : 'calc( 100vh - 185px )', //change this for webview
                      overflow: 'hidden',
                    }}
                  >
                    {this.state.width >= 1000 ? (
                      <div
                        style={{
                          width: '49.9%',
                          height: '100%',
                          float: 'left',
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: '#ffffff',
                            width: '100%',
                            height: 'calc(70%)',
                          }}
                        >
                          {this.state.selectedProduct.images ? (
                            <img
                              src={this.state.selectedProduct.images}
                              style={{
                                borderRadius: '8px',
                                width: 'calc(100% - 40px)',
                                height: 'calc(90%)',
                                objectFit: 'cover',
                              }}
                            />
                          ) : (
                            <></>
                          )}
                        </div>

                        <Typography
                          style={{
                            fontSize: '16px',
                            color: '#464c51',
                            paddingRight: '10px',
                          }}
                        >
                          {this.state.selectedProduct.description
                            ? this.state.selectedProduct.description
                            : ''}
                        </Typography>
                      </div>
                    ) : null}
                    <div
                      style={{
                        width: this.state.width < 1000 ? '100%' : '50%',
                        height: '100%',
                        float: 'right',
                        overflow: 'auto',
                      }}
                    >
                      {this.state.width < 1000 ? (
                        <div
                          style={{
                            width: '100%',
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: '#ffffff',
                              width: '100%',
                              // height: 'calc(300px)',
                            }}
                          >
                            {this.state.selectedProduct.images ? (
                              <img
                                src={this.state.selectedProduct.images}
                                style={{
                                  borderRadius: '12px',
                                  width: 'calc(100%)',
                                  // height: 'calc(75%)',
                                  objectFit: 'cover',
                                  height: '160px',
                                }}
                              />
                            ) : (
                              <></>
                            )}
                          </div>
                          <Box height={'8px'}></Box>

                          <Typography
                            style={{ fontSize: '16px', color: '#464c51' }}
                          >
                            {this.state.selectedProduct.description
                              ? this.state.selectedProduct.description
                              : ''}
                          </Typography>
                        </div>
                      ) : null}
                      {/* {' '} */}
                      <List sx={{ pt: 0 }}>
                        {this.state.selectedProduct.customize.map((email, j) =>
                          (email['enabled'] ||
                            (!email['enabled'] &&
                              email['willBeAvailableAt'] != null &&
                              moment().isAfter(
                                moment(email['willBeAvailableAt'].toDate())
                              ))) &&
                          (email['conditioned'] == null ||
                            !email['conditioned'] ||
                            (email['conditioned'] != null &&
                              email['conditioned'] &&
                              this.state.productIds.includes(
                                email['conditionOption']
                              ))) ? (
                            <>
                              <div
                                key={email.id}
                                ref={refs[email.id]}
                                style={{
                                  backgroundColor: '#ffffff',
                                  margin: '10px 0px 25px 0px',
                                  width: 'calc(100% - 0px)',
                                }}
                              >
                                <Typography
                                  style={{
                                    padding: '0px 10px 0px 0px',
                                    fontSize: '17.4px',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {email.name}
                                </Typography>
                                <Typography
                                  style={{
                                    padding: '2px 10px 0px 0px',
                                    fontSize: '13px',
                                    fontWeight: '400',
                                    color: 'slategray',
                                  }}
                                >
                                  {email['min'] >= 1
                                    ? email['max'] === email['min']
                                      ? strings['Obligatorio']
                                      : email['max']
                                      ? strings['Selecciona al menos '] +
                                        email['min'].toString()
                                      : strings['Selecciona de '] +
                                        email['min'].toString() +
                                        strings['.Hasta '] +
                                        email['max'].toString()
                                    : email['max'] == null
                                    ? ''
                                    : strings['Selecciona hasta '] +
                                      email['max'].toString()}
                                </Typography>
                                <div
                                  style={{
                                    backgroundColor: '#ffffff',
                                    padding: '0px 0px 0px',
                                    width: 'calc(100% - 0px)',
                                  }}
                                >
                                  {email.options.map((image) =>
                                    image['enabled'] ||
                                    (!image['enabled'] &&
                                      image['willBeAvailableAt'] != null &&
                                      moment().isAfter(
                                        moment(
                                          image['willBeAvailableAt'].toDate()
                                        )
                                      )) ? (
                                      <>
                                        <div
                                          key={image.id}
                                          style={{
                                            borderBottom: '1px solid #e6ebf1',
                                          }}
                                          onClick={async () => {
                                            // console.log('hdjdjfhf');
                                            var productIds = JSON.parse(
                                              JSON.stringify(
                                                this.state.productIds
                                              )
                                            );
                                            var tempOrder = JSON.parse(
                                              JSON.stringify(
                                                this.state.tempOrder
                                              )
                                            );
                                            if (
                                              !tempOrder['customize'][j][
                                                'options'
                                              ].find(
                                                (opt) =>
                                                  opt['id'] === image['id']
                                              )
                                            ) {
                                              // console.log('hdjdjfhf', 1);
                                              if (
                                                email['max'] &&
                                                this.state.tempOrder[
                                                  'customize'
                                                ][j]['options'].length ===
                                                  email['max']
                                              ) {
                                                // console.log('hdjdjfhf', 2);
                                                // setState(() {
                                                const index =
                                                  productIds.indexOf(
                                                    tempOrder['customize'][j][
                                                      'options'
                                                    ][0]['id']
                                                  );
                                                if (index > -1) {
                                                  // only splice array when item is found
                                                  productIds.splice(index, 1); // 2nd parameter means remove one item only
                                                }

                                                tempOrder['price'] =
                                                  tempOrder['price'] -
                                                  tempOrder['customize'][j][
                                                    'options'
                                                  ][0]['price'];
                                                tempOrder['originalPrice'] =
                                                  tempOrder['originalPrice'] -
                                                  tempOrder['customize'][j][
                                                    'options'
                                                  ][0]['originalPrice'];
                                                tempOrder['customize'][j][
                                                  'options'
                                                ].splice(0, 1);
                                                // if(!menuIds.contains(menus2[i -
                                                //     3]['products'][index]['customize'][j]['id'])) {
                                                //   menuIds.add(menus2[i -
                                                //       3]['products'][index]['customize'][j]['id']);
                                                // }

                                                tempOrder['addons'] =
                                                  tempOrder['addons'] - 1;
                                                productIds.push(image['id']);
                                                tempOrder['customize'][j][
                                                  'options'
                                                ].push({
                                                  name: image['name'],
                                                  id: image['id'],
                                                  originalPrice:
                                                    this.state.businessData
                                                      .partner != null &&
                                                    this.state.businessData
                                                      .partner
                                                      ? image['price']
                                                      : image['price'] +
                                                        image['price'] *
                                                          (this.state
                                                            .businessData.tax /
                                                            100),
                                                  price:
                                                    Number(((this.state.businessData
                                                      .partner != null &&
                                                    this.state.businessData
                                                      .partner
                                                      ? image['price']
                                                      : image['price'] +
                                                        image['price'] *
                                                          (this.state
                                                            .businessData.tax /
                                                            100))*multiFactor()).toFixed(multiFactor()>1?0:2)),
                                                });
                                                tempOrder['price'] =
                                                  tempOrder['price'] +
                                                  Number(((this.state.businessData
                                                    .partner != null &&
                                                  this.state.businessData
                                                    .partner
                                                    ? image['price']
                                                    : image['price'] +
                                                      image['price'] *
                                                        (this.state.businessData
                                                          .tax /
                                                          100))*multiFactor()).toFixed(multiFactor()>1?0:2));
                                                  tempOrder['originalPrice'] =
                                                  tempOrder['originalPrice'] +
                                                  (this.state.businessData
                                                    .partner != null &&
                                                  this.state.businessData
                                                    .partner
                                                    ? image['price']
                                                    : image['price'] +
                                                      image['price'] *
                                                        (this.state.businessData
                                                          .tax /
                                                          100));
                                                tempOrder['addons'] =
                                                  tempOrder['addons'] + 1;
                                                // });
                                              } else {
                                                // setState(() {
                                                productIds.push(image['id']);
                                                tempOrder['customize'][j][
                                                  'options'
                                                ].push({
                                                  name: image['name'],
                                                  id: image['id'],
                                                  originalPrice:
                                                    this.state.businessData
                                                      .partner != null &&
                                                    this.state.businessData
                                                      .partner
                                                      ? image['price']
                                                      : image['price'] +
                                                        image['price'] *
                                                          (this.state
                                                            .businessData.tax /
                                                            100),
                                                  price:
                                                    Number(((this.state.businessData
                                                      .partner != null &&
                                                    this.state.businessData
                                                      .partner
                                                      ? image['price']
                                                      : image['price'] +
                                                        image['price'] *
                                                          (this.state
                                                            .businessData.tax /
                                                            100))*multiFactor()).toFixed(multiFactor()>1?0:2)),
                                                });
                                                tempOrder['price'] =
                                                  tempOrder['price'] +
                                                  Number(((this.state.businessData
                                                    .partner != null &&
                                                  this.state.businessData
                                                    .partner
                                                    ? image['price']
                                                    : image['price'] +
                                                      image['price'] *
                                                        (this.state.businessData
                                                          .tax /
                                                          100))*multiFactor()).toFixed(multiFactor()>1?0:2));
                                                          tempOrder['originalPrice'] =
                                                  tempOrder['originalPrice'] +
                                                  (this.state.businessData
                                                    .partner != null &&
                                                  this.state.businessData
                                                    .partner
                                                    ? image['price']
                                                    : image['price'] +
                                                      image['price'] *
                                                        (this.state.businessData
                                                          .tax /
                                                          100));
                                                tempOrder['addons'] =
                                                  tempOrder['addons'] + 1;
                                                // });
                                              }
                                            } else {
                                              // console.log('hdjdjfhf', 12);
                                              if (email['min']) {
                                                // console.log('hdjdjfhf', 22);
                                                if (
                                                  tempOrder['customize'][j][
                                                    'options'
                                                  ].length > email['min']
                                                ) {
                                                  // console.log('hdjdjfhf', 23);
                                                  // setState(() {
                                                  const index =
                                                    productIds.indexOf(
                                                      image['id']
                                                    );
                                                  if (index > -1) {
                                                    // only splice array when item is found
                                                    productIds.splice(index, 1); // 2nd parameter means remove one item only
                                                  }
                                                  // productIds
                                                  //     .remove(
                                                  //     menus2[i -
                                                  //         3]['products'][index]['customize'][j]['options'][k]['id']);
                                                  tempOrder['customize'][j][
                                                    'options'
                                                  ] = tempOrder['customize'][j][
                                                    'options'
                                                  ].filter(
                                                    (item) =>
                                                      item['id'] !== image['id']
                                                  );
                                                  // tempOrder['customize'][j]['options']
                                                  //     .removeWhere((
                                                  //     item) =>
                                                  // item['id'] ==
                                                  //     menus2[i -
                                                  //         3]['products'][index]['customize'][j]['options'][k]['id']);
                                                  tempOrder['price'] =
                                                    tempOrder['price'] -
                                                    Number(((this.state.businessData
                                                      .partner != null &&
                                                    this.state.businessData
                                                      .partner
                                                      ? image['price']
                                                      : image['price'] +
                                                        image['price'] *
                                                          (this.state
                                                            .businessData.tax /
                                                            100))*multiFactor()).toFixed(multiFactor()>1?0:2));
                                                    tempOrder['originalPrice'] =
                                                    tempOrder['originalPrice'] -
                                                    (this.state.businessData
                                                      .partner != null &&
                                                    this.state.businessData
                                                      .partner
                                                      ? image['price']
                                                      : image['price'] +
                                                        image['price'] *
                                                          (this.state
                                                            .businessData.tax /
                                                            100));
                                                  tempOrder['addons'] =
                                                    tempOrder['addons'] - 1;
                                                  // });
                                                } else {
                                                  // console.log(
                                                  //   'hdjdjfhf',
                                                  //   122,
                                                  //   tempOrder['customize'][j][
                                                  //     'options'
                                                  //   ].length,
                                                  //   email['min']
                                                  // );
                                                }
                                              } else {
                                                // setState(() {
                                                const index =
                                                  productIds.indexOf(
                                                    image['id']
                                                  );
                                                if (index > -1) {
                                                  // only splice array when item is found
                                                  productIds.splice(index, 1); // 2nd parameter means remove one item only
                                                }
                                                // productIds
                                                //     .remove(
                                                //     menus2[i -
                                                //         3]['products'][index]['customize'][j]['options'][k]['id']);
                                                tempOrder['customize'][j][
                                                  'options'
                                                ] = tempOrder['customize'][j][
                                                  'options'
                                                ].filter(
                                                  (item) =>
                                                    item['id'] !== image['id']
                                                );
                                                // tempOrder['customize'][j]['options']
                                                //     .removeWhere((
                                                //     item) =>
                                                // item['id'] ==
                                                //     menus2[i -
                                                //         3]['products'][index]['customize'][j]['options'][k]['id']);
                                                tempOrder['price'] =
                                                  tempOrder['price'] -
                                                  Number(((this.state.businessData
                                                    .partner != null &&
                                                  this.state.businessData
                                                    .partner
                                                    ? image['price']
                                                    : image['price'] +
                                                      image['price'] *
                                                        (this.state.businessData
                                                          .tax /
                                                          100))*multiFactor()).toFixed(multiFactor()>1?0:2));
                                                tempOrder['originalPrice'] =
                                                  tempOrder['originalPrice'] -
                                                  (this.state.businessData
                                                    .partner != null &&
                                                  this.state.businessData
                                                    .partner
                                                    ? image['price']
                                                    : image['price'] +
                                                      image['price'] *
                                                        (this.state.businessData
                                                          .tax /
                                                          100));
                                                tempOrder['addons'] =
                                                  tempOrder['addons'] - 1;
                                                // });
                                              }
                                            }
                                            this.setState({
                                              tempOrder: tempOrder,
                                              productIds: productIds,
                                            });
                                            // console.log(
                                            //   'hdjdjfhf',
                                            //   tempOrder,
                                            //   productIds
                                            // );
                                          }}
                                        >
                                          <Box
                                            sx={{ flexGrow: 1 }}
                                            style={{
                                              backgroundColor: '#ffffff',
                                              margin: '10px 0px 10px 0px',
                                              width: 'calc(100%)',
                                              cursor: 'pointer',
                                            }}
                                          >
                                            <Grid
                                              style={{
                                                marginLeft: '0px',
                                                width: 'calc(100% + 0px)',
                                                justifyContent: 'left',
                                              }}
                                              container
                                              spacing={1}
                                              direction="row"
                                              alignItems="center"
                                              justifyContent="center"
                                            >
                                              <Grid
                                                style={{ paddingLeft: '0px' }}
                                                item
                                                xs="1"
                                              >
                                                <Checkbox
                                                  style={{
                                                    paddingLeft: '0px',
                                                    color: getPrimaryColor(),
                                                  }}
                                                  checked={
                                                    !this.state.tempOrder[
                                                      'customize'
                                                    ][j]['options'].find(
                                                      (opt) =>
                                                        opt['id'] ===
                                                        image['id']
                                                    )
                                                      ? false
                                                      : true
                                                  }
                                                  onChange={() => {}}
                                                />
                                              </Grid>
                                              <Grid
                                                item
                                                xs
                                                style={{
                                                  paddingLeft: '0px',
                                                  maxWidth: '65%',
                                                }}
                                              >
                                                <Typography
                                                  style={{
                                                    fontSize: '15px',
                                                    fontWeight: 'light',
                                                    paddingLeft: '5px',
                                                  }}
                                                >
                                                  {' '}
                                                  {image.name}
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                xs="1"
                                                style={{
                                                  maxWidth: '85px',
                                                  right: '0',
                                                  position: 'absolute',
                                                }}
                                              >
                                                <Typography
                                                  style={{
                                                    fontSize: '14px',
                                                    fontWeight: '400',
                                                    color: '#6a696e',
                                                  }}
                                                >
                                                  {Number(((this.state.businessData
                                                    .partner != null &&
                                                  this.state.businessData
                                                    .partner
                                                    ? image['price']
                                                    : image['price'] +
                                                      image['price'] *
                                                        (this.state.businessData
                                                          .tax /
                                                          100))*multiFactor()).toFixed(multiFactor()>1?0:2)) > 0
                                                    ? '+¢' +
                                                      ((this.state.businessData
                                                        .partner != null &&
                                                      this.state.businessData
                                                        .partner
                                                        ? image['price']
                                                        : image['price'] +
                                                          image['price'] *
                                                            (this.state
                                                              .businessData
                                                              .tax /
                                                              100)
                                                      )*multiFactor()).toFixed(multiFactor()>1?0:2)
                                                    : ''}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Box>
                                        </div>
                                      </>
                                    ) : null
                                  )}
                                </div>
                              </div>
                            </>
                          ) : null
                        )}
                      </List>{' '}
                    </div>
                  </div>
                  {this.state.storeIsOpen ? (
                    <div
                      style={{
                        width: 'calc(100% - 48px)',
                        height: 'calc( 69px )',
                        overflow: 'hidden',
                        marginBottom: '1px',
                        paddingTop: '7px',
                        bottom: '0',
                        position: 'absolute',
                        background: 'white',
                      }}
                    >
                      <div
                        style={{
                          width: this.state.width > 900 ?'33.34%':'49.9%',
                          height: '100%',
                          float: 'left',
                        }}
                      >
                        <Grid
                          container
                          spacing={0}
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <ButtonGroup
                            variant="text"
                            disableElevation
                            size={'small'}
                            style={{
                              backgroundColor: '#f8f9fb',
                              borderRadius: this.state.width < 600 ? '12px' : '8px',
                              height: this.state.width < 600 ? '52px' : '48px',
                              width: this.state.width < 600 ? 'auto' : '200px',
                              marginRight:
                                this.state.width < 600 ? 'auto' : 'inherit',
                            }}
                          >
                            <Button
                              style={{
                                borderRadius: this.state.width < 600 ?'12px 0 0 12px' : '8px 0 0 8px',
                                border: 'none',
                                minWidth:
                                  this.state.width < 600 ? '45px' : '33.333%',
                              }}
                              onClick={() => {
                                if (this.state.tempOrder['quantity'] === 1) {
                                  handleCloseVariable();
                                } else
                                  this.setState((prevState) => ({
                                    tempOrder: {
                                      ...prevState.tempOrder, // copy all other key-value pairs of food object
                                      quantity:
                                        this.state.tempOrder['quantity'] - 1,
                                    },
                                  }));
                              }}
                            >
                              <RemoveRoundedIcon
                                sx={{ color: '#000' }}
                                style={{
                                  fontSize: '25px',
                                  fontWeight: 'bold',
                                  color: '#06696e',
                                }}
                              />

                            </Button>
                            <Button
                              disabled
                              style={{
                                border: 'none',
                                minWidth:
                                  this.state.width < 600 ? '45px' : '33.333%',
                              }}
                            >

                              <Typography
                                style={{
                                  fontSize: '20px',
                                  fontWeight: 'bold',
                                  textAlign: 'center',
                                  color: '#272727',
                                }}
                              >
                                {this.state.tempOrder['quantity']}
                              </Typography>

                            </Button>
                            <Button
                              style={{
                                borderRadius: this.state.width < 600 ?'0 12px 12px 0' : '0 8px 8px 0',
                                border: 'none',
                                minWidth:
                                  this.state.width < 600 ? '45px' : '33.333%',
                              }}
                              onClick={() => {
                                this.setState((prevState) => ({
                                  tempOrder: {
                                    ...prevState.tempOrder, // copy all other key-value pairs of food object
                                    quantity:
                                      this.state.tempOrder['quantity'] + 1,
                                  },
                                }));
                              }}
                            >
                              <AddRoundedIcon
                                sx={{ color: '#000' }}
                                style={{
                                  fontSize: '25px',
                                  fontWeight: 'bold',
                                  color: '#06696e',
                                }}
                              />
                            </Button>
                          </ButtonGroup>{' '}
                        </Grid>
                      </div>

                      <div
                        style={{
                          width: this.state.width > 900 ?'33.33%':'50%',
                          height: '100%',
                          float: 'right',
                        }}
                      >
                        <Grid
                          container
                          spacing={0}
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Button
                            onClick={() => {
                              var tempOrder = JSON.parse(
                                JSON.stringify(this.state.tempOrder)
                              );
                              var cart = JSON.parse(
                                JSON.stringify(this.state.cart)
                              );
                              if (tempOrder['customize'] == null)
                                tempOrder['customize'] = [];
                              cart['item'].push(tempOrder);
                              cart['totalCost'] =
                                cart['totalCost'] +
                                tempOrder['price'] * tempOrder['quantity'];
                              cart['totalItems'] =
                                cart['totalItems'] + tempOrder['quantity'];
                              if (
                                cart['maxTime'] != null &&
                                tempOrder['time'] != null &&
                                cart['maxTime'] < tempOrder['time']
                              ) {
                                cart['maxTime'] = tempOrder['time'];
                              }
                              this.setState({
                                tempOrder: tempOrder,
                                cart: cart,
                              });
                              handleCloseVariable();
                            }}
                            variant="contained"
                            style={{
                              width: '240px',
                              borderRadius: this.state.width < 600 ? '12px' : '8px',
                              textAlign: 'center',
                              fontSize: this.state.width < 600 ? '18px' : '16px',
                              fontWeight: '800',
                              textTransform: 'none',
                              color: '#fff',
                              fontFamily: 'Nunito',
                              letterSpacing: 'normal',
                              boxShadow: 'none',
                              padding: '10px',
                              backgroundColor: getPrimaryColor(),
                            }}
                          >
                            {(this.state.width > 599 ? strings['Agregar ¢'] : '+¢') +
                              (
                                this.state.tempOrder['price'] *
                                this.state.tempOrder['quantity']
                              ).toFixed(2)}
                          </Button>
                        </Grid>{' '}
                      </div>
                      <div
                        style={{
                          width: this.state.width > 999 ?'33.33%':'50%',
                          height: '100%',
                          float: 'right',
                          display: this.state.width > 999 ?'block':'none',
                        }}
                      >
                        <Grid
                          container
                          spacing={0}
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Button
                            onClick={() => {
                              handleCloseVariable();
                            }}
                            variant="contained"
                            style={{
                              width: '150px',
                              borderRadius: this.state.width < 600 ? '12px' : '8px',
                              textAlign: 'center',
                              fontSize: this.state.width < 600 ? '18px' : '16px',
                              fontWeight: '800',
                              textTransform: 'none',
                              color: '#fff',
                              fontFamily: 'Nunito',
                              letterSpacing: 'normal',
                              boxShadow: 'none',
                              padding: '10px',
                              backgroundColor: 'lightslategray',
                            }}
                          >
                            {strings['Cancelar']}
                          </Button>
                        </Grid>{' '}
                      </div>
                    </div>
                  ) : !this.state.canDeliverHere ? <div
                      style={{
                        width: 'calc(100% - 48px)',
                        height: 'calc( 69px )',
                        overflow: 'hidden',
                        marginBottom: '1px',
                        paddingTop: '7px',
                        bottom: '0',
                        position: 'absolute',
                        background: 'white',
                      }}
                    >
                      <div
                        style={{
                          width: this.state.width > 900 ?'33.34%':'49.9%',
                          height: '100%',
                          float: 'left',
                        }}
                      >
                        <Grid
                          container
                          spacing={0}
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <ButtonGroup
                            variant="text"
                            disableElevation
                            size={'small'}
                            style={{
                              backgroundColor: '#f8f9fb',
                              borderRadius: this.state.width < 600 ? '12px' : '8px',
                              height: this.state.width < 600 ? '52px' : '48px',
                              width: this.state.width < 600 ? 'auto' : '200px',
                              marginRight:
                                this.state.width < 600 ? 'auto' : 'inherit',
                            }}
                          >
                            <Button
                              style={{
                                borderRadius: this.state.width < 600 ?'12px 0 0 12px' : '8px 0 0 8px',
                                border: 'none',
                                minWidth:
                                  this.state.width < 600 ? '45px' : '33.333%',
                              }}
                            >
                              <RemoveRoundedIcon
                                sx={{ color: '#000' }}
                                style={{
                                  fontSize: '25px',
                                  fontWeight: 'bold',
                                  color: '#06696e',
                                }}
                                onClick={() => {
                                  if (this.state.tempOrder['quantity'] === 1) {
                                    handleCloseVariable();
                                  } else
                                    this.setState((prevState) => ({
                                      tempOrder: {
                                        ...prevState.tempOrder,
                                        quantity:
                                          this.state.tempOrder['quantity'] - 1,
                                      },
                                    }));
                                }}
                              />

                            </Button>
                            <Button
                              disabled
                              style={{
                                border: 'none',
                                minWidth:
                                  this.state.width < 600 ? '45px' : '33.333%',
                              }}
                            >

                              <Typography
                                style={{
                                  fontSize: '20px',
                                  fontWeight: 'bold',
                                  textAlign: 'center',
                                  color: '#272727',
                                }}
                              >
                                {this.state.tempOrder['quantity']}
                              </Typography>

                            </Button>
                            <Button
                              style={{
                                borderRadius: this.state.width < 600 ?'0 12px 12px 0' : '0 8px 8px 0',
                                border: 'none',
                                minWidth:
                                  this.state.width < 600 ? '45px' : '33.333%',
                              }}
                            >

                              <AddRoundedIcon
                                sx={{ color: '#000' }}
                                style={{
                                  fontSize: '25px',
                                  fontWeight: 'bold',
                                  color: '#06696e',
                                }}
                                onClick={() => {
                                  this.setState((prevState) => ({
                                    tempOrder: {
                                      ...prevState.tempOrder,
                                      quantity:
                                        this.state.tempOrder['quantity'] + 1,
                                    },
                                  }));
                                }}
                              />
                            </Button>
                          </ButtonGroup>{' '}
                        </Grid>
                      </div>
                      <div
                        style={{
                          width: this.state.width > 999 ?'33.33%':'50%',
                          height: '100%',
                          float: 'right',
                        }}
                      >
                        <Grid
                          container
                          spacing={0}
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Button
                            onClick={() => {
                              handleCloseVariable();
                              handleClickOpen();
                            }}
                            variant="contained"
                            style={{
                              width: '240px',
                              borderRadius: this.state.width < 600 ? '12px' : '8px',
                              textAlign: 'center',
                              fontSize: this.state.width < 600 ? '18px' : '16px',
                              fontWeight: '800',
                              textTransform: 'none',
                              color: '#fff',
                              fontFamily: 'Nunito',
                              letterSpacing: 'normal',
                              boxShadow: 'none',
                              padding: '10px',
                              backgroundColor: getPrimaryColor(),
                            }}
                          >
                            {(this.state.width > 900 ? strings['Por favor ingresa tu dirección'] : strings['Ingresar dirección'])}
                          </Button>
                        </Grid>{' '}
                      </div>
                      <div
                        style={{
                          width: this.state.width > 999 ?'33.33%':'50%',
                          height: '100%',
                          float: 'right',
                          display: this.state.width > 999 ?'block':'none',
                        }}
                      >
                        <Grid
                          container
                          spacing={0}
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Button
                            onClick={() => {
                              handleCloseVariable();
                            }}
                            variant="contained"
                            style={{
                              width: '150px',
                              borderRadius: this.state.width < 600 ? '12px' : '8px',
                              textAlign: 'center',
                              fontSize: this.state.width < 600 ? '18px' : '16px',
                              fontWeight: '800',
                              textTransform: 'none',
                              color: '#fff',
                              fontFamily: 'Nunito',
                              letterSpacing: 'normal',
                              boxShadow: 'none',
                              padding: '10px',
                              backgroundColor: 'lightslategray',
                            }}
                          >
                            {strings['Cancelar']}
                          </Button>
                        </Grid>{' '}
                      </div>
                    </div>:null}
                </div>
              </DialogContent>
            ) : null
          }
        ></VariablesDialog>
        <LoginDialog
          selectedValue={this.state.selectedValue}
          open={this.state.openLogin}
          onClose={handleCloseLogin}
          displayList={
            <DialogContent dividers>
              <div className="showonphone">
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={this.state.businessData.logo}
                    alt="logo"
                    height={'100%'}
                    style={{ borderRadius: '50%', width: '60px', height: '60px', boxShadow: 'rgb(0 0 0 / 16%) 0px 10px 36px 0px, rgb(0 0 0 / 6%) 0px 0px 0px 0px',}}
                  />
                </div>
                <Typography
                  style={{
                    fontSize: '20px',
                    fontWeight: '800',
                    color: '#2c3136',
                    fontFamily: 'Nunito',
                    letterSpacing: 'normal',
                    marginTop: '65px',
                  }}
                >
                  {strings['Bienvenido de regreso']}
                </Typography>
                <Typography
                  style={{
                    fontSize: '15px',
                    fontWeight: '400',
                    color: 'slategray',
                    fontFamily: 'Nunito',
                    letterSpacing: 'normal',
                    marginBottom: '35px',
                  }}
                >
                  {strings['Ingresa tu cuenta para continuar']}
                </Typography>
              </div>
              <TextField
                style={{
                  color: '#272727',
                  borderRadius: '0',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden',
                }}
                error={
                  !validator.isEmail(this.state.email) &&
                  this.state.email.length > 0
                }
                fullWidth
                id="filled-basic"
                label={strings['Email']}
                variant="filled"
                value={this.state.email}
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
              />
              <br />
              <br />
              <FormControl
                fullWidth
                variant="filled"
                style={{
                  color: '#272727',
                  borderRadius: '0',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden',
                }}
              >
                <InputLabel
                  error={
                    this.state.password.length <= 6 &&
                    this.state.password.length > 0
                  }
                  htmlFor="filled-adornment-password"
                >
                  {strings['Contraseña']}
                </InputLabel>
                <FilledInput
                  error={
                    this.state.password.length <= 6 &&
                    this.state.password.length > 0
                  }
                  id="filled-adornment-password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  value={this.state.password}
                  onChange={(event) => {
                    this.setState({ password: event.target.value });
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        style={{ color: '#b3b9c2' }}
                        aria-label="toggle password visibility"
                        onClick={() => {
                          this.setState({
                            showPassword: !this.state.showPassword,
                          });
                        }}
                        onMouseDown={(event) => {
                          event.preventDefault();
                        }}
                        edge="end"
                      >
                        {this.state.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <br />
              <br />
              <Button style={{ height: '61px', borderRadius: '12px', boxShadow: 'rgb(17 12 46 / 15%) 0px 18px 100px 0px', backgroundColor: getPrimaryColor(), }}
                fullWidth
                variant="contained"
                sx={{backgroundColor: getPrimaryColor()}}
                onClick={async () => {
                  if (
                    validator.isEmail(this.state.email) &&
                    this.state.password.length >= 6
                  ) {
                    this.setState({ loading: true });
                    signInWithEmailAndPassword(
                      auth,
                      this.state.email,
                      this.state.password
                    )
                      .then((userCredential) => {
                        // Signed in
                        console.log('signing', userCredential);
                        const user = userCredential.user;
                        const uid = user.uid;

                        // this.setState({ userId: uid });
                        // ...
                      })
                      .catch((error) => {
                        const errorCode = error.code;
                        const errorMessage = error.message;
                        this.setState({ loading: false });
                        openAlert('error', 'Cant login');
                        console.log(errorMessage, errorCode);
                      });
                  }
                }}
              >
                {strings['Iniciar sesión']}
              </Button>
              <br />
              <br />
              <Typography
                gutterBottom
                align="center"
                style={{ marginBottom: '-1px', color: 'lightslategray', }}
              >
                {strings['o']}
              </Typography>
              <Button style={{ background: 'none', boxShadow: 'none', color: getPrimaryColor(), textTransform: 'inherit', }}
                fullWidth
                variant="contained"
                sx={{backgroundColor: getPrimaryColor()}}
                onClick={async () => {
                  handleCloseLogin();
                  handleClickOpenRegister();
                }}
              >
                {strings['Registro']}
              </Button>
            </DialogContent>
          }
        />
                        <AddCardDialog
          selectedValue={this.state.selectedValue}
          open={this.state.openAddCard}
          onClose={handleAddCardClose}
          displayList={
            <div style={{width: this.state.width>600?"500px":"auto"}}>
            <Elements stripe={stripePromise}>
               <ElementsConsumer>
    {({stripe, elements}) => (
            <DialogContent dividers>
              <div               style= {
           {
            color: '#272727',
                        borderRadius: '9px',
                        backgroundColor: '#e6ebf1',
                        overflow: 'hidden',
                        fontFamily: 'Nunito',
                        letterSpacing: 'normal',
                        height: "50px",

            '::placeholder': {
              color: '#272727',
            }
          }
          }>
             <CardNumberElement className="card-element" options={{
              placeholder:strings['Número de tarjeta'],
              style: {
          base: {
            color: '#272727',
                        overflow: 'hidden',
                        fontFamily: 'Nunito',
                        letterSpacing: 'normal',
                        height: "50px",
            '::placeholder': {
              color: '#272727',
            }
          },
          invalid: {
            color: '#272727',
            iconColor: '#fa755a'
          },
          }
        }} />        </div>
        <div style={{padding: "5px"}}></div>
        <div               style= {
           {
            color: '#272727',
                        borderRadius: '9px',
                        backgroundColor: '#e6ebf1',
                        overflow: 'hidden',
                        fontFamily: 'Nunito',
                        letterSpacing: 'normal',
                        height: "50px",

            '::placeholder': {
              color: '#272727',
            }
          }
          }>
        <CardExpiryElement className="card-element" options={{
              style: {
          base: {
            color: '#272727',
                        overflow: 'hidden',
                        fontFamily: 'Nunito',
                        letterSpacing: 'normal',
                        height: "50px",
            '::placeholder': {
              color: '#272727',
            }
          },
          invalid: {
            color: '#272727',
            iconColor: '#fa755a'
          },
          }
        }} />         </div>
        <div style={{padding: "5px"}}></div>
        <div               style= {
           {
            color: '#272727',
                        borderRadius: '9px',
                        backgroundColor: '#e6ebf1',
                        overflow: 'hidden',
                        fontFamily: 'Nunito',
                        letterSpacing: 'normal',
                        height: "50px",

            '::placeholder': {
              color: '#272727',
            }
          }
          }>
        <CardCvcElement className="card-element" options={{
              style: {
          base: {
            color: '#272727',
                        overflow: 'hidden',
                        fontFamily: 'Nunito',
                        letterSpacing: 'normal',
                        height: "50px",
            '::placeholder': {
              color: '#272727',
            }
          },
          invalid: {
            color: '#272727',
            iconColor: '#fa755a'
          },
          }
        }} />         </div>

              {/* <CreditCardInput
  cardNumberInputProps={{ value: this.state.newCard.cardNo, onChange:(event) => {
                  this.setState({ newCard: {
                    ...this.state.newCard,
                    cardNo: event.target.value
                  } });
                },}}
  cardExpiryInputProps={{ value: this.state.newCard.expiry, onChange:(event) => {
                  this.setState({ newCard: {
                    ...this.state.newCard,
                    expiry: event.target.value
                  } });
                }, }}
  cardCVCInputProps={{ value: this.state.newCard.cvv, onChange:(event) => {
                  this.setState({ newCard: {
                    ...this.state.newCard,
                    cvv: event.target.value
                  } });
                }, }}
  fieldClassName="input"
/> */}
<div style={{padding: "5px"}}></div>
<TextField style={{                        color: '#272727',
                        borderRadius: '9px',
                        backgroundColor: '#e6ebf1',
                        overflow: 'hidden',
                        fontFamily: 'Nunito',
                        letterSpacing: 'normal',}} variant="filled" fullWidth label={strings["Nombre de la titular"]} id="fullWidthcard" value={this.state.newCard.name}  onChange={(event) => {
                  this.setState({ newCard: {
                    ...this.state.newCard,
                    name: event.target.value
                  } });
                }} />
                <div style={{padding: "5px"}}></div>
                <Button fullWidth variant="contained" disabled={!stripe || this.state.loading}
                  sx={{backgroundColor: getPrimaryColor()}}
                onClick={async()=>{
                  console.log(this.state.newCard);
                  var cardNo = this.state.newCard.cardNo.replaceAll(" ","");
                  var expMonth = this.state.newCard.expiry.replaceAll(" ","").split('/')[0];
                  var expYear = this.state.newCard.expiry.replaceAll(" ","").split('/')[1];
                  var cvv = this.state.newCard.cvv.replaceAll(" ","");
                  var name = this.state.newCard.name;
                  console.log(cardNo, expMonth, expYear, cvv, name);
                  // const stripe = await loadStripe('pk_test_51Groo5F76HIlmZyWmhOPE8wDkPI40bvJrOmrhsPD4qCMKjPCIjgtuoPLzAwf0xhJHG1B95rGO5sOOgQlziO9P6Yb00tfKKwtpx');
                  // var elements = stripe.elements();
                  this.setState( {
                                            loading: true,
                                          });
                  const {paymentMethod, error} = await stripe.createPaymentMethod({
  type: 'card',
  card: elements.getElement(CardNumberElement),
  billing_details: {
    name: name,
  },
});
console.log(error,'error');
console.log('paymentMethod',paymentMethod,{
                                        'id': paymentMethod.id,
                                        // 'number':
                                        // defaultCard['cardNumber']
                                        //     .replaceAll(
                                        //     new RegExp(r"\s+"),
                                        //     ""),
                                        // 'month': int.parse(
                                        //     defaultCard['expiryDate']
                                        //         .split('/')[0]),
                                        // 'year': int.parse(
                                        //     defaultCard['expiryDate']
                                        //         .split('/')[1]),
                                        // 'cvv': defaultCard['cvv'],
                                        'custId': this.state.userDetails.custId,
                                      });
if(!error) {
  try {
                                    var response = await axios.post(
                                      'https://lemon-order.herokuapp.com/drivers/linkcustomer/',null,
                                        {
                                          params: {
                                        'id': paymentMethod.id,
                                        // 'number':
                                        // defaultCard['cardNumber']
                                        //     .replaceAll(
                                        //     new RegExp(r"\s+"),
                                        //     ""),
                                        // 'month': int.parse(
                                        //     defaultCard['expiryDate']
                                        //         .split('/')[0]),
                                        // 'year': int.parse(
                                        //     defaultCard['expiryDate']
                                        //         .split('/')[1]),
                                        // 'cvv': defaultCard['cvv'],
                                        'custId': this.state.userDetails.custId,
                                      },
                                        }
                                    );
                                    console.log(response);
                                    if (response.status === 200) {
                                      console.log(response.data['id']);
                                      if (response.data['id'] != null &&
                                          response.data['error'] == null) {
                                        this.state.cards.push(response.data);
                                        await updateDoc(doc(db, 'users', this.state.userId), {
                        cards:this.state.cards,
                      }).then((value)=>{
                                          this.setState( {
                                            loading: false,
                                          });
                                          handleAddCardClose();
                                          // Navigator.pop(context);
                                          //await cardBox.delete(element['id']);
                                        });
                                        //if(mounted) {
                                        //   await processPaymentAsDirectCharge(
                                        //       response.data,
                                        //       (grandTotal() * 100)
                                        //           .round(),
                                        //       code);
                                        //}
                                      } else {
                                        console.log(response.data);
                                        this.setState( {
                                            loading: false,
                                          });
                                        if (response.data['code']
                                            .toString()
                                            .includes('card_declined')) {

                                          openAlert(
                                              'error', strings["El banco ha rechazado la transacción. Crea e ingresa aquí una tarjeta digital para realizar compras más seguras"]);
                                        } else if (response.data['code']
                                                .toString()
                                                .contains('incorrect') ||
                                            response.data['code']
                                                .toString()
                                                .contains('invalid')) {
                                                  openAlert(
                                              'error', strings["Los datos de la tarjeta son incorrectos. Verifíquelos para continuar."]);
                                        } else {
                                          openAlert(
                                              'error', strings["Algo salió mal al crear el pago"]);
                                        }
                                      }
                                    } else {
                                      console.log('failed');
                                      this.setState( {
                                            loading: false,
                                          });
                                      openAlert(
                                              'error', strings["Algo salió mal al crear el pago"]);
                                    }
                                  } catch (e) {
                                    console.log('exception ¢e',e);
                                    this.setState( {
                                            loading: false,
                                          });
                                    openAlert(
                                              'error', strings["Algo salió mal al crear el pago"]);
                                  }
} else {
  this.setState( {
                                            loading: false,
                                          });
                                          openAlert(
                                              'error', strings["Algo salió mal al crear el pago"]);
}
                }}
                >{strings["Agregar tarjeta"]}</Button>

{/* <PaymentInputsContainer>
      {({ meta, getCardNumberProps, getExpiryDateProps, getCVCProps }) => (
        <div>
          <TextField fullWidth label="Card Number" id="fullWidthcardNo"  inputProps={getCardNumberProps({})}  value={this.state.newCard.cardNo}  onChange={(event) => {
                  this.setState({ newCard: {
                    ...this.state.newCard,
                    cardNo: event.target.value
                  } });
                }} />
          <input {...getCardNumberProps({ onChange: e => console.log('expiry2 change', e) })} value={this.state.newCard.cardNo} />
          <input {...getExpiryDateProps({ onChange: e => console.log('expiry3 change', e) })} value={this.state.newCard.expiry} />
          <input {...getCVCProps({ onChange: e => console.log('expiry4 change', e) })} value={this.state.newCard.cvv} />
          {meta.isTouched && meta.error && <span>Error: {meta.error}</span>}
          <TextField fullWidth label="Holder Name" id="fullWidthcard" />
        </div>
      )}
    </PaymentInputsContainer> */}

            </DialogContent>   )}
            </ElementsConsumer>
            </Elements></div>
          }
        />
                <RegisterDialog
          selectedValue={this.state.selectedValue}
          open={this.state.openRegister}
          onClose={handleCloseRegister}
          displayList={
            <DialogContent dividers>
              <div className="showonphone">
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={this.state.businessData.logo}
                    alt="logo"
                    height={'100%'}
                    style={{ borderRadius: '50%', width: '60px', height: '60px', boxShadow: 'rgb(0 0 0 / 16%) 0px 10px 36px 0px, rgb(0 0 0 / 6%) 0px 0px 0px 0px',}}
                  />
                </div>
                <Typography
                  style={{
                    fontSize: '20px',
                    fontWeight: '800',
                    color: '#2c3136',
                    fontFamily: 'Nunito',
                    letterSpacing: 'normal',
                    marginTop: '35px',
                  }}
                >
                  {strings['Bienvenido']}
                </Typography>
                <Typography
                  style={{
                    fontSize: '15px',
                    fontWeight: '400',
                    color: 'slategray',
                    fontFamily: 'Nunito',
                    letterSpacing: 'normal',
                    marginBottom: '15px',
                  }}
                >
                  {strings['Crea tu cuenta para continuar']}
                </Typography>
              </div>
              <TextField
                style={{
                  color: '#272727',
                  borderRadius: '0',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden',
                }}
                error={this.state.fullName.length <= 0}
                fullWidth
                id="filled-basic23"
                label={strings['Nombre completo']}
                variant="filled"
                value={this.state.fullName}
                onChange={(event) => {
                  this.setState({ fullName: event.target.value });
                }}
              />
              <br />
              <br />
              <TextField
                style={{
                  color: '#272727',
                  borderRadius: '0',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden',
                }}
                error={
                  !validator.isEmail(this.state.email) &&
                  this.state.email.length > 0
                }
                fullWidth
                id="filled-basic45"
                label={strings['Email']}
                variant="filled"
                value={this.state.email}
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
              />
              <br />
              <br />
              <FormControl
                fullWidth
                variant="filled"
                style={{
                  color: '#272727',
                  borderRadius: '0',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden',
                }}
              >
                <InputLabel
                  error={
                    this.state.password.length <= 6 &&
                    this.state.password.length > 0
                  }
                  htmlFor="filled-adornment-password"
                >
                  {strings['Contraseña']}
                </InputLabel>
                <FilledInput
                  error={
                    this.state.password.length <= 6 &&
                    this.state.password.length > 0
                  }
                  id="filled-adornment-password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  value={this.state.password}
                  onChange={(event) => {
                    this.setState({ password: event.target.value });
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        style={{ color: '#b3b9c2' }}
                        aria-label="toggle password visibility"
                        onClick={() => {
                          this.setState({
                            showPassword: !this.state.showPassword,
                          });
                        }}
                        onMouseDown={(event) => {
                          event.preventDefault();
                        }}
                        edge="end"
                      >
                        {this.state.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <br />
              <br />
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <CountrySelect
                  style={{
                    color: '#272727',
                    borderRadius: '0',
                    backgroundColor: 'white',
                    overflow: 'hidden',
                  }}
                  labels={en}
                  value={this.state.phoneCountry}
                  onChange={(number) => {
                    this.setState({ phoneCountry: number });
                  }}
                />
                &nbsp;&nbsp;
                <FormControl
                  variant="filled"
                  style={{
                    color: '#272727',
                    borderRadius: '0',
                    backgroundColor: 'white',
                    overflow: 'hidden',
                    width: '100%',
                  }}
                >
                  <InputLabel
                    error={
                      this.state.phoneNumber.length < 10 &&
                      this.state.phoneNumber.length > 0
                    }
                    htmlFor="filled-adornment-password"
                  >
                    {strings['Número de teléfono']}
                  </InputLabel>
                  <FilledInput
                    error={
                      this.state.phoneNumber.length < 10 &&
                      this.state.phoneNumber.length > 0
                    }
                    id="filled-adornment-password"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    type="phone"
                    value={this.state.phoneNumber}
                    onChange={(event) => {
                      this.setState({ phoneNumber: event.target.value });
                    }}
                    //           endAdornment={
                    //             <InputAdornment position="end">
                    //               <IconButton
                    //                 aria-label="toggle password visibility"
                    //                 onClick={()=>{
                    //                   this.setState({'showPassword': !this.state.showPassword})
                    //                 }}
                    //                 onMouseDown={(event) => {
                    //   event.preventDefault();
                    // }}
                    //                 edge="end"
                    //               >
                    //                 {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                    //               </IconButton>
                    //             </InputAdornment>
                    //           }
                  />
                </FormControl>
              </Box>

              <br />
              <br />
              <Button style={{ height: '61px', borderRadius: '12px', boxShadow: 'rgb(17 12 46 / 15%) 0px 18px 100px 0px', backgroundColor: getPrimaryColor(), }}
                fullWidth
                variant="contained"
                sx={{backgroundColor: getPrimaryColor()}}
                onClick={async () => {
                  if (
                    validator.isEmail(this.state.email) &&
                    this.state.password.length >= 6 &&
                    this.state.phoneNumber.length >= 10 &&
                    this.state.fullName.length > 0
                  ) {
                    this.setState({ loading: true });
                    // await axios.get(request).then(async (response) => {
                    //           console.log(response);
                    //           this.setState({ locOptions: response.data.predictions });
                    //         });
                    createUserWithEmailAndPassword(
                      auth,
                      this.state.email,
                      this.state.password
                    )
                      .then(async (userCredential) => {
                        // Signed in

                        // console.log('signing', userCredential);
                        const user = userCredential.user;
                        const uid = user.uid;

                        var nameSearch = this.state.fullName
                          .toLowerCase()
                          .split(' ');
                        var insertNameSearch = this.state.fullName
                          .toLowerCase()
                          .split(' ');
                        var i = 0;
                        var dataInsert = '';
                        while (true) {
                          if (i === nameSearch.length) {
                            break;
                          }
                          if (dataInsert === '') {
                            dataInsert = nameSearch[i];
                          } else {
                            dataInsert = dataInsert + ' ' + nameSearch[i];
                            insertNameSearch.push(dataInsert);
                          }
                          i = i + 1;
                        }
                        await setDoc(doc(db, 'users', uid), {
                          fullName: this.state.fullName,
                          nameSearch: insertNameSearch,
                          email: this.state.email,
                          fromNew: true,
                          phoneNumber:
                            this.state.phoneCountry + this.state.phoneNumber,
                          loginType: 'Email/Password',
                          needcount: true,
                          orders: {
                            '0-2021': 0,
                            '1-2021': 0,
                            '2-2021': 0,
                            '3-2021': 0,
                            '4-2021': 0,
                            '5-2021': 0,
                            '6-2021': 0,
                            '7-2021': 0,
                            '8-2021': 0,
                            '9-2021': 0,
                            '10-2021': 0,
                            '11-2021': 0,
                          },
                          isSignedIn: false,
                          lastLogin: null,
                          lastOrder: null,
                          isTestUser: false,
                        });

                        // sendOTP(
                        //   this.state.phoneCountry + this.state.phoneNumber
                        // );
                        this.setState({ loading: false, openRegister: false });
                        this.setState({
                          openAlert: true,
                          alertType: 'success',
                          alertMsg: strings['Datos correctos'],
                        });
                        this.setState({
                          userId: uid,
                          userDetails: {
                            fullName: this.state.fullName,
                            nameSearch: insertNameSearch,
                            email: this.state.email,
                            fromNew: true,
                            phoneNumber:
                              this.state.phoneCountry + this.state.phoneNumber,
                            loginType: 'Email/Password',
                            orders: {
                              '0-2021': 0,
                              '1-2021': 0,
                              '2-2021': 0,
                              '3-2021': 0,
                              '4-2021': 0,
                              '5-2021': 0,
                              '6-2021': 0,
                              '7-2021': 0,
                              '8-2021': 0,
                              '9-2021': 0,
                              '10-2021': 0,
                              '11-2021': 0,
                            },
                            isSignedIn: false,
                            lastLogin: null,
                            lastOrder: null,
                            isTestUser: false,
                          },
                          cards: [],
                        });
                        // handleClickOpenOTP();
                        // this.setState({ userId: uid });
                        // ...
                      })
                      .catch((error) => {
                        const errorCode = error.code;
                        const errorMessage = error.message;
                        this.setState({ loading: false });
                        openAlert(
                          'error',
                          strings['Existe un error en el registro']
                        );
                        // console.log(errorMessage, errorCode);
                      });
                  }
                }}
              >
                {strings['Crear cuenta']}
              </Button>
            </DialogContent>
          }
        />
        <AdditionalDialog
          selectedValue={this.state.selectedValue}
          open={this.state.openAdditional}
          onClose={handleCloseAdditional}
          displayList={
            <DialogContent dividers>
              <TextField
                style={{
                  color: '#272727',
                  borderRadius: '0',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden',
                }}
                // error={this.state.fullName.length <= 0}
                fullWidth
                id="filled-basic234"
                label={strings['Nombre del cliente']}
                variant="filled"
                value={this.state.clientName}
                onChange={(event) => {
                  this.setState({ clientName: event.target.value });
                }}
              />
              <br />
              <br />
              {(this.state.selectedType === 2)?<><TextField
                style={{
                  color: '#272727',
                  borderRadius: '0',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden',
                }}
                // error={this.state.fullName.length <= 0}
                fullWidth
                id="filled-basic235"
                label={strings['Número de mesa']}
                variant="filled"
                value={this.state.tableNumber}
                onChange={(event) => {
                  this.setState({ tableNumber: event.target.value });
                }}
              />
              <br />
              <br /></>:null}
              {(this.state.selectedType === 0)?<><TextField
                style={{
                  color: '#272727',
                  borderRadius: '0',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden',
                }}
                // error={this.state.fullName.length <= 0}
                fullWidth
                id="filled-basic235"
                label={strings['telefono']}
                variant="filled"
                value={this.state.clientTel}
                onChange={(event) => {
                  this.setState({ clientTel: event.target.value });
                }}
              />
              <br />
              <br /></>:null}
              {(this.state.selectedType === 1)?<><TextField
                style={{
                  color: '#272727',
                  borderRadius: '0',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden',
                }}
                // error={this.state.fullName.length <= 0}
                fullWidth
                id="filled-basic235"
                label={strings['telefono']}
                variant="filled"
                value={this.state.clientTel}
                onChange={(event) => {
                  this.setState({ clientTel: event.target.value });
                }}
              />
              <br />
              <br /></>:null}

              {(this.state.selectedType === 0 && this.state.clientTel != '')?<Button style={{ height: '61px', borderRadius: '12px', boxShadow: 'rgb(17 12 46 / 15%) 0px 18px 100px 0px', backgroundColor: getPrimaryColor(), }} fullWidth variant="contained" sx={{backgroundColor: getPrimaryColor()}} onClick={async () => { this.setState({ additionalInfoAdded: true, }); handleCloseAdditional(); }}>
                {strings['Guardar']}
              </Button>:null}
              {(this.state.selectedType === 1 && this.state.clientTel != '')?<Button style={{ height: '61px', borderRadius: '12px', boxShadow: 'rgb(17 12 46 / 15%) 0px 18px 100px 0px', backgroundColor: getPrimaryColor(), }} fullWidth variant="contained" sx={{backgroundColor: getPrimaryColor()}} onClick={async () => { this.setState({ additionalInfoAdded: true, }); handleCloseAdditional(); }}>
                {strings['Guardar']}
              </Button>:null}
              {((this.state.selectedType === 0 || this.state.selectedType === 1) && this.state.clientTel == '')?<Button style={{ height: '61px', borderRadius: '12px', boxShadow: 'rgb(17 12 46 / 15%) 0px 18px 100px 0px', backgroundColor: '#bbbbbb', }} fullWidth variant="contained">
                {strings['Guardar']}
              </Button>:null}
              {(this.state.selectedType === 2)?<Button style={{ height: '61px', borderRadius: '12px', boxShadow: 'rgb(17 12 46 / 15%) 0px 18px 100px 0px', backgroundColor: getPrimaryColor(), }} fullWidth variant="contained" sx={{backgroundColor: getPrimaryColor()}} onClick={async () => { this.setState({ additionalInfoAdded: true, }); handleCloseAdditional(); }}>
                {strings['Guardar']}
              </Button>:null}
              <br />
              <br />
            </DialogContent>
          }
        />
        <OTPDialog
          selectedValue={this.state.selectedValue}
          open={this.state.openOTP}
          onClose={handleCloseOTP}
          displayList={
            <DialogContent dividers>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <CountrySelect
                  labels={en}
                  value={this.state.phoneCountry}
                  onChange={(number) => {
                    this.setState({ phoneCountry: number });
                  }}
                />
                &nbsp;&nbsp;
                <FormControl variant="filled">
                  <InputLabel
                    error={
                      this.state.phoneNumber.length < 10 &&
                      this.state.phoneNumber.length > 0
                    }
                    htmlFor="filled-adornment-password"
                  >
                   {strings["Número de teléfono"]}
                  </InputLabel>
                  <FilledInput
                    error={
                      this.state.phoneNumber.length < 10 &&
                      this.state.phoneNumber.length > 0
                    }
                    id="filled-adornment-password"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    type="phone"
                    value={this.state.phoneNumber.replace('+507','')}
                    onChange={(event) => {
                      this.setState({ phoneNumber: event.target.value });
                    }}
                    //           endAdornment={
                    //             <InputAdornment position="end">
                    //               <IconButton
                    //                 aria-label="toggle password visibility"
                    //                 onClick={()=>{
                    //                   this.setState({'showPassword': !this.state.showPassword})
                    //                 }}
                    //                 onMouseDown={(event) => {
                    //   event.preventDefault();
                    // }}
                    //                 edge="end"
                    //               >
                    //                 {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                    //               </IconButton>
                    //             </InputAdornment>
                    //           }
                  />
                </FormControl>
                &nbsp;&nbsp;
                <Button
                  variant="text"
                  style={{ textTransform: 'none' }}
                  onClick={async () => {
                    if (this.state.phoneNumber.length >= 10) {
                      this.setState({ loading: true });
                      await updateDoc(doc(db, 'users', this.state.userId), {
                        phoneNumber:
                          this.state.phoneCountry + this.state.phoneNumber,
                      });
              sendOTP(this.state.phoneCountry + this.state.phoneNumber);
                      this.setState({ loading: false });
                      this.setState({
                        openAlert: true,
                        alertType: 'success',
                        alertMsg: strings['Cambiar número Éxito'],
                      });
                      // this.setState({ userId: uid });
                      // ...
                      // })
                      // .catch((error) => {
                      //   const errorCode = error.code;
                      //   const errorMessage = error.message;
                      //   this.setState({loading: false});
                      //   openAlert('error',"Cant login");
                      //   console.log(errorMessage,errorCode);
                      // });
                    }
                  }}
                >
                  {strings["Reenviar"]}
                </Button>
              </Box>
              <br></br>
              <br></br>
              <Typography align={'center'}>
                {strings["Mensaje enviado correctamente al número anterior"]}
              </Typography>

              <Button
                fullWidth
                variant="text"
                style={{ textTransform: 'none' }}
                onClick={() => {
                  sendOTP(this.state.phoneCountry + this.state.phoneNumber);
                }}
              ></Button>
              <br></br>
              <br></br>
              <OtpInput
                style={{ placeContent: 'center' }}
                align={'center'}
                inputStyle={{
                  width: '32px',
                  height: '32px',
                  fontSize: '17px',
                  fontWeight: 'bold',
                }}
                numInputs={6}
                onChange={(value) => {
                  this.setState({ otp: value });
                  console.log(value, typeof value);
                }}
                separator={
                  <span style={{ width: '20px', height: '20px' }}></span>
                }
                isInputNum={true}
                shouldAutoFocus
                value={this.state.otp}
              />
              <br />
              <br />
              <Button
                fullWidth
                variant="contained"
                sx={{backgroundColor: getPrimaryColor()}}
                onClick={async () => {
                  if (this.state.otp === this.state.otpSend) {
                    this.setState({ loading: true });
                    await updateDoc(doc(db, 'users', this.state.userId), {
                      phoneNumberVerified: true,
                    });
                    this.setState({ loading: false, openOTP: false });
                    this.setState({
                      openAlert: true,
                      alertType: 'success',
                      alertMsg: strings['Has ingresado correctamente'],
                    });
                    // this.setState({ userId: uid });
                    // ...
                    // })
                    // .catch((error) => {
                    //   const errorCode = error.code;
                    //   const errorMessage = error.message;
                    //   this.setState({loading: false});
                    //   openAlert('error',"Cant login");
                    //   console.log(errorMessage,errorCode);
                    // });
                  } else {
                    this.setState({
                      openAlert: true,
                      alertType: 'error',
                      alertMsg:
                        strings['El código ingresado no es correcto, intenta nuevamente'],
                    });
                  }
                }}
              >
                {strings["Ingresar"]}
              </Button>
            </DialogContent>
          }
        />
        <BusinessInfoDialog
          open={this.state.openBusinessInfo}
          onClose={() => {
            this.setState({ openBusinessInfo: false });
          }}
          displayList={
            <DialogContent dividers>
              <Typography
                style={{
                  fontWeight: 'bolder',
                  fontSize: '20px',
                  color: '#2c3036',
                }}
              >
                {this.state.businessData?.name}
              </Typography>
              <Typography
                fontWeight={'400'}
                fontSize={16}
                style={{ color: 'slategray', marginBottom: '10px' }}
              >
                {this.state.businessData?.description}
              </Typography>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Typography
                  fontWeight={'bold'}
                  fontSize={16}
                  style={{ color: '#2c3036', marginBottom: '10px' }}
                >
                  {strings["Correo:"]}&nbsp;
                </Typography>
                <Typography
                  gutterBottom
                  fontSize={16}
                  marginLeft={'2px'}
                  style={{ color: 'slategray', marginBottom: '10px' }}
                >
                  {this.state.businessData?.email}
                </Typography>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  fontSize: '13px',
                }}
              >
                <Typography
                  fontWeight={'bold'}
                  fontSize={16}
                  style={{ color: '#2c3036', marginBottom: '10px' }}
                >
                  {strings["Teléfono"]}&nbsp;
                </Typography>
                <Typography
                  gutterBottom
                  fontSize={16}
                  marginLeft={'2px'}
                  style={{ color: 'slategray', marginBottom: '10px' }}
                >
                  {this.state.businessData?.phone}
                </Typography>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  fontSize: '13px',
                }}
              >
                <Typography
                  fontWeight={'bold'}
                  fontSize={16}
                  style={{ color: '#2c3036', marginBottom: '30px' }}
                >
                  {strings["Dirección:"]}&nbsp;
                </Typography>
                <Typography
                  gutterBottom
                  fontSize={16}
                  marginLeft={'2px'}
                  style={{ color: 'slategray', marginBottom: '30px' }}
                >
                  {this.state.businessData?.location?.address}
                </Typography>
              </div>
              {Object.keys(this.state.businessData?.schedule).length > 0 && (
                <Box style={{ width: '100%' }}>
                  <Box
                    style={{
                      width: '102%',
                      display: 'flex',
                      overflowX: 'auto',
                    }}
                  >
                    <div style={{ display: 'flex', width: '100%' }}>
                      {this.state.businessData?.schedule?.map((schedule, i) => (
                        <ScheduleBlock key={i} color={getPrimaryColor()}>
                          <h4>{DAYS[i]}</h4>
                          {schedule.enabled ? (
                            schedule.lapses.map((time, k) => (
                              <React.Fragment key={k}>
                                <p>{scheduleFormatted(time.open)}</p>
                                <p
                                  style={{
                                    borderBottom: '2px solid',
                                    borderBottomColor: getPrimaryColor(),
                                    marginBottom: 10,
                                  }}
                                >
                                  {scheduleFormatted(time.close)}
                                </p>
                              </React.Fragment>
                            ))
                          ) : (
                            <p style={{ fontWeight: 500 }}>{'Closed Today'}</p>
                          )}
                        </ScheduleBlock>
                      ))}
                    </div>
                  </Box>
                </Box>
              )}

              <br />
              <>
                <GoogleMapReact
                  defaultCenter={{
                    lat: this.state.businessData?.location?.latitude,
                    lng: this.state.businessData?.location?.longitude,
                  }}
                  defaultZoom={this.state.defaultProps.zoom}
                  resetBoundsOnResize={true}
                  bootstrapURLKeys={{
                    key: 'AIzaSyDNl0corYx_1cBY1uvD7vzIzw8pvppIgAM',
                  }}
                  style={{ height: '30vh', borderRadius: '16px', overflow: 'hidden', }}
                >
                  <LocationOnIcon
                    style={{
                      color: getPrimaryColor(),
                      transform: 'translate(-50%, -100%)',
                    }}
                    fontSize={'large'}
                    lat={this.state.businessData?.location?.latitude}
                    lng={this.state.businessData?.location?.longitude}
                  />
                </GoogleMapReact>
              </>
            </DialogContent>
          }
        />
        <SimpleDialog
          selectedValue={this.state.selectedValue}
          open={this.state.openLocation}
          onClose={handleClose}
          displayList={
            <DialogContent dividers>
              <Typography gutterBottom>
                {strings["Selecciona tu ubicación o ingrese una nueva dirección"]}
              </Typography>
              <br />
              <Autocomplete
                style={{ width: '100%' }}
                id="google-map-demo"
                sx={{ width: 300 }}
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : option.description
                }
                filterOptions={(x) => x}
                options={this.state.locOptions}
                autoComplete
                loading={true}
                loadingText={strings['Buscando direcciones']}
                includeInputInList
                filterSelectedOptions
                value={this.state.autoLoc}
                onChange={(event, newValue) => {
                  console.log(newValue);
                  this.setState({ hasClickedLoc: false });
                  if (newValue.description) {
                    Geocode.setApiKey(
                      'AIzaSyDNl0corYx_1cBY1uvD7vzIzw8pvppIgAM'
                    );
                    Geocode.setLanguage('es');
                    Geocode.setRegion('PA');
                    Geocode.setLocationType('ROOFTOP');
                    Geocode.enableDebug();
                    Geocode.fromAddress(newValue.description).then(
                      (response) => {
                        const { lat, lng } =
                          response.results[0].geometry.location;
                        // console.log(lat, lng);
                        this.setState({
                          defaultProps: {
                            center: {
                              lat: lat,
                              lng: lng,
                            },
                            zoom: 16,
                          },
                          selectLocationData: {
                            id: this.state.selectLocationData.id
                              ? this.state.selectLocationData.id
                              : '',
                            name: this.state.selectLocationData.name
                              ? this.state.selectLocationData.name
                              : strings['mi hogar'],
                            address: this.state.selectLocationData.address
                              ? this.state.selectLocationData.address
                              : '',
                            geoAddress: newValue.description,
                            addressNotes: this.state.selectLocationData
                              .addressNotes
                              ? this.state.selectLocationData.addressNotes
                              : '',
                            latitude: lat,
                            longitude: lng,
                          },
                        });
                        this.setState({ hasClickedLoc: true });
                        this.setState({ autoLoc: newValue });
                      },
                      (error) => {
                        console.error(error);
                      }
                    );
                  }
                  // setOptions(newValue ? [newValue, ...options] : options);
                  // setValue(newValue);
                }}
                onInputChange={_.debounce(async (event, newInputValue) => {
                  // setInputValue(newInputValue);
                  const { value } = event.target;
                  if (newInputValue.length > 4) {
                    var API_KEY = 'AIzaSyDNl0corYx_1cBY1uvD7vzIzw8pvppIgAM';
                    // var type = '(regions)';
                    var baseURL =
                      'https://lemon-order.herokuapp.com/drivers/proxy/https://maps.googleapis.com/maps/api/place/autocomplete/json';
                    var request =
                      baseURL +
                      '?input=' +
                      value +
                      '&key=' +
                      API_KEY +
                      '&sessiontoken=' +
                      _sessionToken;
                    await axios.get(request).then(async (response) => {
                      console.log(response);
                      this.setState({ locOptions: response.data.predictions });
                    });
                  }
                },2000)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    id="filled-basic"
                    label={strings["Ingrese la dirección de entrega"]}
                    variant="filled"
                    style={{ width: '100%' }}
                  />
                )}
                renderOption={(props, option) => {
                  const matches =
                    option.structured_formatting.main_text_matched_substrings;
                  const parts = parse(
                    option.structured_formatting.main_text,
                    matches.map((match) => [
                      match.offset,
                      match.offset + match.length,
                    ])
                  );

                  return (
                    <li {...props}>
                      <Grid container alignItems="center">
                        <Grid item>
                          <Box
                            component={LocationOnIcon}
                            sx={{ color: 'text.secondary', mr: 2 }}
                          />
                        </Grid>
                        <Grid item xs>
                          {parts.map((part, index) => (
                            <span
                              key={index}
                              style={{
                                fontWeight: part.highlight ? 700 : 400,
                              }}
                            >
                              {part.text}
                            </span>
                          ))}

                          <Typography variant="body2" color="text.secondary">
                            {option.structured_formatting.secondary_text}
                          </Typography>
                        </Grid>
                      </Grid>
                    </li>
                  );
                }}
              />
              {this.state.hasClickedLoc ? (
                <>
                  <br />
                  <GoogleMapReact
                    defaultCenter={this.state.defaultProps.center}
                    defaultZoom={this.state.defaultProps.zoom}
                    resetBoundsOnResize={true}
                    options={{
                      fullscreenControl: false,
                      scrollwheel: false,
                      panControl: false,
                      zoomControl: false,
                      rotateControl: false,
                    }}
                    bootstrapURLKeys={{
                      key: 'AIzaSyDNl0corYx_1cBY1uvD7vzIzw8pvppIgAM',
                    }}
                    style={{ height: '23vh' }}
                    onChange={(changeData) => {
                      console.log(changeData);
                      this.setState({
                        defaultProps: {
                          center: {
                            lat: changeData.center.lat,
                            lng: changeData.center.lng,
                          },
                          zoom: changeData.zoom,
                        },
                        selectLocationData: {
                          id: this.state.selectLocationData.id,
                          name: this.state.selectLocationData.name,
                          address: this.state.selectLocationData.address,
                          geoAddress: this.state.selectLocationData.geoAddress,
                          addressNotes:
                            this.state.selectLocationData.addressNotes,
                          latitude: changeData.center.lat,
                          longitude: changeData.center.lng,
                        },
                      });
                    }}
                  >
                    <LocationOnIcon
                      style={{
                        color: getPrimaryColor(),
                        transform: 'translate(-50%, -100%)',
                      }}
                      fontSize={'large'}
                      lat={this.state.defaultProps.center.lat}
                      lng={this.state.defaultProps.center.lng}
                      // text={'Google Map'}
                    />
                  </GoogleMapReact>
                  <br />
                  <TextField
                    fullWidth
                    id="filled-basic"
                    label={strings["Detalles adicionales"]}
                    variant="filled"
                    value={this.state.selectLocationData.addressNotes}
                    onChange={(event) => {
                      this.setState({
                        selectLocationData: {
                          id: this.state.selectLocationData.id,
                          name: this.state.selectLocationData.name,
                          address: this.state.selectLocationData.address,
                          geoAddress: this.state.selectLocationData.geoAddress,
                          addressNotes: event.target.value,
                          latitude: this.state.selectLocationData.latitude,
                          longitude: this.state.selectLocationData.longitude,
                        },
                      });
                    }}
                  />
                  <br />
                  <br />
                  <ToggleButtonGroup
                    fullWidth
                    // color="primary"
                    value={this.state.selectLocationData.name}
                    exclusive
                    onChange={(event, newAlignment) => {
                      this.setState({
                        selectLocationData: {
                          id: this.state.selectLocationData.id,
                          name: newAlignment,
                          address: this.state.selectLocationData.address,
                          geoAddress: this.state.selectLocationData.geoAddress,
                          addressNotes:
                            this.state.selectLocationData.addressNotes,
                          latitude: this.state.selectLocationData.latitude,
                          longitude: this.state.selectLocationData.longitude,
                        },
                      });
                    }}
                  >
                    <ToggleButton
                      value={strings["mi hogar"]}
                      style={{ color: getPrimaryColor() }}
                    >
                      {strings["Hogar"]}
                    </ToggleButton>
                    <ToggleButton
                      value={strings["mi Trabajo"]}
                      style={{ color: getPrimaryColor() }}
                    >
                      {strings["Trabajo"]}
                    </ToggleButton>
                    <ToggleButton
                      value={strings["otra dirección"]}
                      style={{ color: getPrimaryColor() }}
                    >
                      {strings["Visita"]}
                    </ToggleButton>
                  </ToggleButtonGroup>
                  <br />
                  <br />
                  <Button
                    variant="text"
                    style={{ float: 'left' }}
                    onClick={() => {
                      this.setState({ hasClickedLoc: false });
                      this.setState({ autoLoc: '' });
                      this.setState({
                        selectLocationData: {
                          id: '',
                          name: strings['mi hogar'],
                          address: '',
                          geoAddress: '',
                          addressNotes: '',
                          latitude: this.state.defaultProps.center.lat,
                          longitude: this.state.defaultProps.center.lng,
                        },
                      });
                    }}
                  >
                    {strings["Cancelar"]}
                  </Button>

                  <Button
                    variant="contained"
                    sx={{backgroundColor: getPrimaryColor()}}
                    style={{
                      float: 'right',
                      color: '#ffffff',
                      boxShadow: 'none',
                    }}
                    onClick={() => {
                      var locationData = JSON.parse(
                        localStorage.getItem('location')
                      );
                      if (locationData == null) {
                        locationData = [];
                      }
                      if (this.state.selectLocationData.id === '') {
                        for (var i = 0; i < locationData.length; i++) {
                          locationData[i]['selected'] = false;
                        }
                        var idLoc = uuidv4();
                        locationData.push({
                          id: idLoc,
                          name: this.state.selectLocationData.name,
                          address: this.state.selectLocationData.address,
                          latitude: this.state.selectLocationData.latitude,
                          longitude: this.state.selectLocationData.longitude,
                          geoAddress: this.state.selectLocationData.geoAddress,
                          addressNotes:
                            this.state.selectLocationData.addressNotes,
                          selected: true,
                        });
                        console.log('locationData', locationData);
                        var selected = {
                          latitude: this.state.selectLocationData.latitude,
                          longitude: this.state.selectLocationData.longitude,
                        };
                        localStorage.setItem(
                          'selected',
                          JSON.stringify(selected)
                        );
                        if (selected == null) {
                          selected = { latitude: 0, longitude: 0 };
                        }
                        this.setState(
                          {
                            selectedAddress: selected,
                            selectLocationName:
                              this.state.selectLocationData.geoAddress,
                          },
                          (newState) => {
                            handleClose();
                            console.log(
                              'selectedAddress',
                              this.state.selectedAddress,
                              typeof this.state.selectedAddress
                            );
                          }
                        );
                      } else {
                        for (var i = 0; i < locationData.length; i++) {
                          locationData[i]['selected'] = false;
                        }
                        const indexOfTaskToDelete = locationData.findIndex(
                          (task) => task.id === this.state.selectLocationData.id
                        );
                        locationData.splice(indexOfTaskToDelete, 1);
                        locationData.push({
                          id: this.state.selectLocationData.id,
                          name: this.state.selectLocationData.name,
                          address: this.state.selectLocationData.address,
                          latitude: this.state.selectLocationData.latitude,
                          longitude: this.state.selectLocationData.longitude,
                          geoAddress: this.state.selectLocationData.geoAddress,
                          addressNotes:
                            this.state.selectLocationData.addressNotes,
                          selected: true,
                        });
                        var selected2 = {
                          latitude: this.state.selectLocationData.latitude,
                          longitude: this.state.selectLocationData.longitude,
                        };
                        if (this.state.userId && this.state.userId !== '') {
                          updateDoc(doc(db, 'users', this.state.userId), {
                            locations: locationData,
                          });
                        }
                        localStorage.setItem(
                          'selected',
                          JSON.stringify(selected2)
                        );
                        if (selected2 == null) {
                          selected2 = { latitude: 0, longitude: 0 };
                        }
                        this.setState(
                          {
                            selectedAddress: selected2,
                            selectLocationName:
                              this.state.selectLocationData.geoAddress,
                          },
                          (newState) => {
                            handleClose();
                            console.log(
                              'selectedAddress',
                              this.state.selectedAddress,
                              typeof this.state.selectedAddress
                            );
                          }
                        );
                      }
                      this.setState({ addresses: locationData });
                      localStorage.setItem(
                        'location',
                        JSON.stringify(locationData)
                      );
                      this.setState({ hasClickedLoc: false });
                      this.setState({ autoLoc: '' });
                      this.setState({
                        selectLocationData: {
                          id: '',
                          name: strings['mi hogar'],
                          address: '',
                          geoAddress: '',
                          addressNotes: '',
                          latitude: this.state.defaultProps.center.lat,
                          longitude: this.state.defaultProps.center.lng,
                        },
                      });
                      this.setState(
                        { canDeliverHere: false, businessData: null },
                        (newState) => {
                          handleClose();
                          const { id } = this.props.match.params;
                          // this.setState({ businessData: {} });
                          this.getCities(id);
                        }
                      );
                    }}
                  >
                    {strings["Guardar"]}
                  </Button>
                </>
              ) : (
                <>
                  {/* </GoogleMapReact> */}
                  <br />
                  {/* <List sx={{ pt: 0 }}>
                    {this.state.addresses != null &&
                    Array.isArray(this.state.addresses)
                      ? this.state.addresses.map((email, ind) => (
                          <div key={ind}>
                            <div
                              style={{
                                width: '100%',
                                borderBottom: '1px solid #e6ebf1',
                                padding: '5px 0px 5px 0px',
                                height: '75px',
                              }}
                            >
                              <div
                                style={{
                                  width: 'calc(30px)',
                                  float: 'left',
                                  padding: '18px 0px 0px 0px',
                                }}
                              >
                                <LocationOnIcon
                                  style={{
                                    color: email.selected
                                      ? getPrimaryColor()
                                      : '#000',
                                  }}
                                />
                              </div>
                              <div
                                style={{
                                  width: 'calc(100% - 31px)',
                                  float: 'right',
                                }}
                              >
                                <div
                                  style={{
                                    width: 'calc(100% - 55px)',
                                    float: 'left',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    var locationData = JSON.parse(
                                      localStorage.getItem('location')
                                    );
                                    if (locationData == null) {
                                      locationData = [];
                                    }
                                    for (
                                      var i = 0;
                                      i < locationData.length;
                                      i++
                                    ) {
                                      locationData[i]['selected'] = false;
                                    }
                                    const indexOfTaskToDelete =
                                      locationData.findIndex(
                                        (task) => task.id === email.id
                                      );
                                    locationData.splice(indexOfTaskToDelete, 1);
                                    locationData.push({
                                      id: email.id,
                                      name: email.name,
                                      address: email.address,
                                      latitude: email.latitude,
                                      longitude: email.longitude,
                                      geoAddress: email.geoAddress,
                                      addressNotes: email.addressNotes,
                                      selected: true,
                                    });
                                    var selected2 = {
                                      latitude: email.latitude,
                                      longitude: email.longitude,
                                    };
                                    if (
                                      this.state.userId &&
                                      this.state.userId !== ''
                                    ) {
                                      updateDoc(
                                        doc(db, 'users', this.state.userId),
                                        {
                                          locations: locationData,
                                        }
                                      );
                                    }
                                    localStorage.setItem(
                                      'selected',
                                      JSON.stringify(selected2)
                                    );
                                    if (selected2 == null) {
                                      selected2 = { latitude: 0, longitude: 0 };
                                    }
                                    this.setState(
                                      {
                                        selectedAddress: selected2,
                                        selectedLocationName: email.address,
                                      },
                                      (newState) => {
                                        handleClose();
                                        console.log(
                                          'selectedAddress',
                                          this.state.selectedAddress,
                                          typeof this.state.selectedAddress
                                        );
                                      }
                                    );
                                    this.setState({ addresses: locationData });
                                    localStorage.setItem(
                                      'location',
                                      JSON.stringify(locationData)
                                    );
                                    this.setState({
                                      canDeliverHere: false,
                                      businessData: null,
                                    });
                                    handleClose();
                                    const { id } = this.props.match.params;
                                    // this.setState({ businessData: {} });
                                    this.getCities(id);
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      display: '-webkit-box',
                                      WebkitLineClamp: '1',
                                      WebkitBoxOrient: 'vertical',
                                    }}
                                    style={{
                                      fontSize: '16px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {email.name}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      display: '-webkit-box',
                                      WebkitLineClamp: '1',
                                      WebkitBoxOrient: 'vertical',
                                    }}
                                    style={{ fontSize: '14px' }}
                                  >
                                    {email.geoAddress}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      display: '-webkit-box',
                                      WebkitLineClamp: '1',
                                      WebkitBoxOrient: 'vertical',
                                    }}
                                    style={{
                                      fontSize: '13px',
                                      color: 'slategray',
                                    }}
                                  >
                                    {email.addressNotes}
                                  </Typography>
                                </div>
                                <div
                                  style={{
                                    width: 'calc(54px)',
                                    float: 'right',
                                    padding: '18px 0px 0px 0px',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <span>
                                    <EditIcon style={{ color: email.selected ? getPrimaryColor() : '#000', }}
                                      onClick={() => {
                                        // this.setState({ hasClickedLoc: false });
                                        console.log(email);
                                        if (email.latitude != null) {
                                          // const { lat, lng } = response.results[0].geometry.location;

                                          this.setState({
                                            defaultProps: {
                                              center: {
                                                lat: email.latitude,
                                                lng: email.longitude,
                                              },
                                              zoom: 16,
                                            },
                                            selectLocationData: {
                                              id: email.id,
                                              name: email.name,
                                              address: email.address,
                                              geoAddress: email.geoAddress,
                                              addressNotes: email.addressNotes,
                                              latitude: email.latitude,
                                              longitude: email.longitude,
                                            },
                                          });
                                          this.setState({
                                            autoLoc: email.geoAddress,
                                          });
                                          this.setState({
                                            hasClickedLoc: true,
                                          });
                                        }
                                        // setOptions(newValue ? [newValue, ...options] : options);
                                        // setValue(newValue);
                                        // );
                                      }}
                                    />
                                    &nbsp;
                                    {email.selected ? null : (
                                      <DeleteForeverIcon
                                      onClick={
                                        ()=>{
                                          var locationData = this.state.addresses;
                        const indexOfTaskToDelete = locationData.findIndex(
                          (task) => task.id === email.id
                        );
                        locationData.splice(indexOfTaskToDelete, 1);
                        if (this.state.userId && this.state.userId !== '') {
                          updateDoc(doc(db, 'users', this.state.userId), {
                            locations: locationData,
                          });
                        }
                        this.setState({ addresses: locationData });
                      localStorage.setItem(
                        'location',
                        JSON.stringify(locationData)
                      );
                                        }
                                      }
                                        style={{ color: '#e53837' }}
                                      />
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      : null}
                  </List>*/}

                  <Typography
                    gutterBottom
                    align="center"
                    style={{ color: '#626a71', margin: '0' }}
                  >
                    {strings["o"]}
                  </Typography>
                  <br />
                  <Box textAlign="center">
                    <Button
                      variant="contained"
                      startIcon={<MyLocationIcon />}
                      disableElevation
                      align="center"
                      style={{
                        height: '46px',
                        borderRadius: '12px',
                        fontSize: '18px',
                        // backgroundColor: '#E9FCF2',
                        // color: '#48DB8E',
                        backgroundColor: getPrimaryColor(),
                        // color: getPrimaryColor(),
                        textTransform: 'none',
                      }}
                      onClick={async () => {
                        await navigator.geolocation.getCurrentPosition(
                          (position) => {
                            console.log(position.coords.latitude);
                            this.setState({ hasClickedLoc: false });
                            if (position.coords.latitude != null) {
                              Geocode.setApiKey(
                                'AIzaSyDNl0corYx_1cBY1uvD7vzIzw8pvppIgAM'
                              );
                              Geocode.setLanguage('es');
                              Geocode.setRegion('PA');
                              Geocode.setLocationType('ROOFTOP');
                              Geocode.enableDebug();
                              Geocode.fromLatLng(
                                position.coords.latitude,
                                position.coords.longitude
                              ).then(
                                (response) => {
                                  // const { lat, lng } = response.results[0].geometry.location;
                                  // console.log(lat, lng);
                                  this.setState({
                                    defaultProps: {
                                      center: {
                                        lat: position.coords.latitude,
                                        lng: position.coords.longitude,
                                      },
                                      zoom: 16,
                                    },
                                    selectLocationData: {
                                      id: this.state.selectLocationData.id
                                        ? this.state.selectLocationData.id
                                        : '',
                                      name: this.state.selectLocationData.name
                                        ? this.state.selectLocationData.name
                                        : strings['mi hogar'],
                                      address: this.state.selectLocationData
                                        .address
                                        ? this.state.selectLocationData.address
                                        : '',
                                      geoAddress:
                                        response.results[0].formatted_address,
                                      addressNotes: this.state
                                        .selectLocationData.addressNotes
                                        ? this.state.selectLocationData
                                            .addressNotes
                                        : '',
                                      latitude: position.coords.latitude,
                                      longitude: position.coords.longitude,
                                    },
                                  });
                                  this.setState({ hasClickedLoc: true });
                                  this.setState({
                                    autoLoc:
                                      response.results[0].formatted_address,
                                  });
                                },
                                (error) => {
                                  console.error(error);
                                }
                              );
                            }
                            // setOptions(newValue ? [newValue, ...options] : options);
                            // setValue(newValue);
                          },
                          (err) => console.log(err)
                        );
                      }}
                    >
                      {strings["Usar mi ubicación actual"]}
                    </Button>
                  </Box>
                </>
              )}
            </DialogContent>
          }
        />
                            <AlertDialog
              selectedValue={this.state.selectedValue}
              open={this.state.openDialogAlert}
              displayTitle={""}
              onClose={handleAlertClose}
              displayList={
                <DialogContent dividers style={{ textAlign: 'center', }}>
                  <Typography gutterBottom style={{
                                        fontSize: '19.5px',
                                        fontWeight: '600',
                                        fontFamily: 'Nunito',
                                        letterSpacing: 'normal',
                                      }}>
                    {strings['Cambiar el tipo de entrega borrará su carrito. ¿Estas seguro que deseas continuar?']}
                  </Typography>
                  <img style={{ width: this.state.width < 1000 ? '27vw' : '9vw' }} src={emptycart}/>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                  <Button
                    variant="text"
                    style={{ float: 'left', color: 'red' }}
                    onClick={() => {
                      this.setState({ openDialogAlert: false });
                    }}
                  >
                    {'Cancelar'}
                  </Button>
                  <Button
                    variant="text"
                    style={{ float: 'right', background: getPrimaryColor(), color: 'white', fontWeight: '600', borderRadius: '11px', minWidth: '144px', }}
                    onClick={() => {
                      this.setState({ openDialogAlert: false });
                      handleClearCart();
                      this.setState({ selectedType: this.state.selectedType2 });
                        //handleAlertOpen();
                                          console.log(this.state);
                                          if (!this.state.canDeliverHere && this.state.selectedType2=== 0) {
                                            this.setState({ storeIsOpen: false });
                                          } else if (
                                            !this.state.canDeliverHere &&
                                            (this.state.selectedType2 === 1 || this.state.selectedType2 === 2)
                                          ) {
                                            this.setState({ storeIsOpen: true });
                                          }
                    }}
                  >
                    {'OK'}
                  </Button></Stack>
            </DialogContent>
          }
        />
                <MinimumDialog
          selectedValue={this.state.selectedValue}
          open={this.state.showMinimum}
          displayTitle={strings['Añadir más productos']}
          onClose={handleMinimumClose}
          displayList={
            <DialogContent dividers>
              <Typography gutterBottom style={{
                                    fontSize: '17.5px',
                                    fontWeight: '400',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}>
                {strings["La compra mínima debe ser de ¢"]+((this.state.businessData && this.state.businessData.minimumPurchase)?this.state.businessData.minimumPurchase.toFixed(2):'0')}
              </Typography>
              <br />
              <Stack
  direction="row"
  justifyContent="flex-end"
  alignItems="center"
  spacing={2}
>
              <Button
                    variant="text"
                    style={{ float: 'left' }}
                    onClick={() => {
                      this.setState({ showMinimum: false });
                    }}
                  >
                    {'OK'}
                  </Button></Stack>
            </DialogContent>
          }
        />
        <PreOrderDialog
          selectedValue={this.state.selectedValue}
          open={this.state.openPreOrder}
          onClose={handlePreOrderClose}
          displayList={
            <DialogContent dividers style={{padding: '0px 24px 16px 24px',}}>
              <Stack
  direction="column"
  justifyContent="flex-start"
  alignItems="flex-start"
  spacing={0}
>
                                <div style={{width: '100%', padding: '0px 0px 20px',}}>
                                <Stack
  direction="row"
  justifyContent="space-evenly"
  alignItems="center"
  spacing={0}
>
<FormControl sx={{ m: 1, minWidth: 120 }}>
        <Select
          value={this.state.currenciesList2Selected}
          onChange={(event) => {
            // console.log(event.target.value,this.state.currenciesList2Selected, (typeof event.target.value));
    if(event.target.value !== -1) {
      var showTomorrow = this.state.showTomorrow;
      if (this.state.currenciesList2[event.target.value]['id'] === 1) {
                                        showTomorrow = false;
                                      } else {
                                        showTomorrow = true;
                                      }
                                      this.setState({
                                        showTomorrow:showTomorrow,
                                        selectedPreOrder: (showTomorrow)?this.state.currenciesList3[this.state.currenciesList3Selected]['date']:this.state.currenciesList[this.state.currenciesListSelected]['date']
                                      });
    }
    this.setState({
      currenciesList2Selected:event.target.value
                                      });
  }}
          displayEmpty
          inputProps={{ 'aria-label': '' }}
        >

{this.state.currenciesList2.map((name2, index) => (
   <MenuItem value={index}>
    <Stack
  direction="column"
  justifyContent="flex-start"
  alignItems="flex-start"
  spacing={0}
>
<div style={{padding: "1.5px 0px 1.5px"}}></div>
<Typography
                                  style={{
                                    fontSize: '17.5px',
                                    fontWeight: '500',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                    color: 'slategray',
                                  }}
                                >
                                  {name2['title']}
                                </Typography>
                                <Typography
                                  style={{
                                    fontSize: '19.5px',
                                    fontWeight: '600',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  { moment(name2['date'])
                                .format('DD/MM/YYYY')}
                                </Typography>
</Stack>
   </MenuItem>
))}
        </Select>
      </FormControl>
      <>{(!this.state.showTomorrow)?
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <Select
          value={this.state.showTomorrow?this.state.currenciesList3Selected:this.state.currenciesListSelected}
          onChange={(event) => {
    if(event.target.value !== -1) {
      var showTomorrow = this.state.showTomorrow;
      if (this.state.showTomorrow) {
        this.setState({
          selectedPreOrder:this.state.currenciesList3[event.target.value]['date']
                                      });
                                      } else {
                                        this.setState({
          selectedPreOrder:this.state.currenciesList[event.target.value]['date']
                                      });
                                      }

    }
    if(this.state.showTomorrow) {
    this.setState({
      currenciesList3Selected:event.target.value
                                      });
                                    } else {
                                      this.setState({
                                        currenciesListSelected:event.target.value
                                      });
                                    }
  }}
          displayEmpty
          inputProps={{ 'aria-label': '' }}
        >

                    {this.state.currenciesList.map((name2, index) => (
                       <MenuItem value={index}>
                    <div style={{padding: "15px 15px 15px"}}>
                    <Typography
                                                      style={{
                                                        fontSize: '17.5px',
                                                        fontWeight: '400',
                                                        fontFamily: 'Nunito',
                                                        letterSpacing: 'normal',
                                                      }}
                                                    >
                                                      {name2['display']}
                                                    </Typography></div>
                       </MenuItem>
                    ))}
        </Select>
      </FormControl>:<FormControl sx={{ m: 1, minWidth: 120 }}>
        <Select
          value={this.state.showTomorrow?this.state.currenciesList3Selected:this.state.currenciesListSelected}
          onChange={(event) => {
    if(event.target.value !== -1) {
      var showTomorrow = this.state.showTomorrow;
      if (this.state.showTomorrow) {
        this.setState({
          selectedPreOrder:this.state.currenciesList3[event.target.value]['date']
                                      });
                                      } else {
                                        this.setState({
          selectedPreOrder:this.state.currenciesList[event.target.value]['date']
                                      });
                                      }

    }
    if(this.state.showTomorrow) {
    this.setState({
      currenciesList3Selected:event.target.value
                                      });
                                    } else {
                                      this.setState({
                                        currenciesListSelected:event.target.value
                                      });
                                    }
  }}
          displayEmpty
          inputProps={{ 'aria-label': '' }}
        >

                    {this.state.currenciesList3.map((name2, index) => (
                       <MenuItem value={index}>
                    <div style={{padding: "15px 15px 15px"}}>
                    <Typography
                                                      style={{
                                                        fontSize: '17.5px',
                                                        fontWeight: '400',
                                                        fontFamily: 'Nunito',
                                                        letterSpacing: 'normal',
                                                      }}
                                                    >
                                                      {name2['display']}
                                                    </Typography></div>
                       </MenuItem>
                    ))}
        </Select>
      </FormControl>}
      </>
</Stack>
</div>
<Button fullWidth variant="contained"  style={{ height: '61px', borderRadius: '12px', boxShadow: 'rgb(17 12 46 / 15%) 0px 18px 100px 0px', backgroundColor: getPrimaryColor(), }}
onClick={
  ()=>{
    if(this.state.selectedPreOrder) {
    this.setState(
                        { businessData: null },
                        (newState) => {
                          var weekDay = [6,0,1,2,3,4,5];
    var currentDay = weekDay[this.state.selectedPreOrder.getDay()];
    const { id } = this.props.match.params;
    this.setState({ selectedDate: this.state.selectedPreOrder, selectedWeekDay: currentDay, busId: id,isTomorrow: this.state.showTomorrow,  isPreOrder: true });

                          handlePreOrderClose();
                          // this.setState({ businessData: {} });
                          this.getCities(id);
                        }
                      );
    }
  }
}
>{strings["Programar y avanzar"]}</Button>
</Stack>
            </DialogContent>
          }
        />
        <PaymentDialog
          selectedValue={this.state.selectedValue}
          open={this.state.showPayment}
          onClose={handleClosePayment}
          displayList={
            <DialogContent
              dividers
              style={{
                width: this.state.width < 1000 ? '100%' : '50vw',
                paddingTop: '0',
              }}
            >
              <List>
                <Stack direction={'column'} spacing={0}>
                  {/*<>
                    {(this.state.businessData && this.state.cards && !this.state.businessData.cashOnly && (this.state.businessData.paymentOptions == null || this.state.businessData.paymentOptions.length === 0 || this.state.businessData.paymentOptions.includes(0))) ? (
                  <>
                        {this.state.cards.map((items, index) => (
                          <React.Fragment key={index}>
                            <div style={{ padding: '0px 10px 0px' }}>
                        <div
                          style={{
                            padding: '12px',
                            borderBottom: '1px solid #e6ebf1',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            this.setState({
                              defaultCard: items,
                              showPayment: false,
                            });
                          }}
                        >
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Stack
                              direction={'row'}
                              spacing={0}
                              alignItems="center"
                            >
                              <img
                                height={'100%'}
                                style={{
                                  padding: '22px',
                                  height: '45px',
                                  width: '45px',
                                  backgroundSize: 'contain',
                                  backgroundRepeat: 'no-repeat',
                                  border: '0',
                                  backgroundImage:
                                  (items['card']['brand']
                                                      .toString()
                                                      .toLowerCase()
                                                      .includes('visa'))
                                                  ? 'url("https://firebasestorage.googleapis.com/v0/b/cafi-a68cf.appspot.com/o/cards%2Fvisa.png?alt=media&token=1925130f-c1f1-40cf-96ce-07b6d12fb826")'
                                                  : (items['card']
                                                              ['brand']
                                                          .toString()
                                                          .toLowerCase()
                                                          .includes('master'))
                                                      ? 'url("https://firebasestorage.googleapis.com/v0/b/cafi-a68cf.appspot.com/o/cards%2Fmastercard.png?alt=media&token=aed207cf-4abf-4617-9554-c7e4edb66d66")'
                                                      : (items['card']
                                                                  ['brand']
                                                              .toString()
                                                              .toLowerCase()
                                                              .includes(
                                                                  'discover'))
                                                          ? 'url("https://firebasestorage.googleapis.com/v0/b/cafi-a68cf.appspot.com/o/cards%2Fdiscover.png?alt=media&token=3321b25f-44d1-429a-916a-b10b7bf3fdc0")'
                                                          : (items
                                                                          ['card']
                                                                      ['brand']
                                                                  .toString()
                                                                  .toLowerCase()
                                                                  .includes('diners'))
                                                              ? 'url("https://firebasestorage.googleapis.com/v0/b/cafi-a68cf.appspot.com/o/cards%2Fdiners.png?alt=media&token=c08b27e3-a721-4fc0-9819-657716d471f4")'
                                                              :'url("https://dl3.pushbulletusercontent.com/CUuK1FWCl5LMK8FrR3SWbOEctMXBKazX/Payment%20icons-01.png")',
                                }}
                              />
                              <div style={{ padding: '5px 15px' }}>
                                <Typography
                                  style={{
                                    fontSize: '17.5px',
                                    fontWeight: '500',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {strings["Tarjeta con terminación "]+
                                                items['card']['last4']
                                                    .toString()}
                                </Typography>
                              </div>
                            </Stack>
                          </Stack>
                        </div>
                      </div>
                          </React.Fragment>
                        ))}
                      </>
                    ) : null}
                  </> */}
                  {/* <>
              {
                <div style={{padding: "20px 20px 0px"}}>
                  <div style={{padding: "5px", color: "#f8f9fb", borderRadius: "50px"}}>
                  <Stack direction={'row'} spacing={0} justifyContent="space-between"
  alignItems="center">
                  <Stack direction={'row'} spacing={0}
  alignItems="center">
    <CreditCardIcon
    style={{
      fontSize: "24px",
      color:"#000"
    }}
    />
    <div style={{padding: "5px"}}>
    <Typography
                    style={{ fontSize: '17.5px', fontWeight: 'normal' }}
                  >
                    Add new card
                  </Typography>
    </div>
                  </Stack>
                  </Stack>
</div>
                </div>
              }
              </> */}
                  {/*<>
                    {(this.state.businessData && !this.state.businessData.cashOnly && (this.state.businessData.paymentOptions == null || this.state.businessData.paymentOptions.length === 0 || this.state.businessData.paymentOptions.includes(0))) ? (
                      <div style={{ padding: '0px 10px 0px' }}>
                        <div
                          style={{
                            padding: '12px',
                            borderBottom: '1px solid #e6ebf1',
                            cursor: 'pointer',
                          }}
                          onClick={()=>{
                            handleClickAddCardOpen();
                          }}
                        >
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Stack
                              direction={'row'}
                              spacing={0}
                              alignItems="center"
                            >
                              <img
                                height={'100%'}
                                style={{
                                  padding: '22px',
                                  height: '45px',
                                  width: '45px',
                                  backgroundSize: 'contain',
                                  backgroundRepeat: 'no-repeat',
                                  border: '0',
                                  backgroundImage:
                                    'url("https://dl3.pushbulletusercontent.com/CUuK1FWCl5LMK8FrR3SWbOEctMXBKazX/Payment%20icons-01.png")',
                                }}
                              />
                              <div style={{ padding: '5px 15px' }}>
                                <Typography
                                  style={{
                                    fontSize: '17.5px',
                                    fontWeight: '500',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {strings["Agregar nueva tarjeta"]}
                                </Typography>
                              </div>
                            </Stack>
                          </Stack>
                        </div>
                      </div>
                    ) : null}
                  </> */}
                  <>
                    {(this.state.businessData && !this.state.businessData.cardOnly && (this.state.businessData.paymentOptions == null || this.state.businessData.paymentOptions.length === 0 || this.state.businessData.paymentOptions.includes(1))) ? (
                      <div style={{ padding: '0px 10px 0px' }}>
                        <div
                          onClick={() => {
                            this.setState({
                              defaultCard: {
                                cardNumber: 'COD',
                              },
                              showPayment: false,
                            });
                          }}
                          style={{
                            padding: '12px',
                            borderBottom: '1px solid #e6ebf1',
                            cursor: 'pointer',
                          }}
                        >
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Stack
                              direction={'row'}
                              spacing={0}
                              alignItems="center"
                            >
                              <img
                                height={'100%'}
                                style={{
                                  padding: '22px',
                                  height: '45px',
                                  width: '45px',
                                  backgroundSize: 'contain',
                                  backgroundRepeat: 'no-repeat',
                                  border: '0',
                                  backgroundImage:
                                    'url("https://dl3.pushbulletusercontent.com/S4LwEZ2S0F5H5pHbRWmha1WWdQmnDtxg/Payment%20icons-03.png")',
                                }}
                              />
                              <div style={{ padding: '5px 15px' }}>
                                <Typography
                                  style={{
                                    fontSize: '17.5px',
                                    fontWeight: '500',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {strings["Pago en efectivo"]}
                                </Typography>
                              </div>
                            </Stack>
                          </Stack>
                        </div>
                      </div>
                    ) : null}
                  </>
                  <>
                    {(this.state.businessData && !this.state.businessData.cardOnly &&
                    this.state.businessData.cardOnDelivery && (this.state.businessData.paymentOptions == null || this.state.businessData.paymentOptions.length === 0 || this.state.businessData.paymentOptions.includes(2))) ? (
                      <div style={{ padding: '0px 10px 0px' }}>
                        <div
                          onClick={() => {
                            this.setState({
                              defaultCard: {
                                cardNumber: 'CardOD',
                              },
                              showPayment: false,
                            });
                          }}
                          style={{
                            padding: '12px',
                            borderBottom: '1px solid #e6ebf1',
                            cursor: 'pointer',
                          }}
                        >
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Stack
                              direction={'row'}
                              spacing={0}
                              alignItems="center"
                            >
                              <img
                                height={'100%'}
                                style={{
                                  padding: '22px',
                                  height: '45px',
                                  width: '45px',
                                  backgroundSize: 'contain',
                                  backgroundRepeat: 'no-repeat',
                                  border: '0',
                                  backgroundImage:
                                    'url("https://dl3.pushbulletusercontent.com/YT1RwbwCHJoEqRCYB9fjwk7lrpuzapck/Payment%20icons-02.png")',
                                }}
                              />
                              <div style={{ padding: '5px 15px' }}>
                                <Typography
                                  style={{
                                    fontSize: '17.5px',
                                    fontWeight: '500',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {strings["Tarjeta a la entrega"]}
                                </Typography>
                              </div>
                            </Stack>
                          </Stack>
                        </div>
                      </div>
                    ) : null}
                  </>
                  <>
                    {(this.state.businessData && !this.state.businessData.cardOnly &&
                    this.state.businessData.mobilePayment && (this.state.businessData.paymentOptions == null || this.state.businessData.paymentOptions.length === 0 || this.state.businessData.paymentOptions.includes(3))) ? (
                      <div style={{ padding: '0px 10px 0px' }}>
                        <div
                          onClick={() => {
                            this.setState({
                              defaultCard: {
                                cardNumber: 'mobilePayment',
                              },
                              showPayment: false,
                            });
                          }}
                          style={{
                            padding: '12px',
                            borderBottom: '1px solid #e6ebf1',
                            cursor: 'pointer',
                          }}
                        >
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Stack
                              direction={'row'}
                              spacing={0}
                              alignItems="center"
                            >
                              <img
                                height={'100%'}
                                style={{
                                  padding: '22px',
                                  height: '45px',
                                  width: '45px',
                                  backgroundSize: 'contain',
                                  backgroundRepeat: 'no-repeat',
                                  border: '0',
                                  backgroundImage:
                                    'url("https://dl3.pushbulletusercontent.com/YT1RwbwCHJoEqRCYB9fjwk7lrpuzapck/Payment%20icons-02.png")',
                                }}
                              />
                              <div style={{ padding: '5px 15px' }}>
                                <Typography
                                  style={{
                                    fontSize: '17.5px',
                                    fontWeight: '500',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {"Sinpe Móvil: 8787-1617 (mandar comprobante)"}
                                </Typography>
                              </div>
                            </Stack>
                          </Stack>
                        </div>
                      </div>
                    ) : null}
                  </>
                  <>
                    {(this.state.businessData && !this.state.businessData.cardOnly &&
                    this.state.businessData.cryptoPayment && (this.state.businessData.paymentOptions == null || this.state.businessData.paymentOptions.length === 0 || this.state.businessData.paymentOptions.includes(4))) ? (
                      <div style={{ padding: '0px 10px 0px' }}>
                        <div
                          onClick={() => {
                            this.setState({
                              defaultCard: {
                                cardNumber: 'cryptoPayment',
                              },
                              showPayment: false,
                            });
                          }}
                          style={{
                            padding: '12px',
                            borderBottom: '1px solid #e6ebf1',
                            cursor: 'pointer',
                          }}
                        >
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Stack
                              direction={'row'}
                              spacing={0}
                              alignItems="center"
                            >
                              <img
                                height={'100%'}
                                style={{
                                  padding: '22px',
                                  height: '45px',
                                  width: '45px',
                                  backgroundSize: 'contain',
                                  backgroundRepeat: 'no-repeat',
                                  border: '0',
                                  backgroundImage:
                                    'url("https://dl3.pushbulletusercontent.com/YT1RwbwCHJoEqRCYB9fjwk7lrpuzapck/Payment%20icons-02.png")',
                                }}
                              />
                              <div style={{ padding: '5px 15px' }}>
                                <Typography
                                  style={{
                                    fontSize: '17.5px',
                                    fontWeight: '500',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {strings["Pago con Criptomoneda"]}
                                </Typography>
                              </div>
                            </Stack>
                          </Stack>
                        </div>
                      </div>
                    ) : null}
                  </>
                </Stack>
              </List>
            </DialogContent>
          }
        />
        <DiscountDialog
          selectedValue={this.state.selectedValue}
          open={this.state.showDiscount}
          onClose={handleCloseDiscount}
          displayList={
            <DialogContent
              dividers
              style={{ width: this.state.width < 1000 ? '100%' : '50vw' }}
            >
              <>
                {this.state.offers && this.state.offers.length > 0 ? (
                  <List>
                    {this.state.offers.map((items, offerIndex) => (
                      <React.Fragment key={offerIndex}>
                        {(this.state.offersUsed.find(
                          (element) =>
                            element['id'] ===
                            this.state.offers[offerIndex]['id']
                        ) == null ||
                          this.state.offersUsed.filter(
                            (element) =>
                              element['id'] ===
                              this.state.offers[offerIndex]['id']
                          ).length <
                            this.state.offers[offerIndex]['maximumUses']) &&
                        (this.state.offers[offerIndex]['validFrom'] == null ||
                          moment().isAfter(
                            moment(
                              this.state.offers[offerIndex][
                                'validFrom'
                              ].toDate()
                            )
                          )) &&
                        (this.state.offers[offerIndex]['validTill'] == null ||
                          moment().isBefore(
                            moment(
                              this.state.offers[offerIndex][
                                'validTill'
                              ].toDate()
                            )
                          )) ? (
                          <div
                            style={{
                              borderBottom: '1px solid #ccc',
                              backgroundColor: '#fff',
                              padding: '20px',
                            }}
                          >
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="flex-start"
                            >
                              <Stack
                                direction={'column'}
                                spacing={0}
                                sx={{ flexGrow: 1 }}
                                alignItems="flex-start"
                              >
                                <div style={{ padding: '0px 0px 10px' }}>
                                  <Typography
                                    style={{
                                      fontSize: '16px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {this.state.offers[offerIndex]['offerName']}
                                  </Typography>
                                </div>
                                <div>
                                  <Stack direction={'row'} spacing={0}>
                                    <>
                                      {this.state.offers[offerIndex][
                                        'details'
                                      ] == null ||
                                      !this.state.offers[offerIndex][
                                        'details'
                                      ] ? (
                                        <div>
                                          <Typography
                                            onClick={() => {
                                              var devyOffers =
                                                this.state.offers;
                                              devyOffers[offerIndex][
                                                'details'
                                              ] = true;
                                              this.setState({
                                                offers: devyOffers,
                                              });
                                            }}
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: 'normal',
                                              cursor: 'pointer',
                                            }}
                                          >
                                            {this.state.offers[offerIndex][
                                              'description'
                                            ] + strings['. Ver detalles']}
                                          </Typography>
                                        </div>
                                      ) : null}
                                    </>
                                    <>
                                      {this.state.offers[offerIndex][
                                        'details'
                                      ] != null &&
                                      this.state.offers[offerIndex][
                                        'details'
                                      ] ? (
                                        <div>
                                          <Typography
                                            onClick={() => {
                                              var devyOffers =
                                                this.state.offers;
                                              devyOffers[offerIndex][
                                                'details'
                                              ] = false;
                                              this.setState({
                                                offers: devyOffers,
                                              });
                                            }}
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: 'normal',
                                              cursor: 'pointer',
                                            }}
                                          >
                                            {this.state.offers[offerIndex][
                                              'description'
                                            ] + strings['. Menos detalles']}
                                          </Typography>
                                        </div>
                                      ) : null}
                                    </>
                                  </Stack>
                                </div>
                                <>
                                  {this.state.offers[offerIndex]['details'] !=
                                    null &&
                                  this.state.offers[offerIndex]['details'] ? (
                                    <div style={{ padding: '8px 0px 8px' }}>
                                      <Stack direction={'column'} spacing={0}>
                                        <>
                                          {this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] != null &&
                                          this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •
                                              {strings['Comprar '] +
                                                (
                                                  this.state.offers[offerIndex][
                                                    'freeItem'
                                                  ] +
                                                  this.state.offers[offerIndex][
                                                    'buyItem'
                                                  ]
                                                ).toString() +
                                                strings[' productos y pago '] +
                                                this.state.offers[offerIndex][
                                                  'buyItem'
                                                ].toString() +
                                                strings[' en productos seleccionados']}
                                            </Typography>
                                          ) : null}
                                        </>
                                        <>
                                          {this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] != null &&
                                          this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •{strings['Productos promocionados:']}
                                            </Typography>
                                          ) : null}
                                        </>
                                        <>
                                          {this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] != null &&
                                          this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] ? (
                                            <>
                                              {this.state.offers[offerIndex][
                                                'items'
                                              ].map((items, t) => (
                                                <Typography
                                                  style={{
                                                    fontSize: '15px',
                                                    fontWeight: 'normal',
                                                  }}
                                                >
                                                  •
                                                  {
                                                    this.state.offers[
                                                      offerIndex
                                                    ]['items'][t]['name']
                                                  }
                                                </Typography>
                                              ))}
                                            </>
                                          ) : null}
                                        </>
                                        <>
                                          {(this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] == null ||
                                            !this.state.offers[offerIndex][
                                              'isItemOffer'
                                            ]) &&
                                          this.state.offers[offerIndex][
                                            'freeDelivery'
                                          ] ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •
                                              {
                                                strings['Se eliminará la tarifa de envío']
                                              }
                                            </Typography>
                                          ) : null}
                                        </>
                                        <>
                                          {(this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] == null ||
                                            !this.state.offers[offerIndex][
                                              'isItemOffer'
                                            ]) &&
                                          this.state.offers[offerIndex][
                                            'minimumItemValue'
                                          ] > 0 ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •
                                              {strings['El número mínimo de productos debe ser ¢'] +
                                                this.state.offers[offerIndex][
                                                  'minimumItemValue'
                                                ].toString()}
                                            </Typography>
                                          ) : null}
                                        </>
                                        <>
                                          {(this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] == null ||
                                            !this.state.offers[offerIndex][
                                              'isItemOffer'
                                            ]) &&
                                          this.state.offers[offerIndex][
                                            'maximumItemValue'
                                          ] > 0 ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •
                                              {strings['El número máximo de productos debe ser ¢'] +
                                                this.state.offers[offerIndex][
                                                  'maximumItemValue'
                                                ].toString()}
                                            </Typography>
                                          ) : null}
                                        </>
                                        <>
                                          {(this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] == null ||
                                            !this.state.offers[offerIndex][
                                              'isItemOffer'
                                            ]) &&
                                          this.state.offers[offerIndex][
                                            'discountAmount'
                                          ] > 0 ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •
                                              {strings['Descuento ¢'] +
                                                this.state.offers[offerIndex][
                                                  'discountAmount'
                                                ].toString()}
                                            </Typography>
                                          ) : null}
                                        </>
                                        <>
                                          {(this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] == null ||
                                            !this.state.offers[offerIndex][
                                              'isItemOffer'
                                            ]) &&
                                          this.state.offers[offerIndex][
                                            'cashbackAmount'
                                          ] != null &&
                                          this.state.offers[offerIndex][
                                            'cashbackAmount'
                                          ] > 0 ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •
                                              {strings['Obtener ¢'] +
                                                this.state.offers[offerIndex][
                                                  'cashbackAmount'
                                                ].toString() +
                                                strings[' al final del día en Wallet']}
                                            </Typography>
                                          ) : null}
                                        </>
                                        <>
                                          {(this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] == null ||
                                            !this.state.offers[offerIndex][
                                              'isItemOffer'
                                            ]) &&
                                          this.state.offers[offerIndex][
                                            'cashbackPercentage'
                                          ] != null &&
                                          this.state.offers[offerIndex][
                                            'cashbackPercentage'
                                          ] > 0 ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •
                                              {strings['Obtener '] +
                                                this.state.offers[offerIndex][
                                                  'cashbackPercentage'
                                                ].toString() +
                                                strings['% de cashback sobre el total de tus productos en Wallet']}
                                            </Typography>
                                          ) : null}
                                        </>
                                        <>
                                          {(this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] == null ||
                                            !this.state.offers[offerIndex][
                                              'isItemOffer'
                                            ]) &&
                                          this.state.offers[offerIndex][
                                            'discountPercentage'
                                          ] > 0 ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •
                                              {strings['Obtener '] +
                                                this.state.offers[offerIndex][
                                                  'discountPercentage'
                                                ].toString() +
                                                strings['% de descuento en todos sus productos.']}
                                            </Typography>
                                          ) : null}
                                        </>
                                        <>
                                          {(this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] == null ||
                                            !this.state.offers[offerIndex][
                                              'isItemOffer'
                                            ]) &&
                                          this.state.offers[offerIndex][
                                            'minimumDiscount'
                                          ] > 0 ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •
                                              {strings['Consigue un descuento mínimo de ¢'] +
                                                this.state.offers[offerIndex][
                                                  'minimumDiscount'
                                                ].toString()}
                                            </Typography>
                                          ) : null}
                                        </>
                                        <>
                                          {(this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] == null ||
                                            this.state.offers[offerIndex][
                                              'isItemOffer'
                                            ]) &&
                                          this.state.offers[offerIndex][
                                            'maximumDiscount'
                                          ] > 0 ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •
                                              {strings['Sube hasta ¢'] +
                                                this.state.offers[offerIndex][
                                                  'maximumDiscount'
                                                ].toString() +
                                                strings[' descuento']}
                                            </Typography>
                                          ) : null}
                                        </>
                                        <>
                                          {(this.state.offers[offerIndex][
                                            'isItemOffer'
                                          ] == null ||
                                            this.state.offers[offerIndex][
                                              'isItemOffer'
                                            ]) &&
                                          this.state.offers[offerIndex][
                                            'maximumDiscount'
                                          ] > 0 ? (
                                            <Typography
                                              style={{
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              •
                                              {strings['Sube hasta ¢'] +
                                                this.state.offers[offerIndex][
                                                  'maximumDiscount'
                                                ].toString() +
                                                strings[' descuento']}
                                            </Typography>
                                          ) : null}
                                        </>
                                      </Stack>
                                    </div>
                                  ) : null}
                                </>
                              </Stack>
                              <div
                                style={{
                                  padding: '10px 0px 0px',
                                  width: '100%',
                                }}
                              >
                                <Stack
                                  direction={'row'}
                                  spacing={0}
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <div
                                    style={{
                                      padding: '10px 10px 10px',
                                      backgroundColor: '#f8f9fb',
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        fontSize: '17px',
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      {this.state.offers[offerIndex]['code']}
                                    </Typography>
                                  </div>
                                  {!this.state.showDiscountIsBusiness && (
                                    <Typography
                                      onClick={() => {
                                        // console.log('Her');
                                        var offerCode = this.state.offerCode;
                                        var offerId = this.state.offerId;
                                        var offerSuccess =
                                          this.state.offerSuccess;
                                        var offerErrorText =
                                          this.state.offerErrorText;
                                        var offerValue = this.state.offerValue;
                                        var cashbackValue =
                                          this.state.cashbackValue;
                                        var offerInd = this.state.offerInd;
                                        var isOfferApplied =
                                          this.state.isOfferApplied;
                                        var isOfferError =
                                          this.state.isOfferError;
                                        var isFreeDelivery =
                                          this.state.isFreeDelivery;
                                        var offersUsed = this.state.offersUsed;
                                        var devyOffers = this.state.offers;
                                        var cart = this.state.cart;
                                        var delivery = this.state.delivery;
                                        // usingWallet = false;
                                        // isUsingInviteCode = false;
                                        // isUsingSubscription = false;
                                        this.setState({
          selectedOffer: devyOffers[offerIndex],
        });
                                        if (
                                          offersUsed.find(
                                            (element) =>
                                              element['id'] ===
                                              devyOffers[offerIndex]['id']
                                          ) == null
                                        ) {
                                          if (
                                            devyOffers[offerIndex][
                                              'isItemOffer'
                                            ] != null &&
                                            devyOffers[offerIndex][
                                              'isItemOffer'
                                            ]
                                          ) {
                                            offerValue = 0;
                                            cashbackValue = 0.0;
                                            // console.log(
                                            //   devyOffers[offerIndex]['items']
                                            // );
                                            var testList =
                                              devyOffers[offerIndex]['items'];
                                            for (
                                              var ij = 0;
                                              ij < cart['item'].length;
                                              ij++
                                            ) {
                                              //print(testList.filter((element34) => element34['id'].contains(cart['item'][ij]['id'])));
                                              if (
                                                testList.find(
                                                  (element34) =>
                                                    element34['id'] ===
                                                    cart['item'][ij]['id']
                                                ) != null
                                              ) {
                                                var tempValue = testList.find(
                                                  (element) =>
                                                    element['id'].toString() ===
                                                    cart['item'][ij][
                                                      'id'
                                                    ].toString()
                                                );
                                                if (
                                                  tempValue['id'] ===
                                                    cart['item'][ij]['id'] &&
                                                  Math.trunc(
                                                    cart['item'][ij][
                                                      'quantity'
                                                    ] /
                                                      (devyOffers[offerIndex][
                                                        'freeItem'
                                                      ] +
                                                        devyOffers[offerIndex][
                                                          'buyItem'
                                                        ])
                                                  ) > 0
                                                ) {
                                                  offerValue =
                                                    offerValue +
                                                    cart['item'][ij]['price'] *
                                                      Math.trunc(
                                                        cart['item'][ij][
                                                          'quantity'
                                                        ] /
                                                          (devyOffers[
                                                            offerIndex
                                                          ]['freeItem'] +
                                                            devyOffers[
                                                              offerIndex
                                                            ]['buyItem'])
                                                      ) +
                                                    0.0;
                                                }
                                              }
                                            }
                                            if (offerValue > 0) {
                                              isOfferApplied = true;
                                              offerInd = offerIndex;
                                              isFreeDelivery = false;
                                              isOfferError = false;
                                              offerErrorText = '';
                                              offerCode =
                                                devyOffers[offerIndex]['code'];
                                              offerId =
                                                devyOffers[offerIndex]['id'];
                                              offerSuccess =
                                                strings['Su cupón ha sido agregado con éxito.'];
                                            } else {
                                              isOfferApplied = false;
                                              isOfferError = true;
                                              isFreeDelivery = false;
                                              offerInd = offerIndex;
                                              offerErrorText =
                                                strings['Añadir al menos '] +
                                                (
                                                  devyOffers[offerIndex][
                                                    'freeItem'
                                                  ] +
                                                  devyOffers[offerIndex][
                                                    'buyItem'
                                                  ]
                                                ).toString() +
                                                strings[' productos promocionales.'];
                                              offerCode =
                                                devyOffers[offerIndex]['code'];
                                              offerSuccess = '';
                                              offerValue = 0;
                                              cashbackValue = 0.0;
                                              offerId = '';
                                            }
                                          } else if (
                                            cart['totalCost'] >=
                                            devyOffers[offerIndex][
                                              'minimumItemValue'
                                            ]
                                          ) {
                                            if (
                                              devyOffers[offerIndex][
                                                'maximumItemValue'
                                              ] === 0 ||
                                              cart['totalCost'] <=
                                                devyOffers[offerIndex][
                                                  'maximumItemValue'
                                                ]
                                            ) {
                                              isOfferApplied = true;
                                              offerInd = offerIndex;
                                              isFreeDelivery = false;
                                              isOfferError = false;
                                              offerErrorText = '';
                                              offerCode =
                                                devyOffers[offerIndex]['code'];
                                              offerId =
                                                devyOffers[offerIndex]['id'];
                                              offerSuccess =
                                                strings['Su cupón ha sido agregado con éxito.'];
                                              if (
                                                devyOffers[offerIndex][
                                                  'freeDelivery'
                                                ]
                                              ) {
                                                offerValue = delivery + 0.0;
                                                cashbackValue = 0.0;
                                                isFreeDelivery = true;
                                              } else {
                                                isFreeDelivery = false;
                                                offerValue =
                                                  devyOffers[offerIndex][
                                                    'discountAmount'
                                                  ] +
                                                  0.0 +
                                                  (devyOffers[offerIndex][
                                                    'discountPercentage'
                                                  ] /
                                                    100) *
                                                    cart['totalCost'];
                                                if (
                                                  offerValue <
                                                  devyOffers[offerIndex][
                                                    'minimumDiscount'
                                                  ]
                                                ) {
                                                  offerValue =
                                                    devyOffers[offerIndex][
                                                      'minimumDiscount'
                                                    ] + 0.0;
                                                } else if (
                                                  devyOffers[offerIndex][
                                                    'maximumDiscount'
                                                  ] !== 0 &&
                                                  offerValue >
                                                    devyOffers[offerIndex][
                                                      'maximumDiscount'
                                                    ]
                                                ) {
                                                  offerValue =
                                                    devyOffers[offerIndex][
                                                      'maximumDiscount'
                                                    ] + 0.0;
                                                }
                                                cashbackValue =
                                                  devyOffers[offerIndex][
                                                    'cashbackAmount'
                                                  ] != null
                                                    ? devyOffers[offerIndex][
                                                        'cashbackAmount'
                                                      ] +
                                                      0.0 +
                                                      (devyOffers[offerIndex][
                                                        'cashbackPercentage'
                                                      ] != null
                                                        ? (devyOffers[
                                                            offerIndex
                                                          ][
                                                            'cashbackPercentage'
                                                          ] /
                                                            100) *
                                                          cart['totalCost']
                                                        : 0)
                                                    : 0.0;
                                              }
                                            } else {
                                              isOfferApplied = false;
                                              isOfferError = true;
                                              isFreeDelivery = false;
                                              offerInd = offerIndex;
                                              offerErrorText =
                                                strings['Los productos máximos deben ser ¢'] +
                                                devyOffers[offerIndex][
                                                  'maximumItemValue'
                                                ].toString();
                                              offerCode =
                                                devyOffers[offerIndex]['code'];
                                              offerSuccess = '';
                                              offerValue = 0;
                                              cashbackValue = 0.0;
                                              offerId = '';
                                            }
                                          } else if (
                                            cart['totalCost'] <
                                            devyOffers[offerIndex][
                                              'minimumItemValue'
                                            ]
                                          ) {
                                            isOfferApplied = false;
                                            isOfferError = true;
                                            isFreeDelivery = false;
                                            offerInd = offerIndex;
                                            offerErrorText =
                                              strings['Los productos mínimos deben ser ¢'] +
                                              devyOffers[offerIndex][
                                                'minimumItemValue'
                                              ].toString();
                                            offerCode =
                                              devyOffers[offerIndex]['code'];
                                            offerSuccess = '';
                                            offerValue = 0;
                                            cashbackValue = 0.0;
                                            offerId = '';
                                          }
                                        } else {
                                          if (
                                            offersUsed
                                              .filter(
                                                (element) =>
                                                  element['id'] ===
                                                  devyOffers[offerIndex]['id']
                                              )
                                              [
                                                offersUsed.filter(
                                                  (element) =>
                                                    element['id'] ===
                                                    devyOffers[offerIndex]['id']
                                                ).length - 1
                                              ]['usedOn'].toMillis() +
                                              devyOffers[offerIndex][
                                                'timeBetweenUses'
                                              ] *
                                                1000 <
                                            Date.now()
                                          ) {
                                            if (
                                              devyOffers[offerIndex][
                                                'isItemOffer'
                                              ] != null &&
                                              devyOffers[offerIndex][
                                                'isItemOffer'
                                              ]
                                            ) {
                                              offerValue = 0;
                                              cashbackValue = 0.0;
                                              for (
                                                var ij = 0;
                                                ij < cart['item'].length;
                                                ij++
                                              ) {
                                                if (
                                                  devyOffers[offerIndex][
                                                    'items'
                                                  ].find((element) =>
                                                    element['id'] ===
                                                    cart['item'][ij]['id']
                                                      ? true
                                                      : false
                                                  ) != null
                                                ) {
                                                  var tempValue = devyOffers[
                                                    offerIndex
                                                  ]['items'].find((element) =>
                                                    element['id'] ===
                                                    cart['item'][ij]['id']
                                                      ? true
                                                      : false
                                                  );
                                                  if (
                                                    tempValue['id'] ===
                                                      cart['item'][ij]['id'] &&
                                                    Math.trunc(
                                                      cart['item'][ij][
                                                        'quantity'
                                                      ] /
                                                        (devyOffers[offerIndex][
                                                          'freeItem'
                                                        ] +
                                                          devyOffers[
                                                            offerIndex
                                                          ]['buyItem'])
                                                    ) > 0
                                                  ) {
                                                    offerValue =
                                                      offerValue +
                                                      cart['item'][ij][
                                                        'price'
                                                      ] *
                                                        Math.trunc(
                                                          cart['item'][ij][
                                                            'quantity'
                                                          ] /
                                                            (devyOffers[
                                                              offerIndex
                                                            ]['freeItem'] +
                                                              devyOffers[
                                                                offerIndex
                                                              ]['buyItem'])
                                                        ) +
                                                      0.0;
                                                  }
                                                }
                                              }
                                              if (offerValue > 0) {
                                                isOfferApplied = true;
                                                offerInd = offerIndex;
                                                isFreeDelivery = false;
                                                isOfferError = false;
                                                offerErrorText = '';
                                                offerCode =
                                                  devyOffers[offerIndex][
                                                    'code'
                                                  ];
                                                offerId =
                                                  devyOffers[offerIndex]['id'];
                                                offerSuccess =
                                                  strings['Su cupón ha sido agregado con éxito.'];
                                              } else {
                                                isOfferApplied = false;
                                                isOfferError = true;
                                                isFreeDelivery = false;
                                                offerInd = offerIndex;
                                                offerErrorText =
                                                  strings['Añadir al menos '] +
                                                  (
                                                    devyOffers[offerIndex][
                                                      'freeItem'
                                                    ] +
                                                    devyOffers[offerIndex][
                                                      'buyItem'
                                                    ]
                                                  ).toString() +
                                                  strings[' productos promocionales.'];

                                                offerCode =
                                                  devyOffers[offerIndex][
                                                    'code'
                                                  ];
                                                offerSuccess = '';
                                                offerValue = 0;
                                                cashbackValue = 0.0;
                                                offerId = '';
                                              }
                                            } else if (
                                              cart['totalCost'] >=
                                              devyOffers[offerIndex][
                                                'minimumItemValue'
                                              ]
                                            ) {
                                              if (
                                                devyOffers[offerIndex][
                                                  'maximumItemValue'
                                                ] === 0 ||
                                                cart['totalCost'] <=
                                                  devyOffers[offerIndex][
                                                    'maximumItemValue'
                                                  ]
                                              ) {
                                                isOfferApplied = true;
                                                isOfferError = false;
                                                isFreeDelivery = false;
                                                offerInd = offerIndex;
                                                offerErrorText = '';
                                                offerId =
                                                  devyOffers[offerIndex]['id'];
                                                offerCode =
                                                  devyOffers[offerIndex][
                                                    'code'
                                                  ];
                                                offerSuccess =
                                                  strings['Su cupón ha sido agregado con éxito.'];
                                                if (
                                                  devyOffers[offerIndex][
                                                    'freeDelivery'
                                                  ]
                                                ) {
                                                  offerValue = delivery + 0.0;
                                                  cashbackValue = 0.0;
                                                  isFreeDelivery = true;
                                                } else {
                                                  isFreeDelivery = false;
                                                  offerValue =
                                                    devyOffers[offerIndex][
                                                      'discountAmount'
                                                    ] +
                                                    0.0 +
                                                    (devyOffers[offerIndex][
                                                      'discountPercentage'
                                                    ] /
                                                      100) *
                                                      cart['totalCost'];
                                                  if (
                                                    offerValue <
                                                    devyOffers[offerIndex][
                                                      'minimumDiscount'
                                                    ]
                                                  ) {
                                                    offerValue =
                                                      devyOffers[offerIndex][
                                                        'minimumDiscount'
                                                      ] + 0.0;
                                                  } else if (
                                                    devyOffers[offerIndex][
                                                      'maximumDiscount'
                                                    ] !== 0 &&
                                                    offerValue >
                                                      devyOffers[offerIndex][
                                                        'maximumDiscount'
                                                      ]
                                                  ) {
                                                    offerValue =
                                                      devyOffers[offerIndex][
                                                        'maximumDiscount'
                                                      ] + 0.0;
                                                  }
                                                  cashbackValue =
                                                    devyOffers[offerIndex][
                                                      'cashbackAmount'
                                                    ] != null
                                                      ? devyOffers[offerIndex][
                                                          'cashbackAmount'
                                                        ] +
                                                        0.0 +
                                                        (devyOffers[offerIndex][
                                                          'cashbackPercentage'
                                                        ] != null
                                                          ? (devyOffers[
                                                              offerIndex
                                                            ][
                                                              'cashbackPercentage'
                                                            ] /
                                                              100) *
                                                            cart['totalCost']
                                                          : 0)
                                                      : 0.0;
                                                }
                                              } else {
                                                isOfferApplied = false;
                                                isOfferError = true;
                                                isFreeDelivery = false;
                                                offerInd = offerIndex;
                                                offerErrorText =
                                                  strings['Los productos máximos deben ser ¢'] +
                                                  devyOffers[offerIndex][
                                                    'maximumItemValue'
                                                  ].toString();
                                                offerCode =
                                                  devyOffers[offerIndex][
                                                    'code'
                                                  ];
                                                offerSuccess = '';
                                                offerValue = 0;
                                                cashbackValue = 0.0;
                                                offerId = '';
                                              }
                                            } else if (
                                              cart['totalCost'] <
                                              devyOffers[offerIndex][
                                                'minimumItemValue'
                                              ]
                                            ) {
                                              isOfferApplied = false;
                                              isFreeDelivery = false;
                                              isOfferError = true;
                                              offerInd = offerIndex;
                                              offerErrorText =
                                                strings['Los productos mínimos deben ser ¢'] +
                                                devyOffers[offerIndex][
                                                  'minimumItemValue'
                                                ].toString();
                                              offerCode =
                                                devyOffers[offerIndex]['code'];
                                              offerSuccess = '';
                                              offerValue = 0;
                                              cashbackValue = 0.0;
                                              offerId = '';
                                            }
                                          } else {
                                            isOfferApplied = false;
                                            isOfferError = true;
                                            isFreeDelivery = false;
                                            offerInd = offerIndex;
                                            offerErrorText =
                                              strings['Este cupón se ha utilizado recientemente, inténtalo de nuevo más tarde.'];
                                            offerCode =
                                              devyOffers[offerIndex]['code'];
                                            offerSuccess = '';
                                            offerValue = 0;
                                            cashbackValue = 0.0;
                                            offerId = '';
                                          }
                                        }
                                        this.setState(
                                          {
                                            offerCode: offerCode,
                                            offerId: offerId,
                                            offerSuccess: offerSuccess,
                                            offerErrorText: offerErrorText,
                                            offerValue: offerValue,
                                            cashbackValue: cashbackValue,
                                            offerInd: offerInd,
                                            isOfferApplied: isOfferApplied,
                                            isOfferError: isOfferError,
                                            isFreeDelivery: isFreeDelivery,
                                            offersUsed: offersUsed,
                                            offers: devyOffers,
                                            cart: cart,
                                            delivery: delivery,
                                            showDiscount: false,
                                          },
                                          (newState) => {
                                            checkOffer();
                                          }
                                        );

                                        // console.log({
                                        //   offerCode: offerCode,
                                        //   offerId: offerId,
                                        //   offerSuccess: offerSuccess,
                                        //   offerErrorText: offerErrorText,
                                        //   offerValue: offerValue,
                                        //   cashbackValue: cashbackValue,
                                        //   offerInd: offerInd,
                                        //   isOfferApplied: isOfferApplied,
                                        //   isOfferError: isOfferError,
                                        //   isFreeDelivery: isFreeDelivery,
                                        //   offersUsed: offersUsed,
                                        //   offers: devyOffers,
                                        //   cart: cart,
                                        //   delivery: delivery,
                                        //   showDiscount: false,
                                        // });
                                        //                                                                      print(
                                        //                                                                          isOfferApplied);

                                        // Navigator.pop(
                                        //     context);

                                        //                                                                        });
                                      }}
                                      style={{
                                        fontSize: '17px',
                                        fontWeight: 'bold',
                                        color: getPrimaryColor(),
                                        cursor: 'pointer',
                                      }}
                                    >
                                      {strings['Aplicar']}
                                    </Typography>
                                  )}
                                </Stack>
                              </div>
                            </Stack>
                          </div>
                        ) : null}
                      </React.Fragment>
                    ))}
                  </List>
                ) : (
                  <Typography style={{ fontSize: '16px', fontWeight: '500' }}>
                    {
                      strings['Lo sentimos, no hay descuentos disponibles en este momento.']
                    }
                  </Typography>
                )}
              </>
            </DialogContent>
          }
        />
        {this.state.businessData ? (
          <div
            style={{
              width: '100%',
              height: isIOS
                ? 'calc((var(--vh, 1vh) * 100) - 60px )'
                : 'calc( 100vh - 60px )',
              overflow: 'hidden',
            }}
          >
            {columns > 1 ? (
              <div
                style={{
                  width: '240px',
                  height: '100%',
                  float: 'left',
                  overflow: 'auto',
                  borderRight: '0px solid #e6ebf1',
                }}
              >
                <FormControl sx={{ m: 0, minWidth: 120, p: 0,display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '90%',
                    marginLeft: '5%', height: '40px' }}>
                    <Select
                    style={{height: '40px', marginRight: 'auto', borderRadius: '14px',}}
                      value={this.state.selectedType}
                      onChange={(event) => {
                        console.log(event.target.value,this.state.selectedType, (typeof event.target.value));
                        if(event.target.value !== -1) {
                          if(this.state.cart.item.length>0) {
                        this.setState({ selectedType2: event.target.value });
                        handleAlertOpen();
                        } else {
                        this.setState({ selectedType: event.target.value });
                                          console.log(this.state);
                                          if (!this.state.canDeliverHere && event.target.value === 0) {
                                            this.setState({ storeIsOpen: false });
                                          } else if (
                                            !this.state.canDeliverHere &&
                                            (event.target.value === 1 || event.target.value === 2)
                                          ) {
                                            this.setState({ storeIsOpen: true });
                                          }
                            }
                          }
                        }}
                        displayEmpty
                        inputProps={{ 'aria-label': '' }}
                      >

                      <MenuItem value={2}>
                      <Stack
                     direction="row"
                     justifyContent="center"
                     alignItems="center"
                     spacing={0}
                    >
                    <RestaurantMenuIcon
                       style={{
                         height: '17px',
                         fontSize: '17px',
                         fontWeight: 'bold',
                         color: getPrimaryColor(),
                         marginRight: '10px',
                       }}
                     />
                     <Typography
                     style={{
                       fontWeight: '700',
                       fontFamily: 'Nunito',
                       textTransform: 'none',
                       padding: '5px 0px',
                       color: '#3e4547',
                     }}
                    >

                     {strings["Comer en"]}
                    </Typography>
                    </Stack>
                    </MenuItem>
                    <MenuItem value={0}>
                        <Stack
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={0}
                    >
                    <DirectionsBikeIcon
                      style={{
                        fontSize: '17px',
                        fontWeight: 'bold',
                        color: getPrimaryColor(),
                        marginRight: '10px',
                      }}
                    />
                    <Typography
                    style={{
                      fontWeight: '700',
                      fontFamily: 'Nunito',
                      textTransform: 'none',
                      padding: '5px 0px',
                      color: '#3e4547',
                    }}
                  >
                    {strings["Entrega a domicilio"]}
                  </Typography>
                      </Stack>
                    </MenuItem>
                    <MenuItem value={1}>
                      <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={0}
                      >
                      <DirectionsRunIcon
                      style={{
                        height: '17px',
                        fontSize: '17px',
                        fontWeight: 'bold',
                        color: getPrimaryColor(),
                        marginRight: '10px',
                      }}
                    />
                    <Typography
                    style={{
                      fontWeight: '700',
                      fontFamily: 'Nunito',
                      textTransform: 'none',
                      padding: '5px 0px',
                      color: '#3e4547',}}>
                    {strings["Recoger en tienda"]}
                  </Typography>
                </Stack>
              </MenuItem>
              {/* ))} */}
                </Select>
              </FormControl>
                <Box height={'2%'}></Box>
                <div
                  style={{
                    borderBottom: '0px solid #e6ebf1',
                    borderTop: '0px solid #e6ebf1',
                    padding: '10px 0px 10px 10px',
                  }}
                >
                  <Typography
                    style={{ fontSize: '19.2px', fontWeight: 'bold' }}
                  >
                    <WidgetsRoundedIcon
                      style={{
                        height: '19px',
                        position: 'relative',
                        top: '3px',
                        color: 'slategray',
                      }}
                    />{' '}
                    {strings["Menú"]}
                  </Typography>
                </div>
                <ul style={{ listStyle: 'none', paddingInlineStart: '10px', marginTop: '0', }}>
                  {this.state.menu.map((item) => (
                    <li key={item.id}>
                      <Button
                        className="hoversidemneu"
                        variant="contained"
                        disableElevation
                        align="center"
                        style={{
                          backgroundColor: '#fff',
                          color: '#2c3036',
                          textTransform: 'none',
                          fontSize: '19.8px',
                          textAlign: 'left',
                          padding: '10px 5px',
                          minWidth: '41px',
                          marginRight: '0px',
                          fontWeight: '700',
                          fontFamily: 'Nunito',
                          letterSpacing: 'normal',
                        }}
                        // onClick={() => handleClick(item.id)}
                      >
                        <ScrollLink
                          style={{ width: '215px', }}
                          activeClass="active-class"
                          color={getPrimaryColor()}
                          to={`cat-name-${item.id}`}
                          containerId={'scroll-container'}
                          id={`cat-name-${item.id}`}
                          spy={true}
                          smooth={true}
                          offset={50}
                          duration={500}
                          onSetActive={this.handleSetActive}
                        >
                          {item.name}
                          <KeyboardArrowRightRoundedIcon
                            style={{
                              height: '18px',
                              position: 'relative',
                              top: '7px',
                              color: '#99a7a7',
                              float: 'right',
                            }}
                          />
                        </ScrollLink>
                      </Button>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
            <div
              id="scroll-container"
              style={{
                width: columns > 1 ? 'calc(100% - 240px)' : 'calc(100%)',
                height: isIOS ? 'calc((var(--vh, 1vh) * 100))' : '100vh',
                backgroundColor: this.state.width < 600 ? '#ffffff' : '#ffffff',
                float: 'right',
                overflow: 'auto',
              }}
            >
              {columns <= 1 ? (
                <div>
                {this.state.selectedType === 0 && this.state.width < 1000 ? (
                  <Button
                    style={{
                      margin: '0px',
                      backgroundColor: '#fff',
                      textTransform: 'none',
                      borderRight: '0px solid #cccccc',
                      padding: '10px 5%',
                      fontSize: '17px',
                      borderRadius: '0px',
                      width: '100%',
                    }}
                    variant="text"
                    startIcon={
                      <LocationOnIcon style={{ color: getPrimaryColor() }} />
                    }
                    endIcon={
                      <ArrowDropDownIcon style={{ color: getPrimaryColor() }} />
                    }
                    onClick={handleClickOpen}
                    >
                      <>
                        <span
                          style={{
                            color: getPrimaryColor(),
                            fontWeight: '800',
                            fontFamily: 'Nunito',
                          }}
                        >
                          {this.state.selectLocationName
                            ? this.state.selectLocationName
                            : strings['Seleccionar mi ubicación']}
                        </span>
                      </>
                    </Button>
                  ) : null}{' '}
                  <div
                    style={{
                      width: this.state.width < 600 ? '90%' : '94%',
                      height: '130px',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                      backgroundImage: 'linear-gradient(#000000c7,#000000c7),'+`url(${this.state.businessData.header})`,
                      margin: this.state.width < 600 ? '11px 5% 25px 5%' : '11px 3% 25px 3%',
                      borderRadius: '16px',
                      boxShadow: 'rgb(0 0 0 / 10%) 0px 4px 6px -1px, rgb(0 0 0 / 6%) 0px 2px 4px -1px',
                    }}
                  >
                    <div style={{ marginLeft: '16px', display: 'flex', flexDirection: 'column', justifyContent: 'center', height: 'inherit', }}>
                      <div style={{ fontSize: '28px', fontWeight: '800', color: 'white', marginLeft: '12px', fontFamily: 'Nunito', }}>{strings["bienvenidotittle"]}</div>
                      <div style={{ fontSize: '26px', fontWeight: '400', color: 'white', marginLeft: '12px', fontFamily: 'Nunito', }}>{strings["bienvenidodescr"]}</div>
                    </div>
                  </div>
                </div>
              ) : null}
              {/* {' '} */}
              <List sx={{ pt: 0 }} style={{background: this.state.width < 600 ? 'white' : 'initial',}} >
                {columns <= 1 ? (
                  <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    className="example"
                    spacing={1}
                    style={{
                      marginLeft: '10px',
                      marginRight: '10px',
                      marginBottom: '8px',
                      display: 'flex',
                      flexShrink: 0,
                      overflowX: 'auto',
                      zIndex: 99,
                      position: 'sticky',
                      backgroundColor: '#f8f9fb',
                      borderTop: '0px solid rgb(230, 235, 241)',
                      borderBottom: '0px solid rgb(230, 235, 241)',
                      marginTop: '7px',
                      top: 0,
                      background: 'white',
                    }}
                  >
                    {/* <div   > */}
                    {/* <ul style={{ listStyle: 'none' }}> */}
                    {this.state.menu.map((item, index) => (
                      // <li key={item.id}>
                      <Typography
                        noWrap
                        className="noselect"
                        style={{
                          color: '#2e2c36',
                          textTransform: 'none',
                          fontSize: '18px',
                          textAlign: 'left',
                          padding: '6px 8px',
                          marginRight: '5px',
                          overflow: 'visible',
                          borderRadius: '10px',
                          border: '0px solid rgb(230, 235, 241)',
                          fontWeight: '800',
                        }}
                        onClick={() => handleClick(item.id)}
                        key={index}
                      >
                        <ScrollLink
                          activeClass="active-class"
                          color={getPrimaryColor()}
                          to={`cat-name-${item.id}`}
                          containerId={'scroll-container'}
                          id={`cat-name-${item.id}`}
                          spy={true}
                          smooth={true}
                          offset={-50}
                          duration={500}
                          onSetActive={this.handleSetActive}
                        >
                          {item.name}
                        </ScrollLink>
                      </Typography>
                    ))}
                  </Stack>
                ) : (
                  <div style={{height: 'auto',}}>
                  <div
                    style={{
                      width: '94%',
                      height: '90px',
                      marginLeft: '3%',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                      backgroundImage: 'linear-gradient(#000000c7,#000000c7),'+`url(${this.state.businessData.header})`,
                      marginBottom: '10px',
                      borderRadius: '0 10px 10px 0',
                      boxShadow: 'rgb(0 0 0 / 10%) 0px 4px 6px -1px, rgb(0 0 0 / 6%) 0px 2px 4px -1px',
                      borderRadius: '16px',
                    }}
                  >
                    <div style={{ marginLeft: '16px', display: 'flex', flexDirection: 'column', justifyContent: 'center', height: 'inherit', }}>
                      <div style={{ fontSize: '28px', fontWeight: '800', color: 'white', marginLeft: '12px', fontFamily: 'Nunito', }}>{strings["bienvenidotittle"]}</div>
                      <div style={{ fontSize: '26px', fontWeight: '400', color: 'white', marginLeft: '12px', fontFamily: 'Nunito', }}>{strings["bienvenidodescr"]}</div>
                    </div>
                  </div>
                  </div>)}
                {this.state.menuData && this.state.menuData.length>0? this.state.menu.map((email) => (
                  <Element
                    key={email.id}
                    ref={refs[email.id]}
                    style={{
                      backgroundColor: '#ffffff',
                      margin: this.state.width < 600 ? '10px 10px 10px 10px' : '0',
                      width: this.state.width < 600 ? 'calc(100% - 20px)' : 'calc(100% - 0px)',
                    }}
                    name={`cat-name-${email.id}`}
                    id={`cat-${email.id}`}
                    className="element"
                  >
                    <Typography
                      style={{
                        padding:
                          this.state.width < 600
                            ? '20px 20px 20px 10px'
                            : '15px 20px 5px 20px',
                        fontSize: this.state.width < 600 ? '24.4px' : '26.4px',
                        fontWeight: '800',
                      }}
                    >
                      {email.name}
                    </Typography>
                    <div
                      style={{
                        backgroundColor: '#ffffff',
                        padding:
                          this.state.width > 600 ? '0px 15px 15px 15px' : '0',
                        width: 'calc(100% - 0px)',
                      }}
                    >
                      <ImageList rowHeight={130} cols={columns}>
                        {email.products.map((image) => (
                          <ImageListItem
                            key={image.id}
                            style={{
                              height: this.state.width > 600 ? 'fit-content' : '134px',
                              backgroundColor: '#ffffff',
                              borderTop:
                                this.state.width > 600
                                  ? '0px solid #e6ebf1'
                                  : '0',
                              borderRight:
                                this.state.width > 600
                                  ? '0px solid #e6ebf1'
                                  : '0',
                              borderBottom:
                                this.state.width > 600
                                  ? '0px solid #e6ebf1'
                                  : '1px solid #e6ebf1',
                              borderLeft:
                                this.state.width > 600
                                  ? '0px solid #e6ebf1'
                                  : '0',
                              borderRadius: this.state.width > 599 ? '10px' : '0',
                              padding: this.state.width > 599 ? '0px 0px 0px 0px' : '15px 10px 15px 10px',
                              margin: this.state.width < 600 ? '0px 0px 0px 0px' : '5px 5px 15px 5px',
                              cursor: 'pointer',
                              width: this.state.width > 599 ? 'calc(33.33% - 10px)' : 'calc(100% - 2px)',
                            }}
                          >
                            {/* Products list on all views */}
                            <div onClick={() => {handleClickOpenVariable(image);}} style={{ display: this.state.width > 599 ? 'flex' : 'block', flexDirection: 'column', }}>
                              <div
                                style={{
                                  float: this.state.width < 600 ? 'right' : 'left',
                                  backgroundColor: '#ffffff',
                                  width: this.state.width > 599 ? '122px' : '102px',
                                  height: this.state.width > 599 ? '122px' : '102px',
                                  placeSelf: this.state.width > 599 ? 'center' : 'flex-end',
                                }}
                              >
                                {image.images ? (
                                  <img
                                    src={image.images}
                                    width={'100%'}
                                    height={'100%'}
                                    style={{
                                      borderRadius: this.state.width < 600 ? '18px' : '16px',
                                      objectFit: 'cover',
                                      border: this.state.width < 600 ? '0' : '0px solid #ffffff',
                                      boxShadow: '0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%)',
                                      margin: this.state.width > 599 ? '0px 0px 0px 0px' : '0px 0px 0px 2px',
                                      height: this.state.width > 599 ? '122px' : '96px',
                                      width: this.state.width > 599 ? '122px' : '96px',

                                    }}
                                  />
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div
                                style={{
                                  float: 'right',
                                  backgroundColor: '#ffffff00',
                                  width: this.state.width < 600 ? 'calc(100% - 102px)' : '100%',
                                  height: this.state.width < 600 ? '100px' : '114px',
                                  textAlign: this.state.width > 599 ? 'center' : 'left',
                                }}
                              >
                                <Typography
                                  sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: '2',
                                    WebkitBoxOrient: 'vertical',
                                  }}
                                  style={{
                                    padding:
                                      this.state.width < 600
                                        ? '0px 15px 0px 0px'
                                        : '5px 5px 0px 5px',
                                    fontSize:
                                      this.state.width < 600
                                        ? '19px'
                                        : '20.8px',
                                    fontWeight:
                                      this.state.width < 600 ? '600' : '600',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {image.name}
                                </Typography>
                                <Typography
                                  sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: '1',
                                    WebkitBoxOrient: 'vertical',
                                  }}
                                  style={{
                                    padding:
                                      this.state.width < 600
                                        ? '0px 2px 0px 0px'
                                        : '0px 45px',
                                    fontSize:
                                      this.state.width < 600 ? '15px' : '14px',
                                    fontWeight: 'light',
                                    color: 'slategray',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {image.description}
                                </Typography>
                                <>
                                  {image['discountPercentage'] != null &&
                                  image['discountPercentage'] > 0 &&
                                  moment().isBefore(
                                    moment(image['discountedTill'].toDate())
                                  ) ? (
                                    <Stack
                                      style={{
                                        padding: this.state.width < 600 ? '4px 5px 5px 0px' : '4px 5px 5px 4px',
                                        placeContent: this.state.width < 600 && image['discountPercentage'] != null ? ' ' : 'inherit',
                                      }}
                                      direction="row"
                                      justifyContent="flex-start"
                                      alignItems="center"
                                      spacing={0}
                                    >
                                      <LocalOfferIcon
                                        style={{
                                          fontSize:
                                            this.state.width < 600
                                              ? '20px'
                                              : '16.5px',
                                          fontWeight: '800',
                                          color: '#3D75EE',
                                        }}
                                      />
                                      <Typography
                                        style={{
                                          fontSize:
                                            this.state.width < 600
                                              ? '17px'
                                              : '16.5px',
                                          fontWeight: '800',
                                          fontFamily: 'Nunito',
                                          color: '#3D75EE',
                                        }}
                                      >
                                        {'  -' +
                                          image[
                                            'discountPercentage'
                                          ].toString() +
                                          '%'}
                                        &nbsp;&nbsp;
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontSize:
                                            this.state.width < 600
                                              ? '17px'
                                              : '16.5px',
                                          fontWeight: '800',
                                          fontFamily: 'Nunito',
                                        }}
                                      >
                                        ¢
                                        {((this.state.businessData.partner !=
                                          null &&
                                        this.state.businessData.partner
                                          ? image['discountPercentage'] !=
                                              null &&
                                            image['discountPercentage'] > 0 &&
                                            moment().isBefore(
                                              moment(
                                                image['discountedTill'].toDate()
                                              )
                                            )
                                            ? image['price'] -
                                              (image['price'] *
                                                image['discountPercentage']) /
                                                100
                                            : image['price']
                                          : (image['discountPercentage'] !=
                                              null &&
                                            image['discountPercentage'] > 0 &&
                                            moment().isBefore(
                                              moment(
                                                image['discountedTill'].toDate()
                                              )
                                            )
                                              ? image['price'] -
                                                (image['price'] *
                                                  image['discountPercentage']) /
                                                  100
                                              : image['price']) +
                                            (image['discountPercentage'] !=
                                              null &&
                                            image['discountPercentage'] > 0 &&
                                            moment().isBefore(
                                              moment(
                                                image['discountedTill'].toDate()
                                              )
                                            )
                                              ? image['price'] -
                                                (image['price'] *
                                                  image['discountPercentage']) /
                                                  100
                                              : image['price']) *
                                              (this.state.businessData.tax /
                                                100)
                                        )*multiFactor()).toFixed(multiFactor()>1?0:2)}
                                        &nbsp;&nbsp;
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontSize:
                                            this.state.width < 600
                                              ? '17px'
                                              : '16.5px',
                                          fontWeight: '400',
                                          fontFamily: 'Nunito',
                                          textDecoration: 'line-through',
                                          color: '#616468',
                                        }}
                                      >
                                        ¢
                                        {((this.state.businessData.partner !=
                                          null &&
                                        this.state.businessData.partner
                                          ? image['discountPercentage'] !=
                                              null &&
                                            image['discountPercentage'] > 0 &&
                                            moment().isBefore(
                                              moment(
                                                image['discountedTill'].toDate()
                                              )
                                            )
                                            ? image['price']
                                            : image['price']
                                          : (image['discountPercentage'] !=
                                              null &&
                                            image['discountPercentage'] > 0 &&
                                            moment().isBefore(
                                              moment(
                                                image['discountedTill'].toDate()
                                              )
                                            )
                                              ? image['price']
                                              : image['price']) +
                                            (image['discountPercentage'] !=
                                              null &&
                                            image['discountPercentage'] > 0 &&
                                            moment().isBefore(
                                              moment(
                                                image['discountedTill'].toDate()
                                              )
                                            )
                                              ? image['price']
                                              : image['price']) *
                                              (this.state.businessData.tax /
                                                100)
                                        )*multiFactor()).toFixed(multiFactor()>1?0:2)}
                                      </Typography>
                                    </Stack>
                                  ) : (
                                    <Typography
                                      style={{
                                        padding:
                                          this.state.width < 600
                                            ? '4px 5px 5px 0px'
                                            : '4px 5px 5px 4px',
                                        fontSize:
                                          this.state.width < 600
                                            ? '17px'
                                            : '16.5px',
                                        fontWeight: '800',
                                        fontFamily: 'Nunito',
                                      }}
                                    >
                                      ¢
                                      {((this.state.businessData.partner !=
                                        null && this.state.businessData.partner
                                        ? image['discountPercentage'] != null &&
                                          image['discountPercentage'] > 0 &&
                                          moment().isBefore(
                                            moment(
                                              image['discountedTill'].toDate()
                                            )
                                          )
                                          ? image['price'] -
                                            (image['price'] *
                                              image['discountPercentage']) /
                                              100
                                          : image['price']
                                        : (image['discountPercentage'] !=
                                            null &&
                                          image['discountPercentage'] > 0 &&
                                          moment().isBefore(
                                            moment(
                                              image['discountedTill'].toDate()
                                            )
                                          )
                                            ? image['price'] -
                                              (image['price'] *
                                                image['discountPercentage']) /
                                                100
                                            : image['price']) +
                                          (image['discountPercentage'] !=
                                            null &&
                                          image['discountPercentage'] > 0 &&
                                          moment().isBefore(
                                            moment(
                                              image['discountedTill'].toDate()
                                            )
                                          )
                                            ? image['price'] -
                                              (image['price'] *
                                                image['discountPercentage']) /
                                                100
                                            : image['price']) *
                                            (this.state.businessData.tax / 100)
                                      )*multiFactor()).toFixed(multiFactor()>1?0:2)}
                                    </Typography>
                                  )}
                                </>
                              </div>
                            </div>
                            {this.state.storeIsOpen &&
                            this.state.cart['item'].find(
                              (opt) => opt['id'] === image['id']
                            ) == null &&
                            (image['enabled'] ||
                              (!image['enabled'] &&
                                image['willBeAvailableAt'] != null &&
                                moment().isAfter(
                                  moment(image['willBeAvailableAt'].toDate())
                                ))) ? (
                              <div
                                style={{
                                  position: this.state.width < 600 ? 'relative' : 'absolute',
                                  left: this.state.width < 600 ? 'calc(100% - 35px)' : ' ',
                                  right: this.state.width < 600 ? ' ' : '10px',
                                  bottom: this.state.width < 600 ? '100px' : '19px',
                                  height: this.state.width < 600 ? '100px' : 'auto',
                                }}
                              >
                                <Avatar
                                  style={{
                                    backgroundColor: getPrimaryColor(),
                                    width: '35px',
                                    height: '35px',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    if (
                                      image['customize'] != null &&
                                      image['customize'].length > 0
                                    ) {
                                      handleClickOpenVariable(image);
                                    } else {
                                      var cart = JSON.parse(
                                        JSON.stringify(this.state.cart)
                                      );
                                      // setState(() {
                                      cart['item'].push({
                                        name: image['name'],
                                        id: image['id'],
                                        price:
                                          Number(((this.state.businessData.partner !=
                                            null &&
                                          this.state.businessData.partner
                                            ? image['discountPercentage'] !=
                                                null &&
                                              image['discountPercentage'] > 0 &&
                                              moment().isBefore(
                                                moment(
                                                  image[
                                                    'discountedTill'
                                                  ].toDate()
                                                )
                                              )
                                              ? image['price'] -
                                                (image['price'] *
                                                  image['discountPercentage']) /
                                                  100
                                              : image['price']
                                            : (image['discountPercentage'] !=
                                                null &&
                                              image['discountPercentage'] > 0 &&
                                              moment().isBefore(
                                                moment(
                                                  image[
                                                    'discountedTill'
                                                  ].toDate()
                                                )
                                              )
                                                ? image['price'] -
                                                  (image['price'] *
                                                    image[
                                                      'discountPercentage'
                                                    ]) /
                                                    100
                                                : image['price']) +
                                              (image['discountPercentage'] !=
                                                null &&
                                              image['discountPercentage'] > 0 &&
                                              moment().isBefore(
                                                moment(
                                                  image[
                                                    'discountedTill'
                                                  ].toDate()
                                                )
                                              )
                                                ? image['price'] -
                                                  (image['price'] *
                                                    image[
                                                      'discountPercentage'
                                                    ]) /
                                                    100
                                                : image['price']) *
                                                (this.state.businessData.tax /
                                                  100))*multiFactor()).toFixed(multiFactor()>1?0:2)),
                                        originalPrice:
                                          this.state.businessData.partner !=
                                            null &&
                                          this.state.businessData.partner
                                            ? image['discountPercentage'] !=
                                                null &&
                                              image['discountPercentage'] > 0 &&
                                              moment().isBefore(
                                                moment(
                                                  image[
                                                    'discountedTill'
                                                  ].toDate()
                                                )
                                              )
                                              ? image['price'] -
                                                (image['price'] *
                                                  image['discountPercentage']) /
                                                  100
                                              : image['price']
                                            : (image['discountPercentage'] !=
                                                null &&
                                              image['discountPercentage'] > 0 &&
                                              moment().isBefore(
                                                moment(
                                                  image[
                                                    'discountedTill'
                                                  ].toDate()
                                                )
                                              )
                                                ? image['price'] -
                                                  (image['price'] *
                                                    image[
                                                      'discountPercentage'
                                                    ]) /
                                                    100
                                                : image['price']) +
                                              (image['discountPercentage'] !=
                                                null &&
                                              image['discountPercentage'] > 0 &&
                                              moment().isBefore(
                                                moment(
                                                  image[
                                                    'discountedTill'
                                                  ].toDate()
                                                )
                                              )
                                                ? image['price'] -
                                                  (image['price'] *
                                                    image[
                                                      'discountPercentage'
                                                    ]) /
                                                    100
                                                : image['price']) *
                                                (this.state.businessData.tax /
                                                  100),
                                        quantity: 1,
                                        addons: 0,
                                        customize: [],
                                      });
                                      cart['totalCost'] =
                                        cart['totalCost'] +
                                        Number(((this.state.businessData.partner !=
                                          null &&
                                        this.state.businessData.partner
                                          ? image['discountPercentage'] !=
                                              null &&
                                            image['discountPercentage'] > 0 &&
                                            moment().isBefore(
                                              moment(
                                                image['discountedTill'].toDate()
                                              )
                                            )
                                            ? image['price'] -
                                              (image['price'] *
                                                image['discountPercentage']) /
                                                100
                                            : image['price']
                                          : (image['discountPercentage'] !=
                                              null &&
                                            image['discountPercentage'] > 0 &&
                                            moment().isBefore(
                                              moment(
                                                image['discountedTill'].toDate()
                                              )
                                            )
                                              ? image['price'] -
                                                (image['price'] *
                                                  image['discountPercentage']) /
                                                  100
                                              : image['price']) +
                                            (image['discountPercentage'] !=
                                              null &&
                                            image['discountPercentage'] > 0 &&
                                            moment().isBefore(
                                              moment(
                                                image['discountedTill'].toDate()
                                              )
                                            )
                                              ? image['price'] -
                                                (image['price'] *
                                                  image['discountPercentage']) /
                                                  100
                                              : image['price']) *
                                              (this.state.businessData.tax /
                                                100))*multiFactor()).toFixed(multiFactor()>1?0:2));
                                      cart['totalItems']++;
                                      if (
                                        image['averageTime'] != null &&
                                        cart['maxTime'] < image['averageTime']
                                      ) {
                                        cart['maxTime'] = image['averageTime'];
                                      }
                                      this.setState({ cart: cart });
                                      // });
                                    }
                                  }}
                                >
                                  <AddRoundedIcon style={{ height: '30px' }} />
                                </Avatar>
                              </div>
                            ) : null}
                            {this.state.storeIsOpen  &&
                            (!image['enabled'] &&
                              (image['willBeAvailableAt'] == null ||
                                moment().isBefore(
                                  moment(image['willBeAvailableAt'].toDate())
                                ))) ? (
                              <div
                                style={{
                                  position: 'absolute',
                                  width: '100%',
                                  bottom: '0',
                                  height: '100%',
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: 'rgb(255 255 255 / 80%)',
                                    padding: "5px",
                                    border: '0px solid '+getPrimaryColor(),
                                    height: 'inherit',
                                    //backdropFilter: 'blur(5px)',
                                  }}
                                >
                                   <div
                                      style={{
                                        fontSize: this.state.width < 600 ? '18px' : '20.4px',
                                        fontFamily: 'Nunito',
                                        color: '#000',
                                        textAlign: 'center',
                                        fontWeight: '600',
                                        marginTop: this.state.width < 600 ? '34px' : '87px',
                                        textShadow: 'rgb(149 157 165 / 20%) 0px 8px 24px',
                                      }}
                                    >
                                        {strings['Agotado']}
                                   </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.storeIsOpen &&
                            this.state.cart['item'].find(
                              (opt) => opt['id'] === image['id']
                            ) != null &&
                            (image['enabled'] ||
                              (!image['enabled'] &&
                                image['willBeAvailableAt'] != null &&
                                moment().isAfter(
                                  moment(image['willBeAvailableAt'].toDate())
                                ))) ? (
                              <div
                                style={{
                                  position: this.state.width < 600 ? 'relative' : 'absolute',
                                  left: this.state.width < 600 ? 'calc(100% - 86px)' : ' ',
                                  right: this.state.width < 600 ? ' ' : '10px',
                                  bottom: this.state.width < 600 ? '100px' : '19px',
                                  height: this.state.width < 600 ? '100px' : 'auto',
                                }}
                              >
                                <ButtonGroup
                                  variant="text"
                                  disableElevation
                                  size={'small'}
                                  style={{
                                    backgroundColor: getPrimaryColor(),
                                    borderRadius: '50px',
                                  }}
                                >
                                  <Button
                                    style={{
                                      borderRadius: '50px 0 0 50px',
                                      minWidth: '28px',
                                      border: '0',
                                    }}
                                  >
                                    <RemoveRoundedIcon
                                      sx={{ color: 'action.active' }}
                                      style={{
                                        fontSize: '17px',
                                        color: '#fff',
                                        fontWeight: 'bold',
                                      }}
                                      onClick={() => {
                                        var cart = JSON.parse(
                                          JSON.stringify(this.state.cart)
                                        );
                                        for (
                                          var t1 = cart['item'].length - 1;
                                          t1 >= 0;
                                          t1--
                                        ) {
                                          if (
                                            cart['item'][t1]['id'] ===
                                            image['id']
                                          ) {
                                            if (
                                              cart['item'][t1]['quantity'] > 1
                                            ) {
                                              // setState(() {
                                              cart['totalCost'] =
                                                cart['totalCost'] -
                                                cart['item'][t1]['price'];
                                              cart['totalItems']--;
                                              cart['item'][t1]['quantity']--;
                                              // boxCart
                                              //     .put(
                                              //     'cart',
                                              //     cart);
                                              // });
                                            } else if (
                                              cart['item'][t1]['quantity'] === 1
                                            ) {
                                              // setState(() {
                                              cart['totalCost'] =
                                                cart['totalCost'] -
                                                cart['item'][t1]['price'];
                                              cart['totalItems']--;
                                              cart['item'].splice(t1, 1);
                                              // boxCart
                                              //     .put(
                                              //     'cart',
                                              //     cart);
                                              // });
                                              if (
                                                cart['maxTime'] ===
                                                image['averageTime']
                                              ) {
                                                cart['maxTime'] = 0;
                                                for (
                                                  var t2 =
                                                    cart['item'].length - 1;
                                                  t2 >= 0;
                                                  t2--
                                                ) {
                                                  if (
                                                    cart['maxTime'] != null &&
                                                    cart['item'][t2]['time'] !=
                                                      null &&
                                                    cart['maxTime'] <
                                                      cart['item'][t2]['time']
                                                  ) {
                                                    cart['maxTime'] =
                                                      cart['item'][t2]['time'];
                                                  }
                                                }
                                              }
                                            }
                                            break;
                                          }
                                        }
                                        this.setState({ cart: cart });
                                      }}
                                    />
                                  </Button>
                                  <Button disabled style={{ minWidth: '30px', border: '0', }}>
                                    <Typography
                                      style={{
                                        fontSize: '15px',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        color: '#fff',
                                      }}
                                    >
                                      {findTotal3(image['id'])}
                                    </Typography>
                                  </Button>
                                  <Button
                                    style={{
                                      borderRadius: '0 50px 50px 0',
                                      minWidth: '28px',
                                      border: '0',
                                    }}
                                  >
                                    <AddRoundedIcon
                                      sx={{ color: 'action.active' }}
                                      style={{
                                        fontSize: '17px',
                                        color: '#fff',
                                        fontWeight: 'bold',
                                      }}
                                      onClick={() => {
                                        var cart = JSON.parse(
                                          JSON.stringify(this.state.cart)
                                        );
                                        if (
                                          image['customize'] != null &&
                                          image['customize'].length > 0
                                        ) {
                                          handleClickOpenVariable(image);
                                        } else {
                                          // setState(() {
                                          for (
                                            var t1 = cart['item'].length - 1;
                                            t1 >= 0;
                                            t1--
                                          ) {
                                            if (
                                              cart['item'][t1]['id'] ===
                                              image['id']
                                            ) {
                                              cart['item'][t1]['quantity']++;
                                              cart['totalCost'] =
                                                cart['totalCost'] +
                                                Number(((this.state.businessData
                                                  .partner != null &&
                                                this.state.businessData.partner
                                                  ? image[
                                                      'discountPercentage'
                                                    ] != null &&
                                                    image[
                                                      'discountPercentage'
                                                    ] > 0 &&
                                                    moment().isBefore(
                                                      moment(
                                                        image[
                                                          'discountedTill'
                                                        ].toDate()
                                                      )
                                                    )
                                                    ? image['price'] -
                                                      (image['price'] *
                                                        image[
                                                          'discountPercentage'
                                                        ]) /
                                                        100
                                                    : image['price']
                                                  : (image[
                                                      'discountPercentage'
                                                    ] != null &&
                                                    image[
                                                      'discountPercentage'
                                                    ] > 0 &&
                                                    moment().isBefore(
                                                      moment(
                                                        image[
                                                          'discountedTill'
                                                        ].toDate()
                                                      )
                                                    )
                                                      ? image['price'] -
                                                        (image['price'] *
                                                          image[
                                                            'discountPercentage'
                                                          ]) /
                                                          100
                                                      : image['price']) +
                                                    (image[
                                                      'discountPercentage'
                                                    ] != null &&
                                                    image[
                                                      'discountPercentage'
                                                    ] > 0 &&
                                                    moment().isBefore(
                                                      moment(
                                                        image[
                                                          'discountedTill'
                                                        ].toDate()
                                                      )
                                                    )
                                                      ? image['price'] -
                                                        (image['price'] *
                                                          image[
                                                            'discountPercentage'
                                                          ]) /
                                                          100
                                                      : image['price']) *
                                                      (this.state.businessData
                                                        .tax /
                                                        100))*multiFactor()).toFixed(multiFactor()>1?0:2));
                                              cart['totalItems']++;
                                              break;
                                            }
                                          }
                                          // });
                                        }
                                        this.setState({ cart: cart });
                                      }}
                                    />
                                  </Button>
                                </ButtonGroup>
                              </div>
                            ) : null}
                          </ImageListItem>
                        ))}
                      </ImageList>
                    </div>
                  </Element>
                )):(!this.state.loading)?
                <div style={{width: "100%", height: "100%", display: 'flex', alignItems:"center", justifyContent: "center", padding: "10px"}}>
                  <Stack

                  direction="column"
  justifyContent="center"
  alignItems="center"
  spacing={2}

                  >
                  <img
            style={{ width: this.state.width < 1000 ? '50vw' : '17.5vw' }}
            src={strings.language === 'es'?closed_spanish:closed_english}
            alt="loading"
          />
          <Typography
                        style={{
                          fontSize: '18.2px',
                          fontWeight: '500',
                          overflow: 'visible',
                          fontFamily: 'Nsunito',
                          textTransform: 'none',
                          padding: '0 5%',
                        }}
                      >
                        {strings["Lo sentimos, no tenemos productos disponibles para comprar en este momento, intenta en otra hora"]}
                      </Typography>
                      </Stack>
                </div>:null
                }

              </List>{' '}
              <div
                style={{
                  padding:
                    this.state.width > 600 ? '125px 0px 0px' : '165px 0px 0px',
                }}
              ></div>
            </div>
          </div>
        ) : null}

        {/* <Button onClick={handleToggle}>Show backdrop</Button> */}
        <Backdrop
          onClick={() => {}}
          style={{ color: '#fff', zIndex: 9999999 }}
          open={this.state.loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <CartDialog
          className="cartsidepage"
          selectedValue={this.state.selectedValue}
          open={this.state.showCart}
          onClose={() => {
            this.setState({ showCart: false, additionalInfoAdded: false });
          }}
          title={this.state.width}
          displayList={
            <Container
              maxWidth={false}
              disableGutters
              sx={{
                margin: '0px',
                zIndex: '9998',
                bgcolor: '#fff',
                height: isIOS ? 'calc((var(--vh, 1vh) * 100))' : '100vh',
                maxWidth: this.state.width > 600 ? '400px' : 'auto',
              }}
            >
              {/* <Container sx={{ bgcolor: '#fff', height: '100vh', width: "100%"}} > */}
              <Stack direction={'column'} spacing={0}>
                {/* {(this.state.width<600)?<div style={{paddingTop: "15px"}}></div>:null} */}
                <Stack direction={'row'} style={{ height: '50px', background: '#ffffff99', zIndex: '1', backdropFilter: 'blur(5px)', }}>
                  <img
                    height={'100%'}
                    style={{
                      padding: '30px',
                      height: '60px',
                      width: '60px',
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      border: '0',
                      marginTop: '2px',
                      backgroundImage: 'url("https://dl3.pushbulletusercontent.com/r7Mutnr1j3QSdAtvRzQztrOYryt9sUot/Shopping_cart2.png")',
                    }}
                  />
                  <Typography
                    sx={{ p: 2 }}
                    style={{
                      fontSize: this.state.width > 600 ? '24px' : '28px',
                      fontWeight: '800',
                      color: '#2e2c36',
                      lineHeight: '1',
                      letterSpacing: '-0.24px',
                      fontFamily: 'Nunito',
                      paddingLeft: '0',
                      paddingRight: '5px',
                    }}
                  >
                    {strings['Tu pedido']}
                  </Typography>
                  <div title={strings['Borrarcarrito']}>
                    <DeleteOutlineIcon
                      title={strings['Borrarcarrito']}
                      onClick={handleClearCart}
                      style={{
                        height: '21px',
                        position: 'relative',
                        top: this.state.width > 599 ? '18px' : '21px',
                        color: '#958eb1',
                        width: '100%',
                        cursor: 'pointer',
                      }}
                    />
                  </div>
                  <IconButton
                    style={{
                      color: 'slategray',
                    }}
                    aria-label="close"
                    onClick={() => {
                      this.setState({ showCart: false, additionalInfoAdded: false });
                    }}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CancelIcon />
                  </IconButton>
                </Stack>
                <Stack
                  direction={'column'}
                  spacing={0}
                  style={{
                    height: isIOS ? 'calc((var(--vh, 1vh) * 100) - 50px)' : 'calc(100vh - 0px)',
                    overflow: 'auto',
                    marginTop: isIOS ? ' ' : '-50px',
                    paddingTop: isIOS ? ' ' : '50px',
                  }}
                >
                  <>
                    {' '}
                    {this.state.selectedType === 0 ? (
                      <div style={{ padding: '8px' }}>
                        <Stack direction={'column'} spacing={0}>
                          <div style={{ padding: '8px' }}>
                            <Stack direction={'row'} spacing={2}>
                              <DirectionsBikeIcon
                                style={{
                                  fontSize: '24px',
                                  fontWeight: 'bold',
                                  color: '#01a9e0',
                                }}
                              />
                              <Typography
                                sx={{ flexGrow: 1 }}
                                style={{
                                  fontSize: '16px',
                                  fontWeight: '500',
                                  color: '#5E5E5D',
                                  fontFamily: 'Nunito',
                                  letterSpacing: 'normal',
                                }}
                              >
                                {strings['Entregar a ']}
                              </Typography>
                            </Stack>
                          </div>
                          <div onClick={() => { this.setState({ showCart: false, additionalInfoAdded: false }); handleClickOpen();}} style={{ padding: '0px 8px 0px', height: '100px', cursor: 'pointer', }}>
                            <Stack direction={'row'} spacing={1}>
                              <GoogleMapReact
                                defaultCenter={{
                                  lat: this.state.selectedLocation.latitude,
                                  lng: this.state.selectedLocation.longitude,
                                }}
                                defaultZoom={this.state.defaultProps.zoom}
                                resetBoundsOnResize={true}
                                options={{
                                  fullscreenControl: false,
                                  scrollwheel: false,
                                  panControl: false,
                                  zoomControl: false,
                                  rotateControl: false,
                                  draggable: false,
                                }}
                                bootstrapURLKeys={{
                                  key: 'AIzaSyDNl0corYx_1cBY1uvD7vzIzw8pvppIgAM',
                                }}
                                style={{
                                  height: '100px',
                                  padding: '8px',
                                  borderRadius: this.state.width < 600 ? '18px' : '12px',
                                  width: this.state.width < 600 ? '100px' : '150px',
                                  border: this.state.width < 600 ? '2px solid #ffffff' : '0',
                                  boxShadow: this.state.width < 600 ? '0 4px 8px #46545d0a' : 'none',
                                  overflow: 'hidden',
                                }}
                                onChange={(changeData) => {
                                }}
                              >
                                <LocationOnIcon
                                  style={{
                                    color: getPrimaryColor(),
                                    transform: 'translate(-50%, -100%)',
                                  }}
                                  fontSize={'large'}
                                  lat={this.state.selectedLocation.latitude}
                                  lng={this.state.selectedLocation.longitude}
                                  // text={'Google Map'}
                                />
                              </GoogleMapReact>
                              <Stack direction={'column'} spacing={1}>
                                <Typography
                                  sx={{ flexGrow: 1 }}
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#3f464a',
                                    padding: '8px',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {this.state.selectedLocationData}
                                </Typography>
                                <Typography
                                  sx={{ flexGrow: 1 }}
                                  style={{
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    color: 'slategray',
                                    padding: '0 8px',
                                    marginTop: '0',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {this.state.selectedLocationNotes}
                                </Typography>
                              </Stack>
                            </Stack>
                          </div>
                          <div
                            style={{
                              padding: '15px 6px 5px',
                              borderRadius: '10px',
                            }}
                          >
                            <TextField
                              style={{
                                color: '#272727',
                                borderRadius: '0',
                                backgroundColor: '#e6ebf1',
                                overflow: 'hidden',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                              fullWidth
                              id="filled-basic-34"
                              label={strings["Agregar instrucciones de entrega"]}
                              variant="filled"
                              value={this.state.deliveryInstructions}
                              onChange={(event) => {
                                this.setState({
                                  deliveryInstructions: event.target.value,
                                });
                              }}
                            />
                          </div>
                        </Stack>
                      </div>
                    ) : null}
                  </>
                  <>
                    {' '}
                    {this.state.selectedType === 1 || this.state.selectedType === 2 ? (
                      <div style={{ padding: '8px' }}></div>
                    ) : null}
                  </>

                  <>
                      {this.state.selectedType === 0 || this.state.selectedType === 1 ? (
                        <div style={{ marginBottom: '15px', }}>
                          <Divider variant="middle" />
                          <Typography
                            style={{
                              fontSize: '22px',
                              fontWeight: '800',
                              color: 'slategray',
                              padding: '10px 20px 0px',
                              marginTop: '0',
                              fontFamily: 'Nunito',
                              letterSpacing: 'normal',
                            }}
                          >
                            {strings['Pedido programado para']}
                          </Typography>
                          <span style={{ color: '#2e2c36', fontWeight: '800', padding: '1px 20px 0px', fontSize: '22px', }}>
                            {((!this.state.isTomorrow)
                                                  ? strings[' Hoy, ']
                                                  : strings[' Mañana, ']) + moment(this.state.selectedDate).add(0, 'm').toDate().getHours()
                                                  .toString() +
                                              ':' +
                                              (Math.round(moment(this.state.selectedDate).add(0, 'm').toDate().getMinutes() /
                                                      10))
                                                  .toString() +
                                              '0'}
                          </span>
                        </div>
                      ) : null}
                  </>

                  <Divider variant="middle" />
                  <div style={{ padding: '10px 20px 0px 20px' }}>
                    <List>
                      <Stack direction={'column'} spacing={0}>
                        {this.state.cart.item.map((items, index) => (
                          <Stack direction={'column'} spacing={0} key={index}>
                            <Stack
                              direction={'row'}
                              spacing={0}
                              style={{
                                borderBottom: '1px solid #e6ebf1',
                                padding: '0px 5px 8px 5px',
                                marginBottom: '15px',
                              }}
                            >
                              <Stack
                                sx={{ flexGrow: 1 }}
                                direction={'column'}
                                spacing={0}
                              >
                                <Typography
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#000',
                                    paddingTop: '6px',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {items['name']}
                                </Typography>
                                <div style={{ padding: '5px 0px 0px' }}></div>
                                <List
                                // sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                                >
                                  {items['customize'].map((customize, t) => (
                                    <React.Fragment key={t}>
                                      {' '}
                                      {customize['options'].length > 0 ? (
                                        <Typography
                                          style={{
                                            fontSize: '13px',
                                            fontWeight: '500',
                                            color: '#6a696e',
                                            fontFamily: 'Nunito',
                                            letterSpacing: 'normal',
                                          }}
                                        >
                                          {findTotal(index, t)}
                                        </Typography>
                                      ) : null}
                                    </React.Fragment>
                                  ))}
                                </List>
                                <Typography
                                  style={{
                                    fontSize: '15px',
                                    fontWeight: '800',
                                    color: '#615f67',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  ¢
                                  {(items['quantity'] * items['price']).toFixed(
                                    2
                                  )}
                                </Typography>
                              </Stack>
                              <div style={{ padding: '0px 5px 0px' }}>
                                <ButtonGroup
                                  variant="text"
                                  disableElevation
                                  size={'small'}
                                  style={{
                                    backgroundColor: getPrimaryColor(),
                                    borderRadius: '50px',
                                    boxShadow: 'rgb(149 157 165 / 20%) 0px 8px 24px',
                                  }}
                                >
                                  <Button
                                    style={{
                                      borderRadius: '50px 0 0 50px',
                                      minWidth: '28px',
                                      border: '0',
                                    }}
                                  >
                                    <RemoveRoundedIcon
                                      sx={{ color: 'action.active' }}
                                      style={{
                                        fontSize: '17px',
                                        color: '#fff',
                                        fontWeight: 'bold',
                                      }}
                                      onClick={() => {
                                        var cart = JSON.parse(
                                          JSON.stringify(this.state.cart)
                                        );
                                        if (
                                          cart['item'][index]['quantity'] > 1
                                        ) {
                                          cart['totalCost'] =
                                            cart['totalCost'] -
                                            cart['item'][index]['price'];
                                          cart['totalItems']--;
                                          cart['item'][index]['quantity']--;
                                          // boxCart.put(
                                          //     'cart', cart);
                                        } else {
                                          cart['totalCost'] =
                                            cart['totalCost'] -
                                            cart['item'][index]['price'];
                                          cart['totalItems']--;
                                          cart['item'].splice(index, 1);
                                          // boxCart.put(
                                          //     'cart', cart);
                                        }
                                        checkOffer();
                                        if (cart['item'].length === 0) {
                                          this.setState({ showCart: false, additionalInfoAdded: false });
                                        }
                                        this.setState({ cart: cart });
                                      }}
                                    />
                                  </Button>
                                  <Button disabled style={{ minWidth: '30px', border: '0', }}>
                                    <Typography
                                      style={{
                                        fontSize: '15px',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        color: '#fff',
                                      }}
                                    >
                                      {this.state.cart['item'][index][
                                        'quantity'
                                      ].toString()}
                                    </Typography>
                                  </Button>
                                  <Button
                                    style={{
                                      borderRadius: '0 50px 50px 0',
                                      minWidth: '28px',
                                      border: '0',
                                    }}
                                  >
                                    <AddRoundedIcon
                                      sx={{ color: 'action.active' }}
                                      style={{
                                        fontSize: '17px',
                                        fontWeight: '800',
                                        textAlign: 'center',
                                        color: '#fff',
                                        fontFamily: 'Nunito',
                                        letterSpacing: 'normal',
                                      }}
                                      onClick={() => {
                                        var cart = JSON.parse(
                                          JSON.stringify(this.state.cart)
                                        );
                                        cart['item'][index]['quantity']++;
                                        cart['totalCost'] =
                                          cart['totalCost'] +
                                          cart['item'][index]['price'];
                                        cart['totalItems']++;
                                        checkOffer();
                                        this.setState({ cart: cart });
                                      }}
                                    />
                                  </Button>
                                </ButtonGroup>
                              </div>
                            </Stack>
                          </Stack>
                        ))}
                        {(this.state.selectedOffer!=null && this.state.selectedOffer['id']!=null && this.state.isOfferApplied && this.state.selectedOffer['isFreeItem']!=null && this.state.selectedOffer['isFreeItem'])?
                        <Stack direction={'column'} spacing={0} key={this.state.cart.length}>
                            <Stack
                              direction={'row'}
                              spacing={0}
                              style={{
                                borderBottom: '1px solid #e6ebf1',
                                paddingBottom: '8px',
                                marginBottom: '15px',
                              }}
                            >
                              <Stack
                                sx={{ flexGrow: 1 }}
                                direction={'column'}
                                spacing={0}
                              >
                                <Typography
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#000',
                                    paddingTop: '6px',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {this.state.selectedOffer['freeItems'][0]['name']}
                                </Typography>
                                <div style={{ padding: '5px 0px 0px' }}></div>
                                <Typography
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: '800',
                                    color: '#2e2c36',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {strings['Gratis']}
                                </Typography>
                              </Stack>
                            </Stack>
                          </Stack>:null}
                      </Stack>
                    </List>
                  </div>
                  <>
                    {this.state.businessData.spoon && this.state.selectedType === 0 ? (
                      <div style={{ padding: '5px 15px 5px' }}>
                        <div>
                          <Stack
                            direction={'row'}
                            spacing={0}
                            style={{
                              borderRadius: '10px',
                              padding: '5px 8px 5px',
                              backgroundColor: '#f8f9fb',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <RestaurantIcon
                              style={{
                                fontSize: '20px',
                                fontWeight: 'normal',
                                color: 'slategray',
                              }}
                            />
                            <div style={{ padding: '0px 5px 0px' }}></div>
                            <Typography
                              sx={{ flexGrow: 1 }}
                              style={{
                                fontSize: '15px',
                                fontWeight: '500',
                                color: 'slategray',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {this.state.spoon
                                ? strings['Sí enviar cubiertos']
                                : strings['No envíar cubiertos']}
                            </Typography>
                            <Switch
                              checked={this.state.spoon}
                              onChange={() => {
                                this.setState({ spoon: !this.state.spoon });
                              }}
                              inputProps={{ 'aria-label': 'switch' }}
                            />
                          </Stack>
                        </div>
                      </div>
                    ) : null}
                  </>
                  <div style={{ padding: '0px 15px 5px 15px', borderRadius: '10px' }}>
                    <TextField
                      style={{
                        color: '#272727',
                        borderRadius: '0',
                        backgroundColor: '#e6ebf1',
                        overflow: 'hidden',
                        fontFamily: 'Nunito',
                        letterSpacing: 'normal',
                      }}
                      fullWidth
                      id="filled-basic-35"
                      label={strings["Agregar instrucciones de preparación"]}
                      variant="filled"
                      value={this.state.cookingInstructions}
                      onChange={(event) => {
                        this.setState({
                          cookingInstructions: event.target.value,
                        });
                      }}
                    />
                  </div>
                  <div style={{ padding: '10px 0px 0px' }}></div>

                  {/* Show client's name and table number on order details for eat in */}
                  {this.state.selectedType === 2 && this.state.clientName != '' ? (
                    <Divider variant="middle" />
                  ) : null}
                  {this.state.selectedType === 2 && this.state.clientName != '' ? (
                    <div style={{background: '#ffffff',margin: '10px 0 0 5%',padding: '0 2%',width: '90%',borderRadius: this.state.defaultCard ? '0 18px 0 0' : '0 18px 18px 18px',}}>
                      {this.state.selectedType === 2 && this.state.clientName != '' ? (
                        <div style={{ padding: '12px 1px 12px' }}>
                          <Stack direction={'column'} spacing={0}>
                            <Typography
                              style={{
                                fontSize: '18px',
                                fontWeight: '800',
                                color: '#43484d',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {strings['Cliente']}
                            </Typography>
                            <TextField className="inputstyletonormal"
                              style={{
                                fontSize: '15px',
                                fontWeight: '400',
                                color: '#2c3136',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                              //readOnly= {true}
                              id="filled-basic234"
                              value={this.state.clientName}
                              onChange={(event) => {
                                this.setState({ clientName: event.target.value });
                              }}
                            />
                          </Stack>
                        </div>
                      ) : null}
                      {this.state.selectedType === 2 && this.state.tableNumber != '' ? (
                        <Divider variant="middle" style={{border: '2px solid white',margin: '0 -3% 0 -3%',}} />
                      ) : null}
                      {this.state.selectedType === 2 && this.state.tableNumber != '' ? (
                        <div style={{ padding: '12px 1px 12px' }}>
                          <Stack direction={'column'} spacing={0}>
                            <Typography
                              style={{
                                fontSize: '18px',
                                fontWeight: '800',
                                color: '#43484d',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {strings['Mesa']}
                            </Typography>
                            <TextField className="inputstyletonormal"
                              style={{
                                fontSize: '15px',
                                fontWeight: '400',
                                color: '#2c3136',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                              //readOnly= {true}
                              id="filled-basic235"
                              value={this.state.tableNumber}
                              onChange={(event) => {
                                this.setState({ clientName: event.target.value });
                              }}
                            />
                          </Stack>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {/* Show client's name and table number on order details for eat in */}

                  {/* Show client's name on order details for pickup*/}
                  {this.state.selectedType === 1 && this.state.clientName != '' ? (
                    <Divider variant="middle" />
                  ) : null}
                  {this.state.selectedType === 1 && this.state.clientName != '' ? (
                    <div style={{background: '#ffffff',margin: '10px 0 0 5%',padding: '0 2%',width: '90%',borderRadius: this.state.defaultCard ? '0 18px 0 0' : '0 18px 18px 18px',}}>
                      {this.state.selectedType === 1 && this.state.clientName != '' ? (
                        <div style={{ padding: '12px 1px 12px' }}>
                          <Stack direction={'column'} spacing={0}>
                            <Typography
                              style={{
                                fontSize: '18px',
                                fontWeight: '800',
                                color: '#43484d',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {strings['Cliente']}
                            </Typography>
                            <TextField className="inputstyletonormal"
                              style={{
                                fontSize: '15px',
                                fontWeight: '400',
                                color: '#2c3136',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                              //readOnly= {true}
                              id="filled-basic234"
                              value={this.state.clientName}
                              onChange={(event) => {
                                this.setState({ clientName: event.target.value });
                              }}
                            />
                          </Stack>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {/* Show client's name on order details for pickup*/}

                  {/* Show client's name on order details for delivery*/}
                  {this.state.selectedType === 0 && this.state.clientName != '' ? (
                    <Divider variant="middle" />
                  ) : null}
                  {this.state.selectedType === 0 && this.state.clientName != '' ? (
                    <div style={{background: '#ffffff',margin: '10px 0 0 5%',padding: '0 2%',width: '90%',borderRadius: this.state.defaultCard ? '0 18px 0 0' : '0 18px 18px 18px',}}>
                      {this.state.selectedType === 0 && this.state.clientName != '' ? (
                        <div style={{ padding: '12px 1px 12px' }}>
                          <Stack direction={'column'} spacing={0}>
                            <Typography
                              style={{
                                fontSize: '18px',
                                fontWeight: '800',
                                color: '#43484d',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {strings['Cliente']}
                            </Typography>
                            <TextField className="inputstyletonormal"
                              style={{
                                fontSize: '15px',
                                fontWeight: '400',
                                color: '#2c3136',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                              //readOnly= {true}
                              id="filled-basic234"
                              value={this.state.clientName}
                              onChange={(event) => {
                                this.setState({ clientName: event.target.value });
                              }}
                            />
                          </Stack>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {/* Show client's name on order details for delivery*/}

                  {/* Show client's phone on order details for pickup*/}
                  {this.state.selectedType === 1 && this.state.clientTel != '' ? (
                    <div style={{background: '#ffffff',margin: '10px 0 0 5%',padding: '0 2%',width: '90%',borderRadius: this.state.defaultCard ? '0 18px 0 0' : '0 18px 18px 18px',}}>
                      {this.state.selectedType === 1 && this.state.clientTel != '' ? (
                        <div style={{ padding: '12px 1px 12px' }}>
                          <Stack direction={'column'} spacing={0}>
                            <Typography
                              style={{
                                fontSize: '18px',
                                fontWeight: '800',
                                color: '#43484d',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {strings['telefono']}
                            </Typography>
                            <TextField className="inputstyletonormal"
                              style={{
                                fontSize: '15px',
                                fontWeight: '400',
                                color: '#2c3136',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                              //readOnly= {true}
                              id="filled-basic236"
                              value={this.state.clientTel}
                              onChange={(event) => {
                                this.setState({ clientTel: event.target.value });
                              }}
                            />
                          </Stack>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {/* Show client's phone on order details for pickup*/}

                  {/* Show client's phone on order details for delivery*/}
                  {this.state.selectedType === 0 && this.state.clientTel != '' ? (
                    <div style={{background: '#ffffff',margin: '10px 0 0 5%',padding: '0 2%',width: '90%',borderRadius: this.state.defaultCard ? '0 18px 0 0' : '0 18px 18px 18px',}}>
                      {this.state.selectedType === 0 && this.state.clientTel != '' ? (
                        <div style={{ padding: '12px 1px 12px' }}>
                          <Stack direction={'column'} spacing={0}>
                            <Typography
                              style={{
                                fontSize: '18px',
                                fontWeight: '800',
                                color: '#43484d',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {strings['telefono']}
                            </Typography>
                            <TextField className="inputstyletonormal"
                              style={{
                                fontSize: '15px',
                                fontWeight: '400',
                                color: '#2c3136',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                              //readOnly= {true}
                              id="filled-basic234"
                              value={this.state.clientTel}
                              onChange={(event) => {
                                this.setState({ clientTel: event.target.value });
                              }}
                            />
                          </Stack>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {/* Show client's phone on order details for delivery*/}

                  {/* Show selected payment method */}
                  <>
                    {!this.state.loading &&
                    this.state.cart &&
                    this.state.cart.totalCost &&
                    this.state.defaultCard ? (
                      <div
                        style={{
                          padding: this.state.width > 599 ? '4px 5% 15px 5%' : '4px 5% 15px 5%',
                          borderTop: '0px solid #e6ebf1',
                          borderBottom: '0px solid #e6ebf1',
                          marginBottom: '0px',
                        }}
                      >
                        <div
                          onClick={() => {
                            handleClickOpenPayment();
                          }}
                          style={{ padding: 'calc(12px + 0%) calc(1px + 2%) calc(12px + 0%) calc(1px + 2%)', cursor: 'pointer', background: '#ffffff', borderRadius: '0px 0 18px 18px', }}
                        >
                          <Stack style={{ placeItems: 'center', display: 'block', }}
                            direction={'row'}
                            spacing={0}
                            justifyContent="space-between"
                          >
                            <Typography
                              style={{
                                fontSize: '18px',
                                fontWeight: '800',
                                color: '#43484d',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {strings['Método de pago']}
                            </Typography>
                            <Stack style={{ alignItems: 'center', justifyContent: 'left', }}
                              direction={'row'}
                              spacing={0}
                              justifyContent="center"
                            >
                              <>
                                {this.state.defaultCard['cardNumber'] != null &&
                                this.state.defaultCard['cardNumber'] ===
                                  'COD' ? (
                                  <>
                                    <img
                                      height={'100%'}
                                      style={{
                                        padding: '15px',
                                        height: '30px',
                                        width: '30px',
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        border: '0',
                                        backgroundImage: 'url("https://dl3.pushbulletusercontent.com/S4LwEZ2S0F5H5pHbRWmha1WWdQmnDtxg/Payment%20icons-03.png")',
                                      }}
                                    />
                                    <Typography
                                      style={{
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        color: '#2c3136',
                                        fontFamily: 'Nunito',
                                        letterSpacing: 'normal',
                                      }}
                                    >
                                      {strings['Pago en efectivo']}
                                    </Typography>
                                  </>
                                ) : null}
                              </>
                              <>
                                {this.state.defaultCard['cardNumber'] != null &&
                                this.state.defaultCard['cardNumber'] ===
                                  'CardOD' ? (
                                  <>
                                    <img
                                      height={'100%'}
                                      style={{
                                        padding: '15px',
                                        height: '30px',
                                        width: '30px',
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        border: '0',
                                        backgroundImage: 'url("https://dl3.pushbulletusercontent.com/YT1RwbwCHJoEqRCYB9fjwk7lrpuzapck/Payment%20icons-02.png")',
                                      }}
                                    />
                                    <Typography
                                      style={{
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        color: '#2c3136',
                                        fontFamily: 'Nunito',
                                        letterSpacing: 'normal',
                                      }}
                                    >
                                      {strings['Tarjeta a la entrega']}
                                    </Typography>
                                  </>
                                ) : null}
                              </>
                              <>
                                {this.state.defaultCard['cardNumber'] != null &&
                                this.state.defaultCard['cardNumber'] ===
                                  'mobilePayment' ? (
                                  <>
                                    <img
                                      height={'100%'}
                                      style={{
                                        padding: '15px',
                                        height: '30px',
                                        width: '30px',
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        border: '0',
                                        backgroundImage: 'url("https://dl3.pushbulletusercontent.com/YT1RwbwCHJoEqRCYB9fjwk7lrpuzapck/Payment%20icons-02.png")',
                                      }}
                                    />
                                    <Typography
                                      style={{
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        color: '#2c3136',
                                        fontFamily: 'Nunito',
                                        letterSpacing: 'normal',
                                      }}
                                    >
                                      {"Sinpe Móvil: 8787-1617 (mandar comprobante)"}
                                    </Typography>
                                  </>
                                ) : null}
                              </>
                              <>
                                {this.state.defaultCard['cardNumber'] != null &&
                                this.state.defaultCard['cardNumber'] ===
                                  'cryptoPayment' ? (
                                  <>
                                    <img
                                      height={'100%'}
                                      style={{
                                        padding: '15px',
                                        height: '30px',
                                        width: '30px',
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        border: '0',
                                        backgroundImage: 'url("https://dl3.pushbulletusercontent.com/YT1RwbwCHJoEqRCYB9fjwk7lrpuzapck/Payment%20icons-02.png")',
                                      }}
                                    />
                                    <Typography
                                      style={{
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        color: '#2c3136',
                                        fontFamily: 'Nunito',
                                        letterSpacing: 'normal',
                                      }}
                                    >
                                      {strings["Pago con Criptomoneda"]}
                                    </Typography>
                                  </>
                                ) : null}
                              </>
                              <>
                                {this.state.defaultCard['cardNumber'] == null ||
                                (this.state.defaultCard['cardNumber'] !==
                                  'COD' &&
                                  this.state.defaultCard['cardNumber'] !==
                                    'PAYPAL' &&
                                  this.state.defaultCard['cardNumber'] !==
                                    'CardOD' &&
                                    this.state.defaultCard['cardNumber'] !==
                                      'mobilePayment' &&
                                      this.state.defaultCard['cardNumber'] !==
                                        'cryptoPayment') ? (
                                  <Stack
                                    direction={'row'}
                                    spacing={0}
                                    justifyContent="space-evenly"
                                    alignItems="center"
                                  >
                                    <CreditCardIcon
                                      style={{
                                        fontSize: '20px',
                                        fontWeight: 'normal',
                                        color: '#c96812',
                                      }}
                                    />

                                    <Typography
                                      style={{
                                        fontSize: '16px',
                                        color: '#2c3136',
                                        fontWeight: '500',
                                        fontFamily: 'Nunito',
                                        letterSpacing: 'normal',
                                      }}
                                    >
                                      {'   ' +
                                        this.state.defaultCard['card'][
                                          'last4'
                                        ].toString()}
                                    </Typography>
                                  </Stack>
                                ) : null}
                              </>
                            </Stack>
                          </Stack>
                        </div>
                      </div>
                    ) : null}
                  </>
                  {/* Show selected payment method */}

                  {/* Add tip to the driver on delivery type */}
                  <>
                    {this.state.selectedType === 0 ? (
                      <div style={{ padding: '15px 15px 15px' }}>
                        <Stack direction={'column'} spacing={0}>
                          <Typography
                            style={{
                              fontSize: '18px',
                              fontWeight: '800',
                              color: '#2c3136',
                              fontFamily: 'Nunito',
                              letterSpacing: 'normal',
                            }}
                          >
                            {strings['Agregar propina para el repartidor']}
                          </Typography>
                          <Typography
                            style={{
                              fontSize: '15px',
                              fontWeight: '400',
                              color: 'slategray',
                              fontFamily: 'Nunito',
                              letterSpacing: 'normal',
                              marginBottom: '10px',
                            }}
                          >
                            {strings['¡Las entregas solo son posible gracias a ellos!']}
                          </Typography>
                          <div style={{ padding: '5px 0px 0px' }}></div>
                          <Stack
                            direction="row"
                            justifyContent="space-evenly"
                            alignItems="center"
                            spacing={2}
                          >
                            <div
                              style={{
                                borderRadius: this.state.width < 600 ? '13px' : '10px',
                                padding: '5px 8px 5px',
                                border: '2px solid',
                                borderColor:
                                  this.state.tipPercent === 0
                                    ? getPrimaryColor()
                                    : '#e6ebf1',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                              }}
                              onClick={() => {
                                this.setState({ tipPercent: 0 });
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: '500',
                                  color: '#2c3136',
                                  fontFamily: 'Nunito',
                                  letterSpacing: 'normal',
                                }}
                              >
                                {'0%'}
                              </Typography>
                            </div>
                            <div
                              style={{
                                borderRadius: this.state.width < 600 ? '13px' : '10px',
                                padding: '5px 8px 5px',
                                border: '2px solid',
                                borderColor:
                                  this.state.tipPercent === 5
                                    ? getPrimaryColor()
                                    : '#e6ebf1',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                textTransform: 'none',
                                background: 'none !important',
                              }}
                              onClick={() => {
                                this.setState({ tipPercent: 5 });
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: '500',
                                  color: '#2c3136',
                                  fontFamily: 'Nunito',
                                  letterSpacing: 'normal',
                                  textTransform: 'none',
                                  background: 'none !important',
                                }}
                              >
                                {'5%'}
                              </Typography>
                            </div>
                            <div
                              style={{
                                borderRadius: this.state.width < 600 ? '13px' : '10px',
                                padding: '5px 8px 5px',
                                border: '2px solid',
                                borderColor:
                                  this.state.tipPercent === 10
                                    ? getPrimaryColor()
                                    : '#e6ebf1',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                              }}
                              onClick={() => {
                                this.setState({ tipPercent: 10 });
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: '500',
                                  color: '#2c3136',
                                  fontFamily: 'Nunito',
                                  letterSpacing: 'normal',
                                }}
                              >
                                {'10%'}
                              </Typography>
                            </div>
                            <div
                              style={{
                                borderRadius: this.state.width < 600 ? '13px' : '10px',
                                padding: '5px 8px 5px',
                                border: '2px solid',
                                borderColor:
                                  this.state.tipPercent === 15
                                    ? getPrimaryColor()
                                    : '#e6ebf1',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                              }}
                              onClick={() => {
                                this.setState({ tipPercent: 15 });
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: '500',
                                  color: '#2c3136',
                                  fontFamily: 'Nunito',
                                  letterSpacing: 'normal',
                                }}
                              >
                                {'15%'}
                              </Typography>
                            </div>
                            <div
                              style={{
                                borderRadius: this.state.width < 600 ? '13px' : '10px',
                                padding: '5px 8px 5px',
                                border: '2px solid',
                                borderColor:
                                  this.state.tipPercent === 20
                                    ? getPrimaryColor()
                                    : '#e6ebf1',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                              }}
                              onClick={() => {
                                this.setState({ tipPercent: 20 });
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: '500',
                                  color: '#2c3136',
                                  fontFamily: 'Nunito',
                                  letterSpacing: 'normal',
                                }}
                              >
                                {'20%'}
                              </Typography>
                            </div>
                          </Stack>
                        </Stack>
                      </div>
                    ) : null}
                  </>
                  {/* Add tip to the driver on delivery type */}

                  <Divider variant="middle" />
                  <div style={{ padding: '15px 25px 0px' }}>
                    <Stack direction={'column'} spacing={0}>
                      <Stack
                        direction={'row'}
                        spacing={0}
                        justifyContent="space-between"
                      >
                        <Typography
                          style={{
                            fontSize: '16px',
                            fontWeight: '500',
                            color: '#2c3136',
                            fontFamily: 'Nunito',
                            letterSpacing: 'normal',
                          }}
                        >
                          {strings['Todos los productos']}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '16px',
                            fontWeight: '500',
                            color: '#2c3136',
                            fontFamily: 'Nunito',
                            letterSpacing: 'normal',
                          }}
                        >
                          {'¢' + this.state.cart.totalCost.toFixed(2)}
                        </Typography>
                      </Stack>
                      <div style={{ padding: '8px 0px 0px' }}></div>
                      <Stack
                        direction={'row'}
                        spacing={0}
                        justifyContent="space-between"
                      >
                        <Typography
                          style={{
                            fontSize: '16px',
                            fontWeight: '500',
                            color: '#2c3136',
                            fontFamily: 'Nunito',
                            letterSpacing: 'normal',
                          }}
                        >
                          {strings['Tarifa de servicio']}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '16px',
                            fontWeight: '500',
                            color: '#2c3136',
                            fontFamily: 'Nunito',
                            letterSpacing: 'normal',
                          }}
                        >
                          {'¢' +
                            (
                              (this.state.businessData.driverServiceFee
                                ? this.state.businessData.driverServiceFee
                                : 0) +
                              (this.state.cart['totalCost'] *
                                (this.state.businessData.driverServicePercentage
                                  ? this.state.businessData
                                      .driverServicePercentage
                                  : 0)) /
                                100
                            ).toFixed(2)}
                        </Typography>
                      </Stack>
                      <div style={{ padding: '8px 0px 0px' }}></div>
                      <>
                        {this.state.selectedType === 0 ? (
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="space-between"
                          >
                            <Typography
                              style={{
                                fontSize: '16px',
                                fontWeight: '500',
                                color: '#2c3136',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {strings['Costo de envío']}
                            </Typography>
                            <Typography
                              style={{
                                fontSize: '16px',
                                fontWeight: '500',
                                color: '#2c3136',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {'¢' + this.state.delivery.toFixed(2)}
                            </Typography>
                          </Stack>
                        ) : null}
                      </>
                      <>
                        {this.state.selectedType === 0 ? (
                          <div style={{ padding: '8px 0px 0px' }}></div>
                        ) : null}
                      </>
                    </Stack>
                  </div>
                  <div style={{ padding: '0px 25px 0px' }}>
                    <Stack direction={'column'} spacing={0}>
                      <>
                        {this.state.offerValue > 0 ? (
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="space-between"
                          >
                            <Typography
                              style={{
                                color: '#66BB6A',
                                fontSize: '16px',
                                fontWeight: '500',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {strings['Descuento']}
                            </Typography>
                            <Typography
                              style={{
                                color: '#66BB6A',
                                fontSize: '16px',
                                fontWeight: '500',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {'-¢' + this.state.offerValue.toFixed(2)}
                            </Typography>
                          </Stack>
                        ) : null}
                      </>
                      <>
                        {this.state.offerValue > 0 ? (
                          <div style={{ padding: '5px 0px 0px' }}></div>
                        ) : null}
                      </>
                    </Stack>
                  </div>
                  <>
                    {calcTip() > 0 ? (
                      <div style={{ padding: '0px 25px 15px' }}>
                        <Stack
                          direction={'row'}
                          spacing={0}
                          justifyContent="space-between"
                        >
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: '500',
                              color: '#2c3136',
                              fontFamily: 'Nunito',
                              letterSpacing: 'normal',
                            }}
                          >
                            {strings['Propina']}
                          </Typography>
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: '500',
                              color: '#2c3136',
                              fontFamily: 'Nunito',
                              letterSpacing: 'normal',
                            }}
                          >
                            {'¢' + calcTip().toFixed(2)}
                          </Typography>
                        </Stack>
                      </div>
                    ) : null}
                  </>

                  <div style={{ padding: '0px 25px 45px' }}>
                    <Stack
                      direction={'row'}
                      spacing={0}
                      justifyContent="space-between"
                    >
                      <Typography
                        style={{
                          fontSize: '18px',
                          color: '#2c3136',
                          fontWeight: '800',
                          color: '#2c3136',
                          fontFamily: 'Nunito',
                          letterSpacing: 'normal',
                        }}
                      >
                        {strings['Total']}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: '18px',
                          color: '#2c3136',
                          fontWeight: '800',
                          fontFamily: 'Nunito',
                          letterSpacing: 'normal',
                        }}
                      >
                        {'¢' + grandTotal2().toFixed(2)}
                      </Typography>
                    </Stack>
                  </div>
                  <div
                    style={{
                      padding:
                        this.state.width > 600
                          ? '80px 0px 0px 0px'
                          : '100px 0px 0px 0px',
                    }}
                  ></div>
                </Stack>
                {/* </div> */}
                <>
                  {!this.state.loading &&
                  this.state.cart &&
                  this.state.cart['totalCost'] != null &&
                  this.state.delivery != null &&
                  this.state.defaultCard == null &&
                  this.state.userDetails == null ? (
                    <div
                      style={{
                        position: this.state.width < 600 ? 'fixed' : 'relative',
                        left: '0px',
                        bottom: this.state.width < 600 ? '0' : '80px',
                        padding: '10px 15px 10px 5px',
                        zIndex: '9',
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundColor: '#fff',
                        borderTop: '0px solid #0000001f',
                        width: '100%',
                        boxShadow: 'rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px',
                      }}
                    >
                      <div style={{ width: '12%' }}>
                        <DeleteOutlineIcon
                          onClick={handleClearCart}
                          style={{
                            height: '24px',
                            position: 'relative',
                            top: '18px',
                            color: '#6a696e',
                            width: '100%',
                            cursor: 'pointer',
                          }}
                        />
                      </div>
                      <div
                        onClick={() => {
                          this.setState({ showCart: false, additionalInfoAdded: false });
                          handleClickOpenLogin();
                        }}
                        variant="contained"
                        style={{
                          height: '60px',
                          borderRadius: this.state.width < 600 ? '16px' : '16px',
                          textTransform: 'none',
                          backgroundColor: getPrimaryColor(),
                          padding: '13px 10px 13px',
                          alignItems: 'center',
                          width: '88%',
                          cursor: 'pointer',
                        }}
                      >
                        {/* <div style={{padding: "10px"}}> */}
                        <Stack
                          style={{ marginTop: '0px' }}
                          direction={'row'}
                          spacing={0}
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="start"
                            alignItems="center"
                          >
                            <Typography
                              style={{
                                fontSize: this.state.width < 600 ? '20px' : '18px',
                                fontWeight: '800',
                                color: '#fff',
                                textAlign: 'center',
                                cursor: 'pointer',
                                letterSpacing: 'normal',
                                fontFamily: 'Nunito',
                              }}
                            >
                              {strings['Ingresar']}
                            </Typography>
                          </Stack>
                          <Stack
                            direction={'column'}
                            spacing={0}
                            justifyContent="center"
                            alignItems="start"
                          >
                            <Stack
                              style={{ marginLeft: '0px' }}
                              direction={'row'}
                              spacing={0}
                              justifyContent="start"
                              alignItems="center"
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: '400',
                                  color: '#fff',
                                  textAlign: 'center',
                                }}
                              >
                                {strings["Total"]}:
                              </Typography>
                              <Typography
                                style={{
                                  fontSize: '22px',
                                  fontWeight: '800',
                                  color: '#fff',
                                  textAlign: 'center',
                                }}
                              >
                                &nbsp;&nbsp;{'¢' + grandTotal2().toFixed(2)}
                              </Typography>
                            </Stack>
                          </Stack>
                        </Stack>
                        {/* </div> */}
                      </div>
                    </div>
                  ) : null}
                </>
                <>
                  {!this.state.loading &&
                  this.state.cart &&
                  !this.state.additionalInfoAdded &&
                  this.state.cart['totalCost'] != null &&
                  this.state.delivery != null &&
                  this.state.defaultCard == null &&
                  this.state.userDetails != null ? (
                    <div
                      style={{
                        position: this.state.width < 600 ? 'fixed' : 'relative',
                        left: '0px',
                        bottom: this.state.width < 600 ? '0' : '80px',
                        padding: '10px 5% 10px 5%',
                        zIndex: '9',
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundColor: '#fff',
                        borderTop: '0px solid #0000001f',
                        width: '100%',
                      }}
                    >
                      <div
                        onClick={() => {
                          // this.setState({ showCart: false });
                          handleClickOpenAdditional();
                        }}
                        variant="contained"
                        style={{
                          height: '60px',
                          borderRadius: this.state.width < 600 ? '16px' : '14px',
                          textTransform: 'none',
                          backgroundColor: getPrimaryColor(),
                          padding: '13px 10px 13px',
                          alignItems: 'center',
                          width: '100%',
                          cursor: 'pointer',
                        }}
                      >
                        {/* <div style={{padding: "10px"}}> */}
                        <Stack
                          direction={'row'}
                          spacing={0}
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="start"
                            alignItems="center"
                          >
                            <InfoIcon
                              style={{
                                fontSize: this.state.width < 600 ? '24px' : '22px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                                marginTop: this.state.width < 600 ? '1px' : '4px',
                                marginRight: '8px',
                              }}
                            />
                            <Typography
                              style={{
                                fontSize: this.state.width < 600 ? '20px' : '18px',
                                fontWeight: '800',
                                color: '#ffffff',
                                textAlign: 'center',
                                marginTop: this.state.width < 600 ? '2px' : '4px',
                                letterSpacing: 'normal',
                              }}
                            >
                              {strings['Agregar mesa']}
                            </Typography>
                          </Stack>
                        </Stack>
                        {/* </div> */}
                      </div>
                    </div>
                  ) : null}
                </>
                <>
                  {!this.state.loading &&
                  this.state.cart &&
                  this.state.additionalInfoAdded &&
                  this.state.cart['totalCost'] != null &&
                  this.state.delivery != null &&
                  this.state.defaultCard == null &&
                  this.state.userDetails != null ? (
                    <div
                      style={{
                        position: this.state.width < 600 ? 'fixed' : 'relative',
                        left: '0px',
                        bottom: this.state.width < 600 ? '0' : '80px',
                        padding: '10px 5% 10px 5%',
                        zIndex: '9',
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundColor: '#fff',
                        borderTop: '0px solid #0000001f',
                        width: '100%',
                      }}
                    >
                      <div
                        onClick={() => {
                          // this.setState({ showCart: false });
                          handleClickOpenPayment();
                        }}
                        variant="contained"
                        style={{
                          height: '60px',
                          borderRadius: this.state.width < 600 ? '16px' : '14px',
                          textTransform: 'none',
                          backgroundColor: getPrimaryColor(),
                          padding: '13px 10px 13px',
                          alignItems: 'center',
                          width: '100%',
                          cursor: 'pointer',
                        }}
                      >
                        <Stack
                          direction={'row'}
                          spacing={0}
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="start"
                            alignItems="center"
                          >
                            <CreditCardIcon
                              style={{
                                fontSize: this.state.width < 600 ? '24px' : '22px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                                marginTop: this.state.width < 600 ? '1px' : '4px',
                                marginRight: '8px',
                              }}
                            />
                            <Typography
                              style={{
                                fontSize: this.state.width < 600 ? '20px' : '16px',
                                fontWeight: '800',
                                color: '#ffffff',
                                textAlign: 'center',
                                marginTop: this.state.width < 600 ? '2px' : '4px',
                                letterSpacing: 'normal',
                              }}
                            >
                              {strings['Elige tu método de pago ']}
                            </Typography>
                          </Stack>
                        </Stack>
                        {/* </div> */}
                      </div>
                    </div>
                  ) : null}
                </>
                <>
                  {!this.state.loading &&
                  this.state.cart &&
                  this.state.cart['totalCost'] != null &&
                  this.state.delivery != null &&
                  this.state.defaultCard != null &&
                  this.state.userDetails != null ? (
                    <div
                      style={{
                        position: this.state.width < 600 ? 'fixed' : 'relative',
                        left: '0px',
                        bottom: this.state.width < 600 ? '0' : '80px',
                        padding: '10px 5% 10px 5%',
                        zIndex: '9',
                        display: 'flex',
                        flexDirection: 'row',
                        backgroundColor: '#fff',
                        borderTop: '0px solid #0000001f',
                        width: '100%',
                      }}
                    >
                      <div
                        onClick={async () => {
                          // this.setState({ showCart: false });
                          // handleClickOpenPayment();
                          var value = this.state.businessData;
                          var order = this.state.order;
                          this.setState({
                            loading: true,
                          });
                          var isOpen;
                          var toggledOff = false;
                          if (value['available']) {
                            // console.log(this.state.selectedWeekDay);
                            if (
                              value['schedule'][this.state.selectedWeekDay][
                                'enabled'
                              ]
                            ) {
                              for (
                                var i = 0;
                                i <
                                value['schedule'][this.state.selectedWeekDay][
                                  'lapses'
                                ].length;
                                i++
                              ) {
                                //date = tz.TZDateTime.now(timezone);
                                //print(date.hour);
                                if (
                                  value['schedule'][this.state.selectedWeekDay][
                                    'lapses'
                                  ][i]['open']['hour'] <
                                    this.state.selectedDate.getHours() &&
                                  value['schedule'][this.state.selectedWeekDay][
                                    'lapses'
                                  ][i]['close']['hour'] >
                                    this.state.selectedDate.getHours()
                                ) {
                                  isOpen = true;
                                } else if (
                                  value['schedule'][this.state.selectedWeekDay][
                                    'lapses'
                                  ][i]['open']['hour'] ===
                                  this.state.selectedDate.getHours()
                                ) {
                                  if (
                                    value['schedule'][
                                      this.state.selectedWeekDay
                                    ]['lapses'][i]['open']['minute'] <
                                    this.state.selectedDate.getMinutes()
                                  ) {
                                    isOpen = true;
                                  }
                                } else if (
                                  value['schedule'][this.state.selectedWeekDay][
                                    'lapses'
                                  ][i]['close']['hour'] ===
                                  this.state.selectedDate.getHours()
                                ) {
                                  if (
                                    value['schedule'][
                                      this.state.selectedWeekDay
                                    ]['lapses'][i]['close']['minute'] >
                                    this.state.selectedDate.getMinutes()
                                  ) {
                                    isOpen = true;
                                  }
                                }
                              }
                            }
                            if (isOpen == null) isOpen = false;
                          } else {
                            isOpen = false;
                            toggledOff = true;
                          }
                          if (
                            isOpen ||
                            (value.canPickup && toggledOff && !value.cashOnly)
                          ) {
                            order = {
                              offerCode: this.state.offerCode,
                              offerId: this.state.offerId,
                              offerCode2: '',
                              offerId2: '',
                              appVersion: '(is)5.1.65',
                              reviewedDriver: false,
                              reviewedBus: false,
                              tip: calcTip(),
                              driverService:
                              (value.driverServiceFee
          ? value.driverServiceFee
          : 0) +
                                (this.state.cart['totalCost'] *
          (value.driverServicePercentage
            ? value.driverServicePercentage
            : 0)) /
                                  100,
                              driverServiceFee: value.driverServiceFee,
                              driverServicePercentage:
                                value.driverServicePercentage,
                              tipPercent: this.state.tipPercent,
                              tableNumber: this.state.tableNumber,
                              clientPhone: this.state.clientTel,
                              clientName: this.state.clientName,
                              canChangeProd: true,
                              isUsingWallet: false,
                              isUsingInvite: false,
                              onlyInHouseDriver:
                                (this.state.selectedType === 1 || this.state.selectedType === 2)
                                  ? true
                                  : value.onlyInHouseDriver,
                              isPickup: this.state.selectedType === 1,
                              isEatIn: this.state.selectedType === 2,
                              isDriver: false,
                              assignmentEnabled:
                                (this.state.selectedType === 1 || this.state.selectedType === 2)
                                  ? false
                                  : !value.onlyInHouseDriver,
                              isClubDevy: false,
                              isUsingSubscription: false,
                              isNewUser: false,
                              isInviteFinished: false,
                              offerValue: this.state.offerValue,
                              offerValue2: 0.0,
                              cashbackValue: this.state.cashbackValue,
                              restId: this.state.cart['restId'],
                              restName: this.state.cart['restName'],
                              oxxoNameData: this.state.cart['oxxoNameData'],
                              oxxoLogoImage: this.state.cart['oxxoLogoImage'],
                              restLogo: this.state.cart['restLogo'],
                              cookingTime: this.state.cart['maxTime'],
                              distance: geolib.getDistance(
                                {
                                  latitude:
                                    this.state.selectedLocation['latitude'],
                                  longitude:
                                    this.state.selectedLocation['longitude'],
                                },
                                {
                                  latitude: value.location['latitude'],
                                  longitude: value.location['longitude'],
                                }
                              ),
                              itemCost: this.state.cart['totalCost'],
                              deliveryCharge: (this.state.selectedType === 1 || this.state.selectedType === 2)?0:this.state.delivery,
                              normalCharge: this.state.normalDelivery,
                              additionalDeliveryCharge:
                                this.state.additionalDelivery,
                              additionalDeliveryPercentage:
                                this.state.additionalDeliveryPercentage2,
                              dynamicDelivery: this.state.dynamicDelivery,
                              reasonTitle: this.state.reasonTitle,
                              reasonDescription: this.state.reasonDescription,
                              grandTotal: grandTotal2(),
                              items: this.state.cart['item'],
                            };
                            order['inviteCodeUser'] = '';
                            order['oxxoItems'] = [];
                            order['oxxoDeliveryCharge'] = 0;
                            order['oxxoItemCost'] = 0;
                            order['grandTotalWithoutOxxo'] = grandTotal();
                            order['restLocation'] = value.location;
                            order['restEstimateTime'] = (value['totalTime'] == null ||
                            value['totalOrders'] == null ||
                            value['totalOrders'] === 0 ||
                            value['totalTime'] /
                            value['totalOrders'] /
                          60 <=
                          7
                          ? 35
                          : value['totalTime'] >= 46
                          ? 46
                          : value['totalTime'] /
                          value['totalOrders'] /
                            60);
                            order['restContact'] = value.phone;
                            order['perKMDeliveryFee'] = this.state.deliveryFee;
                            order['minimumDeliveryFee'] =
                              this.state.dynamicFeeType;
                            order['userName'] =
                            this.state.clientName;
                            order['userNameInstore'] = this.state.userDetails['fullName'];
                            order['userId'] = this.state.userId;
                            order['userContact'] =
                            this.state.clientTel;
                            order['userEmail'] =
                              this.state.userDetails['email'];
                            order['userLocation'] = this.state.selectedLocation;
                            order['acceptedByRest'] = false;
                            order['driverContact'] = '';
                            order['driverAvatar'] = '';
                            order['driverReachingTime'] = null;
                            order['orderReachingTime'] = 60;
                            order['driverId'] = '';
                            order['driverLocation'] = {
                              address: '',
                              latitude: null,
                              longitude: null,
                            };
                            order['showSpoonOption'] = value.spoon;
                            order['giveSpoon'] = this.state.spoon;
                            order['driversContacted'] = '';
                            order['completedOn'] = null;
                            order['orderAcceptedAt'] = null;
                            order['orderReadyAt'] = null;
                            order['orderPickedUpAt'] = null;
                            order['orderDeliveredAt'] = null;
                            order['driverAssignedAt'] = null;
                            order['driverName'] = '';
                            order['driverAssigned'] = false;
                            order['driverReached'] = false;
                            order['orderPickedUp'] = false;
                            order['cancelled'] = false;
                            order['delivered'] = false;
                            order['devyPercentage'] =
                              value.partner != null && !value.partner
                                ? value.fixedUsageFee
                                : 0;
                            order['isNonPartner'] =
                              value.partner != null ? !value.partner : false;
                            order['originalCost'] =
                              value.partner != null && !value.partner
                                ? getOriginal() /
                                  ((value.tax + 100) / 100)
                                : getOriginal();
                            order['additionalCharge'] =
                              value.partner != null && !value.partner
                                ? getOriginal() -
                                  getOriginal() /
                                    ((value.tax + 100) / 100)
                                : 0;
                                order['additionalIncrease'] = (Number((this.state.cart['totalCost'] - getOriginal())
                                  .toFixed(2)));
                            order['allergyActivate'] = false;
                            // if (userData.containsKey('allergy') &&
                            //     userData['allergy'] != [] && allergyActivate) {
                            //   order['allergy'] = userData['allergy'];
                            // } else {
                            order['allergy'] = [];
                            // }
                            if (
                              this.state.userDetails.avatar &&
                              this.state.userDetails['avatar'] !== ''
                            ) {
                              order['userAvatar'] =
                                this.state.userDetails['avatar'];
                            } else {
                              order['userAvatar'] =
                                this.state.businessData.logo;
                            }
                            order['issues'] = [];
                            order['custId'] = this.state.userDetails['custId'];
                            order['readyToBePicked'] = false;
                            order['mobilePayment'] = false;
                            order['cryptoPayment'] = false;
                            order['status'] =
                              strings['Esperando a que el negocio acepte el pedido'];
                            if (
                              this.state.defaultCard['cardNumber'] != null &&
                              (this.state.defaultCard['cardNumber'] === 'COD' ||
                                this.state.defaultCard['cardNumber'] ===
                                  'CardOD'  ||
                                  this.state.defaultCard['cardNumber'] ===
                                    'mobilePayment'  ||
                                    this.state.defaultCard['cardNumber'] ===
                                      'cryptoPayment')
                            ) {
                              order['onlinePayment'] = false;
                              if (
                                this.state.defaultCard['cardNumber'] === 'COD'
                              ) {
                                order['cardOnDelivery'] = false;
                              } else if(this.state.defaultCard['cardNumber'] ===
                              'CardOD') {
                                order['cardOnDelivery'] = true;
                              } else if(this.state.defaultCard['cardNumber'] ===
                              'mobilePayment'){
                                order['cardOnDelivery'] = false;
                                order['mobilePayment'] = true;
                              } else {
                                order['cardOnDelivery'] = false;
                                order['cryptoPayment'] = true;
                              }
                            } else {
                              order['onlinePayment'] = true;
                            }
                            if (
                              order['onlinePayment'] &&
                              this.state.defaultCard['cardNumber'] === 'PAYPAL'
                            ) {
                              order['paypalPayment'] = true;
                            } else {
                              order['paypalPayment'] = false;
                            }
                            order = JSON.parse(JSON.stringify(order));
                            // console.log(order);
                            order['selectedOffer']= (this.state.isOfferApplied)?this.state.selectedOffer: {};
                            if(!this.state.isPreOrder) {
                            order['createdOn'] = Timestamp.now();
                            order['isPreOrder'] = false;
                            } else {
                              order['createdOn'] = Timestamp.fromDate(this.state.selectedDate);
                              order['preOrderedOn'] = Timestamp.now();
                              order['isPreOrder'] = true;
                            }
                            order['isFleetOffer'] = false;
                            order['createdBy'] =
                              this.state.userDetails['fullName'];
                            order['preOrderedBy'] =
                              this.state.userDetails['fullName'];
                            if (
                              this.state.cookingInstructions != null &&
                              this.state.cookingInstructions !== ''
                            ) {
                              order['userToRest'] = [
                                {
                                  message: this.state.cookingInstructions,
                                  time: Timestamp.now(),
                                  from: 'user',
                                },
                              ];
                              order['cookingInstructions'] =
                                this.state.cookingInstructions;
                            } else order['userToRest'] = [];
                            if (
                              this.state.deliveryInstructions != null &&
                              this.state.deliveryInstructions !== ''
                            ) {
                              order['userToDriver'] = [
                                {
                                  message: this.state.deliveryInstructions,
                                  time: Timestamp.now(),
                                  from: 'user',
                                },
                              ];
                              order['deliveryInstructions'] =
                                this.state.deliveryInstructions;
                            } else order['userToDriver'] = [];
                            var dataSend = {
                              order: order,
                              defaultCard: this.state.defaultCard,
                              code:
                                value.location['country'].toLowerCase() ===
                                'mexico'
                                  ? 'CRC'
                                  : 'CRC',
                              findTotal2: findTotal2(),
                              userData: this.state.userDetails,
                              balance: 0,
                              offersUsed: this.state.offersUsed,
                              inviteExpire: Timestamp.now(),
                              inviteBalance: 0,
                              inviteAdd: '',
                            };

                            if (
                              dataSend.defaultCard['cardNumber'] != null &&
                              dataSend.defaultCard['cardNumber'] === 'PAYPAL'
                            ) {
                              // processPaymentAsPaypalCharge((order['grandTotalWithoutOxxo']));
                            } else if (
                              dataSend.defaultCard['cardNumber'] == null ||
                              (dataSend.defaultCard['cardNumber'] !== 'COD' &&
                                dataSend.defaultCard['cardNumber'] !== 'CardOD' &&
                                dataSend.defaultCard['cardNumber'] !== 'mobilePayment' &&
                                dataSend.defaultCard['cardNumber'] !== 'cryptoPayment')
                            ) {
                              console.log(dataSend.defaultCard);
                              var dataSendStripe = dataSend.findTotal2;
                              // console.log("dataSend.order['grandTotalWithoutOxxo'] * 100",(dataSend.order['grandTotalWithoutOxxo'] * 100));
                              var response = await axios.get(
                    `https://lemon-order.herokuapp.com/drivers/proxy/https://us-central1-lemon-exp.cloudfunctions.net/StripePICust?amount=${grandTotal2() * 100}&currency=${dataSend.code}&customer=${dataSend.order['custId'].toString()}&description=${dataSendStripe}&paym=${dataSend.defaultCard['id']}`,null,
                  );
                  console.log('Now i decode');
    if (response.data != null && response.data !== 'error' && response.status === 200) {
      var paymentIntentX = response.data;
      var statusData = paymentIntentX['paymentIntent']['status'];
      var strAccount = paymentIntentX['stripeAccount'];
      if (statusData === 'succeeded') {
        // console.log(
        //     `Payment completed. ${paymentIntentX['paymentIntent']['amount'].toString()}p succesfully charged`);
        order['paymentIntentId'] =
            paymentIntentX['paymentIntent']['id'].toString();
            await addDoc(collection(db, 'orders'), order)
                                .then(async (value) => {
                                  order['id'] = value.id;
                                  if (order['offerValue'] > 0) {
                                    dataSend.offersUsed.push({
                                      id: order['offerId'],
                                      usedOn: Timestamp.now(),
                                    });
                                    // console.log(dataSend.offersUsed);
                                    await updateDoc(
                                      doc(db, 'users', this.state.userId),
                                      {
                                        offersUsed: dataSend.offersUsed,
                                        updatedOn: Timestamp.now(),
                                      }
                                    );
                                  }
                                  if (
                                    order['offerValue2'] > 0 ||
                                    (order['cashbackValue'] != null &&
                                      order['cashbackValue'] > 0)
                                  ) {
                                    if (
                                      !order['isUsingInvite'] &&
                                      !order['isUsingWallet'] &&
                                      !order['isUsingSubscription']
                                    ) {
                                    } else if (
                                      order['isUsingInvite'] &&
                                      !order['isUsingWallet'] &&
                                      !order['isUsingSubscription']
                                    ) {
                                      if (order['isNewUser']) {
                                      }
                                    } else if (
                                      !order['isUsingInvite'] &&
                                      order['isUsingWallet'] &&
                                      !order['isUsingSubscription']
                                    ) {
                                    } else if (
                                      !order['isUsingInvite'] &&
                                      !order['isUsingWallet'] &&
                                      order['isUsingSubscription']
                                    ) {
                                    }
                                  }
                                  if (!order['isPreOrder']) {
                                    sendNotification(
                                      order['restId'],
                                      strings['Nuevo pedido de '] +
                                        dataSend.userData['fullName'],
                                      strings['Nuevo orden'],
                                      value.id,
                                      order
                                    );
                                  }
                                  this.setState({
                                    openAlert: true,
                                    alertType: 'success',
                                    alertMsg: strings['Pedido realizado con éxito'],
                                  });
                                  this.setState({
                                    loading: false,
                                    showCart: false,
                                    additionalInfoAdded: false,
                                    cart: {
                                      ...this.state.cart,
                                      maxTime: 0,
                                      totalCost: 0,
                                      totalItems: 0,
                                      item: [],
                                      totalOxxoCost: 0,
                                      totalOxxoItems: 0,
                                      oxxoNameData: '',
                                      oxxoLogoImage: '',
                                      oxxoItem: [],
                                    },
                                  });
                                })
                                .catch((e) => {
                                  openAlert(
                                    'error',
                                    strings['Algo salió mal al crear el pedido']
                                  );
                                  this.setState({
                                    loading: false,
                                  });
                                });
      } else {
        const stripe = await loadStripe('pk_test_51Groo5F76HIlmZyWmhOPE8wDkPI40bvJrOmrhsPD4qCMKjPCIjgtuoPLzAwf0xhJHG1B95rGO5sOOgQlziO9P6Yb00tfKKwtpx');
        const {paymentIntent, error} = await stripe.confirmCardPayment(
          paymentIntentX['paymentIntent']['client_secret'],
  {
    payment_method: paymentIntentX['paymentIntent']
                        ['payment_method'],
  },
);

if(!error) {
            var statusFinal = paymentIntent.status;
            if (statusFinal === 'succeeded') {
              // console.log(
              //     `Payment completed. ${paymentIntentX['paymentIntent']['amount'].toString()}p succesfully charged`);
              order['paymentIntentId'] =
                  paymentIntentX['paymentIntent']['id'].toString();
                  await addDoc(collection(db, 'orders'), order)
                                .then(async (value) => {
                                  order['id'] = value.id;
                                  if (order['offerValue'] > 0) {
                                    dataSend.offersUsed.push({
                                      id: order['offerId'],
                                      usedOn: Timestamp.now(),
                                    });
                                    // console.log(dataSend.offersUsed);
                                    await updateDoc(
                                      doc(db, 'users', this.state.userId),
                                      {
                                        offersUsed: dataSend.offersUsed,
                                        updatedOn: Timestamp.now(),
                                      }
                                    );
                                  }
                                  if (
                                    order['offerValue2'] > 0 ||
                                    (order['cashbackValue'] != null &&
                                      order['cashbackValue'] > 0)
                                  ) {
                                    if (
                                      !order['isUsingInvite'] &&
                                      !order['isUsingWallet'] &&
                                      !order['isUsingSubscription']
                                    ) {
                                    } else if (
                                      order['isUsingInvite'] &&
                                      !order['isUsingWallet'] &&
                                      !order['isUsingSubscription']
                                    ) {
                                      if (order['isNewUser']) {
                                      }
                                    } else if (
                                      !order['isUsingInvite'] &&
                                      order['isUsingWallet'] &&
                                      !order['isUsingSubscription']
                                    ) {
                                    } else if (
                                      !order['isUsingInvite'] &&
                                      !order['isUsingWallet'] &&
                                      order['isUsingSubscription']
                                    ) {
                                    }
                                  }
                                  if (!order['isPreOrder']) {
                                    sendNotification(
                                      order['restId'],
                                      strings['Nuevo pedido de '] +
                                        dataSend.userData['fullName'],
                                      strings['Nuevo orden'],
                                      value.id,
                                      order
                                    );
                                  }
                                  this.setState({
                                    openAlert: true,
                                    alertType: 'success',
                                    alertMsg: strings['Pedido realizado con éxito'],
                                  });
                                  this.setState({
                                    loading: false,
                                    additionalInfoAdded: false,
                                    showCart: false,
                                    cart: {
                                      ...this.state.cart,
                                      maxTime: 0,
                                      totalCost: 0,
                                      totalItems: 0,
                                      item: [],
                                      totalOxxoCost: 0,
                                      totalOxxoItems: 0,
                                      oxxoNameData: '',
                                      oxxoLogoImage: '',
                                      oxxoItem: [],
                                    },
                                  });
                                })
                                .catch((e) => {
                                  openAlert(
                                    'error',
                                    strings['Algo salió mal al crear el pedido']
                                  );
                                  this.setState({
                                    loading: false,
                                  });
                                });
            } else if (statusFinal === 'processing') {
              this.setState( {
                loading: false
              });
              openAlert('error',
                  strings["El pago aún se encuentra en estado de \"procesamiento\". Esto es inusual por favor contáctenos"]);
              console.log(
                  'The payment is still in "processing" state. This is unusual. Please contact us');
            } else {
              this.setState( {
                loading: false
              });
              openAlert('error',
                  strings['Hubo un error al confirmar el pago. Detalles: ']+statusFinal.toString());
                  console.log(
                  'There was an error to confirm the payment. Details: ¢statusFinal',statusFinal);
            }
} else {
  this.setState( {
                loading: false
              });
              openAlert('error',
                  strings["Hubo un error al confirmar el pago. Vuelve a intentarlo con otra tarjeta"]);
                  console.log('this is error');
}
      }
    } else {
      this.setState({
        loading: false,
      });
      openAlert('error',
      strings["Hubo un error al confirmar el pago. Vuelve a intentarlo con otra tarjeta"]);
      console.log(
          'There was an error in creating the payment. Please try again with another card');
    }
                            } else {
                              await addDoc(collection(db, 'orders'), order)
                                .then(async (value) => {
                                  order['id'] = value.id;
                                  if (order['offerValue'] > 0) {
                                    dataSend.offersUsed.push({
                                      id: order['offerId'],
                                      usedOn: Timestamp.now(),
                                    });
                                    // console.log(dataSend.offersUsed);
                                    await updateDoc(
                                      doc(db, 'users', this.state.userId),
                                      {
                                        offersUsed: dataSend.offersUsed,
                                        updatedOn: Timestamp.now(),
                                      }
                                    );
                                  }
                                  if (
                                    order['offerValue2'] > 0 ||
                                    (order['cashbackValue'] != null &&
                                      order['cashbackValue'] > 0)
                                  ) {
                                    if (
                                      !order['isUsingInvite'] &&
                                      !order['isUsingWallet'] &&
                                      !order['isUsingSubscription']
                                    ) {
                                    } else if (
                                      order['isUsingInvite'] &&
                                      !order['isUsingWallet'] &&
                                      !order['isUsingSubscription']
                                    ) {
                                      if (order['isNewUser']) {
                                      }
                                    } else if (
                                      !order['isUsingInvite'] &&
                                      order['isUsingWallet'] &&
                                      !order['isUsingSubscription']
                                    ) {
                                    } else if (
                                      !order['isUsingInvite'] &&
                                      !order['isUsingWallet'] &&
                                      order['isUsingSubscription']
                                    ) {
                                    }
                                  }
                                  if (!order['isPreOrder']) {
                                    sendNotification(
                                      order['restId'],
                                      strings['Nuevo pedido de '] +
                                        dataSend.userData['fullName'],
                                      strings['Nuevo orden'],
                                      value.id,
                                      order
                                    );
                                  }
                                  this.setState({
                                    openAlert: true,
                                    alertType: 'success',
                                    alertMsg: strings['Pedido realizado con éxito'],
                                  });
                                  this.setState({
                                    loading: false,
                                    showCart: false,
                                    additionalInfoAdded: false,
                                    cart: {
                                      ...this.state.cart,
                                      maxTime: 0,
                                      totalCost: 0,
                                      totalItems: 0,
                                      item: [],
                                      totalOxxoCost: 0,
                                      totalOxxoItems: 0,
                                      oxxoNameData: '',
                                      oxxoLogoImage: '',
                                      oxxoItem: [],
                                    },
                                  });
                                })
                                .catch((e) => {
                                  openAlert(
                                    'error',
                                    strings['Algo salió mal al crear el pedido']
                                  );
                                  this.setState({
                                    loading: false,
                                  });
                                });
                            }
                          } else {
                            this.setState({
                              loading: false,
                            });
                            openAlert('error', strings['El negocio está cerrado']);
                          }
                        }}
                        variant="contained"
                        style={{
                          height: '60px',
                          borderRadius: this.state.width < 600 ? '16px' : '14px',
                          textTransform: 'none',
                          backgroundColor: getPrimaryColor(),
                          padding: '13px 10px 13px',
                          alignItems: 'center',
                          cursor: 'pointer',
                          width: '100%',
                          boxShadow: this.state.width < 600 ? '0 4px 10px #3d485340' : 'none',
                        }}
                      >
                        {/* <div style={{padding: "10px"}}> */}
                        <Stack
                          style={{ marginTop: this.state.width > 600 ? '2px' : '0', }}
                          direction={'row'}
                          spacing={0}
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Stack
                            direction={'column'}
                            spacing={0}
                            justifyContent="center"
                            alignItems="start"
                          >
                            <Stack
                              style={{ marginLeft: '3px' }}
                              direction={'row'}
                              spacing={0}
                              justifyContent="start"
                              alignItems="center"
                            >
                              <div
                                style={{
                                  padding: '1px 6px 1px',
                                  backgroundColor: '#e6ebf1',
                                  borderRadius: '7px',
                                  minWidth: '32px',
                                }}
                              >
                                <Typography
                                  style={{
                                    fontSize: '20px',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#41464a',
                                    textAlign: 'center',
                                    fontFamily: 'Nunito',
                                    letterSpacing: 'normal',
                                  }}
                                >
                                  {this.state.cart.totalItems.toString()}
                                </Typography>
                              </div>
                              <Typography
                                style={{
                                  fontSize: this.state.width > 600 ? '20px' : '22px',
                                  fontWeight: '800',
                                  color: '#fff',
                                  textAlign: 'center',
                                  fontFamily: 'Nunito',
                                  letterSpacing: 'norma',
                                }}
                              >
                                &nbsp;&nbsp;{'¢' + grandTotal2().toFixed(2)}
                              </Typography>
                            </Stack>
                          </Stack>
                          <Stack
                            direction={'row'}
                            spacing={0}
                            justifyContent="start"
                            alignItems="center"
                          >
                            <Typography
                              style={{
                                fontSize: this.state.width > 600 ? '18px' : '20px',
                                fontWeight: '800',
                                color: '#fff',
                                textAlign: 'center',
                                fontFamily: 'Nunito',
                                letterSpacing: 'normal',
                              }}
                            >
                              {this.state.defaultCard['cardNumber'] == null ||
                              (this.state.defaultCard['cardNumber'] !== 'COD' &&
                                this.state.defaultCard['cardNumber'] !==
                                  'CardOD' &&
                                  this.state.defaultCard['cardNumber'] !==
                                    'mobilePayment' &&
                                    this.state.defaultCard['cardNumber'] !==
                                      'cryptoPayment')
                                ? strings['Pagar pedido ']
                                : strings['Hacer pedido ']}
                            </Typography>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  ) : null}
                </>
              </Stack>
            </Container>
          }
        ></CartDialog>
        <TrackDialog
          selectedValue={this.state.selectedValue}
          open={this.state.showTracking}
          onClose={() => {
            this.setState({
              showTracking: false,
              trackingDetails: null,
              trackingId: null,
            });
          }}
          title={this.state.width}
          displayList={
            <Container
              maxWidth={false}
              disableGutters
              sx={{
                margin: '0px',
                bgcolor: '#fff',
                height: isIOS ? 'calc((var(--vh, 1vh) * 100))' : '100vh',
                maxWidth: this.state.width > 600 ? '400px' : 'auto',
              }}
              style={{ background: '#ffffff' }}
            >
              <Stack direction={'column'} spacing={0}>
                <Stack direction={'row'} style={{ height: '50px' }}>
                  <Typography
                    sx={{ p: 2 }}
                    style={{
                      fontSize: this.state.width < 600 ? '24px' : '18px',
                      fontWeight: '800',
                      color: '#2c3136',
                      lineHeight: '1',
                      letterSpacing: '-0.24px',
                      paddingLeft: '10px',
                    }}
                  >
                    {strings['Detalles del pedido']}
                  </Typography>
                  <IconButton
                    style={{
                      color: 'slategray',
                    }}
                    aria-label="close"
                    onClick={() => {
                      this.setState({
                        showTracking: false,
                        trackingDetails: null,
                        trackingId: null,
                      });
                    }}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CancelIcon />
                  </IconButton>
                </Stack>
                <>
                  {this.state.trackingDetails ? (
                    <Stack
                      direction={'column'}
                      spacing={0}
                      style={{
                        height: isIOS
                          ? 'calc((var(--vh, 1vh) * 100) - 50px)'
                          : 'calc(100vh - 50px)',
                        overflow: 'auto',
                      }}
                    >
                      <div style={{ height: '300px' }}>
                        <div style={{ height: '300px', width: '100%' }}>
                          <GoogleMapReact
                            defaultCenter={{
                              lat: this.state.trackingDetails.userLocation
                                .latitude,
                              lng: this.state.trackingDetails.userLocation
                                .longitude,
                            }}
                            defaultZoom={this.state.defaultProps.zoom}
                            resetBoundsOnResize={true}
                            options={{
                              fullscreenControl: false,
                              scrollwheel: false,
                              panControl: false,
                              zoomControl: false,
                              rotateControl: false,
                            }}
                            bootstrapURLKeys={{
                              key: 'AIzaSyDNl0corYx_1cBY1uvD7vzIzw8pvppIgAM',
                            }}
                            style={{
                              height: '300px',
                              padding: '8px',
                              borderRadius: '10px',
                            }}
                            onChange={(changeData) => {
                            }}
                          >
                            <svg
                              className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              viewBox="0 0 512 512"
                              xmlSpace="preserve"
                              style={{
                                fontSize: '50px',
                                padding: '6px',
                                transform: 'translate(-50%, -100%)',
                              }}
                              lat={
                                this.state.trackingDetails.userLocation.latitude
                              }
                              lng={
                                this.state.trackingDetails.userLocation
                                  .longitude
                              }
                            >
                              <rect
                                id="Rectangle-6_1_"
                                x="0.4"
                                y="0.4"
                                className="st0"
                                width="511.2"
                                height="511.2"
                              />
                              <g>
                                <path
                                  id="path-1_1_"
                                  className="st4"
                                  d="M309.4,446.1c63.4-4,118.7-15.1,136.4-33.5c45.2-46.8,45.2-330.3,0-377.1s-334.3-46.8-379.5,0
                                              s-45.2,330.3,0,377.1c17.7,18.4,72.9,29.5,136.3,33.5c14,25.3,38.8,65.9,53.5,65.5C270.7,511.2,295.4,471.1,309.4,446.1z"
                                />
                              </g>
                              <path
                                className="st5"
                                d="M255.6,511.4c-6.1,0-12.3-3.7-25.5-21.7c-8.6-11.7-18.4-27.3-27.5-43.8l0-0.1l-0.1,0
                                            c-33.2-2.1-113.1-9.5-136.2-33.4c-25-25.9-33.8-114.3-33.8-188.4S41.4,61.5,66.3,35.6C91.3,9.8,180.7,0.6,256,0.6c0,0,0,0,0,0
                                            c75.3,0,164.7,9.2,189.6,35.1c25,25.9,33.8,114.3,33.8,188.4s-8.9,162.6-33.8,188.4c-23.1,23.9-103,31.4-136.3,33.4l-0.1,0l0,0.1
                                            c-9.2,16.5-19,32-27.6,43.6c-13.3,18-19.7,21.7-25.6,21.8C255.9,511.4,255.8,511.4,255.6,511.4z M259.1,491.2
                                            C259.1,491.2,259.1,491.2,259.1,491.2L259.1,491.2z M256,21.6c-85.1,0-158.5,12-174.5,28.6c-7.9,8.2-15.3,31.2-20.4,63
                                            c-4.9,31-7.6,70.4-7.6,110.9c0,40.5,2.7,79.9,7.6,110.9c5,31.8,12.4,54.8,20.4,63c9.9,10.3,51.6,22.6,122.4,27.1l11.6,0.7l5.6,10.1
                                            c15.2,27.5,28.4,45.4,34.8,52.4c6.4-6.8,19.5-24.4,35.1-52.4l5.6-10.1l11.5-0.7c70.8-4.4,112.6-16.8,122.5-27.1
                                            c7.9-8.2,15.3-31.2,20.4-63c4.9-31,7.6-70.4,7.6-110.9c0-40.5-2.7-79.9-7.6-110.9c-5-31.8-12.4-54.8-20.4-63
                                            C414.5,33.6,341.1,21.6,256,21.6z"
                              />
                              <path
                                className="st3"
                                d="M231.4,324.2c-7.2,0-14.1-3.1-18.9-8.5l-67.6-76c-9.3-10.5-8.3-26.5,2.1-35.8c10.5-9.3,26.5-8.4,35.8,2.1
                                            l46.5,52.3l108.2-151.5c8.1-11.4,23.9-14,35.3-5.9c11.4,8.1,14,24,5.9,35.3L252.1,313.6c-4.5,6.3-11.6,10.2-19.3,10.6
                                            C232.3,324.2,231.9,324.2,231.4,324.2z"
                              />
                            </svg>
                            <svg
                              className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              viewBox="0 0 512 512"
                              xmlSpace="preserve"
                              style={{
                                fontSize: '50px',
                                padding: '6px',
                                transform: 'translate(-50%, -100%)',
                              }}
                              lat={
                                this.state.trackingDetails.restLocation.latitude
                              }
                              lng={
                                this.state.trackingDetails.restLocation
                                  .longitude
                              }
                            >
                              <rect
                                id="Rectangle-6"
                                x="0.4"
                                y="0.4"
                                className="st0"
                                width="511.2"
                                height="511.2"
                              />
                              <g>
                                <path
                                  id="path-1"
                                  className="st1"
                                  d="M309.4,446.1c63.4-4,118.7-15.1,136.4-33.5c45.2-46.8,45.2-330.3,0-377.1s-334.3-46.8-379.5,0
                                          s-45.2,330.3,0,377.1c17.7,18.4,72.9,29.5,136.3,33.5c14,25.3,38.8,65.9,53.5,65.5C270.7,511.2,295.4,471.1,309.4,446.1z"
                                />
                              </g>
                              <path
                                className="st2"
                                d="M255.6,511.4c-6.1,0-12.3-3.7-25.5-21.7c-8.6-11.7-18.4-27.3-27.5-43.8l0-0.1l-0.1,0
                                        c-33.2-2.1-113.1-9.5-136.2-33.4c-25-25.9-33.8-114.3-33.8-188.4S41.4,61.5,66.3,35.6C91.3,9.8,180.7,0.6,256,0.6c0,0,0,0,0,0
                                        c75.3,0,164.7,9.2,189.6,35.1c25,25.9,33.8,114.3,33.8,188.4s-8.9,162.6-33.8,188.4c-23.1,23.9-103,31.4-136.3,33.4l-0.1,0l0,0.1
                                        c-9.2,16.5-19,32-27.6,43.6c-13.3,18-19.7,21.7-25.6,21.8C255.9,511.4,255.8,511.4,255.6,511.4z M259.1,491.2
                                        C259.1,491.2,259.1,491.2,259.1,491.2L259.1,491.2z M256,21.6c-85.1,0-158.5,12-174.5,28.6c-7.9,8.2-15.3,31.2-20.4,63
                                        c-4.9,31-7.6,70.4-7.6,110.9c0,40.5,2.7,79.9,7.6,110.9c5,31.8,12.4,54.8,20.4,63c9.9,10.3,51.6,22.6,122.4,27.1l11.6,0.7l5.6,10.1
                                        c15.2,27.5,28.4,45.4,34.8,52.4c6.4-6.8,19.5-24.4,35.1-52.4l5.6-10.1l11.5-0.7c70.8-4.4,112.6-16.8,122.5-27.1
                                        c7.9-8.2,15.3-31.2,20.4-63c4.9-31,7.6-70.4,7.6-110.9c0-40.5-2.7-79.9-7.6-110.9c-5-31.8-12.4-54.8-20.4-63
                                        C414.5,33.6,341.1,21.6,256,21.6z"
                              />
                              <path
                                className="st3"
                                d="M386.5,182.8c-0.2-0.5-0.5-0.9-0.8-1.3l-31.9-39.6v-54c0-3.9-3.1-7-7-7H166.3c-3.9,0-7,3.1-7,7v50.9L125,183.9
                                        c-0.4,0.5-0.7,1-0.9,1.6c-0.3,0.7-6.4,16.1,1.7,28.3c4.6,6.9,12.6,11,23.7,12.1v120.2c0,3.9,3.1,7,7,7h200.7c3.9,0,7-3.1,7-7V225.7
                                        c10.7-1.5,18.2-5.6,22.5-12.4C394.9,200.2,386.9,183.5,386.5,182.8z M231.6,339.2v-84.6h56.9v84.6H231.6z M263.8,212.2v-62.6h17.4
                                        l16.8,62.6C287.2,212.2,275.6,212.2,263.8,212.2z M312.5,212.2l-16.8-62.6h16.9l33.6,62.6C338.9,212.2,327.8,212.2,312.5,212.2z
                                        M167.3,212.3l33.6-62.7h16.9L201,212.3C188,212.3,176.4,212.3,167.3,212.3z M215.5,212.2l16.8-62.6h17.6v62.6
                                        C238.2,212.2,226.5,212.2,215.5,212.2z M217.6,247.6v91.6h-54V226.3h186.7v112.9h-47.7v-91.6c0-3.9-3.1-7-7-7h-70.9
                                        C220.7,240.6,217.6,243.7,217.6,247.6z M137.4,206L137.4,206c-3.3-4.9-1.3-12.4-0.6-14.5l31.8-41.9h16.4l-33.5,62.5
                                        C144.5,211.5,139.7,209.4,137.4,206z M339.8,94.8v40.8H173.3V94.8H339.8z M342.1,149.6l32.1,39.9c0.9,2.2,4.1,10.8,0.7,16.3
                                        c-2.1,3.2-6.4,5.3-13,6.1l-33.4-62.3H342.1z"
                              />
                            </svg>
                            <>
                              {this.state.trackingDetails.driverAssigned ? (
                                // <DeliveryDiningIcon
                                //   style={{
                                //     color: getPrimaryColor(),
                                //     transform: 'translate(-50%, -100%)',
                                //   }}
                                //   fontSize={'large'}
                                //   lat={
                                //     this.state.trackingDetails.driverLocation
                                //       .latitude
                                //   }
                                //   lng={
                                //     this.state.trackingDetails.driverLocation
                                //       .longitude
                                //   }
                                //   // text={'Google Map'}
                                // />
                                <svg
                                  className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
                                  version="1.1"
                                  id="Capa_1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 512 512"
                                  xmlSpace="preserve"
                                  style={{
                                    fontSize: '50px',
                                    padding: '6px',
                                    transform: 'translate(-50%, -100%)',
                                  }}
                                  lat={
                                    this.state.trackingDetails.driverLocation
                                      .latitude
                                  }
                                  lng={
                                    this.state.trackingDetails.driverLocation
                                      .longitude
                                  }
                                >
                                  <rect
                                    id="Rectangle-6_4_"
                                    x="0.4"
                                    y="0.4"
                                    className="st0"
                                    width="511.2"
                                    height="511.2"
                                  />
                                  <g>
                                    <g>
                                      <path
                                        id="path-1_12_"
                                        className="st6"
                                        d="M309.4,446.1c63.4-4,118.7-15.1,136.4-33.5c45.2-46.8,45.2-330.3,0-377.1
                                                  s-334.3-46.8-379.5,0s-45.2,330.3,0,377.1c17.7,18.4,72.9,29.5,136.3,33.5c14,25.3,38.8,65.9,53.5,65.5
                                                  C270.7,511.2,295.4,471.1,309.4,446.1z"
                                      />
                                    </g>
                                  </g>
                                  <path
                                    className="st7"
                                    d="M255.6,511.4c-6.1,0-12.3-3.7-25.5-21.7c-8.6-11.7-18.4-27.3-27.5-43.8l0-0.1l-0.1,0
                                              c-33.2-2.1-113.1-9.5-136.2-33.4c-25-25.9-33.8-114.3-33.8-188.4S41.4,61.5,66.3,35.6C91.3,9.8,180.7,0.6,256,0.6c0,0,0,0,0,0
                                              c75.3,0,164.7,9.2,189.6,35.1c25,25.9,33.8,114.3,33.8,188.4s-8.9,162.6-33.8,188.4c-23.1,23.9-103,31.4-136.3,33.4l-0.1,0l0,0.1
                                              c-9.2,16.5-19,32-27.6,43.6c-13.3,18-19.7,21.7-25.6,21.8C255.9,511.4,255.8,511.4,255.6,511.4z M259.1,491.2
                                              C259.1,491.2,259.1,491.2,259.1,491.2L259.1,491.2z M256,21.6c-85.1,0-158.5,12-174.5,28.6c-7.9,8.2-15.3,31.2-20.4,63
                                              c-4.9,31-7.6,70.4-7.6,110.9c0,40.5,2.7,79.9,7.6,110.9c5,31.8,12.4,54.8,20.4,63c9.9,10.3,51.6,22.6,122.4,27.1l11.6,0.7l5.6,10.1
                                              c15.2,27.5,28.4,45.4,34.8,52.4c6.4-6.8,19.5-24.4,35.1-52.4l5.6-10.1l11.5-0.7c70.8-4.4,112.6-16.8,122.5-27.1
                                              c7.9-8.2,15.3-31.2,20.4-63c4.9-31,7.6-70.4,7.6-110.9c0-40.5-2.7-79.9-7.6-110.9c-5-31.8-12.4-54.8-20.4-63
                                              C414.5,33.6,341.1,21.6,256,21.6z"
                                  />
                                  <path
                                    className="st3"
                                    d="M168.9,319.9c-1.6,0-3.1-0.1-4.7-0.3c-23.9-2.9-39.5-22.4-37-46.5c0-0.1,0-0.2,0.1-0.4h-7.8
                                              c-2.2,0-4.2-1.2-5.3-3.1l-15-26.2c-1.3-2.3-1-5.2,0.8-7.1l42.7-46.8c1.2-1.3,2.8-2,4.5-2h58.1c3.4,0,6.1,2.7,6.1,6.1
                                              s-2.7,6.1-6.1,6.1h-55.4l-37.9,41.6l11.1,19.3h172.5c7.9-13.9,23.7-39.9,32.5-43.9c3-1.4,6.7-0.1,8.1,3c1.4,3.1,0,6.7-3,8
                                              c-4.4,2.3-18.4,23.5-28.7,41.9c-1.1,1.9-3.1,3.1-5.3,3.1H139.2c0.1,0.5,0.1,1,0.1,1.6c-1.7,17.2,9.3,31.1,26.4,33.2
                                              c12.8,1.6,25.1-6.2,30.4-19.3c1.3-3.1,4.8-4.6,7.9-3.3c3.1,1.3,4.6,4.8,3.4,7.9C200.5,309.5,185.5,319.9,168.9,319.9z M370.3,319.9
                                              c-21.5,0-40-16.7-43-38.8c-0.5-3.3,1.9-6.4,5.2-6.9c3.2-0.4,6.4,1.9,6.9,5.2c2.2,16.1,15.5,28.3,31,28.3c17.3,0,31.3-14.8,31.3-33.1
                                              c0-5.4-1.2-10.7-3.6-15.4c-1.5-3-0.3-6.7,2.7-8.2c3-1.5,6.7-0.3,8.2,2.7c3.2,6.4,4.9,13.6,4.9,20.8
                                              C413.8,299.6,394.3,319.9,370.3,319.9z M335.6,268.4h-19.5c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1h15.8c3.9-7,14.2-21.6,30.7-21.6
                                              c13.9,0,22.9,1.4,26.4,2l4.8-1.5c-3.7-6.7-12.9-18.1-34.8-24.3c-0.2-0.1-0.4-0.1-0.6-0.2c-2.6,1-5.7,0.2-7.3-2.3
                                              c0,0-45.2-66.9-46.5-68.9c-1.2-1.7-1.4-3.9-0.6-5.9c0.8-1.9,2.5-3.3,4.6-3.7l6.6-1.1l-0.6-13.6l-4.1-1l-19.3,13.5
                                              c-1,0.7-2.2,1.1-3.5,1.1l-23.1,0.1c0,0,0,0,0,0c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1l21.2,0l20-14c1.4-1,3.2-1.3,4.9-0.9
                                              l11.2,2.7c2.6,0.6,4.5,3,4.6,5.7l1,23.6c0.1,3.1-2,5.7-5.1,6.2l-2.5,0.4c10.1,15,31.6,46.8,39.6,58.6c0.9-0.2,1.9-0.1,2.8,0.1
                                              c38.9,11.1,45.3,37.4,45.6,38.5c0.7,3.1-1.1,6.2-4.1,7.2l-12.6,3.9c-1,0.3-2.2,0.4-3.2,0.1c-0.1,0-8.9-2-25.3-2
                                              c-13.3,0-21.3,17.7-21.4,17.9C340.2,267,338.1,268.4,335.6,268.4z M276,242.7h-63c-2.3,0-4.4-1.3-5.5-3.4c-1-2.1-0.8-4.6,0.7-6.4
                                              l27.3-35.3c1.2-1.5,2.9-2.5,5-2.4l5.6,0.1c0.5-5.3-1.1-15-15.9-23.8l-91.6-0.4c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.5-6.2,6.1-6.1
                                              l93.2,0.4c1,0,2,0.3,2.9,0.8c25.8,14.4,25.4,34.9,21.7,43.8c-1,2.3-3.3,3.7-5.7,3.7l-7.4-0.2l-17.8,23H273l27.3-37.3l-20.9-36.6
                                              c-1.7-2.9-0.7-6.6,2.3-8.3c2.9-1.7,6.7-0.6,8.3,2.3l22.9,40.1c1.2,2.1,1,4.7-0.4,6.6l-31.5,42.9C279.8,241.7,278,242.7,276,242.7z"
                                  />
                                </svg>
                              ) : null}
                            </>
                          </GoogleMapReact>
                          <>
                            {!this.state.trackingDetails.acceptedByRest ? (
                              <div
                                style={{
                                  position: 'relative',
                                  bottom: '290px',
                                  left: '10px',
                                  width: '200px',
                                }}
                              >
                                <Typography
                                  onClick={async () => {
                                    this.setState({ loading: true });
                                    await axios
                                      .post(
                                        'https://lemon-order.herokuapp.com/drivers/cancelorder/',
                                        null,
                                        {
                                          params: {
                                            id: this.state.trackingId,
                                          },
                                        }
                                      )
                                      .then(async (response) => {
                                        this.setState({ loading: false });
                                        // console.log(response);
                                      })
                                      .catch((e) => {
                                        this.setState({ loading: false });
                                      });
                                  }}
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#D62B2B',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {strings['Cancelar pedido']}
                                </Typography>
                              </div>
                            ) : null}
                          </>
                          <>
                            {!this.state.trackingDetails.delivered ? (
                              <div
                                style={{
                                  position: 'relative',
                                  bottom: '200px',
                                  right: '10px',
                                  width: '200px',
                                  float: 'right',
                                }}
                              >
                                <div style={{ padding: '15px' }}>
                                  <div
                                    style={{
                                      backgroundColor: '#fff',
                                      borderRadius: '20px',
                                      height: '120px',
                                      boxShadow: '0px 4px 10px #64717a42',
                                      padding: '10px',
                                    }}
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="center"
                                    >
                                      <>
                                        {this.state.trackingDetails != null &&
                                        (this.state.trackingDetails[
                                          'isPickup'
                                        ] == null ||
                                          !this.state.trackingDetails[
                                            'isPickup'
                                          ]) ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: 'normal',
                                              color: '#777',
                                            }}
                                          >
                                            {strings['Pedido número']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails != null &&
                                        this.state.trackingDetails[
                                          'isPickup'
                                        ] != null &&
                                        this.state.trackingDetails[
                                          'isPickup'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: 'normal',
                                              color: '#777',
                                            }}
                                          >
                                            {strings['ID del pedido']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <div
                                        style={{ padding: '2px 0px 0px' }}
                                      ></div>
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {this.state.trackingDetails['number']
                                          ? this.state.trackingDetails[
                                              'number'
                                            ].toString()
                                          : ''}
                                      </Typography>
                                      <div
                                        style={{ padding: '2px 0px 0px' }}
                                      ></div>
                                      <Divider />
                                      <div
                                        style={{ padding: '2px 0px 0px' }}
                                      ></div>
                                      <>
                                        {this.state.trackingDetails != null &&
                                        (this.state.trackingDetails[
                                          'isPickup'
                                        ] == null ||
                                          !this.state.trackingDetails[
                                            'isPickup'
                                          ]) ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: 'normal',
                                              color: '#777',
                                            }}
                                          >
                                            {strings['Entrega estimada']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails != null &&
                                        this.state.trackingDetails[
                                          'isPickup'
                                        ] != null &&
                                        this.state.trackingDetails[
                                          'isPickup'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: 'normal',
                                              color: '#777',
                                            }}
                                          >
                                            {strings['Recogida estimada']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <div
                                        style={{ padding: '2px 0px 0px' }}
                                      ></div>
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {moment(this.state.trackingDetails['createdOn']
                                          .toDate()).add(Math.trunc(
                                              this.state.trackingDetails[
                                                'restEstimateTime'
                                              ]
                                                ? this.state.trackingDetails[
                                                    'restEstimateTime'
                                                  ]
                                                : 30
                                            ) -
                                            6, 'minutes').format('HH:mm').toString()+" - "+moment(this.state.trackingDetails['createdOn']
                                          .toDate()).add(Math.trunc(
                                              this.state.trackingDetails[
                                                'restEstimateTime'
                                              ]
                                                ? this.state.trackingDetails[
                                                    'restEstimateTime'
                                                  ]
                                                : 30
                                            ) +
                                            6, 'minutes').format('HH:mm').toString()}
                                        {/* {this.state.trackingDetails['createdOn']
                                          .toDate()
                                          .getHours()
                                          .toString() +
                                          ':' +
                                          (
                                            this.state.trackingDetails[
                                              'createdOn'
                                            ]
                                              .toDate()
                                              .getMinutes() +
                                            Math.trunc(
                                              this.state.trackingDetails[
                                                'restEstimateTime'
                                              ]
                                                ? this.state.trackingDetails[
                                                    'restEstimateTime'
                                                  ]
                                                : 30
                                            ) -
                                            6
                                          ).toString() +
                                          ' - ' +
                                          this.state.trackingDetails[
                                            'createdOn'
                                          ]
                                            .toDate()
                                            .getHours()
                                            .toString() +
                                          ':' +
                                          (
                                            this.state.trackingDetails[
                                              'createdOn'
                                            ]
                                              .toDate()
                                              .getMinutes() +
                                            Math.trunc(
                                              this.state.trackingDetails[
                                                'restEstimateTime'
                                              ]
                                                ? this.state.trackingDetails[
                                                    'restEstimateTime'
                                                  ]
                                                : 30
                                            ) +
                                            6
                                          ).toString()} */}
                                      </Typography>
                                    </Stack>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </>
                        </div>
                      </div>
                      <div
                        style={{
                          padding: '10px 20px 10px',
                          marginTop: '-38px',
                          zIndex: '9',
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: '#fff',
                            boxShadow: '0px 4px 10px #64717a42',
                            borderRadius: '20px',
                            padding: '12px 16px 12px 16px',
                          }}
                        >
                          <Stack
                            direction={'column'}
                            spacing={0}
                            alignItems="center"
                          >
                            <Stack
                              direction={'row'}
                              spacing={0}
                              alignItems="center"
                              justifyContent="center"
                            >
                              <>
                                {true ? (
                                  <AspectRatio
                                    ratio="1/1"
                                    style={{
                                      borderRadius: '50%',
                                      width: 'calc(100% / 8 + 7.5px)',
                                      maxWidth: 'calc(100% / 8 + 7.5px)',
                                      padding: '2px',
                                      marginTop: '3px',
                                    }}
                                  >
                                    <BusinessSvg
                                      viewBox="-20 -40 550 550"
                                      style={{
                                        border: `2px solid #4dd884`,
                                        borderRadius: '50%',
                                        width: 'calc(100%)',
                                        padding: '6px',
                                        fontSize: '50px',
                                      }}
                                    />
                                  </AspectRatio>
                                ) : null}
                              </>
                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '60px 0 0 60px',
                                        backgroundColor: getPrimaryColor(),
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '0 60px 60px 0',
                                        backgroundColor:
                                          this.state.trackingDetails[
                                            'acceptedByRest'
                                          ] ||
                                          this.state.trackingDetails[
                                            'delivered'
                                          ]
                                            ? getPrimaryColor()
                                            : '#C4C1C0',
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {true ? (
                                  <AspectRatio
                                    ratio="1/1"
                                    style={{
                                      borderRadius: '80px',
                                      border: this.state.trackingDetails[
                                        'acceptedByRest'
                                      ]
                                        ? `0px solid ${getPrimaryColor()}`
                                        : '0px solid #C4C1C0',
                                      width: 'calc(100% / 8 + 7.5px)',
                                      maxWidth: 'calc(100% / 8 + 7.5px)',
                                      padding: '5.5px',
                                    }}
                                  >
                                    <StoreMallDirectoryIcon
                                      style={{
                                        fontSize: '40px',
                                        border: '2px solid',
                                        borderRadius: '60px',
                                        borderColor: this.state.trackingDetails[
                                          'acceptedByRest'
                                        ]
                                          ? getPrimaryColor()
                                          : '#C4C1C0',
                                        padding: '6px',
                                        color: this.state.trackingDetails[
                                          'acceptedByRest'
                                        ]
                                          ? getPrimaryColor()
                                          : '#C4C1C0',
                                      }}
                                    />
                                  </AspectRatio>
                                ) : null}
                              </>
                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '60px 0 0 60px',
                                        backgroundColor:
                                          this.state.trackingDetails[
                                            'driverAssigned'
                                          ] ||
                                          this.state.trackingDetails[
                                            'delivered'
                                          ]
                                            ? getPrimaryColor()
                                            : '#C4C1C0',
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '0 60px 60px 0',
                                        backgroundColor:
                                          this.state.trackingDetails[
                                            'driverReached'
                                          ] ||
                                          this.state.trackingDetails[
                                            'delivered'
                                          ]
                                            ? getPrimaryColor()
                                            : '#C4C1C0',
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {true ? (
                                  <AspectRatio
                                    ratio="1/1"
                                    style={{
                                      borderRadius: '80px',
                                      border: this.state.trackingDetails[
                                        'driverReached'
                                      ]
                                        ? `0px solid ${getPrimaryColor()}`
                                        : '0px solid #C4C1C0',
                                      width: 'calc(100% / 8 + 7.5px)',
                                      maxWidth: 'calc(100% / 8 + 7.5px)',
                                      padding: '5.5px',
                                    }}
                                  >
                                    <DeliveryDiningIcon
                                      style={{
                                        fontSize: '40px',
                                        border: '2px solid',
                                        borderRadius: '60px',
                                        borderColor: this.state.trackingDetails[
                                          'driverReached'
                                        ]
                                          ? getPrimaryColor()
                                          : '#C4C1C0',
                                        padding: '6px',
                                        color: this.state.trackingDetails[
                                          'driverReached'
                                        ]
                                          ? getPrimaryColor()
                                          : '#C4C1C0',
                                      }}
                                    />
                                  </AspectRatio>
                                ) : null}
                              </>
                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '60px 0 0 60px',
                                        backgroundColor:
                                          this.state.trackingDetails[
                                            'orderPickedUp'
                                          ] ||
                                          this.state.trackingDetails[
                                            'delivered'
                                          ]
                                            ? getPrimaryColor()
                                            : '#C4C1C0',
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '0 60px 60px 0',
                                        backgroundColor: this.state
                                          .trackingDetails['delivered']
                                          ? getPrimaryColor()
                                          : '#C4C1C0',
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {true ? (
                                  <AspectRatio
                                    ratio="1/1"
                                    style={{
                                      borderRadius: '80px',
                                      border:
                                        this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails['cancelled']
                                          ? `0px solid ${getPrimaryColor()}`
                                          : this.state.trackingDetails[
                                              'delivered'
                                            ] &&
                                            this.state.trackingDetails[
                                              'cancelled'
                                            ]
                                          ? '0px solid #D62B2B'
                                          : '0px solid #C4C1C0',
                                      width: 'calc(100% / 8 + 7.5px)',
                                      maxWidth: 'calc(100% / 8 + 7.5px)',
                                      padding: '2px',
                                    }}
                                  >
                                    <WhereToVoteIcon
                                      style={{
                                        fontSize: '40px',
                                        border: '2px solid',
                                        borderRadius: '60px',
                                        borderColor:
                                          this.state.trackingDetails[
                                            'delivered'
                                          ] &&
                                          !this.state.trackingDetails[
                                            'cancelled'
                                          ]
                                            ? getPrimaryColor()
                                            : this.state.trackingDetails[
                                                'delivered'
                                              ] &&
                                              this.state.trackingDetails[
                                                'cancelled'
                                              ]
                                            ? '#D62B2B'
                                            : '#C4C1C0',
                                        color:
                                          this.state.trackingDetails[
                                            'delivered'
                                          ] &&
                                          !this.state.trackingDetails[
                                            'cancelled'
                                          ]
                                            ? getPrimaryColor()
                                            : this.state.trackingDetails[
                                                'delivered'
                                              ] &&
                                              this.state.trackingDetails[
                                                'cancelled'
                                              ]
                                            ? '#D62B2B'
                                            : '#C4C1C0',
                                        padding: '6px',
                                      }}
                                    />
                                  </AspectRatio>
                                ) : null}
                              </>
                            </Stack>
                            <div style={{ padding: '15px 0px 0px' }}></div>
                            <Typography
                              style={{
                                fontSize: '16px',
                                fontWeight: 'bold',
                                color: '#2e3436',
                                textAlign: 'center',
                              }}
                            >
                              {getStat(this.state.trackingDetails)}
                            </Typography>
                            <div style={{ padding: '15px 0px 0px' }}></div>
                            <Stack
                              onClick={() => {
                                this.setState({
                                  toggleDetails: !this.state.toggleDetails,
                                });
                              }}
                              direction={'row'}
                              spacing={0}
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Typography
                                style={{
                                  fontSize: '14px',
                                  fontWeight: 'normal',
                                  color: '#7E7D81',
                                  cursor: 'pointer',
                                }}
                              >
                                {strings['Ver más']}
                              </Typography>
                              <div style={{ padding: '0px 2px 0px' }}></div>
                              <>
                                {!this.state.toggleDetails ? (
                                  <KeyboardArrowDownIcon
                                    style={{
                                      fontSize: '24px',
                                      fontWeight: 'normal',
                                      color: '#7E7D81',
                                      cursor: 'pointer',
                                    }}
                                  />
                                ) : (
                                  <KeyboardArrowUpIcon
                                    style={{
                                      fontSize: '24px',
                                      fontWeight: 'normal',
                                      color: '#7E7D81',
                                      cursor: 'pointer',
                                    }}
                                  />
                                )}
                              </>
                            </Stack>
                            <div style={{ padding: '5px 0px 0px' }}></div>
                            <>
                              {this.state.toggleDetails ? (
                                <div>
                                  <Stack
                                    direction={'row'}
                                    spacing={0}
                                    alignItems="center"
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="center"
                                    >
                                      <>
                                        {true ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {
                                              strings['Esperando a que el negocio acepte su pedido']
                                            }
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {
                                              strings['Te avisaremos una vez que el negocio acepte tu pedido']
                                            }
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {
                                              strings['El negocio está preparando tu pedido']
                                            }
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {strings['Tu pedido está siendo preparado']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: '400',
                                              color: '#3a4247',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' está en camino para recoger tu pedido']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: '400',
                                              color: '#3a4247',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' está en camino para recoger tu pedido']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' llegó al negocio']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' ha llegado al negocio y recogerá tu pedido']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' ha recogido tu pedido']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' ha recogido tu pedido']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {strings['Tu pedido ha sido entregado']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {strings['Tu pedido ha sido entregado']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: '400',
                                              color: '#3a4247',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {strings['Tu pedido ha sido cancelado']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: '400',
                                              color: '#3a4247',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'reason'
                                            ] == null
                                              ? strings['Tu pedido ha sido cancelado']
                                              : this.state.trackingDetails[
                                                  'reason'
                                                ]}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <Divider
                                            style={{
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '600',
                                              color: '#3a4247',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {strings['Tu ubicación']}:{' '}
                                            <span
                                              style={{
                                                color: 'slategray',
                                                fontWeight: '400',
                                              }}
                                            >
                                              {
                                                this.state.trackingDetails[
                                                  'userLocation'
                                                ]['geoAddress']
                                              }
                                            </span>
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                    </Stack>
                                  </Stack>
                                </div>
                              ) : null}
                            </>
                          </Stack>
                        </div>
                      </div>
                      <>
                        {!this.state.trackingDetails['delivered'] ? (
                          <div
                            style={{
                              padding: '5px 10px 5px',
                              borderTop: '1px solid #d8d8d8',
                              marginTop: '10px',
                            }}
                          >
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="center"
                            >
                              <Stack
                                direction={'row'}
                                spacing={0}
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Stack
                                  direction={'row'}
                                  spacing={0}
                                  alignItems="center"
                                  justifyContent="flex-start"
                                >
                                  <div
                                    style={{
                                      borderRadius: '10px',
                                      width: 'calc(15%)',
                                      paddingTop: '10px',
                                    }}
                                  >
                                    <div style={{ padding: '1.75px' }}>
                                      <img
                                        src={
                                          this.state.trackingDetails['restLogo']
                                        }
                                        alt="logo"
                                        // width={'50px'}
                                        style={{
                                          borderRadius: '12px',
                                          width: 'calc(100%)',
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      padding: '5px 15px 0px',
                                      flexGrow: 1,
                                    }}
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-start"
                                      justifyContent="flex-start"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'normal',
                                          color: '#000',
                                        }}
                                      >
                                        {this.state.trackingDetails['restName']}
                                      </Typography>
                                      <Stack
                                        direction={'row'}
                                        spacing={0}
                                        alignItems="center"
                                      >
                                        <StarIcon
                                          style={{
                                            fontSize: '16px',
                                            color: getPrimaryColor(),
                                          }}
                                        />
                                        <Typography
                                          style={{
                                            fontSize: '15px',
                                            fontWeight: 'normal',
                                            color: '#000',
                                          }}
                                        >
                                          {' ' +
                                            this.state.businessData[
                                              'averageRating'
                                            ].toFixed(2)}
                                        </Typography>
                                      </Stack>
                                    </Stack>
                                  </div>
                                </Stack>
                                <div style={{ padding: '0px 5px 0px' }}>
                                  <div
                                    onClick={() => {
                                      window.open(
                                        'tel://' +
                                          this.state.trackingDetails[
                                            'restContact'
                                          ],
                                        '_blank'
                                      );
                                    }}
                                    style={{
                                      width: '38px',
                                      height: '38px',
                                      backgroundColor: '#33343b',
                                      borderRadius: '50%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      textAlign: 'center',
                                      padding: '4px 6px 4px 8px',
                                    }}
                                  >
                                    <LocalPhoneIcon
                                      style={{
                                        fontSize: '23px',
                                        color: '#fff',
                                      }}
                                    />
                                  </div>
                                </div>
                              </Stack>
                            </Stack>
                          </div>
                        ) : null}
                      </>

                      <div style={{ padding: '5px 0px 0px' }}></div>
                      <Divider />
                      <>
                        {this.state.trackingDetails['driverAssigned'] &&
                        !this.state.trackingDetails['delivered'] ? (
                          <div style={{ padding: '5px 10px 5px' }}>
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="center"
                            >
                              <Stack
                                direction={'row'}
                                spacing={0}
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Stack
                                  direction={'row'}
                                  spacing={0}
                                  alignItems="center"
                                  justifyContent="flex-start"
                                >
                                  <div
                                    style={{
                                      backgroundColor: '#f8f9fb',
                                      boxShadow: '0px 0px 5px #aaa',
                                      borderRadius: '100px',
                                      width: 'calc(12%)',
                                    }}
                                  >
                                    <div style={{ padding: '1.75px' }}>
                                      <img
                                        src={
                                          this.state.trackingDetails[
                                            'driverAvatar'
                                          ]
                                        }
                                        alt="logo"
                                        // width={'50px'}
                                        style={{
                                          borderRadius: '100px',
                                          width: 'calc(100%)',
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      padding: '5px 15px 0px',
                                      flexGrow: 1,
                                    }}
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-start"
                                      justifyContent="flex-start"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '18px',
                                          fontWeight: 'normal',
                                          color: '#000',
                                        }}
                                      >
                                        {
                                          this.state.trackingDetails[
                                            'driverName'
                                          ]
                                        }
                                      </Typography>
                                      <Stack
                                        direction={'row'}
                                        spacing={0}
                                        alignItems="center"
                                      >
                                        <StarIcon
                                          style={{
                                            fontSize: '18px',
                                            color: getPrimaryColor(),
                                          }}
                                        />
                                        <Typography
                                          style={{
                                            fontSize: '15px',
                                            fontWeight: 'normal',
                                            color: '#000',
                                          }}
                                        >
                                          {' ' +
                                          this.state.trackingDetails[
                                            'driverRating'
                                          ]
                                            ? this.state.trackingDetails[
                                                'driverRating'
                                              ].toFixed(2)
                                            : ''}
                                        </Typography>
                                        <div
                                          style={{ padding: '0px 7.5px 0px' }}
                                        ></div>
                                        <Typography
                                          style={{
                                            fontSize: '15px',
                                            fontWeight: 'normal',
                                            color: '#000',
                                          }}
                                        >
                                          {strings['Nivel: '] +
                                          this.state.trackingDetails[
                                            'driverLevel'
                                          ]
                                            ? this.state.trackingDetails[
                                                'driverLevel'
                                              ].toString()
                                            : '1'}
                                        </Typography>
                                      </Stack>
                                    </Stack>
                                  </div>
                                </Stack>
                                <div style={{ padding: '0px 5px 0px' }}>
                                  <div
                                    onClick={() => {
                                      window.open(
                                        'tel://' +
                                          this.state.trackingDetails[
                                            'driverContact'
                                          ],
                                        '_blank'
                                      );
                                    }}
                                    style={{
                                      width: '45px',
                                      height: '45px',
                                      backgroundColor: '#272727',
                                      borderRadius: '50%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      textAlign: 'center',
                                      padding: '4px 6px 4px',
                                    }}
                                  >
                                    <LocalPhoneIcon
                                      style={{
                                        fontSize: '27px',
                                        color: '#fff',
                                      }}
                                    />
                                  </div>
                                </div>
                              </Stack>
                            </Stack>
                          </div>
                        ) : null}
                      </>
                      <div style={{ padding: '15px 0px 0px' }}></div>
                      <Divider />
                      <>
                        {' '}
                        {this.state.trackingDetails != null &&
                        (this.state.trackingDetails['isPickup'] == null ||
                          !this.state.trackingDetails['isPickup']) ? (
                          <div style={{ padding: '5px 20px 5px' }}>
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="flex-start"
                              justifyContent="flex-start"
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#6A6A6E',
                                }}
                              >
                                {strings['Dirección de entrega']}
                              </Typography>
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#000',
                                }}
                              >
                                {
                                  this.state.trackingDetails['userLocation'][
                                    'geoAddress'
                                  ]
                                }
                              </Typography>
                              <>
                                {this.state.trackingDetails['userLocation'][
                                  'addressNotes'
                                ] != null &&
                                this.state.trackingDetails['userLocation'][
                                  'addressNotes'
                                ] !== '' ? (
                                  <Typography
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: 'normal',
                                      color: '#6A6A6E',
                                    }}
                                  >
                                    {
                                      this.state.trackingDetails[
                                        'userLocation'
                                      ]['addressNotes']
                                    }
                                  </Typography>
                                ) : null}
                              </>
                              <div style={{ padding: '5px 0px 0px' }}></div>
                            </Stack>
                          </div>
                        ) : null}
                      </>
                      <>
                        {' '}
                        {this.state.trackingDetails != null &&
                        this.state.trackingDetails['isPickup'] != null &&
                        this.state.trackingDetails['isPickup'] ? (
                          <div style={{ padding: '5px 20px 5px' }}>
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="flex-start"
                              justifyContent="flex-start"
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#6A6A6E',
                                }}
                              >
                                {strings['Para recoger tu pedido debes dirigirte a:']}
                              </Typography>
                              <Typography
                                onClick={() => {
                                  window.open(
                                    'https://www.google.com/maps/search/?api=1&query=' +
                                      this.state.businessData.location.latitude.toString() +
                                      '%2C' +
                                      this.state.businessData.location.longitude.toString(),
                                    '_blank'
                                  );
                                }}
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#000',
                                }}
                              >
                                {
                                  this.state.trackingDetails['restLocation'][
                                    'address'
                                  ]
                                }
                              </Typography>
                              {/* <>
                  {
                    (this.state.trackingDetails['userLocation']
                                                  ['addressNotes'] !=
                                              null &&
                                              this.state.trackingDetails['userLocation']
                                                  ['addressNotes'] !==
                                              '')? <Typography
                    style={{
                      fontSize: '15px',
                      fontWeight: 'normal',
                      color: '#6A6A6E',
                    }}
                  >

{this.state.trackingDetails['userLocation']['addressNotes']}
                  </Typography>:null
                  }
                  </> */}
                              <div style={{ padding: '5px 0px 0px' }}></div>
                            </Stack>
                          </div>
                        ) : null}
                      </>
                      <div style={{ padding: '0px 20px 0px' }}>
                        <Divider />
                      </div>
                      <div style={{ padding: '5px 0px 0px' }}></div>
                      <div style={{ padding: '5px 20px 5px' }}>
                        <Stack
                          direction={'column'}
                          spacing={0}
                          alignItems="flex-start"
                          justifyContent="flex-start"
                        >
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: 'bold',
                              color: '#6A6A6E',
                            }}
                          >
                            {strings['Método de pago']}
                          </Typography>
                          <>
                            {!this.state.trackingDetails['onlinePayment'] ? (
                              <Stack direction={'row'} spacing={0}>
                                <>
                                  {this.state.trackingDetails[
                                    'cardOnDelivery'
                                  ] != null &&
                                  this.state.trackingDetails[
                                    'cardOnDelivery'
                                  ] ? (
                                    <CreditCardIcon
                                      style={{
                                        fontWeight: 'normal',
                                        color: '#c96812',
                                      }}
                                    />
                                  ) : (
                                    <MoneyIcon
                                      style={{
                                        fontSize: '20px',
                                        fontWeight: 'normal',
                                        color: '#54bd66',
                                        marginTop: '2px',
                                      }}
                                    />
                                  )}
                                </>
                                <div style={{ padding: '0px 2.5px 0px' }}></div>
                                <>
                                  {this.state.trackingDetails[
                                    'cardOnDelivery'
                                  ] != null &&
                                  this.state.trackingDetails[
                                    'cardOnDelivery'
                                  ] ? (
                                    <>
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {strings['Tarjeta contra entrega']}
                                      </Typography>
                                    </>
                                  ) : (this.state.trackingDetails[
                                    'mobilePayment'
                                  ] != null &&
                                  this.state.trackingDetails[
                                    'mobilePayment'
                                  ] ? (
                                    <>
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {"Sinpe Móvil: 8787-1617 (mandar comprobante)"}
                                      </Typography>
                                    </>
                                  ) :  (this.state.trackingDetails[
                                    'cryptoPayment'
                                  ] != null &&
                                  this.state.trackingDetails[
                                    'cryptoPayment'
                                  ] ? (
                                    <>
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {strings['Pago con Criptomoneda']}
                                      </Typography>
                                    </>
                                  ) : (
                                    <>
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {strings['Efectivo']}
                                      </Typography>
                                    </>
                                  )))}
                                </>
                                <div style={{ padding: '0px 5.5px 0px' }}></div>
                                <Typography
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'normal',
                                    color: '#6A6A6E',
                                  }}
                                >
                                  {'¢' +
                                    (
                                      this.state.trackingDetails['grandTotal'] +
                                      (this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] != null &&
                                      this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] > 0
                                        ? this.state.trackingDetails[
                                            'changeAddressExtraCost'
                                          ] + 0.0
                                        : 0.0)
                                    ).toFixed(2)}
                                </Typography>
                              </Stack>
                            ) : null}
                          </>
                          <>
                            {this.state.trackingDetails['onlinePayment'] ? (
                              <Stack direction={'row'} spacing={0}>
                                <CreditCardIcon
                                  style={{
                                    fontWeight: 'normal',
                                    color: '#2c59a8',
                                  }}
                                />
                                <div style={{ padding: '0px 2.5px 0px' }}></div>
                                <Typography
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {strings['Tarjeta']}
                                </Typography>
                                <div style={{ padding: '0px 2.5px 0px' }}></div>
                                <Typography
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'normal',
                                    color: '#6A6A6E',
                                  }}
                                >
                                  {'¢' +
                                    (
                                      this.state.trackingDetails['grandTotal'] +
                                      (this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] != null &&
                                      this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] > 0
                                        ? this.state.trackingDetails[
                                            'changeAddressExtraCost'
                                          ] + 0.0
                                        : 0.0)
                                    ).toFixed(2)}
                                </Typography>
                              </Stack>
                            ) : null}
                          </>
                        </Stack>
                      </div>
                      <div style={{ padding: '5px 0px 0px' }}></div>
                      <div style={{ padding: '0px 20px 0px' }}>
                        <Divider />
                      </div>
                      <div style={{ padding: '5px 0px 0px' }}></div>
                      <div style={{ padding: '5px 20px 5px' }}>
                        <Stack
                          direction={'column'}
                          spacing={0}
                          alignItems="flex-start"
                          justifyContent="flex-start"
                        >
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: 'bold',
                              color: '#6A6A6E',
                            }}
                          >
                            {strings['Día y hora de su pedido']}
                          </Typography>
                          <Stack
                            direction={'row'}
                            spacing={0}
                            alignItems="center"
                          >
                            <AccessTimeFilledIcon
                              style={{
                                fontSize: '20px',
                                fontWeight: 'normal',
                                color: '#4b596a',
                              }}
                            />{' '}
                            <div style={{ padding: '0px 2.5px 0px' }}></div>
                            <Typography
                              style={{
                                fontSize: '16px',
                                fontWeight: 'bold',
                                color: '#000',
                              }}
                            >
                              {moment(this.state.trackingDetails['createdOn']
                                .toDate()).format('DD-MM-YYYY hh:mm a').toString()}
                              {/* {this.state.trackingDetails['createdOn']
                                .toDate()
                                .getDate()
                                .toString() +
                                '-' +
                                (
                                  this.state.trackingDetails['createdOn']
                                    .toDate()
                                    .getMonth() + 1
                                ).toString() +
                                '-' +
                                this.state.trackingDetails['createdOn']
                                  .toDate()
                                  .getFullYear()
                                  .toString() +
                                ' ' +
                                this.state.trackingDetails['createdOn']
                                  .toDate()
                                  .getHours()
                                  .toString() +
                                ':' +
                                this.state.trackingDetails['createdOn']
                                  .toDate()
                                  .getMinutes()
                                  .toString()} */}
                            </Typography>
                          </Stack>
                          <div style={{ padding: '5px 0px 0px' }}></div>
                        </Stack>
                      </div>
                      <div style={{ padding: '0px 20px 0px' }}>
                        <Divider />
                      </div>
                      <div style={{ padding: '5px 0px 0px' }}></div>
                      <>
                        {this.state.trackingDetails['showSpoonOption'] !=
                          null &&
                        this.state.trackingDetails['showSpoonOption'] ? (
                          <div style={{ padding: '5px 20px 5px' }}>
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="flex-start"
                              justifyContent="flex-start"
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#6A6A6E',
                                }}
                              >
                                {strings['Enviar cubiertos']}
                              </Typography>
                              <Stack
                                direction={'row'}
                                spacing={0}
                                alignItems="center"
                              >
                                <Typography
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {this.state.trackingDetails['giveSpoon'] !=
                                    null &&
                                  this.state.trackingDetails['giveSpoon']
                                    ? strings['Sí']
                                    : strings['No']}
                                </Typography>
                              </Stack>
                              <div style={{ padding: '5px 0px 0px' }}></div>
                            </Stack>
                          </div>
                        ) : null}
                      </>
                      <>
                        {this.state.trackingDetails['showSpoonOption'] !=
                          null &&
                        this.state.trackingDetails['showSpoonOption'] ? (
                          <div style={{ padding: '0px 20px 0px' }}>
                            <Divider />
                          </div>
                        ) : null}
                      </>
                      <>
                        {this.state.trackingDetails['showSpoonOption'] !=
                          null &&
                        this.state.trackingDetails['showSpoonOption'] ? (
                          <div style={{ padding: '5px 0px 0px' }}></div>
                        ) : null}
                      </>

                      <div style={{ padding: '5px 20px 5px', width: '100%' }}>
                        <Stack
                          direction={'column'}
                          spacing={0}
                          alignItems="flex-start"
                          justifyContent="flex-start"
                        >
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: 'bold',
                              color: '#6A6A6E',
                            }}
                          >
                            {strings['Detalles del pedido:']}
                          </Typography>
                          <List style={{ width: '100%' }}>
                            {this.state.trackingDetails['items'].map(
                              (customize, index) => (
                                <div
                                  style={{
                                    padding: '5px 0px 0px',
                                    width: '100%',
                                  }}
                                  key={index}
                                >
                                  <Stack
                                    direction={'row'}
                                    spacing={0}
                                    alignItems="flex-start"
                                    justifyContent="space-between"
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-start"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {this.state.trackingDetails['items'][
                                          index
                                        ]['quantity'].toString() +
                                          ' X ' +
                                          (this.state.trackingDetails['items'][
                                            index
                                          ]['nameEng'] != null
                                            ? this.state.trackingDetails[
                                                'items'
                                              ][index]['nameEng']
                                            : this.state.trackingDetails[
                                                'items'
                                              ][index]['name'])}
                                      </Typography>
                                      <div style={{ padding: '3px 0px 0px' }}>
                                        <List>
                                          {this.state.trackingDetails['items'][
                                            index
                                          ]['customize'].map((customize, t) => (
                                            <React.Fragment key={t}>
                                              {this.state.trackingDetails[
                                                'items'
                                              ][index]['customize'][t][
                                                'options'
                                              ].length > 0 ? (
                                                <Typography
                                                  style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'normal',
                                                    color: 'slategray',
                                                  }}
                                                >
                                                  {findTotalT(
                                                    index,
                                                    t,
                                                    this.state.trackingDetails
                                                  )}
                                                </Typography>
                                              ) : null}
                                            </React.Fragment>
                                          ))}
                                        </List>
                                      </div>
                                    </Stack>
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-end"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'normal',
                                          color: '#000',
                                        }}
                                      >
                                        {'¢' +
                                          Number(
                                            this.state.trackingDetails['items'][
                                              index
                                            ]['price'] *
                                              this.state.trackingDetails[
                                                'items'
                                              ][index]['quantity']
                                          )
                                            .toFixed(2)
                                            .toString()}
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                </div>
                              )
                            )}
                            {(this.state.trackingDetails['removedItems']==null && this.state.trackingDetails['selectedOffer']!=null && this.state.trackingDetails['selectedOffer']['id']!=null && this.state.trackingDetails['selectedOffer']['isFreeItem']!=null && this.state.trackingDetails['selectedOffer']['isFreeItem'])?
                            <div
                                  style={{
                                    padding: '5px 0px 0px',
                                    width: '100%',
                                  }}
                                  key={this.state.trackingDetails['items'].length}
                                >
                                  <Stack
                                    direction={'row'}
                                    spacing={0}
                                    alignItems="flex-start"
                                    justifyContent="space-between"
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-start"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {'1 X ' +
                                          (this.state.trackingDetails['selectedOffer']['freeItems'][0]
                                                      ['name'])}
                                      </Typography>
                                    </Stack>
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-end"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'normal',
                                          color: '#000',
                                        }}
                                      >
                                        {strings['Gratis']}
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                </div>:null}
                          </List>
                          <div style={{ padding: '10px 0px 0px' }}></div>
                          {/* <div style={{padding: "0px 20px 0px"}}>
                    <Divider />
                   </div> */}
                        </Stack>
                      </div>
                      <div style={{ padding: '0px 20px 0px' }}>
                        <Divider />
                      </div>
                      <div style={{ padding: '10px 0px 0px' }}></div>
                      <div style={{ padding: '5px 20px 5px', width: '100%' }}>
                        <Stack
                          direction={'column'}
                          spacing={0}
                          alignItems="flex-start"
                        >
                          <div style={{ width: '100%' }}>
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="flex-start"
                            >
                              <div
                                style={{
                                  padding: '0px 0px 5px',
                                  width: '100%',
                                }}
                              >
                                <Stack
                                  direction={'row'}
                                  spacing={0}
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Typography
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: 'normal',
                                      color: '#33343a',
                                    }}
                                  >
                                    {strings['Total parcial']}
                                  </Typography>
                                  <Typography
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: 'normal',
                                      color: '#33343a',
                                    }}
                                  >
                                    {'¢' +
                                      this.state.trackingDetails[
                                        'itemCost'
                                      ].toFixed(2)}
                                  </Typography>
                                </Stack>
                              </div>
                              <>
                                {this.state.trackingDetails['driverService'] !=
                                  null &&
                                this.state.trackingDetails['driverService'] >
                                  0 ? (
                                  <div
                                    style={{
                                      padding: '0px 0px 5px',
                                      width: '100%',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="space-between"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {strings['Tarifa de servicio']}
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {'¢' +
                                          this.state.trackingDetails[
                                            'driverService'
                                          ].toFixed(2)}
                                      </Typography>
                                    </Stack>
                                  </div>
                                ) : null}
                              </>
                              <>
                                {this.state.trackingDetails['deliveryCharge'] !=
                                  null &&
                                this.state.trackingDetails['deliveryCharge'] >
                                  0 ? (
                                  <div
                                    style={{
                                      padding: '0px 0px 5px',
                                      width: '100%',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="space-between"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {strings['Costo de envío']}
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {'¢' +
                                          (
                                            this.state.trackingDetails[
                                              'deliveryCharge'
                                            ] +
                                            (this.state.trackingDetails[
                                              'changeAddressExtraCost'
                                            ] != null &&
                                            this.state.trackingDetails[
                                              'changeAddressExtraCost'
                                            ] > 0
                                              ? this.state.trackingDetails[
                                                  'changeAddressExtraCost'
                                                ] + 0.0
                                              : 0.0)
                                          ).toFixed(2)}
                                      </Typography>
                                    </Stack>
                                  </div>
                                ) : null}
                              </>
                              <>
                                {this.state.trackingDetails['tip'] != null &&
                                this.state.trackingDetails['tip'] > 0 ? (
                                  <div
                                    style={{
                                      padding: '0px 0px 5px',
                                      width: '100%',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="space-between"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {strings['Propina']}
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {'¢' +
                                          this.state.trackingDetails[
                                            'tip'
                                          ].toFixed(2)}
                                      </Typography>
                                    </Stack>
                                  </div>
                                ) : null}
                              </>
                              <>
                                {this.state.trackingDetails[
                                  'dynamicDelivery'
                                ] != null &&
                                this.state.trackingDetails[
                                  'dynamicDelivery'
                                ] ? (
                                  <div
                                    style={{
                                      padding: '0px 0px 5px',
                                      width: '100%',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="flex-start"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {'(' +
                                          this.state.trackingDetails[
                                            'reasonDescription'
                                          ].toString() +
                                          ')'}
                                      </Typography>
                                    </Stack>
                                  </div>
                                ) : null}
                              </>
                              <>
                                {this.state.trackingDetails['offerValue'] !=
                                  null &&
                                this.state.trackingDetails['offerValue'] > 0 ? (
                                  <div
                                    style={{
                                      padding: '0px 0px 5px',
                                      width: '100%',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="space-between"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {strings['Descuento']}
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {'-¢' +
                                          this.state.trackingDetails[
                                            'offerValue'
                                          ].toFixed(2)}
                                      </Typography>
                                    </Stack>
                                  </div>
                                ) : null}
                              </>
                            </Stack>
                          </div>
                          <>
                            {this.state.trackingDetails['onlinePayment'] &&
                            ((this.state.trackingDetails['isOxxoEnabled'] !=
                              null &&
                              this.state.trackingDetails['isOxxoEnabled']) ||
                              (this.state.trackingDetails[
                                'changeAddressExtraCost'
                              ] != null &&
                                this.state.trackingDetails[
                                  'changeAddressExtraCost'
                                ] > 0)) ? (
                              <Stack
                                direction={'row'}
                                spacing={0}
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Typography
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {strings['Pagado con '] +
                                    (this.state.trackingDetails[
                                      'paypalPayment'
                                    ] != null &&
                                    this.state.trackingDetails['paypalPayment']
                                      ? 'paypal'
                                      : strings['tarjeta'])}
                                </Typography>
                                <Typography
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {'¢' +
                                    this.state.trackingDetails[
                                      'grandTotalWithoutOxxo'
                                    ].toFixed(2)}
                                </Typography>
                              </Stack>
                            ) : null}
                          </>
                          <>
                            {this.state.trackingDetails['onlinePayment'] &&
                            ((this.state.trackingDetails['isOxxoEnabled'] !=
                              null &&
                              this.state.trackingDetails['isOxxoEnabled']) ||
                              (this.state.trackingDetails[
                                'changeAddressExtraCost'
                              ] != null &&
                                this.state.trackingDetails[
                                  'changeAddressExtraCost'
                                ] > 0)) ? (
                              <Stack
                                direction={'row'}
                                spacing={0}
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Typography
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {strings['Pagar en efectivo']}
                                </Typography>
                                <Typography
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {'¢' +
                                    (
                                      this.state.trackingDetails['grandTotal'] -
                                      this.state.trackingDetails[
                                        'grandTotalWithoutOxxo'
                                      ] +
                                      (this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] != null &&
                                      this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] > 0
                                        ? this.state.trackingDetails[
                                            'changeAddressExtraCost'
                                          ] + 0.0
                                        : 0.0)
                                    ).toFixed(2)}
                                </Typography>
                              </Stack>
                            ) : null}
                          </>
                          <>
                            {true ? (
                              <div style={{ width: '100%' }}>
                                <Stack
                                  direction={'row'}
                                  spacing={0}
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Typography
                                    style={{
                                      fontSize: '18px',
                                      fontWeight: 'bold',
                                      color: '#2c3136',
                                      marginTop: '20px',
                                    }}
                                  >
                                    {strings['Total']}
                                  </Typography>
                                  <Typography
                                    style={{
                                      fontSize: '18px',
                                      fontWeight: 'bold',
                                      color: '#2c3136',
                                      marginTop: '20px',
                                    }}
                                  >
                                    {'¢' +
                                      (
                                        this.state.trackingDetails[
                                          'grandTotal'
                                        ] +
                                        (this.state.trackingDetails[
                                          'changeAddressExtraCost'
                                        ] != null &&
                                        this.state.trackingDetails[
                                          'changeAddressExtraCost'
                                        ] > 0
                                          ? this.state.trackingDetails[
                                              'changeAddressExtraCost'
                                            ] + 0.0
                                          : 0.0)
                                      ).toFixed(2)}
                                  </Typography>
                                </Stack>
                              </div>
                            ) : null}
                          </>
                        </Stack>
                      </div>
                      <div
                        style={{
                          padding: isIOS ? '120px 0px 0px' : '65px 0px 0px',
                        }}
                      ></div>
                    </Stack>
                  ) : null}
                </>
                {/* </div> */}
              </Stack>
            </Container>
          }
        ></TrackDialog>

        <Backdrop
          onClick={() => {}}
          style={{
            color: '#fff',
            zIndex: 9999,
            maxHeight: isIOS ? 'calc((var(--vh, 1vh) * 100))' : '100vh',
            height: isIOS ? 'calc((var(--vh, 1vh) * 100))' : '100vh',
          }}
          open={false}
        >
          <React.Fragment>
            <CssBaseline />
          </React.Fragment>
        </Backdrop>
      </>
    ) : (
      <>
        <div id="loading_indicator" className="container">
          <img
            style={{ width: this.state.width < 1000 ? '28vw' : '12vw' }}
            src={logo}
            alt="loading"
          />
        </div>
      </>
    );
  }
}

class ProfilePage extends React.Component {
  constructor(props, context) {
    super(props, context);
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        const uid = user.uid;
        // console.log('signed', user);
        const menuDoc = doc(db, 'users', uid);

        const docMenuSn = onSnapshot(menuDoc, async (docMenuSnap) => {
          if (docMenuSnap.data()) {
            if (docMenuSnap.data().phoneNumberVerified) {
              this.setState({ loading: false, openLogin: false });
              this.setState({
                userId: uid,
                email: docMenuSnap.data().email,
                displayName: docMenuSnap.data().fullName ? docMenuSnap.data().fullName : '',
                userDetails: docMenuSnap.data(),
                photoURL: docMenuSnap.data().avatar,
                imageAsUrl: docMenuSnap.data().avatar,
                cards: docMenuSnap.data().cards ? docMenuSnap.data().cards : [],
                offersUsed: docMenuSnap.data().offersUsed
                  ? docMenuSnap.data().offersUsed
                  : [],
              });
            } else {
              if(!this.state.hasSendOTP) {
              this.setState({hasSendOTP: true});
              const min = 0;
              const max = 999999;
              const rand = Math.floor(min + Math.random() * (max - min));
              var dataSend = rand.toString();
              for (var i = 0; i < 6; i++) {
                if (dataSend.length < 6) {
                  dataSend = '0' + dataSend;
                }
              }
              // console.log(dataSend);
              this.setState({ otpSend: dataSend });
              await axios
                .post('https://lemon-order.herokuapp.com/drivers/create-otp/', {
                  code: dataSend,
                  number: docMenuSnap.data().phoneNumber,
                })
                .then(async (response) => {
                  // console.log(response);
                });
              }
                this.setState({
                  userId: uid,
                  email: docMenuSnap.data().email,
                  displayName: docMenuSnap.data().fullName ? docMenuSnap.data().fullName : '',
                  userDetails: docMenuSnap.data(),
                  photoURL: docMenuSnap.data().avatar,
                  imageAsUrl: docMenuSnap.data().avatar,
                  cards: docMenuSnap.data().cards ? docMenuSnap.data().cards : [],
                  offersUsed: docMenuSnap.data().offersUsed
                    ? docMenuSnap.data().offersUsed
                    : [],
                });
              this.setState({
                openOTP: true,
                phoneNumber: docMenuSnap.data().phoneNumber,
                phoneCountry: '+507',
                showPassword: false,
              });
            }
          } else {
            if (this.state.openLogin) {
              this.setState({
                openAlert: true,
                alertType: 'error',
                alertMsg: strings['Error de inicio de sesión'],
              });
            }
            if (!this.state.openRegister) {
              this.setState({ loading: false });
              this.setState({ userId: null, userDetails: null, cards: [] });
              auth.signOut();
            }
          }
        });
      } else {
        console.log('Login Here');
        this.setState({ userId: null, userDetails: null, cards: [] });
        signInWithEmailAndPassword(
          auth,
          'ordernar@golemon.express',
          'demo1234'
        )
          .then((userCredential) => {
            // Signed in
            console.log('signing', userCredential);
            const user = userCredential.user;
            const uid = user.uid;

            // this.setState({ userId: uid });
            // ...
          })
          .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            this.setState({
              openAlert: true,
              alertType: 'error',
              alertMsg: strings['No puedo iniciar sesión, actualice la página'],
            });
            console.log(errorMessage, errorCode);
          });
      }
    });
    this.state = {
      orders: [],
      busId: '',
      alertMsg: '',
      openOTP: false,
      openAlert: false,
      alertType: 'error',
      anchorEl: null,
      open: false,
      openLocation: false,
      openLogin: false,
      hasSendOTP: false,
      password: '',
      email: '',
      displayName: '',
      phoneNumber: '',
      phoneCountry: '+507',
      showPassword: false,
      userId: null,
      selectedValue: emails[1],
      selectedLocationName: '',
      selectedLocationNotes: '',
      currentLocation: {
        latitude: 0,
        longitude: 0,
      },
      currentAddress: '',
      selectedLocationData: '',
      selectedLocationId: '',
      selectedLocation: {
        latitude: 0,
        longitude: 0,
      },
      addresses: [],
      defaultCountry: 'PA',
      selectedLocationDetails: {},
      defaultProps: {
        center: {
          lat: 10.99835602,
          lng: 77.01502627,
        },
        zoom: 16,
      },
      userDetails: null,
      width: 0,
      height: 0,
      selectedDate: new Date(),
      selectedWeekDay: new Date().getDay(),
      showMap: false,
      userDetailsUpdated: false,
      photoURL: '',
      isPasswordChange: false,
      imageAsFile: '',
      imageAsUrl: '',
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentWillMount() {
    var locationData = JSON.parse(localStorage.getItem('location'));
    if (locationData == null) {
      locationData = [];
    }
    for (var i = 0; i < locationData.length; i++) {
      if (locationData[i]['selected']) {
        this.setState({
          selectLocationName: locationData[i]['geoAddress'],
        });
        // console.log(locationData[i]);
        break;
      }
    }
    const { id } = this.props.match.params;
    this.setState({ selectedAddress: selected, busId: id }, (newState) => {
      // console.log(
      //   'locationData',
      //   this.state.addresses,
      //   typeof this.state.addresses
      // );
    });
    var selected = JSON.parse(localStorage.getItem('selected'));
    if (selected == null) {
      selected = { latitude: 0, longitude: 0 };
    }
    this.setState({ selectedAddress: selected }, (newState) => {
      // console.log(
      //   'selectedAddress',
      //   this.state.selectedAddress,
      //   typeof this.state.selectedAddress
      // );
    });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    this.setState({isMounted: true});
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    this.setState({isMounted: false});
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  handleChange(e) {
    var menuD = this.state.menuData.map(item => ({...item}));
    for (var i = 0; i < menuD.length; i++) {
      menuD[i]['products'] = menuD[i]['products'].filter(
        (val) =>
          typeof val.name === 'string' &&
          val.name.toLowerCase().includes(e.target.value.toLowerCase())
      );
      // console.log(
      //   'handle change called',
      //   e.target.value,
      //   i,
      //   menuD[i]['products'].length
      // );
    }
    this.setState({ menu: menuD });
  }
  render() {
    const openAlert = (alertType, alertMsg) => {
      this.setState({
        openAlert: true,
        alertType: alertType,
        alertMsg: alertMsg,
      });
    };

    const handleImageAsFile = (e) => {
      if (e.target.files) {
        const image = e.target.files[0];
        this.setState({
          userDetailsUpdated: true,
          imageAsFile: image,
          imageAsUrl: URL.createObjectURL(image),
        });
      }
    };

    const handleFireBaseUpload = async () => {
      let downloadURL = null;
      if (this.state.imageAsFile === '') {
        console.error(
          `not an image, the image file is a ${typeof this.state.imageAsFile}`
        );
      }

      const storageRef = ref(
        storage,
        `/images/users/${this.state.userId}/avatar`
      );
      await uploadBytes(storageRef, this.state.imageAsFile)
        .then(async (response) => {
          await getDownloadURL(storageRef).then((url) => {
            downloadURL = url;
            this.setState({ ...this.state, imageAsUrl: url, photoURL: url });
          });
        })
        .catch((error) => {
          console.log('error', error);
        });
      return downloadURL;
    };

    const isMenuOpen = Boolean(this.state.anchorEl);
    const isMobileMenuOpen = Boolean(this.state.mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event) => {
      // setAnchorEl(event.currentTarget);
      this.setState({ anchorEl: event.currentTarget });
      // this.state.anchorEl = event.currentTarget;
    };

    const handleMobileMenuClose = () => {
      // setMobileMoreAnchorEl(null);
      this.setState({ mobileMoreAnchorEl: null });
    };

    const handleMenuClose = () => {
      this.setState({ anchorEl: null });
      handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
      this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
      <>
        <Menu
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          id={menuId}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={isMenuOpen}
          onClose={handleMenuClose}
        >
          {this.state.userDetails && (
            <>
              <MenuItem
                onClick={async () => {
                  handleMenuClose();
                }}
              >
                <Link
                  to={'/profile/'+this.state.busId}
                  style={{
                    color: '#444444',
                    textDecoration: 'none',
                    width: '100%',
                  }}
                >
                  {strings["Perfil"]}
                </Link>
              </MenuItem>
            </>
          )}
          <MenuItem
            onClick={async () => {
              handleMenuClose();
              await auth.signOut();
            }}
          >
            {strings["Cerrar sesión"]}
          </MenuItem>
        </Menu>
      </>
    );

    const handleCloseLogin = () => {
      this.setState({
        openLogin: false,
        showPassword: false,
      });
    };

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
      <Menu
        anchorEl={this.state.mobileMoreAnchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        id={mobileMenuId}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
      >
        <MenuItem onClick={handleProfileMenuOpen}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
          >
            {this.state.photoURL ? (
              <img
                style={{
                  verticalAlign: 'middle',
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                }}
                src={this.state.photoURL}
              />
            ) : (
              <AccountCircle />
            )}
          </IconButton>
          <p>{strings['Perfil']}</p>
        </MenuItem>
      </Menu>
    );

    return this.state.userDetails ? (
      <>
        {/* Menu Start */}

        <Snackbar
        style={{zIndex: 9999999}}
          open={this.state.openAlert}
          autoHideDuration={6000}
          onClose={(event, reason) => {
            if (reason === 'clickaway') {
              return;
            }
            this.setState({ openAlert: false });
          }}
        >
          <Alert
            onClose={(event, reason) => {
              if (reason === 'clickaway') {
                return;
              }

              this.setState({ openAlert: false });
            }}
            severity={this.state.alertType}
            sx={{ width: '100%' }}
          >
            {this.state.alertMsg}
          </Alert>
        </Snackbar>

        <Box sx={{ flexGrow: 1 }}>
          <AppBar
            position="sticky"
            color="transparent"
            elevation={1}
            style={{
              boxShadow:
                '0px 2px 1px -1px rgb(0 0 0 / 2%), 0px 1px 1px 0px rgb(0 0 0 / 2%), 0px 1px 3px 0px rgb(0 0 0 / 2%)',
            }}
          >
            <Toolbar>
              <Button
                style={{
                  margin: '1px',
                  backgroundColor: '#fff',
                  textTransform: 'none',
                  borderRight: '0px solid #cccccc',
                  padding: '5px 15px 5px 5px',
                  fontSize: '14px',
                  borderRadius: '6px',
                  color: '#2e2c36',
                }}
                variant="text"
                startIcon={
                  <ArrowBackIcon color={'primary'} fontSize={'25px'} />
                }
                onClick={() => window.history.back()}
              >
                {strings["Regresar"]}
              </Button>{' '}
              <Box sx={{ flexGrow: 1 }} />
              <Box
                sx={{ display: { xs: 'flex', md: 'flex' } }}
                style={{
                  margin: '1px',
                  borderLeft: '0px solid #cccccc',
                  color: '#44cf8e',
                }}
              >
                <IconButton
                  size="large"
                  edge="end"
                  aria-label="account of current user"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  color="inherit"
                >
                  {this.state.photoURL ? (
                    <img
                      style={{
                        verticalAlign: 'middle',
                        width: '30px',
                        height: '30px',
                        borderRadius: '50%',
                      }}
                      src={this.state.photoURL}
                    />
                  ) : (
                    <AccountCircle />
                  )}
                </IconButton>
              </Box>
              <Box sx={{ display: { xs: 'none', md: 'none' } }}>
                <IconButton
                  size="large"
                  aria-label="show more"
                  aria-controls={mobileMenuId}
                  aria-haspopup="true"
                  onClick={handleMobileMenuOpen}
                  color="inherit"
                >
                  <MoreIcon />
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
          {renderMobileMenu}
          {renderMenu}
        </Box>

        {/* Menu End */}

        {/* Container Start */}
        <div
          style={{
            width: '70vw',
            height: this.state.width > 500 ? '53vh' : '70vh',
            margin: 'auto',
            backgroundColor: '#fff',
            boxShadow: '0px 4px 10px #64717a42',
            padding: '12px 6px 12px',
            borderRadius: 20,
            marginTop: 25,
          }}
        >
          <div
            className="profile-pic"
            style={{
              paddingTop: 10,
              textAlign: 'center',
              width: '170px',
              margin: 'auto',
            }}
          >
            <input
              id="car"
              type="file"
              accept="image/*"
              capture="camera"
              style={{
                width: '1px',
                height: '1px',
                opacity: '0',
                position: 'absolute',
                overflow: 'hidden',
                zIndex: '-1',
              }}
              onChange={(e) => handleImageAsFile(e)}
            />
            <div
              style={{
                backgroundImage: `url(${
                  this.state?.imageAsUrl
                    ? this.state?.imageAsUrl
                    : require('./assets/default-user.png')
                })`,
                position: 'relative',
                width: '20vh',
                height: '20vh',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                border: '1px solid #e6ebf1',
                borderRadius: 20,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {!this.data && !this.loading && (
                <label
                  htmlFor="car"
                  style={{
                    marginBottom: '60%',
                    marginLeft: '75%',
                    fontSize: 0,
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    backgroundColor: '#44cf8e',
                    borderRadius: 7,
                  }}
                >
                  <EditIcon
                    style={{
                      color: '#fff',
                      border: '2px solid #fff',
                      borderRadius: 7,
                    }}
                  />
                </label>
              )}
            </div>
            {/* <img style={{width: this.state.width < 1000? "40vw":"15vw"}} src={this.state.userDetails?.photoURL ? this.state.userDetails?.photoURL : require('./assets/default-user.png')} alt="Profile" /> */}
          </div>

          <div className="profile-form">
            <DialogContent>
              <div
                style={{
                  display: 'flex',
                  flexDirection: this.state.width > 420 ? 'row' : 'column',
                }}
              >
                <TextField
                  style={{
                    color: '#272727',
                    borderRadius: '9px',
                    backgroundColor: '#e6ebf1',
                    overflow: 'hidden',
                    width: this.state.width > 420 ? '50%' : '100%',
                    marginRight: 10,
                  }}
                  error={this.state.displayName?.length < 3}
                  label={strings["Nombre"]}
                  variant="filled"
                  value={this.state.displayName}
                  onChange={(event) => {
                    this.setState({
                      displayName: event.target.value,
                      userDetailsUpdated: true,
                    });
                  }}
                />
                <br />
                <TextField
                disabled={true}
                  style={{
                    color: '#272727',
                    borderRadius: '9px',
                    backgroundColor: '#e6ebf1',
                    overflow: 'hidden',
                    width: this.state.width > 420 ? '50%' : '100%',
                  }}
                  error={
                    !validator.isEmail(this.state.email) &&
                    this.state.email.length > 0
                  }
                  id="filled-basic"
                  label={strings["Email"]}
                  variant="filled"
                  value={this.state.email}
                  onChange={(event) => {
                    // this.setState({
                    //   email: event.target.value,
                    //   userDetailsUpdated: true,
                    // });
                  }}
                />
                <br />
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginTop: this.state.width > 420 ? 10 : 0,
                }}
              >
                <FormControl
                  fullWidth
                  variant="filled"
                  style={{
                    color: '#272727',
                    borderRadius: '9px',
                    backgroundColor: '#e6ebf1',
                    overflow: 'hidden',
                    width: this.state.width > 420 ? '50%' : '100%',
                    marginRight: this.state.width > 420 ? '50.5%' : 0,
                  }}
                >
                  <InputLabel
                    error={
                      this.state.password.length <= 6 &&
                      this.state.password.length > 0
                    }
                    htmlFor="filled-adornment-password"
                  >
                    {strings["Contraseña"]}
                  </InputLabel>
                  <FilledInput
                    error={
                      this.state.password.length <= 6 &&
                      this.state.password.length > 0
                    }
                    id="filled-adornment-password"
                    type={this.state.showPassword ? 'text' : 'password'}
                    value={this.state.password}
                    onChange={(event) => {
                      this.setState({
                        password: event.target.value,
                        userDetailsUpdated: true,
                        isPasswordChange: true,
                      });
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          style={{ color: '#b3b9c2' }}
                          aria-label="toggle password visibility"
                          onClick={() => {
                            this.setState({
                              showPassword: !this.state.showPassword,
                            });
                          }}
                          onMouseDown={(event) => {
                            event.preventDefault();
                          }}
                          edge="end"
                        >
                          {this.state.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <br />
                <br />
              </div>
              {this.state.userDetailsUpdated && (
                <Button
                  disabled={!this.state.userDetailsUpdated}
                  style={{ float: 'right', marginTop: 20, color: '#ffffff' }}
                  variant="contained"
                  onClick={async () => {
                    let flag = true;
                    let shouldLoginAgain = false;
                    if (
                      validator.isEmail(this.state.email) &&
                      this.state.displayName?.length >= 3 &&
                      auth.currentUser
                    ) {
                      this.setState({ loading: true });
                      if (this.state.imageAsFile) {
                        const url = await handleFireBaseUpload();
                        this.state.imageAsUrl = url;
                      }

                      await updateDoc(doc(db, 'users', this.state.userId), {
                        fullName:this.state.displayName,
                        avatar:this.state.imageAsUrl
            })
                        .then((result) => {
                          this.setState({ loading: false });
                        })
                        .catch((error) => {
                          const errorCode = error.code;
                          const errorMessage = error.message;
                          this.setState({ loading: false });
                          console.log(errorMessage, errorCode);
                          flag = false;
                        });
                      if (this.state.isPasswordChange) {
                        await updatePassword(
                          auth.currentUser,
                          this.state.password
                        )
                          .then((res) => {
                            console.log('Result after updating password', res);
                          })
                          .catch((error) => {
                            console.log(
                              'error while updating password',
                              error.code
                            );
                            if (error.code === 'auth/requires-recent-login') {
                              shouldLoginAgain = true;
                            }
                            flag = false;
                          });
                      }
                      if (flag) {
                        openAlert(
                          'success',
                          strings['Perfil actualizado correctamente']
                        );
                      } else if (shouldLoginAgain) {
                        this.setState({ openLogin: true });
                        openAlert(
                          'error',
                          strings['Por favor ingresa de nuevo para actualizar tu contraseña']
                        );
                      } else {
                        openAlert('error', strings["Algo salió mal"]);
                      }
                    }
                  }}
                >
                  {strings["Actualizar Perfil"]}
                </Button>
              )}
              <br />
            </DialogContent>
          </div>
        </div>
        {/* Container End */}

        {/* Start Loading Indicator */}
        <Backdrop
          onClick={() => {}}
          style={{ color: '#fff', zIndex: 9999999 }}
          open={this.state.loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        {/* End Loading Indicator */}

        {/* Start Dialogs (Modals) */}

        <LoginDialog
          selectedValue={this.state.selectedValue}
          open={this.state.openLogin}
          onClose={handleCloseLogin}
          displayList={
            <DialogContent dividers>
              <TextField
                style={{
                  color: '#272727',
                  borderRadius: '9px',
                  backgroundColor: '#e6ebf1',
                  overflow: 'hidden',
                }}
                error={
                  !validator.isEmail(this.state.email) &&
                  this.state.email.length > 0
                }
                fullWidth
                id="filled-basic"
                label={strings["Email"]}
                variant="filled"
                value={this.state.email}
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
              />
              <br />
              <br />
              <FormControl
                fullWidth
                variant="filled"
                style={{
                  color: '#272727',
                  borderRadius: '9px',
                  backgroundColor: '#e6ebf1',
                  overflow: 'hidden',
                }}
              >
                <InputLabel
                  error={
                    this.state.password.length <= 6 &&
                    this.state.password.length > 0
                  }
                  htmlFor="filled-adornment-password"
                >
                  {strings["Contraseña"]}
                </InputLabel>
                <FilledInput
                  error={
                    this.state.password.length <= 6 &&
                    this.state.password.length > 0
                  }
                  id="filled-adornment-password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  value={this.state.password}
                  onChange={(event) => {
                    this.setState({ password: event.target.value });
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        style={{ color: '#b3b9c2' }}
                        aria-label="toggle password visibility"
                        onClick={() => {
                          this.setState({
                            showPassword: !this.state.showPassword,
                          });
                        }}
                        onMouseDown={(event) => {
                          event.preventDefault();
                        }}
                        edge="end"
                      >
                        {this.state.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <br />
              <br />
              <Button
                fullWidth
                variant="contained"
                onClick={async () => {
                  if (
                    validator.isEmail(this.state.email) &&
                    this.state.password.length >= 6
                  ) {
                    this.setState({ loading: true });
                    signInWithEmailAndPassword(
                      auth,
                      this.state.email,
                      this.state.password
                    )
                      .then((userCredential) => {
                        // Signed in
                        this.setState({ loading: false, openLogin: false });
                        openAlert(
                          'success',
                          strings['Ahora puedes cambiar tu contraseña']
                        );
                      })
                      .catch((error) => {
                        const errorCode = error.code;
                        const errorMessage = error.message;
                        this.setState({ loading: false });
                        openAlert('error', strings['No puedo iniciar sesión']);
                        console.log(errorMessage, errorCode);
                      });
                  }
                }}
              >
                {strings["Iniciar sesión"]}
              </Button>
              <br />
            </DialogContent>
          }
        />
        {/* End Dialogs (Modals) */}
      </>
    ) : (
      <>
        <div id="loading_indicator" className="container">
          <img
            style={{ width: this.state.width < 1000 ? '40vw' : '15vw' }}
            src={logo}
            alt="loading"
          />
        </div>
      </>
    );
  }
}

class OrdersPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        const uid = user.uid;
        console.log('signed', user);
        const menuDoc = doc(db, 'users', uid);
        this.setState({
          orders: [],
        });
        var orders = [];
        const { id } = this.props.match.params;
        const q = query(
          collection(db, 'orders'),
          where('userId', '==', uid),
          where('restId', '==', id),
          orderBy('createdOn', 'desc')
        );
        await onSnapshot(q, async (data) => {
          this.setState({
            orders: [],
          });
          if (data.docs.length <= 0 && this.state.trackingId) {
            this.setState({
              showTracking: false,
              trackingDetails: null,
              trackingId: null,
            });
          }
          data.docs.forEach(async (document) => {
            orders = orders.filter((element) => element.id !== document.id);
            if (
              this.state.trackingId &&
              this.state.trackingId === document.id
            ) {
              await this.setState({ trackingDetails: document.data() });
            }
            orders.push(document);
            await this.setState({ orders: orders });
            console.log('orders', orders);
          });
        });

        const docMenuSn = onSnapshot(menuDoc, async (docMenuSnap) => {
          if (docMenuSnap.data()) {
            if (docMenuSnap.data().phoneNumberVerified) {
              if (this.state.openLogin) {
                this.setState({ loading: false, openLogin: false });
                this.setState({
                  openAlert: true,
                  alertType: 'success',
                  alertMsg: strings['Inicio de sesión exitoso'],
                });
              }
              this.setState({
                userId: uid,
                userDetails: docMenuSnap.data(),
                photoURL: user.photoURL,
                cards: docMenuSnap.data().cards ? docMenuSnap.data().cards : [],
                offersUsed: docMenuSnap.data().offersUsed
                  ? docMenuSnap.data().offersUsed
                  : [],
              });
            } else {
              const min = 0;
              const max = 999999;
              const rand = Math.floor(min + Math.random() * (max - min));
              var dataSend = rand.toString();
              for (var i = 0; i < 6; i++) {
                if (dataSend.length < 6) {
                  dataSend = '0' + dataSend;
                }
              }
              console.log(dataSend);
              this.setState({ otpSend: dataSend });
              await axios
                .post('https://lemon-order.herokuapp.com/drivers/create-otp/', {
                  code: dataSend,
                  number: docMenuSnap.data().phoneNumber,
                })
                .then(async (response) => {
                  console.log(response);
                });
              this.setState({
                userId: uid,
                userDetails: docMenuSnap.data(),
                photoURL: user.photoURL,
                cards: docMenuSnap.data().cards ? docMenuSnap.data().cards : [],
              });
              this.setState({
                openOTP: true,
                phoneNumber: docMenuSnap.data().phoneNumber,
                phoneCountry: '+507',
                showPassword: false,
              });
            }
          } else {
            // console.log('openlogin',this.setState.openLogin);
            if (this.state.openLogin) {
              this.setState({
                openAlert: true,
                alertType: 'error',
                alertMsg: strings['Error de inicio de sesión'],
              });
            }
            if (!this.state.openRegister) {
              this.setState({ loading: false });
              this.setState({ userId: null, userDetails: null, cards: [] });
              auth.signOut();
            }
          }
        });
        // ...
      } else {
        console.log('Login Here');
        this.setState({ userId: null, userDetails: null, cards: [] });
        signInWithEmailAndPassword(
          auth,
          'ordernar@golemon.express',
          'demo1234'
        )
          .then((userCredential) => {
            // Signed in
            console.log('signing', userCredential);
            const user = userCredential.user;
            const uid = user.uid;

            // this.setState({ userId: uid });
            // ...
          })
          .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            this.setState({
              openAlert: true,
              alertType: 'error',
              alertMsg: strings['No puedo iniciar sesión, actualice la página'],
            });
            console.log(errorMessage, errorCode);
          });
      }
    });
    this.state = {
      orders: [],
      alertMsg: '',
      busId: '',
      selectLocationName: null,
      canDeliverHere: false,
      openAlert: false,
      showCart: false,
      additionalInfoAdded: false,
      showTracking: false,
      trackingDetails: null,
      toggleDetails: false,
      trackingId: null,
      showDiscount: false,
      showPayment: false,
      alertType: 'error',
      anchorEl: null,
      open: false,
      openLocation: false,
      openPreOrder: false,
      openLogin: false,
      openBusinessInfo: false,
      password: '',
      email: '',
      fullName: '',
      tempOrder: {},
      productIds: [],
      otp: '',
      otpSend: '',
      phoneNumber: '',
      phoneCountry: '+507',
      showPassword: false,
      openRegister: false,
      openOTP: false,
      openVariable: false,
      selectedProduct: null,
      userId: null,
      selectedValue: emails[1],
      selectedLocationName: '',
      selectedLocationNotes: '',
      currentLocation: {
        latitude: 0,
        longitude: 0,
      },
      currentAddress: '',
      selectedLocationData: '',
      selectedLocationId: '',
      selectedLocation: {
        latitude: 0,
        longitude: 0,
      },
      businessData: null,
      locOptions: [],
      offers: [],
      offers2: [],
      addresses: [],
      defaultCountry: 'PA',
      selectedLocationDetails: {},
      cards: [],
      loading: false,
      offersUsed: [],
      cart: {
        restId: '',
        restName: '',
        restLogo: '',
        maxTime: 0,
        totalCost: 0,
        totalItems: 0,
        item: [],
        totalOxxoCost: 0,
        totalOxxoItems: 0,
        oxxoNameData: '',
        oxxoLogoImage: '',
        oxxoItem: [],
      },
      delivery: 0,
      selectedMenuIndex: 0,
      menuProductItems: [],
      selectedType: 0,
      hasClickedLoc: false,
      autoLoc: '',
      offerDetails: {},
      onlyPickup: false,
      storeIsOpen: false,
      deliveryFee: 0,
      dynamicFeeType: 0,
      selectLocationData: {
        id: '',
        name: '',
        address: '',
        geoAddress: '',
        addressNotes: '',
        latitude: 10.99835602,
        longitude: 77.01502627,
      },
      cookingInstructions: '',
      spoon: false,
      selectedAddress: {
        latitude: 0,
        longitude: 0,
      },
      defaultProps: {
        center: {
          lat: 10.99835602,
          lng: 77.01502627,
        },
        zoom: 16,
      },
      mobileMoreAnchorEl: null,
      menuData: [],
      menu: [],
      userDetails: null,
      width: 0,
      height: 0,
      showAddressModal: false,
      selectedDate: new Date(),
      selectedWeekDay: new Date().getDay(),
      isStore: false,
      order: {
        offerCode: '',
        offerId: '',
        offerValue: 0,
        cashbackValue: 0,
        offerCode2: '',
        offerId2: '',
        offerValue2: 0,
        restId: '',
        restName: '',
        restLogo: '',
        maxTime: 0,
        itemCost: 0,
        deliveryCharge: 0,
        usageFee: 0,
        taxes: 0,
        serviceFee: 0,
        grandTotal: 0,
        items: [],
      },
      offerCode: '',
      offerId: '',
      offerSuccess: '',
      offerErrorText: '',
      offerValue: 0,
      cashbackValue: 0,
      offerInd: null,
      isOfferApplied: false,
      isOfferError: false,
      isFreeDelivery: false,
      deliveryInstructions: '',
      defaultCard: null,
      toggleDelivery: true,
      tipPercent: 0,
      dynamicDelivery: false,
      additionalDelivery: 0,
      normalDelivery: 0,
      additionalDeliveryPercentage2: 0,
      reasonTitle: '',
      reasonDescription: '',
      isStore2: false,
      showMap: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentWillMount() {
    var locationData = JSON.parse(localStorage.getItem('location'));
    if (locationData == null) {
      locationData = [];
    }
    for (var i = 0; i < locationData.length; i++) {
      if (locationData[i]['selected']) {
        this.setState({
          selectLocationName: locationData[i]['geoAddress'],
        });
        console.log(locationData[i]);
        break;
      }
    }
    this.setState({ addresses: locationData }, (newState) => {
      console.log(
        'locationData',
        this.state.addresses,
        typeof this.state.addresses
      );
    });
    var selected = JSON.parse(localStorage.getItem('selected'));
    if (selected == null) {
      selected = { latitude: 0, longitude: 0 };
    }
    const { id } = this.props.match.params;
    this.setState({ selectedAddress: selected, busId: id }, (newState) => {
      console.log(
        'selectedAddress',
        this.state.selectedAddress,
        typeof this.state.selectedAddress
      );
    });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  handleChange(e) {
    var menuD = this.state.menuData.map(item => ({...item}));
    for (var i = 0; i < menuD.length; i++) {
      menuD[i]['products'] = menuD[i]['products'].filter(
        (val) =>
          typeof val.name === 'string' &&
          val.name.toLowerCase().includes(e.target.value.toLowerCase())
      );
      console.log(
        'handle change called',
        e.target.value,
        i,
        menuD[i]['products'].length
      );
    }
    this.setState({ menu: menuD });
  }
  render() {
    const getStat = (order) => {
      var update = '';
      if (!order['acceptedByRest']) {
        update = strings['Esperando a que el negocio acepte su pedido'];
      }
      if (order['acceptedByRest'] && !order['readyToBePicked']) {
        update = strings['El negocio está preparando su producto.'];
      }
      // if (order['acceptedByRest'] && order['readyToBePicked']) {
      //   update = 'Orden lista para recolección ';
      // }
      if (
        order['driverAssigned'] &&
        !order['driverReached'] &&
        !order['orderPickedUp']
      ) {
        update =
          order['driverName'].split(' ')[0] +
          strings[' está en camino para recoger su pedido'];
      }
      if (
        order['driverAssigned'] &&
        order['driverReached'] &&
        !order['orderPickedUp']
      ) {
        update = order['driverName'].split(' ')[0] + strings[' llegó al negocio'];
      }

      if (order['orderPickedUp']) {
        update = order['driverName'].split(' ')[0] + strings[' ha recogido tu pedido'];
      }
      if (order['delivered'] && !order['cancelled']) {
        update = strings['Su orden ha sido completada'];
      }
      if (order['delivered'] && order['cancelled']) {
        update = strings['Su pedido ha sido cancelado'];
      }
      return update;
    };

    const handleTrackingOpen = (orderDetails, id) => {
      this.setState({
        showTracking: true,
        trackingDetails: orderDetails,
        trackingId: id,
      });
      window.history.pushState(null, '', window.location.href);

      window.onpopstate = () => {
        window.onpopstate = () => {};
        window.history.back();
        this.setState({
          showTracking: false,
          trackingDetails: null,
          trackingId: null,
        });
      };
    };
    console.log('asdasd', this.state.trackingDetails);

    const findTotalT = (id, i, order) => {
      var total1 =
        (order['items'][id]['customize'][i]['nameEng'] != null
          ? order['items'][id]['customize'][i]['nameEng']
          : order['items'][id]['customize'][i]['name']) + ': ';
      for (
        var j = 0;
        j < order['items'][id]['customize'][i]['options'].length;
        j++
      ) {
        if (j === 0) {
          total1 =
            total1 +
            (order['items'][id]['customize'][i]['options'][j]['nameEng'] != null
              ? order['items'][id]['customize'][i]['options'][j]['nameEng']
              : order['items'][id]['customize'][i]['options'][j]['name']);
        } else {
          total1 =
            total1 +
            ',' +
            (order['items'][id]['customize'][i]['options'][j]['nameEng'] != null
              ? order['items'][id]['customize'][i]['options'][j]['nameEng']
              : order['items'][id]['customize'][i]['options'][j]['name']);
        }
      }
      return total1;
    };

    let columns = this.state.width < 770 ? 1 : this.state.width < 1600 ? 2 : 3;
    const isMenuOpen = Boolean(this.state.anchorEl);
    const isMobileMenuOpen = Boolean(this.state.mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event) => {
      // setAnchorEl(event.currentTarget);
      this.setState({ anchorEl: event.currentTarget });
      // this.state.anchorEl = event.currentTarget;
    };

    const handleMobileMenuClose = () => {
      // setMobileMoreAnchorEl(null);
      this.setState({ mobileMoreAnchorEl: null });
    };

    const handleMenuClose = () => {
      this.setState({ anchorEl: null });
      handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
      this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
      <>
        {!this.state.userId ? (
          <Menu
            anchorEl={this.state.anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => {
                handleMenuClose();
              }}
            >
              Iniciar sesión
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleMenuClose();
              }}
            >
              {strings["Registrarse"]}
            </MenuItem>
          </Menu>
        ) : (
          <Menu
            anchorEl={this.state.anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
          >
            {this.state.userDetails && (
              <>
                <MenuItem
                  onClick={async () => {
                    handleMenuClose();
                  }}
                >
                  <Link
                    to={'/profile/'+this.state.busId}
                    style={{
                      color: '#444444',
                      textDecoration: 'none',
                      width: '100%',
                    }}
                  >
                    {strings["Perfil"]}
                  </Link>
                </MenuItem>
                <MenuItem
                  onClick={async () => {
                    handleMenuClose();
                  }}
                >
                  <Link
                    to={'/my-orders/'+this.state.busId}
                    style={{
                      color: '#444444',
                      textDecoration: 'none',
                      width: '100%',
                    }}
                  >
                    {strings["Mis Pedidos"]}
                  </Link>
                </MenuItem>
              </>
            )}
            <MenuItem
              onClick={async () => {
                handleMenuClose();
                await auth.signOut();
              }}
            >
              {strings["Cerrar sesión"]}
            </MenuItem>
          </Menu>
        )}
      </>
    );

    const openAlert = (alertType, alertMsg) => {
      this.setState({
        openAlert: true,
        alertType: alertType,
        alertMsg: alertMsg,
      });
    };

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
      <Menu
        anchorEl={this.state.mobileMoreAnchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        id={mobileMenuId}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
      >
        <MenuItem onClick={handleProfileMenuOpen}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
          >
            {this.state.photoURL ? (
              <img
                style={{
                  verticalAlign: 'middle',
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                }}
                src={this.state.photoURL}
              />
            ) : (
              <AccountCircle />
            )}
          </IconButton>
          <p>{strings["Perfil"]}</p>
        </MenuItem>
      </Menu>
    );

    return !this.loading ? (
      <>
        <Snackbar
        style={{zIndex: 9999999}}
          open={this.state.openAlert}
          autoHideDuration={6000}
          onClose={(event, reason) => {
            if (reason === 'clickaway') {
              return;
            }

            this.setState({ openAlert: false });
          }}
        >
          <Alert
            onClose={(event, reason) => {
              if (reason === 'clickaway') {
                return;
              }

              this.setState({ openAlert: false });
            }}
            severity={this.state.alertType}
            sx={{ width: '100%' }}
          >
            {this.state.alertMsg}
          </Alert>
        </Snackbar>

        <Box sx={{ flexGrow: 1 }}>
          <AppBar
            position="sticky"
            color="transparent"
            elevation={1}
            style={{
              boxShadow:
                '0px 2px 1px -1px rgb(0 0 0 / 2%), 0px 1px 1px 0px rgb(0 0 0 / 2%), 0px 1px 3px 0px rgb(0 0 0 / 2%)',
            }}
          >
            <Toolbar>
              <Button
                style={{
                  margin: '1px',
                  backgroundColor: '#fff',
                  textTransform: 'none',
                  borderRight: '0px solid #cccccc',
                  padding: '5px 15px 5px 5px',
                  fontSize: '14px',
                  borderRadius: '6px',
                  color: '#2e2c36',
                }}
                variant="text"
                startIcon={
                  <ArrowBackIcon color={'primary'} fontSize={'25px'} />
                }
                onClick={() => window.history.back()}
              >
                {strings["Regresar"]}
              </Button>

              <Box sx={{ flexGrow: 1 }} />
              <Box sx={{ flexGrow: 1 }} />
              <Box
                sx={{ display: { xs: 'flex', md: 'flex' } }}
                style={{
                  margin: '1px',
                  borderLeft: '0px solid #cccccc',
                  color: '#44cf8e',
                }}
              >
                <IconButton
                  size="large"
                  edge="end"
                  aria-label="account of current user"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  color="inherit"
                >
                  {this.state.photoURL ? (
                    <img
                      style={{
                        verticalAlign: 'middle',
                        width: '30px',
                        height: '30px',
                        borderRadius: '50%',
                      }}
                      src={this.state.photoURL}
                    />
                  ) : (
                    <AccountCircle />
                  )}
                </IconButton>
              </Box>
              <Box sx={{ display: { xs: 'none', md: 'none' } }}>
                <IconButton
                  size="large"
                  aria-label="show more"
                  aria-controls={mobileMenuId}
                  aria-haspopup="true"
                  onClick={handleMobileMenuOpen}
                  color="inherit"
                >
                  <MoreIcon />
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
          {renderMobileMenu}
          {renderMenu}
        </Box>
        {/* Container Start */}
        <Container
          disableGutters
          style={{
            width: '100vw',
            margin: 'auto',
            padding: '10px 5px',
            background: '#f7f8f9',
          }}
        >
          {this.state.orders.length > 0 ? (
            this.state.orders.map((i, ind) => {
              let order = i.data();
              return (
                <Order
                  onClick={() => handleTrackingOpen(order, i.id)}
                  direction={'column'}
                  spacing={0}
                  style={{ background: '#ffffff' }}
                  key={'order-details' + i.id}
                >
                  <div
                    className="business-logo"
                    style={{
                      width: columns == 1 ? '100%' : '18%',
                      textAlign: 'center',
                      placeSelf: 'center',
                    }}
                  >
                    <img
                      style={{ width: 50, height: 50 }}
                      alt="business-logo"
                      src={i.data()['restLogo']}
                    />
                  </div>
                  <div
                    className="order-info"
                    style={{
                      width: columns == 1 ? '100%' : '42%',
                      padding: '5px',
                    }}
                  >
                    <p
                      style={{
                        fontWeight: 'bold',
                        marginBottom: 0,
                        marginTop: 0,
                        color: '#2e2c36',
                      }}
                    >
                      {i.data()['number']} · {i.data()['restName']}
                    </p>
                    <p
                      style={{
                        marginBottom: 0,
                        color: 'slategray',
                        marginTop: '6px',
                      }}
                    >
                      {' '}
                      {order.serverTime
                        ? moment
                            .unix(order.serverTime?.seconds)
                            .format('DD-MM-YYYY hh:mm A')
                        : ''}
                    </p>
                    <p
                      style={{
                        marginBottom: 0,
                        color: 'slategray',
                        marginTop: '6px',
                      }}
                    >
                      {' '}
                      {getStat(order)}
                    </p>
                  </div>
                  <div
                    className="action-and-status"
                    style={{
                      width: columns == 1 ? '100%' : '40%',
                      padding: '0px',
                      placeSelf: 'center',
                    }}
                  >
                    <div
                      style={{
                        padding: '0',
                        zIndex: '9',
                      }}
                    >
                      <div style={{ padding: '0' }}>
                        <Stack
                          direction={'column'}
                          spacing={0}
                          alignItems="center"
                        >
                          <Stack
                            direction={'row'}
                            spacing={0}
                            alignItems="center"
                            justifyContent="center"
                          >
                            <>
                              {true ? (
                                <AspectRatio
                                  ratio="1/1"
                                  style={{
                                    borderRadius: '50%',
                                    width: 'calc(100% / 8 + 7.5px)',
                                    maxWidth: 'calc(100% / 8 + 7.5px)',
                                    padding: '5.5px',
                                    marginTop: '3px',
                                  }}
                                >
                                  <BusinessSvg
                                    viewBox="-20 -40 550 550"
                                    style={{
                                      border: `2px solid #4dd884`,
                                      borderRadius: '50%',
                                      width: 'calc(100%)',
                                      padding: '6px',
                                      fontSize: '50px',
                                    }}
                                  />
                                </AspectRatio>
                              ) : null}
                            </>
                            <>
                              {
                                <div
                                  style={{
                                    width: 'calc(100% / 16 - 5px)',
                                    height: '6px',
                                  }}
                                >
                                  <Divider
                                    style={{
                                      borderBottomWidth: '4px',
                                      borderRadius: '60px 0 0 60px',
                                      backgroundColor: '#4DD884',
                                    }}
                                  />
                                </div>
                              }
                            </>
                            <>
                              {
                                <div
                                  style={{
                                    width: 'calc(100% / 16 - 5px)',
                                    height: '6px',
                                  }}
                                >
                                  <Divider
                                    style={{
                                      borderBottomWidth: '4px',
                                      borderRadius: '0 60px 60px 0',
                                      backgroundColor:
                                        order['acceptedByRest'] ||
                                        order['delivered']
                                          ? '#4DD884'
                                          : '#C4C1C0',
                                    }}
                                  />
                                </div>
                              }
                            </>
                            <>
                              {true ? (
                                <AspectRatio
                                  ratio="1/1"
                                  style={{
                                    borderRadius: '80px',
                                    border: order['acceptedByRest']
                                      ? '0px solid #4dd884'
                                      : '0px solid #C4C1C0',
                                    width: 'calc(100% / 8 + 7.5px)',
                                    maxWidth: 'calc(100% / 8 + 7.5px)',
                                    padding: '5.5px',
                                  }}
                                >
                                  <StoreMallDirectoryIcon
                                    style={{
                                      fontSize: '29px',
                                      marginTop: '3px',
                                      border: '2px solid',
                                      borderRadius: '60px',
                                      borderColor: order['acceptedByRest']
                                        ? '#4DD884'
                                        : '#C4C1C0',
                                      padding: '6px',
                                      color: order['acceptedByRest']
                                        ? '#4DD884'
                                        : '#C4C1C0',
                                    }}
                                  />
                                </AspectRatio>
                              ) : null}
                            </>
                            <>
                              {
                                <div
                                  style={{
                                    width: 'calc(100% / 16 - 5px)',
                                    height: '6px',
                                  }}
                                >
                                  <Divider
                                    style={{
                                      borderBottomWidth: '4px',
                                      borderRadius: '60px 0 0 60px',
                                      backgroundColor:
                                        order['driverAssigned'] ||
                                        order['delivered']
                                          ? '#4DD884'
                                          : '#C4C1C0',
                                    }}
                                  />
                                </div>
                              }
                            </>
                            <>
                              {
                                <div
                                  style={{
                                    width: 'calc(100% / 16 - 5px)',
                                    height: '6px',
                                  }}
                                >
                                  <Divider
                                    style={{
                                      borderBottomWidth: '4px',
                                      borderRadius: '0 60px 60px 0',
                                      backgroundColor:
                                        order['driverReached'] ||
                                        order['delivered']
                                          ? '#4DD884'
                                          : '#C4C1C0',
                                    }}
                                  />
                                </div>
                              }
                            </>
                            <>
                              {true ? (
                                <AspectRatio
                                  ratio="1/1"
                                  style={{
                                    borderRadius: '80px',
                                    border: order['driverReached']
                                      ? '0px solid #4dd884'
                                      : '0px solid #C4C1C0',
                                    width: 'calc(100% / 8 + 7.5px)',
                                    maxWidth: 'calc(100% / 8 + 7.5px)',
                                    padding: '5.5px',
                                  }}
                                >
                                  <DeliveryDiningIcon
                                    style={{
                                      fontSize: '29px',
                                      marginTop: '3px',
                                      border: '2px solid',
                                      borderRadius: '60px',
                                      borderColor: order['driverReached']
                                        ? '#4DD884'
                                        : '#C4C1C0',
                                      padding: '6px',
                                      color: order['driverReached']
                                        ? '#4DD884'
                                        : '#C4C1C0',
                                    }}
                                  />
                                </AspectRatio>
                              ) : null}
                            </>

                            <>
                              {
                                <div
                                  style={{
                                    width: 'calc(100% / 16 - 5px)',
                                    height: '6px',
                                  }}
                                >
                                  <Divider
                                    style={{
                                      borderBottomWidth: '4px',
                                      borderRadius: '60px 0 0 60px',
                                      backgroundColor:
                                        order['orderPickedUp'] ||
                                        order['delivered']
                                          ? '#4DD884'
                                          : '#C4C1C0',
                                    }}
                                  />
                                </div>
                              }
                            </>
                            <>
                              {
                                <div
                                  style={{
                                    width: 'calc(100% / 16 - 5px)',
                                    height: '6px',
                                  }}
                                >
                                  <Divider
                                    style={{
                                      borderBottomWidth: '4px',
                                      borderRadius: '0 60px 60px 0',
                                      backgroundColor: order['delivered']
                                        ? '#4DD884'
                                        : '#C4C1C0',
                                    }}
                                  />
                                </div>
                              }
                            </>
                            <>
                              {true ? (
                                <AspectRatio
                                  ratio="1/1"
                                  style={{
                                    borderRadius: '80px',
                                    border:
                                      order['delivered'] && !order['cancelled']
                                        ? '0px solid #4dd884'
                                        : order['delivered'] &&
                                          order['cancelled']
                                        ? '0px solid #D62B2B'
                                        : '0px solid #C4C1C0',
                                    width: 'calc(100% / 8 + 7.5px)',
                                    maxWidth: 'calc(100% / 8 + 7.5px)',
                                    padding: '5.5px',
                                  }}
                                >
                                  <WhereToVoteIcon
                                    style={{
                                      fontSize: '29px',
                                      marginTop: '3px',
                                      border: '2px solid',
                                      borderRadius: '60px',
                                      borderColor:
                                        order['delivered'] &&
                                        !order['cancelled']
                                          ? '#4DD884'
                                          : order['delivered'] &&
                                            order['cancelled']
                                          ? '#D62B2B'
                                          : '#C4C1C0',
                                      padding: '6px',
                                      color:
                                        order['delivered'] &&
                                        !order['cancelled']
                                          ? '#4DD884'
                                          : order['delivered'] &&
                                            order['cancelled']
                                          ? '#D62B2B'
                                          : '#C4C1C0',
                                    }}
                                  />
                                </AspectRatio>
                              ) : null}
                            </>
                          </Stack>
                        </Stack>
                      </div>
                    </div>
                  </div>
                </Order>
              );
            })
          ) : (
            <Typography
              style={{
                fontSize: '2vh',
                fontWeight: 'normal',
                color: 'slategray',
                textAlign: 'center',
              }}
            >
              {strings["No existen pedidos para mostrar"]}
            </Typography>
          )}
        </Container>
        {/* Container End */}

        <Backdrop
          onClick={() => {}}
          style={{ color: '#fff', zIndex: 9999999 }}
          open={this.state.loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <TrackDialog
          selectedValue={this.state.selectedValue}
          open={this.state.showTracking}
          onClose={() => {
            this.setState({
              showTracking: false,
              trackingDetails: null,
              trackingId: null,
            });
          }}
          title={this.state.width}
          displayList={
            <Container
              maxWidth="sm"
              disableGutters
              sx={{
                margin: '0px',
                bgcolor: '#fff',
                height: isIOS ? 'calc((var(--vh, 1vh) * 100))' : '100vh',
              }}
              style={{ background: '#ffffff' }}
            >
              <Stack direction={'column'} spacing={0}>
                <Stack direction={'row'} style={{ height: '50px' }}>
                  <Typography
                    sx={{ p: 2 }}
                    style={{
                      fontSize: this.state.width < 600 ? '24px' : '18px',
                      fontWeight: '800',
                      color: '#2c3136',
                      lineHeight: '1',
                      letterSpacing: '-0.24px',
                    }}
                  >
                    {strings['Detalles del pedido']}
                  </Typography>
                  <IconButton
                    aria-label="close"
                    onClick={() => {
                      this.setState({
                        showTracking: false,
                        trackingDetails: null,
                        trackingId: null,
                      });
                    }}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CancelIcon />
                  </IconButton>
                </Stack>
                <>
                  {this.state.trackingDetails ? (
                    <Stack
                      direction={'column'}
                      spacing={0}
                      style={{
                        height: isIOS
                          ? 'calc((var(--vh, 1vh) * 100) - 50px)'
                          : 'calc(100vh - 50px)',
                        overflow: 'auto',
                      }}
                    >
                      <div style={{ height: '300px' }}>
                        <div style={{ height: '300px', width: '100%' }}>
                          <GoogleMapReact
                            defaultCenter={{
                              lat: this.state.trackingDetails.userLocation
                                .latitude,
                              lng: this.state.trackingDetails.userLocation
                                .longitude,
                            }}
                            defaultZoom={this.state.defaultProps.zoom}
                            resetBoundsOnResize={true}
                            options={{
                              fullscreenControl: false,
                              scrollwheel: false,
                              panControl: false,
                              zoomControl: true,
                              rotateControl: false,
                            }}
                            bootstrapURLKeys={{
                              key: 'AIzaSyDNl0corYx_1cBY1uvD7vzIzw8pvppIgAM',
                            }}
                            style={{
                              height: '300px',
                              padding: '8px',
                              borderRadius: '10px',
                            }}
                            onChange={(changeData) => {}}
                          >
                            <svg
                              className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              viewBox="0 0 512 512"
                              xmlSpace="preserve"
                              style={{
                                fontSize: '50px',
                                padding: '6px',
                                transform: 'translate(-50%, -100%)',
                              }}
                              lat={
                                this.state.trackingDetails.userLocation.latitude
                              }
                              lng={
                                this.state.trackingDetails.userLocation
                                  .longitude
                              }
                            >
                              <rect
                                id="Rectangle-6_1_"
                                x="0.4"
                                y="0.4"
                                className="st0"
                                width="511.2"
                                height="511.2"
                              />
                              <g>
                                <path
                                  id="path-1_1_"
                                  className="st4"
                                  d="M309.4,446.1c63.4-4,118.7-15.1,136.4-33.5c45.2-46.8,45.2-330.3,0-377.1s-334.3-46.8-379.5,0
                                              s-45.2,330.3,0,377.1c17.7,18.4,72.9,29.5,136.3,33.5c14,25.3,38.8,65.9,53.5,65.5C270.7,511.2,295.4,471.1,309.4,446.1z"
                                />
                              </g>
                              <path
                                className="st5"
                                d="M255.6,511.4c-6.1,0-12.3-3.7-25.5-21.7c-8.6-11.7-18.4-27.3-27.5-43.8l0-0.1l-0.1,0
                                            c-33.2-2.1-113.1-9.5-136.2-33.4c-25-25.9-33.8-114.3-33.8-188.4S41.4,61.5,66.3,35.6C91.3,9.8,180.7,0.6,256,0.6c0,0,0,0,0,0
                                            c75.3,0,164.7,9.2,189.6,35.1c25,25.9,33.8,114.3,33.8,188.4s-8.9,162.6-33.8,188.4c-23.1,23.9-103,31.4-136.3,33.4l-0.1,0l0,0.1
                                            c-9.2,16.5-19,32-27.6,43.6c-13.3,18-19.7,21.7-25.6,21.8C255.9,511.4,255.8,511.4,255.6,511.4z M259.1,491.2
                                            C259.1,491.2,259.1,491.2,259.1,491.2L259.1,491.2z M256,21.6c-85.1,0-158.5,12-174.5,28.6c-7.9,8.2-15.3,31.2-20.4,63
                                            c-4.9,31-7.6,70.4-7.6,110.9c0,40.5,2.7,79.9,7.6,110.9c5,31.8,12.4,54.8,20.4,63c9.9,10.3,51.6,22.6,122.4,27.1l11.6,0.7l5.6,10.1
                                            c15.2,27.5,28.4,45.4,34.8,52.4c6.4-6.8,19.5-24.4,35.1-52.4l5.6-10.1l11.5-0.7c70.8-4.4,112.6-16.8,122.5-27.1
                                            c7.9-8.2,15.3-31.2,20.4-63c4.9-31,7.6-70.4,7.6-110.9c0-40.5-2.7-79.9-7.6-110.9c-5-31.8-12.4-54.8-20.4-63
                                            C414.5,33.6,341.1,21.6,256,21.6z"
                              />
                              <path
                                className="st3"
                                d="M231.4,324.2c-7.2,0-14.1-3.1-18.9-8.5l-67.6-76c-9.3-10.5-8.3-26.5,2.1-35.8c10.5-9.3,26.5-8.4,35.8,2.1
                                            l46.5,52.3l108.2-151.5c8.1-11.4,23.9-14,35.3-5.9c11.4,8.1,14,24,5.9,35.3L252.1,313.6c-4.5,6.3-11.6,10.2-19.3,10.6
                                            C232.3,324.2,231.9,324.2,231.4,324.2z"
                              />
                            </svg>

                            {/* <StoreMallDirectoryIcon
                              style={{
                                color: '#44cf8e',
                                transform: 'translate(-50%, -100%)',
                              }}
                              fontSize={'large'}
                              lat={
                                this.state.trackingDetails.restLocation.latitude
                              }
                              lng={
                                this.state.trackingDetails.restLocation.longitude
                              }
                              // text={'Google Map'}
                            /> */}

                            <svg
                              className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              viewBox="0 0 512 512"
                              xmlSpace="preserve"
                              style={{
                                fontSize: '50px',
                                padding: '6px',
                                transform: 'translate(-50%, -100%)',
                              }}
                              lat={
                                this.state.trackingDetails.restLocation.latitude
                              }
                              lng={
                                this.state.trackingDetails.restLocation
                                  .longitude
                              }
                            >
                              <rect
                                id="Rectangle-6"
                                x="0.4"
                                y="0.4"
                                className="st0"
                                width="511.2"
                                height="511.2"
                              />
                              <g>
                                <path
                                  id="path-1"
                                  className="st1"
                                  d="M309.4,446.1c63.4-4,118.7-15.1,136.4-33.5c45.2-46.8,45.2-330.3,0-377.1s-334.3-46.8-379.5,0
                                                s-45.2,330.3,0,377.1c17.7,18.4,72.9,29.5,136.3,33.5c14,25.3,38.8,65.9,53.5,65.5C270.7,511.2,295.4,471.1,309.4,446.1z"
                                />
                              </g>
                              <path
                                className="st2"
                                d="M255.6,511.4c-6.1,0-12.3-3.7-25.5-21.7c-8.6-11.7-18.4-27.3-27.5-43.8l0-0.1l-0.1,0
                                              c-33.2-2.1-113.1-9.5-136.2-33.4c-25-25.9-33.8-114.3-33.8-188.4S41.4,61.5,66.3,35.6C91.3,9.8,180.7,0.6,256,0.6c0,0,0,0,0,0
                                              c75.3,0,164.7,9.2,189.6,35.1c25,25.9,33.8,114.3,33.8,188.4s-8.9,162.6-33.8,188.4c-23.1,23.9-103,31.4-136.3,33.4l-0.1,0l0,0.1
                                              c-9.2,16.5-19,32-27.6,43.6c-13.3,18-19.7,21.7-25.6,21.8C255.9,511.4,255.8,511.4,255.6,511.4z M259.1,491.2
                                              C259.1,491.2,259.1,491.2,259.1,491.2L259.1,491.2z M256,21.6c-85.1,0-158.5,12-174.5,28.6c-7.9,8.2-15.3,31.2-20.4,63
                                              c-4.9,31-7.6,70.4-7.6,110.9c0,40.5,2.7,79.9,7.6,110.9c5,31.8,12.4,54.8,20.4,63c9.9,10.3,51.6,22.6,122.4,27.1l11.6,0.7l5.6,10.1
                                              c15.2,27.5,28.4,45.4,34.8,52.4c6.4-6.8,19.5-24.4,35.1-52.4l5.6-10.1l11.5-0.7c70.8-4.4,112.6-16.8,122.5-27.1
                                              c7.9-8.2,15.3-31.2,20.4-63c4.9-31,7.6-70.4,7.6-110.9c0-40.5-2.7-79.9-7.6-110.9c-5-31.8-12.4-54.8-20.4-63
                                              C414.5,33.6,341.1,21.6,256,21.6z"
                              />
                              <path
                                className="st3"
                                d="M386.5,182.8c-0.2-0.5-0.5-0.9-0.8-1.3l-31.9-39.6v-54c0-3.9-3.1-7-7-7H166.3c-3.9,0-7,3.1-7,7v50.9L125,183.9
                                              c-0.4,0.5-0.7,1-0.9,1.6c-0.3,0.7-6.4,16.1,1.7,28.3c4.6,6.9,12.6,11,23.7,12.1v120.2c0,3.9,3.1,7,7,7h200.7c3.9,0,7-3.1,7-7V225.7
                                              c10.7-1.5,18.2-5.6,22.5-12.4C394.9,200.2,386.9,183.5,386.5,182.8z M231.6,339.2v-84.6h56.9v84.6H231.6z M263.8,212.2v-62.6h17.4
                                              l16.8,62.6C287.2,212.2,275.6,212.2,263.8,212.2z M312.5,212.2l-16.8-62.6h16.9l33.6,62.6C338.9,212.2,327.8,212.2,312.5,212.2z
                                              M167.3,212.3l33.6-62.7h16.9L201,212.3C188,212.3,176.4,212.3,167.3,212.3z M215.5,212.2l16.8-62.6h17.6v62.6
                                              C238.2,212.2,226.5,212.2,215.5,212.2z M217.6,247.6v91.6h-54V226.3h186.7v112.9h-47.7v-91.6c0-3.9-3.1-7-7-7h-70.9
                                              C220.7,240.6,217.6,243.7,217.6,247.6z M137.4,206L137.4,206c-3.3-4.9-1.3-12.4-0.6-14.5l31.8-41.9h16.4l-33.5,62.5
                                              C144.5,211.5,139.7,209.4,137.4,206z M339.8,94.8v40.8H173.3V94.8H339.8z M342.1,149.6l32.1,39.9c0.9,2.2,4.1,10.8,0.7,16.3
                                              c-2.1,3.2-6.4,5.3-13,6.1l-33.4-62.3H342.1z"
                              />
                            </svg>
                            <>
                              {this.state.trackingDetails.driverAssigned ? (
                                // <DeliveryDiningIcon
                                //   style={{
                                //     color: '#44cf8e',
                                //     transform: 'translate(-50%, -100%)',
                                //   }}
                                //   fontSize={'large'}
                                //   lat={
                                //     this.state.trackingDetails.driverLocation
                                //       .latitude
                                //   }
                                //   lng={
                                //     this.state.trackingDetails.driverLocation
                                //       .longitude
                                //   }
                                //   // text={'Google Map'}
                                // />
                                <svg
                                  className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
                                  version="1.1"
                                  id="Capa_1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 512 512"
                                  xmlSpace="preserve"
                                  style={{
                                    fontSize: '50px',
                                    padding: '6px',
                                    transform: 'translate(-50%, -100%)',
                                  }}
                                  lat={
                                    this.state.trackingDetails.driverLocation
                                      .latitude
                                  }
                                  lng={
                                    this.state.trackingDetails.driverLocation
                                      .longitude
                                  }
                                >
                                  <rect
                                    id="Rectangle-6_4_"
                                    x="0.4"
                                    y="0.4"
                                    className="st0"
                                    width="511.2"
                                    height="511.2"
                                  />
                                  <g>
                                    <g>
                                      <path
                                        id="path-1_12_"
                                        className="st6"
                                        d="M309.4,446.1c63.4-4,118.7-15.1,136.4-33.5c45.2-46.8,45.2-330.3,0-377.1
                                                  s-334.3-46.8-379.5,0s-45.2,330.3,0,377.1c17.7,18.4,72.9,29.5,136.3,33.5c14,25.3,38.8,65.9,53.5,65.5
                                                  C270.7,511.2,295.4,471.1,309.4,446.1z"
                                      />
                                    </g>
                                  </g>
                                  <path
                                    className="st7"
                                    d="M255.6,511.4c-6.1,0-12.3-3.7-25.5-21.7c-8.6-11.7-18.4-27.3-27.5-43.8l0-0.1l-0.1,0
                                              c-33.2-2.1-113.1-9.5-136.2-33.4c-25-25.9-33.8-114.3-33.8-188.4S41.4,61.5,66.3,35.6C91.3,9.8,180.7,0.6,256,0.6c0,0,0,0,0,0
                                              c75.3,0,164.7,9.2,189.6,35.1c25,25.9,33.8,114.3,33.8,188.4s-8.9,162.6-33.8,188.4c-23.1,23.9-103,31.4-136.3,33.4l-0.1,0l0,0.1
                                              c-9.2,16.5-19,32-27.6,43.6c-13.3,18-19.7,21.7-25.6,21.8C255.9,511.4,255.8,511.4,255.6,511.4z M259.1,491.2
                                              C259.1,491.2,259.1,491.2,259.1,491.2L259.1,491.2z M256,21.6c-85.1,0-158.5,12-174.5,28.6c-7.9,8.2-15.3,31.2-20.4,63
                                              c-4.9,31-7.6,70.4-7.6,110.9c0,40.5,2.7,79.9,7.6,110.9c5,31.8,12.4,54.8,20.4,63c9.9,10.3,51.6,22.6,122.4,27.1l11.6,0.7l5.6,10.1
                                              c15.2,27.5,28.4,45.4,34.8,52.4c6.4-6.8,19.5-24.4,35.1-52.4l5.6-10.1l11.5-0.7c70.8-4.4,112.6-16.8,122.5-27.1
                                              c7.9-8.2,15.3-31.2,20.4-63c4.9-31,7.6-70.4,7.6-110.9c0-40.5-2.7-79.9-7.6-110.9c-5-31.8-12.4-54.8-20.4-63
                                              C414.5,33.6,341.1,21.6,256,21.6z"
                                  />
                                  <path
                                    className="st3"
                                    d="M168.9,319.9c-1.6,0-3.1-0.1-4.7-0.3c-23.9-2.9-39.5-22.4-37-46.5c0-0.1,0-0.2,0.1-0.4h-7.8
                                              c-2.2,0-4.2-1.2-5.3-3.1l-15-26.2c-1.3-2.3-1-5.2,0.8-7.1l42.7-46.8c1.2-1.3,2.8-2,4.5-2h58.1c3.4,0,6.1,2.7,6.1,6.1
                                              s-2.7,6.1-6.1,6.1h-55.4l-37.9,41.6l11.1,19.3h172.5c7.9-13.9,23.7-39.9,32.5-43.9c3-1.4,6.7-0.1,8.1,3c1.4,3.1,0,6.7-3,8
                                              c-4.4,2.3-18.4,23.5-28.7,41.9c-1.1,1.9-3.1,3.1-5.3,3.1H139.2c0.1,0.5,0.1,1,0.1,1.6c-1.7,17.2,9.3,31.1,26.4,33.2
                                              c12.8,1.6,25.1-6.2,30.4-19.3c1.3-3.1,4.8-4.6,7.9-3.3c3.1,1.3,4.6,4.8,3.4,7.9C200.5,309.5,185.5,319.9,168.9,319.9z M370.3,319.9
                                              c-21.5,0-40-16.7-43-38.8c-0.5-3.3,1.9-6.4,5.2-6.9c3.2-0.4,6.4,1.9,6.9,5.2c2.2,16.1,15.5,28.3,31,28.3c17.3,0,31.3-14.8,31.3-33.1
                                              c0-5.4-1.2-10.7-3.6-15.4c-1.5-3-0.3-6.7,2.7-8.2c3-1.5,6.7-0.3,8.2,2.7c3.2,6.4,4.9,13.6,4.9,20.8
                                              C413.8,299.6,394.3,319.9,370.3,319.9z M335.6,268.4h-19.5c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1h15.8c3.9-7,14.2-21.6,30.7-21.6
                                              c13.9,0,22.9,1.4,26.4,2l4.8-1.5c-3.7-6.7-12.9-18.1-34.8-24.3c-0.2-0.1-0.4-0.1-0.6-0.2c-2.6,1-5.7,0.2-7.3-2.3
                                              c0,0-45.2-66.9-46.5-68.9c-1.2-1.7-1.4-3.9-0.6-5.9c0.8-1.9,2.5-3.3,4.6-3.7l6.6-1.1l-0.6-13.6l-4.1-1l-19.3,13.5
                                              c-1,0.7-2.2,1.1-3.5,1.1l-23.1,0.1c0,0,0,0,0,0c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1l21.2,0l20-14c1.4-1,3.2-1.3,4.9-0.9
                                              l11.2,2.7c2.6,0.6,4.5,3,4.6,5.7l1,23.6c0.1,3.1-2,5.7-5.1,6.2l-2.5,0.4c10.1,15,31.6,46.8,39.6,58.6c0.9-0.2,1.9-0.1,2.8,0.1
                                              c38.9,11.1,45.3,37.4,45.6,38.5c0.7,3.1-1.1,6.2-4.1,7.2l-12.6,3.9c-1,0.3-2.2,0.4-3.2,0.1c-0.1,0-8.9-2-25.3-2
                                              c-13.3,0-21.3,17.7-21.4,17.9C340.2,267,338.1,268.4,335.6,268.4z M276,242.7h-63c-2.3,0-4.4-1.3-5.5-3.4c-1-2.1-0.8-4.6,0.7-6.4
                                              l27.3-35.3c1.2-1.5,2.9-2.5,5-2.4l5.6,0.1c0.5-5.3-1.1-15-15.9-23.8l-91.6-0.4c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.5-6.2,6.1-6.1
                                              l93.2,0.4c1,0,2,0.3,2.9,0.8c25.8,14.4,25.4,34.9,21.7,43.8c-1,2.3-3.3,3.7-5.7,3.7l-7.4-0.2l-17.8,23H273l27.3-37.3l-20.9-36.6
                                              c-1.7-2.9-0.7-6.6,2.3-8.3c2.9-1.7,6.7-0.6,8.3,2.3l22.9,40.1c1.2,2.1,1,4.7-0.4,6.6l-31.5,42.9C279.8,241.7,278,242.7,276,242.7z"
                                  />
                                </svg>
                              ) : null}
                            </>
                          </GoogleMapReact>
                          <>
                            {!this.state.trackingDetails.delivered ? (
                              <div
                                style={{
                                  position: 'relative',
                                  bottom: '126px',
                                  right: '10px',
                                  width: '200px',
                                  float: 'right',
                                }}
                              >
                                <div style={{ padding: '15px' }}>
                                  <div
                                    style={{
                                      backgroundColor: '#fff',
                                      borderRadius: '13px',
                                      height: '73px',
                                      boxShadow: '0px 4px 10px #64717a42',
                                      padding: '10px',
                                    }}
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="center"
                                    >
                                      <>
                                        {this.state.trackingDetails != null &&
                                        (this.state.trackingDetails[
                                          'isPickup'
                                        ] == null ||
                                          !this.state.trackingDetails[
                                            'isPickup'
                                          ]) ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: 'normal',
                                              color: '#777',
                                            }}
                                          >
                                            {strings['Pedido número']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails != null &&
                                        this.state.trackingDetails[
                                          'isPickup'
                                        ] != null &&
                                        this.state.trackingDetails[
                                          'isPickup'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: 'normal',
                                              color: '#777',
                                            }}
                                          >
                                            {strings['Solicitar ID']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <div
                                        style={{ padding: '2px 0px 0px' }}
                                      ></div>
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {this.state.trackingDetails['number']
                                          ? this.state.trackingDetails[
                                              'number'
                                            ].toString()
                                          : ''}
                                      </Typography>
                                    </Stack>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </>
                        </div>
                      </div>
                      <div
                        style={{
                          padding: '10px 20px 10px',
                          marginTop: '-38px',
                          zIndex: '9',
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: '#fff',
                            boxShadow: '0px 4px 10px #64717a42',
                            borderRadius: '20px',
                            padding: '12px 16px 12px 16px',
                          }}
                        >
                          <Stack
                            direction={'column'}
                            spacing={0}
                            alignItems="center"
                          >
                            <Stack
                              direction={'row'}
                              spacing={0}
                              alignItems="center"
                              justifyContent="center"
                            >
                              <>
                                {true ? (
                                  <AspectRatio
                                    ratio="1/1"
                                    style={{
                                      borderRadius: '50%',
                                      width: 'calc(100% / 8 + 7.5px)',
                                      maxWidth: 'calc(100% / 8 + 7.5px)',
                                      padding: '2px',
                                      marginTop: '3px',
                                    }}
                                  >
                                    <BusinessSvg
                                      viewBox="-20 -40 550 550"
                                      style={{
                                        border: `2px solid #4dd884`,
                                        borderRadius: '50%',
                                        width: 'calc(100%)',
                                        padding: '6px',
                                        fontSize: '50px',
                                      }}
                                    />
                                  </AspectRatio>
                                ) : null}
                              </>
                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '60px 0 0 60px',
                                        backgroundColor: '#4DD884',
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '0 60px 60px 0',
                                        backgroundColor:
                                          this.state.trackingDetails[
                                            'acceptedByRest'
                                          ] ||
                                          this.state.trackingDetails[
                                            'delivered'
                                          ]
                                            ? '#4DD884'
                                            : '#C4C1C0',
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {true ? (
                                  <AspectRatio
                                    ratio="1/1"
                                    style={{
                                      borderRadius: '80px',
                                      border: this.state.trackingDetails[
                                        'acceptedByRest'
                                      ]
                                        ? '0px solid #4dd884'
                                        : '0px solid #C4C1C0',
                                      width: 'calc(100% / 8 + 7.5px)',
                                      maxWidth: 'calc(100% / 8 + 7.5px)',
                                      padding: '5.5px',
                                    }}
                                  >
                                    <StoreMallDirectoryIcon
                                      style={{
                                        fontSize: '40px',
                                        border: '2px solid',
                                        borderRadius: '60px',
                                        borderColor: this.state.trackingDetails[
                                          'acceptedByRest'
                                        ]
                                          ? '#4DD884'
                                          : '#C4C1C0',
                                        padding: '6px',
                                        color: this.state.trackingDetails[
                                          'acceptedByRest'
                                        ]
                                          ? '#4DD884'
                                          : '#C4C1C0',
                                      }}
                                    />
                                  </AspectRatio>
                                ) : null}
                              </>
                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '60px 0 0 60px',
                                        backgroundColor:
                                          this.state.trackingDetails[
                                            'driverAssigned'
                                          ] ||
                                          this.state.trackingDetails[
                                            'delivered'
                                          ]
                                            ? '#4DD884'
                                            : '#C4C1C0',
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '0 60px 60px 0',
                                        backgroundColor:
                                          this.state.trackingDetails[
                                            'driverReached'
                                          ] ||
                                          this.state.trackingDetails[
                                            'delivered'
                                          ]
                                            ? '#4DD884'
                                            : '#C4C1C0',
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {true ? (
                                  <AspectRatio
                                    ratio="1/1"
                                    style={{
                                      borderRadius: '80px',
                                      border: this.state.trackingDetails[
                                        'driverReached'
                                      ]
                                        ? '0px solid #4dd884'
                                        : '0px solid #C4C1C0',
                                      width: 'calc(100% / 8 + 7.5px)',
                                      maxWidth: 'calc(100% / 8 + 7.5px)',
                                      padding: '5.5px',
                                    }}
                                  >
                                    <DeliveryDiningIcon
                                      style={{
                                        fontSize: '40px',
                                        border: '2px solid',
                                        borderRadius: '60px',
                                        borderColor: this.state.trackingDetails[
                                          'driverReached'
                                        ]
                                          ? '#4DD884'
                                          : '#C4C1C0',
                                        padding: '6px',
                                        color: this.state.trackingDetails[
                                          'driverReached'
                                        ]
                                          ? '#4DD884'
                                          : '#C4C1C0',
                                      }}
                                    />
                                  </AspectRatio>
                                ) : null}
                              </>

                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '60px 0 0 60px',
                                        backgroundColor:
                                          this.state.trackingDetails[
                                            'orderPickedUp'
                                          ] ||
                                          this.state.trackingDetails[
                                            'delivered'
                                          ]
                                            ? '#4DD884'
                                            : '#C4C1C0',
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {
                                  <div
                                    style={{
                                      width: 'calc(100% / 16 - 5px)',
                                      height: '6px',
                                    }}
                                  >
                                    <Divider
                                      style={{
                                        borderBottomWidth: '4px',
                                        borderRadius: '0 60px 60px 0',
                                        backgroundColor: this.state
                                          .trackingDetails['delivered']
                                          ? '#4DD884'
                                          : '#C4C1C0',
                                      }}
                                    />
                                  </div>
                                }
                              </>
                              <>
                                {true ? (
                                  <AspectRatio
                                    ratio="1/1"
                                    style={{
                                      borderRadius: '80px',
                                      border:
                                        this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails['cancelled']
                                          ? '0px solid #4dd884'
                                          : this.state.trackingDetails[
                                              'delivered'
                                            ] &&
                                            this.state.trackingDetails[
                                              'cancelled'
                                            ]
                                          ? '0px solid #D62B2B'
                                          : '0px solid #C4C1C0',
                                      width: 'calc(100% / 8 + 7.5px)',
                                      maxWidth: 'calc(100% / 8 + 7.5px)',
                                      padding: '5.5px',
                                    }}
                                  >

                                    <WhereToVoteIcon
                                      style={{
                                        fontSize: '40px',
                                        border: '2px solid',
                                        borderRadius: '60px',
                                        borderColor:
                                          this.state.trackingDetails[
                                            'delivered'
                                          ] &&
                                          !this.state.trackingDetails[
                                            'cancelled'
                                          ]
                                            ? '#4DD884'
                                            : this.state.trackingDetails[
                                                'delivered'
                                              ] &&
                                              this.state.trackingDetails[
                                                'cancelled'
                                              ]
                                            ? '#D62B2B'
                                            : '#C4C1C0',
                                        padding: '6px',
                                        color:
                                          this.state.trackingDetails[
                                            'delivered'
                                          ] &&
                                          !this.state.trackingDetails[
                                            'cancelled'
                                          ]
                                            ? '#4DD884'
                                            : this.state.trackingDetails[
                                                'delivered'
                                              ] &&
                                              this.state.trackingDetails[
                                                'cancelled'
                                              ]
                                            ? '#D62B2B'
                                            : '#C4C1C0',
                                      }}
                                    />
                                  </AspectRatio>
                                ) : null}
                              </>
                            </Stack>
                            <div style={{ padding: '15px 0px 0px' }}></div>
                            <Typography
                              style={{
                                fontSize: '16px',
                                fontWeight: 'bold',
                                color: '#2e3436',
                                textAlign: 'center',
                              }}
                            >
                              {getStat(this.state.trackingDetails)}
                            </Typography>
                            <div style={{ padding: '15px 0px 0px' }}></div>
                            <Stack
                              onClick={() => {
                                this.setState({
                                  toggleDetails: !this.state.toggleDetails,
                                });
                              }}
                              direction={'row'}
                              spacing={0}
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Typography
                                style={{
                                  fontSize: '14px',
                                  fontWeight: 'normal',
                                  color: '#7E7D81',
                                  cursor: 'pointer',
                                }}
                              >
                                {strings['Ver más']}
                              </Typography>
                              <div style={{ padding: '0px 2px 0px' }}></div>
                              <>
                                {!this.state.toggleDetails ? (
                                  <KeyboardArrowDownIcon
                                    style={{
                                      fontSize: '24px',
                                      fontWeight: 'normal',
                                      color: '#7E7D81',
                                      cursor: 'pointer',
                                    }}
                                  />
                                ) : (
                                  <KeyboardArrowUpIcon
                                    style={{
                                      fontSize: '24px',
                                      fontWeight: 'normal',
                                      color: '#7E7D81',
                                      cursor: 'pointer',
                                    }}
                                  />
                                )}
                              </>
                            </Stack>
                            <div style={{ padding: '5px 0px 0px' }}></div>
                            <>
                              {this.state.toggleDetails ? (
                                <div>
                                  <Stack
                                    direction={'row'}
                                    spacing={0}
                                    alignItems="center"
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="center"
                                    >
                                      <>
                                        {true ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {
                                              strings['Esperando a que el negocio acepte su pedido']
                                            }
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {
                                              strings['Te avisaremos una vez que el negocio acepte tu pedido']
                                            }
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {
                                              strings['El negocio está preparando tu producto']
                                            }
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {strings['Tu pedido está siendo preparado']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'acceptedByRest'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: '400',
                                              color: '#3a4247',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' está en camino para recoger tu pedido']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: '400',
                                              color: '#3a4247',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' está en camino para recoger tu pedido']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverAssigned'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' llegó al negocio']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' ha llegado al negocio y recogerá tu pedido']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'driverReached'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' ha recogido tu pedido']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'driverName'
                                            ].split(' ')[0] +
                                              strings[' ha recogido tu pedido']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'orderPickedUp'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {strings['Tu orden ha sido entregada']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '400',
                                              color: 'slategray',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {strings['Tu pedido ha sido entregado']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'delivered'
                                        ] &&
                                        !this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Divider
                                            style={{
                                              borderBottomWidth: '1px',
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: '400',
                                              color: '#3a4247',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {strings['Tu pedido ha sido cancelado']}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <Typography
                                            style={{
                                              fontSize: '15px',
                                              fontWeight: '400',
                                              color: '#3a4247',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {this.state.trackingDetails[
                                              'reason'
                                            ] == null
                                              ? strings['Tu pedido ha sido cancelado']
                                              : this.state.trackingDetails[
                                                  'reason'
                                                ]}
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {this.state.trackingDetails[
                                          'cancelled'
                                        ] ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <Divider
                                            style={{
                                              backgroundColor: '#BDBDBD',
                                            }}
                                          />
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <Typography
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '600',
                                              color: '#3a4247',
                                              marginRight: 'auto',
                                            }}
                                          >
                                            {strings['Tu ubicación']}:{' '}
                                            <span
                                              style={{
                                                color: 'slategray',
                                                fontWeight: '400',
                                              }}
                                            >
                                              {
                                                this.state.trackingDetails[
                                                  'userLocation'
                                                ]['geoAddress']
                                              }
                                            </span>
                                          </Typography>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                      <>
                                        {true ? (
                                          <div
                                            style={{ padding: '5px 0px 0px' }}
                                          ></div>
                                        ) : null}
                                      </>
                                    </Stack>
                                  </Stack>
                                </div>
                              ) : null}
                            </>
                          </Stack>
                        </div>
                      </div>
                      <>
                        {!this.state.trackingDetails['delivered'] ? (
                          <div
                            style={{
                              padding: '5px 10px 5px',
                              borderTop: '1px solid #d8d8d8',
                              marginTop: '10px',
                            }}
                          >
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="center"
                            >
                              <Stack
                                direction={'row'}
                                spacing={0}
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Stack
                                  direction={'row'}
                                  spacing={0}
                                  alignItems="center"
                                  justifyContent="flex-start"
                                >
                                  <div
                                    style={{
                                      borderRadius: '10px',
                                      width: 'calc(15%)',
                                      paddingTop: '10px',
                                    }}
                                  >
                                    <div style={{ padding: '1.75px' }}>
                                      <img
                                        src={
                                          this.state.trackingDetails['restLogo']
                                        }
                                        alt="logo"
                                        // width={'50px'}
                                        style={{
                                          borderRadius: '12px',
                                          width: 'calc(100%)',
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      padding: '5px 15px 0px',
                                      flexGrow: 1,
                                    }}
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-start"
                                      justifyContent="flex-start"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'normal',
                                          color: '#000',
                                        }}
                                      >
                                        {this.state.trackingDetails['restName']}
                                      </Typography>
                                      <Stack
                                        direction={'row'}
                                        spacing={0}
                                        alignItems="center"
                                      >
                                        <StarIcon
                                          style={{
                                            fontSize: '16px',
                                            color: '#44cf8e',
                                          }}
                                        />
                                        <Typography
                                          style={{
                                            fontSize: '15px',
                                            fontWeight: 'normal',
                                            color: '#000',
                                          }}
                                        >
                                          {/* {' ' +
                                            this.state.businessData[
                                              'averageRating'
                                            ].toFixed(2)} */}
                                        </Typography>
                                      </Stack>
                                    </Stack>
                                  </div>
                                </Stack>
                                <div style={{ padding: '0px 5px 0px' }}>
                                  <div
                                    onClick={() => {
                                      window.open(
                                        'tel://' +
                                          this.state.trackingDetails[
                                            'restContact'
                                          ],
                                        '_blank'
                                      );
                                    }}
                                    style={{
                                      width: '38px',
                                      height: '38px',
                                      backgroundColor: '#33343b',
                                      borderRadius: '50%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      textAlign: 'center',
                                      padding: '4px 6px 4px 8px',
                                    }}
                                  >
                                    <LocalPhoneIcon
                                      style={{
                                        fontSize: '23px',
                                        color: '#fff',
                                      }}
                                    />
                                  </div>
                                </div>
                              </Stack>
                            </Stack>
                          </div>
                        ) : null}
                      </>

                      <div style={{ padding: '5px 0px 0px' }}></div>
                      <Divider />
                      <>
                        {this.state.trackingDetails['driverAssigned'] &&
                        !this.state.trackingDetails['delivered'] ? (
                          <div style={{ padding: '5px 10px 5px' }}>
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="center"
                            >
                              <Stack
                                direction={'row'}
                                spacing={0}
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Stack
                                  direction={'row'}
                                  spacing={0}
                                  alignItems="center"
                                  justifyContent="flex-start"
                                >
                                  <div
                                    style={{
                                      backgroundColor: '#f8f9fb',
                                      boxShadow: '0px 0px 5px #aaa',
                                      borderRadius: '100px',
                                      width: 'calc(12%)',
                                    }}
                                  >
                                    <div style={{ padding: '1.75px' }}>
                                      <img
                                        src={
                                          this.state.trackingDetails[
                                            'driverAvatar'
                                          ]
                                        }
                                        alt="logo"
                                        // width={'50px'}
                                        style={{
                                          borderRadius: '100px',
                                          width: 'calc(100%)',
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      padding: '5px 15px 0px',
                                      flexGrow: 1,
                                    }}
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-start"
                                      justifyContent="flex-start"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '18px',
                                          fontWeight: 'normal',
                                          color: '#000',
                                        }}
                                      >
                                        {
                                          this.state.trackingDetails[
                                            'driverName'
                                          ]
                                        }
                                      </Typography>
                                      <Stack
                                        direction={'row'}
                                        spacing={0}
                                        alignItems="center"
                                      >
                                        <StarIcon
                                          style={{
                                            fontSize: '18px',
                                            color: '#44cf8e',
                                          }}
                                        />
                                        <Typography
                                          style={{
                                            fontSize: '15px',
                                            fontWeight: 'normal',
                                            color: '#000',
                                          }}
                                        >
                                          {' ' +
                                          this.state.trackingDetails[
                                            'driverRating'
                                          ]
                                            ? this.state.trackingDetails[
                                                'driverRating'
                                              ].toFixed(2)
                                            : ''}
                                        </Typography>
                                        <div
                                          style={{ padding: '0px 7.5px 0px' }}
                                        ></div>
                                        <Typography
                                          style={{
                                            fontSize: '15px',
                                            fontWeight: 'normal',
                                            color: '#000',
                                          }}
                                        >
                                          {strings['Nivel: '] +
                                          this.state.trackingDetails[
                                            'driverLevel'
                                          ]
                                            ? this.state.trackingDetails[
                                                'driverLevel'
                                              ].toString()
                                            : '1'}
                                        </Typography>
                                      </Stack>
                                    </Stack>
                                  </div>
                                </Stack>
                                <div style={{ padding: '0px 5px 0px' }}>
                                  <div
                                    onClick={() => {
                                      window.open(
                                        'tel://' +
                                          this.state.trackingDetails[
                                            'driverContact'
                                          ],
                                        '_blank'
                                      );
                                    }}
                                    style={{
                                      width: '45px',
                                      height: '45px',
                                      backgroundColor: '#272727',
                                      borderRadius: '50%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      textAlign: 'center',
                                      padding: '4px 6px 4px',
                                    }}
                                  >
                                    <LocalPhoneIcon
                                      style={{
                                        fontSize: '27px',
                                        color: '#fff',
                                      }}
                                    />
                                  </div>
                                </div>
                              </Stack>
                            </Stack>
                          </div>
                        ) : null}
                      </>
                      <div style={{ padding: '15px 0px 0px' }}></div>
                      <Divider />
                      <>
                        {' '}
                        {this.state.trackingDetails != null &&
                        (this.state.trackingDetails['isPickup'] == null ||
                          !this.state.trackingDetails['isPickup']) ? (
                          <div style={{ padding: '5px 20px 5px' }}>
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="flex-start"
                              justifyContent="flex-start"
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#6A6A6E',
                                }}
                              >
                                {strings['Dirección de entrega']}
                              </Typography>
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#000',
                                }}
                              >
                                {
                                  this.state.trackingDetails['userLocation'][
                                    'geoAddress'
                                  ]
                                }
                              </Typography>
                              <>
                                {this.state.trackingDetails['userLocation'][
                                  'addressNotes'
                                ] != null &&
                                this.state.trackingDetails['userLocation'][
                                  'addressNotes'
                                ] !== '' ? (
                                  <Typography
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: 'normal',
                                      color: '#6A6A6E',
                                    }}
                                  >
                                    {
                                      this.state.trackingDetails[
                                        'userLocation'
                                      ]['addressNotes']
                                    }
                                  </Typography>
                                ) : null}
                              </>
                              <div style={{ padding: '5px 0px 0px' }}></div>
                            </Stack>
                          </div>
                        ) : null}
                      </>
                      <>
                        {' '}
                        {this.state.trackingDetails != null &&
                        this.state.trackingDetails['isPickup'] != null &&
                        this.state.trackingDetails['isPickup'] ? (
                          <div style={{ padding: '5px 20px 5px' }}>
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="flex-start"
                              justifyContent="flex-start"
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#6A6A6E',
                                }}
                              >
                                {strings['Para recoger tu pedido debes dirigirte a:']}
                              </Typography>
                              <Typography
                                onClick={() => {
                                  window.open(
                                    'https://www.google.com/maps/search/?api=1&query=' +
                                      this.state.trackingDetails.restLocation.latitude.toString() +
                                      '%2C' +
                                      this.state.trackingDetails.restLocation.longitude.toString(),
                                    '_blank'
                                  );
                                }}
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#000',
                                }}
                              >
                                {
                                  this.state.trackingDetails['restLocation'][
                                    'address'
                                  ]
                                }
                              </Typography>
                              <div style={{ padding: '5px 0px 0px' }}></div>
                            </Stack>
                          </div>
                        ) : null}
                      </>
                      <div style={{ padding: '0px 20px 0px' }}>
                        <Divider />
                      </div>
                      <div style={{ padding: '5px 0px 0px' }}></div>
                      <div style={{ padding: '5px 20px 5px' }}>
                        <Stack
                          direction={'column'}
                          spacing={0}
                          alignItems="flex-start"
                          justifyContent="flex-start"
                        >
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: 'bold',
                              color: '#6A6A6E',
                            }}
                          >
                            {strings['Método de pago']}
                          </Typography>
                          <>
                            {!this.state.trackingDetails['onlinePayment'] ? (
                              <Stack direction={'row'} spacing={0}>
                                <>
                                  {this.state.trackingDetails[
                                    'cardOnDelivery'
                                  ] != null &&
                                  this.state.trackingDetails[
                                    'cardOnDelivery'
                                  ] ? (
                                    <CreditCardIcon
                                      style={{
                                        fontSize: '20px',
                                        fontWeight: 'normal',
                                        color: '#c96812',
                                        marginTop: '2px',
                                      }}
                                    />
                                  ) : (
                                    <MoneyIcon
                                      style={{
                                        fontSize: '20px',
                                        fontWeight: 'normal',
                                        color: '#54bd66',
                                        marginTop: '2px',
                                      }}
                                    />
                                  )}
                                </>
                                <div style={{ padding: '0px 2.5px 0px' }}></div>
                                <>
                                  {this.state.trackingDetails[
                                    'cardOnDelivery'
                                  ] != null &&
                                  this.state.trackingDetails[
                                    'cardOnDelivery'
                                  ] ? (
                                    <>
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {strings['Tarjeta contra entrega']}
                                      </Typography>
                                    </>
                                  ) : (this.state.trackingDetails[
                                    'mobilePayment'
                                  ] != null &&
                                  this.state.trackingDetails[
                                    'mobilePayment'
                                  ] ? (
                                    <>
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {"Sinpe Móvil: 8787-1617 (mandar comprobante)"}
                                      </Typography>
                                    </>
                                  ) : (this.state.trackingDetails[
                                    'cryptoPayment'
                                  ] != null &&
                                  this.state.trackingDetails[
                                    'cryptoPayment'
                                  ] ? (
                                    <>
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {strings["Pago con Criptomoneda"]}
                                      </Typography>
                                    </>
                                  ) : (
                                    <>
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {strings['Efectivo']}
                                      </Typography>
                                    </>
                                  )))}
                                </>
                                <div style={{ padding: '0px 5.5px 0px' }}></div>
                                <Typography
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'normal',
                                    color: '#6A6A6E',
                                  }}
                                >
                                  {'¢' +
                                    (
                                      this.state.trackingDetails['grandTotal'] +
                                      (this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] != null &&
                                      this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] > 0
                                        ? this.state.trackingDetails[
                                            'changeAddressExtraCost'
                                          ] + 0.0
                                        : 0.0)
                                    ).toFixed(2)}
                                </Typography>
                              </Stack>
                            ) : null}
                          </>
                          <>
                            {this.state.trackingDetails['onlinePayment'] ? (
                              <Stack direction={'row'} spacing={0}>
                                <CreditCardIcon
                                  style={{
                                    fontWeight: 'normal',
                                    color: '#2c59a8',
                                  }}
                                />
                                <div style={{ padding: '0px 2.5px 0px' }}></div>
                                <Typography
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {strings['Tarjeta']}
                                </Typography>
                                <div style={{ padding: '0px 2.5px 0px' }}></div>
                                <Typography
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'normal',
                                    color: '#6A6A6E',
                                  }}
                                >
                                  {'¢' +
                                    (
                                      this.state.trackingDetails['grandTotal'] +
                                      (this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] != null &&
                                      this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] > 0
                                        ? this.state.trackingDetails[
                                            'changeAddressExtraCost'
                                          ] + 0.0
                                        : 0.0)
                                    ).toFixed(2)}
                                </Typography>
                              </Stack>
                            ) : null}
                          </>
                        </Stack>
                      </div>
                      <div style={{ padding: '5px 0px 0px' }}></div>
                      <div style={{ padding: '0px 20px 0px' }}>
                        <Divider />
                      </div>
                      <div style={{ padding: '5px 0px 0px' }}></div>
                      <div style={{ padding: '5px 20px 5px' }}>
                        <Stack
                          direction={'column'}
                          spacing={0}
                          alignItems="flex-start"
                          justifyContent="flex-start"
                        >
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: 'bold',
                              color: '#6A6A6E',
                            }}
                          >
                            {strings['Día y hora de su pedido']}
                          </Typography>
                          <Stack
                            direction={'row'}
                            spacing={0}
                            alignItems="center"
                          >
                            <AccessTimeFilledIcon
                              style={{
                                fontSize: '20px',
                                fontWeight: 'normal',
                                color: '#4b596a',
                              }}
                            />{' '}
                            <div style={{ padding: '0px 2.5px 0px' }}></div>
                            <Typography
                              style={{
                                fontSize: '16px',
                                fontWeight: 'bold',
                                color: '#000',
                              }}
                            >
                              {moment
                                (this.state.trackingDetails['createdOn'].toDate())
                                .format('DD-MM-YYYY hh:mm a')}
                            </Typography>
                          </Stack>
                          <div style={{ padding: '5px 0px 0px' }}></div>
                        </Stack>
                      </div>
                      <div style={{ padding: '0px 20px 0px' }}>
                        <Divider />
                      </div>
                      <div style={{ padding: '5px 0px 0px' }}></div>
                      <>
                        {this.state.trackingDetails['showSpoonOption'] !=
                          null &&
                        this.state.trackingDetails['showSpoonOption'] ? (
                          <div style={{ padding: '5px 20px 5px' }}>
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="flex-start"
                              justifyContent="flex-start"
                            >
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#6A6A6E',
                                }}
                              >
                                {strings['Enviar cubiertos']}
                              </Typography>
                              <Stack
                                direction={'row'}
                                spacing={0}
                                alignItems="center"
                              >
                                <Typography
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {this.state.trackingDetails['giveSpoon'] !=
                                    null &&
                                  this.state.trackingDetails['giveSpoon']
                                    ? strings['Sí']
                                    : strings['No']}
                                </Typography>
                              </Stack>
                              <div style={{ padding: '5px 0px 0px' }}></div>
                            </Stack>
                          </div>
                        ) : null}
                      </>
                      <>
                        {this.state.trackingDetails['showSpoonOption'] !=
                          null &&
                        this.state.trackingDetails['showSpoonOption'] ? (
                          <div style={{ padding: '0px 20px 0px' }}>
                            <Divider />
                          </div>
                        ) : null}
                      </>
                      <>
                        {this.state.trackingDetails['showSpoonOption'] !=
                          null &&
                        this.state.trackingDetails['showSpoonOption'] ? (
                          <div style={{ padding: '5px 0px 0px' }}></div>
                        ) : null}
                      </>

                      <div style={{ padding: '5px 20px 5px', width: '100%' }}>
                        <Stack
                          direction={'column'}
                          spacing={0}
                          alignItems="flex-start"
                          justifyContent="flex-start"
                        >
                          <Typography
                            style={{
                              fontSize: '16px',
                              fontWeight: 'bold',
                              color: '#6A6A6E',
                            }}
                          >
                            {strings['Detalles del pedido:']}
                          </Typography>
                          <List style={{ width: '100%' }}>
                            {this.state.trackingDetails['items'].map(
                              (customize, index) => (
                                <div
                                  key={'tracking-deals' + index}
                                  style={{
                                    padding: '5px 0px 0px',
                                    width: '100%',
                                  }}
                                >
                                  <Stack
                                    direction={'row'}
                                    spacing={0}
                                    alignItems="flex-start"
                                    justifyContent="space-between"
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-start"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {this.state.trackingDetails['items'][
                                          index
                                        ]['quantity'].toString() +
                                          ' X ' +
                                          (this.state.trackingDetails['items'][
                                            index
                                          ]['nameEng'] != null
                                            ? this.state.trackingDetails[
                                                'items'
                                              ][index]['nameEng']
                                            : this.state.trackingDetails[
                                                'items'
                                              ][index]['name'])}
                                      </Typography>
                                      <div style={{ padding: '3px 0px 0px' }}>
                                        <List>
                                          {this.state.trackingDetails['items'][
                                            index
                                          ]['customize'].map((customize, t) => (
                                            <>
                                              {this.state.trackingDetails[
                                                'items'
                                              ][index]['customize'][t][
                                                'options'
                                              ].length > 0 ? (
                                                <Typography
                                                  style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'normal',
                                                    color: 'slategray',
                                                  }}
                                                >
                                                  {findTotalT(
                                                    index,
                                                    t,
                                                    this.state.trackingDetails
                                                  )}
                                                </Typography>
                                              ) : null}
                                            </>
                                          ))}
                                        </List>
                                      </div>
                                    </Stack>
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-end"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'normal',
                                          color: '#000',
                                        }}
                                      >
                                        {'¢' +
                                          Number(
                                            this.state.trackingDetails['items'][
                                              index
                                            ]['price'] *
                                              this.state.trackingDetails[
                                                'items'
                                              ][index]['quantity']
                                          )
                                            .toFixed(2)
                                            .toString()}
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                </div>
                              )
                            )}
                                                        {(this.state.trackingDetails['removedItems']==null && this.state.trackingDetails['selectedOffer']!=null && this.state.trackingDetails['selectedOffer']['id']!=null && this.state.trackingDetails['selectedOffer']['isFreeItem']!=null && this.state.trackingDetails['selectedOffer']['isFreeItem'])?
                            <div
                                  style={{
                                    padding: '5px 0px 0px',
                                    width: '100%',
                                  }}
                                  key={this.state.trackingDetails['items'].length}
                                >
                                  <Stack
                                    direction={'row'}
                                    spacing={0}
                                    alignItems="flex-start"
                                    justifyContent="space-between"
                                  >
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-start"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'bold',
                                          color: '#000',
                                        }}
                                      >
                                        {'1 X ' +
                                          (this.state.trackingDetails['selectedOffer']['freeItems'][0]
                                                      ['name'])}
                                      </Typography>
                                    </Stack>
                                    <Stack
                                      direction={'column'}
                                      spacing={0}
                                      alignItems="flex-end"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: 'normal',
                                          color: '#000',
                                        }}
                                      >
                                        {strings['Gratis']}
                                      </Typography>
                                    </Stack>
                                  </Stack>
                                </div>:null}
                          </List>
                          <div style={{ padding: '10px 0px 0px' }}></div>
                          {/* <div style={{padding: "0px 20px 0px"}}>
                    <Divider />
                   </div> */}
                        </Stack>
                      </div>
                      <div style={{ padding: '0px 20px 0px' }}>
                        <Divider />
                      </div>
                      <div style={{ padding: '10px 0px 0px' }}></div>
                      <div style={{ padding: '5px 20px 5px', width: '100%' }}>
                        <Stack
                          direction={'column'}
                          spacing={0}
                          alignItems="flex-start"
                        >
                          <div style={{ width: '100%' }}>
                            <Stack
                              direction={'column'}
                              spacing={0}
                              alignItems="flex-start"
                            >
                              <div
                                style={{
                                  padding: '0px 0px 5px',
                                  width: '100%',
                                }}
                              >
                                <Stack
                                  direction={'row'}
                                  spacing={0}
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Typography
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: 'normal',
                                      color: '#33343a',
                                    }}
                                  >
                                    {strings['Subtotal']}
                                  </Typography>
                                  <Typography
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: 'normal',
                                      color: '#33343a',
                                    }}
                                  >
                                    {'¢' +
                                      this.state.trackingDetails[
                                        'itemCost'
                                      ].toFixed(2)}
                                  </Typography>
                                </Stack>
                              </div>
                              <>
                                {this.state.trackingDetails['driverService'] !=
                                  null &&
                                this.state.trackingDetails['driverService'] >
                                  0 ? (
                                  <div
                                    style={{
                                      padding: '0px 0px 5px',
                                      width: '100%',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="space-between"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {strings['Tarifa de servicio']}
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {'¢' +
                                          this.state.trackingDetails[
                                            'driverService'
                                          ].toFixed(2)}
                                      </Typography>
                                    </Stack>
                                  </div>
                                ) : null}
                              </>
                              <>
                                {this.state.trackingDetails['deliveryCharge'] !=
                                  null &&
                                this.state.trackingDetails['deliveryCharge'] >
                                  0 ? (
                                  <div
                                    style={{
                                      padding: '0px 0px 5px',
                                      width: '100%',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="space-between"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {strings['Costo de envío']}
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {'¢' +
                                          (
                                            this.state.trackingDetails[
                                              'deliveryCharge'
                                            ] +
                                            (this.state.trackingDetails[
                                              'changeAddressExtraCost'
                                            ] != null &&
                                            this.state.trackingDetails[
                                              'changeAddressExtraCost'
                                            ] > 0
                                              ? this.state.trackingDetails[
                                                  'changeAddressExtraCost'
                                                ] + 0.0
                                              : 0.0)
                                          ).toFixed(2)}
                                      </Typography>
                                    </Stack>
                                  </div>
                                ) : null}
                              </>
                              <>
                                {this.state.trackingDetails['tip'] != null &&
                                this.state.trackingDetails['tip'] > 0 ? (
                                  <div
                                    style={{
                                      padding: '0px 0px 5px',
                                      width: '100%',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="space-between"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {strings['Propina']}
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {'¢' +
                                          this.state.trackingDetails[
                                            'tip'
                                          ].toFixed(2)}
                                      </Typography>
                                    </Stack>
                                  </div>
                                ) : null}
                              </>
                              <>
                                {this.state.trackingDetails[
                                  'dynamicDelivery'
                                ] != null &&
                                this.state.trackingDetails[
                                  'dynamicDelivery'
                                ] ? (
                                  <div
                                    style={{
                                      padding: '0px 0px 5px',
                                      width: '100%',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="flex-start"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {'(' +
                                          this.state.trackingDetails[
                                            'reasonDescription'
                                          ].toString() +
                                          ')'}
                                      </Typography>
                                    </Stack>
                                  </div>
                                ) : null}
                              </>
                              <>
                                {this.state.trackingDetails['offerValue'] !=
                                  null &&
                                this.state.trackingDetails['offerValue'] > 0 ? (
                                  <div
                                    style={{
                                      padding: '0px 0px 5px',
                                      width: '100%',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      spacing={0}
                                      alignItems="center"
                                      justifyContent="space-between"
                                    >
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {strings['Descuento']}
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontSize: '15px',
                                          fontWeight: 'normal',
                                          color: '#33343a',
                                        }}
                                      >
                                        {'-¢' +
                                          this.state.trackingDetails[
                                            'offerValue'
                                          ].toFixed(2)}
                                      </Typography>
                                    </Stack>
                                  </div>
                                ) : null}
                              </>
                            </Stack>
                          </div>
                          <>
                            {this.state.trackingDetails['onlinePayment'] &&
                            ((this.state.trackingDetails['isOxxoEnabled'] !=
                              null &&
                              this.state.trackingDetails['isOxxoEnabled']) ||
                              (this.state.trackingDetails[
                                'changeAddressExtraCost'
                              ] != null &&
                                this.state.trackingDetails[
                                  'changeAddressExtraCost'
                                ] > 0)) ? (
                              <Stack
                                direction={'row'}
                                spacing={0}
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Typography
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {strings['Pagado con '] +
                                    (this.state.trackingDetails[
                                      'paypalPayment'
                                    ] != null &&
                                    this.state.trackingDetails['paypalPayment']
                                      ? 'paypal'
                                      : strings['tarjeta'])}
                                </Typography>
                                <Typography
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {'¢' +
                                    this.state.trackingDetails[
                                      'grandTotalWithoutOxxo'
                                    ].toFixed(2)}
                                </Typography>
                              </Stack>
                            ) : null}
                          </>
                          <>
                            {this.state.trackingDetails['onlinePayment'] &&
                            ((this.state.trackingDetails['isOxxoEnabled'] !=
                              null &&
                              this.state.trackingDetails['isOxxoEnabled']) ||
                              (this.state.trackingDetails[
                                'changeAddressExtraCost'
                              ] != null &&
                                this.state.trackingDetails[
                                  'changeAddressExtraCost'
                                ] > 0)) ? (
                              <Stack
                                direction={'row'}
                                spacing={0}
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Typography
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {strings['Pagar en efectivo']}
                                </Typography>
                                <Typography
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                  }}
                                >
                                  {'¢' +
                                    (
                                      this.state.trackingDetails['grandTotal'] -
                                      this.state.trackingDetails[
                                        'grandTotalWithoutOxxo'
                                      ] +
                                      (this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] != null &&
                                      this.state.trackingDetails[
                                        'changeAddressExtraCost'
                                      ] > 0
                                        ? this.state.trackingDetails[
                                            'changeAddressExtraCost'
                                          ] + 0.0
                                        : 0.0)
                                    ).toFixed(2)}
                                </Typography>
                              </Stack>
                            ) : null}
                          </>
                          <>
                            {true ? (
                              <div style={{ width: '100%' }}>
                                <Stack
                                  direction={'row'}
                                  spacing={0}
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Typography
                                    style={{
                                      fontSize: '18px',
                                      fontWeight: 'bold',
                                      color: '#2c3136',
                                      marginTop: '20px',
                                    }}
                                  >
                                    {strings['Total']}
                                  </Typography>
                                  <Typography
                                    style={{
                                      fontSize: '18px',
                                      fontWeight: 'bold',
                                      color: '#2c3136',
                                      marginTop: '20px',
                                    }}
                                  >
                                    {'¢' +
                                      (
                                        this.state.trackingDetails[
                                          'grandTotal'
                                        ] +
                                        (this.state.trackingDetails[
                                          'changeAddressExtraCost'
                                        ] != null &&
                                        this.state.trackingDetails[
                                          'changeAddressExtraCost'
                                        ] > 0
                                          ? this.state.trackingDetails[
                                              'changeAddressExtraCost'
                                            ] + 0.0
                                          : 0.0)
                                      ).toFixed(2)}
                                  </Typography>
                                </Stack>
                              </div>
                            ) : null}
                          </>
                        </Stack>
                      </div>
                      <div style={{ padding: '60px 0px 0px' }}></div>
                    </Stack>
                  ) : null}
                </>
                {/* </div> */}
              </Stack>
            </Container>
          }
        ></TrackDialog>

        <Backdrop
          onClick={() => {}}
          style={{
            color: '#fff',
            zIndex: 9999,
            maxHeight: isIOS ? 'calc((var(--vh, 1vh) * 100))' : '100vh',
            height: isIOS ? 'calc((var(--vh, 1vh) * 100))' : '100vh',
          }}
          open={false}
        >
          <React.Fragment>
            <CssBaseline />
          </React.Fragment>
        </Backdrop>
      </>
    ) : (
      <>
        <div id="loading_indicator" className="container">
          <img
            style={{ width: this.state.width < 1000 ? '40vw' : '15vw' }}
            src={logo}
            alt="loading"
          />
        </div>
      </>
    );
  }
}

export default withRouter(Detail);
export const Profile = withRouter(ProfilePage);
export const Orders =  withRouter(OrdersPage);
